import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** DateTime Scalar Description */
  ArrowDateTime: any;
  /** DateTime Scalar Description */
  ArrowField: any;
  /**
   * An ID that uniquely identifies an object of a specific type within the context
   * of a batch. This can be used to refer to an object not yet created by the system.
   * Once the object is created, all referrers will then be updated with the real ID.
   */
  BatchOperations__ReferenceID: any;
  BigInteger: any;
  /**
   * A unique identifier to serve as a marker when paginating through a list
   * of results. Note, the value is a string.
   */
  ConnectionCursor: any;
  /** Date Scalar - stores date only without time or timezone information */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /** An email address. Accepts any string without validation. */
  Email: any;
  /** A JSON object that accepts dict input and serializes to/from JSON. */
  JSON: any;
  /**
   * A phone number in E.164 format (e.g., +15551234567).
   * Must start with '+' followed by country code and subscriber number.
   */
  PhoneNumber: any;
  PositiveInteger: any;
  /**
   * A Stock Keeping Unit identifier.
   *
   * This number is used to uniquely identify a part for a company.
   */
  SKU: any;
  /** A string or an integer */
  TypePreservingID: any;
  /**
   * A value that can be stored in the user preferences table.
   * String, number, boolean, json, etc.
   */
  UserPreferencesData: any;
};

export type ActivateItemMasterVariantInput = {
  itemMasterVariantId: Scalars['ID'];
};

export type ActivateItemMasterVariantResult = IMutationResult & {
  __typename?: 'ActivateItemMasterVariantResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  itemMaster?: Maybe<ItemMaster>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddFulfillmentOrdersToPickOrderInput = {
  fulfillmentOrderIds: Array<Scalars['ID']>;
  pickOrderId: Scalars['ID'];
};

export type AddFulfillmentOrdersToPickOrderResult = IMutationResult & {
  __typename?: 'AddFulfillmentOrdersToPickOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  pickOrder?: Maybe<PickOrder>;
  success: Scalars['Boolean'];
};

export type AddItemMasterVariant__Result = IMutationResult & {
  __typename?: 'AddItemMasterVariant__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  itemMaster?: Maybe<ItemMaster>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddItemMasterVariantDimensionsInput = {
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  unit: DimensionUom;
  width: Scalars['Decimal'];
};

export type AddItemMasterVariantInput = {
  itemMasterId: Scalars['ID'];
  variant: AddItemMasterVariantVariantInput;
};

export type AddItemMasterVariantNewProductInput = {
  manufacturerId: Scalars['ID'];
  manufacturerNumber: Scalars['String'];
  name: Scalars['String'];
};

export type AddItemMasterVariantVariantInput = {
  conversionRate: Scalars['Int'];
  dimensions?: InputMaybe<AddItemMasterVariantDimensionsInput>;
  freightClass?: InputMaybe<Scalars['String']>;
  isPolybagEligible?: InputMaybe<Scalars['Boolean']>;
  newProduct?: InputMaybe<AddItemMasterVariantNewProductInput>;
  nmfc?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  shippedInOriginalContainer: Scalars['Boolean'];
  siocQuantity?: InputMaybe<Scalars['Int']>;
  uom: ItemMasterVariantUom;
  weight?: InputMaybe<AddItemMasterVariantWeightInput>;
};

export type AddItemMasterVariantWeightInput = {
  amount: Scalars['Decimal'];
  unit: WeightUnit;
};

export type AddPolicyToGroup__Result = IMutationResult & {
  __typename?: 'AddPolicyToGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The Group that had the policy added to it. */
  group?: Maybe<Group>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddProductToVendorCatalogInput = {
  isPreferred?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AddProductToVendorCatalogResult = IMutationResult & {
  __typename?: 'AddProductToVendorCatalogResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AddProductVendorPricingInput = {
  agreedNetPrice: Scalars['Decimal'];
  priceEndDate?: InputMaybe<Scalars['Date']>;
  priceStartDate: Scalars['Date'];
  productId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AddProductVendorPricingResult = IMutationResult & {
  __typename?: 'AddProductVendorPricingResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<CountryCode>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AdjustReservationQuantity__Result = IMutationResult & {
  __typename?: 'AdjustReservationQuantity__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  reservation?: Maybe<Reservation>;
  success: Scalars['Boolean'];
};

export type ApproveTransferOrderInput = {
  /** Notes about the approval */
  approverNote?: InputMaybe<Scalars['String']>;
  /** The ID of the transfer order to approve */
  transferOrderId: Scalars['ID'];
};

export type ApproveTransferOrderResult = IMutationResult & {
  __typename?: 'ApproveTransferOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transferOrder?: Maybe<ManualTransferOrder>;
};

export type ArchiveInventoryLocation__Result = IMutationResult & {
  __typename?: 'ArchiveInventoryLocation__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The archived inventory location */
  inventoryLocation?: Maybe<InventoryLocation>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ArchiveStore__Result = IMutationResult & {
  __typename?: 'ArchiveStore__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The archived store */
  store?: Maybe<StoreInterface>;
  success: Scalars['Boolean'];
};

export type ArchiveStorePart__Result = IMutationResult & {
  __typename?: 'ArchiveStorePart__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The updated StorePart */
  storePart?: Maybe<StorePart>;
  success: Scalars['Boolean'];
};

export type Asset = {
  __typename?: 'Asset';
  archivedStatus?: Maybe<Scalars['String']>;
  assetTypeId: Scalars['Int'];
  companyId?: Maybe<Scalars['ID']>;
  customName?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['ArrowField']>;
  dateHardDeleted?: Maybe<Scalars['ArrowField']>;
  dateUpdated?: Maybe<Scalars['ArrowField']>;
  deleted: Scalars['Boolean'];
  equipmentMake?: Maybe<EquipmentMake>;
  equipmentMakeId?: Maybe<Scalars['ID']>;
  equipmentModel?: Maybe<EquipmentModel>;
  equipmentModelId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  inventoryBranchId?: Maybe<Scalars['ID']>;
  itemMaster?: Maybe<ItemMaster>;
  marketId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  rentalBranchId?: Maybe<Scalars['ID']>;
  serialNumber?: Maybe<Scalars['String']>;
  serviceBranchId?: Maybe<Scalars['ID']>;
};

export type AssetConnection = {
  __typename?: 'AssetConnection';
  edges: Array<AssetEdge>;
  pageInfo: PageInfo;
};

export type AssetEdge = {
  __typename?: 'AssetEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: Asset;
};

export type AssetFilter = {
  deleted?: InputMaybe<Scalars['Boolean']>;
  equipmentMakeIds?: InputMaybe<Array<Scalars['ID']>>;
  equipmentModelIds?: InputMaybe<Array<Scalars['ID']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  inventoryBranchIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AssetTransfer = {
  __typename?: 'AssetTransfer';
  asset?: Maybe<Asset>;
  assetTransferOrderId?: Maybe<Scalars['ID']>;
  assetTransferOrderNumber?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  status: AssetTransferItemStatus;
};

export enum AssetTransferItemStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum AssetTransferStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

/** Input type for assigning demand requests */
export type AssignDemandRequestInput = {
  /** The ID of the user to assign to (null to unassign) */
  assignedToUserId?: InputMaybe<Scalars['ID']>;
  /** The ID of the demand request to assign */
  demandRequestId: Scalars['ID'];
};

/** Result type for assigning demand requests */
export type AssignDemandRequestResult = {
  __typename?: 'AssignDemandRequestResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type AssignPermissionsToRole__Result = IMutationResult & {
  __typename?: 'AssignPermissionsToRole__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The Role that had the user added to it. */
  role?: Maybe<Role>;
  success: Scalars['Boolean'];
};

export type AssignPickOrderInput = {
  pickOrderId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AssignPickOrderResult = IMutationResult & {
  __typename?: 'AssignPickOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  pickOrder?: Maybe<PickOrder>;
  success: Scalars['Boolean'];
};

export type AssignUsersToGroup__Result = IMutationResult & {
  __typename?: 'AssignUsersToGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The Group that had the user added to it. */
  group?: Maybe<Group>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BatchOperations__Data = {
  /** Specify in order to perform all operations for a company other than the current user's company. The user must have permissions for all operations for that company. */
  companyId?: InputMaybe<Scalars['ID']>;
  /** Allows for initializing a company into the inventory system while also importing all of its data. The company data passed in here will be used instead of the companyId attribute at the top. */
  initializeCompany?: InputMaybe<BatchOperations__Data__InitializeCompany>;
  partClasses?: InputMaybe<BatchOperations__Data__PartClasses>;
  parts?: InputMaybe<BatchOperations__Data__Parts>;
  productCategories?: InputMaybe<BatchOperations__Data__ProductCategories>;
  providers?: InputMaybe<BatchOperations__Data__Providers>;
  stores?: InputMaybe<BatchOperations__Data__Stores>;
};

export type BatchOperations__Data__InitializeCompany = {
  /** A list of user IDs to assign as company-level admins for the inventory system. */
  adminUserIds?: InputMaybe<Array<Scalars['ID']>>;
  companyId: Scalars['ID'];
  name: Scalars['String'];
};

export type BatchOperations__Data__PartClasses = {
  /** If a part class with the exact same (case insensitive) class_number exists, then the already-existing part class will be used to fulfill the refId. Otherwise, the class will be created and the newly created instance will be used to fulfill the refId. The refId can be used wherever a partClassRefId is accepted */
  getOrCreate?: InputMaybe<Array<BatchOperations__Data__PartClasses__GetOrCreate>>;
};

export type BatchOperations__Data__PartClasses__GetOrCreate = {
  /** A custom ID used used when referencing this class. */
  classNumber?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  /** Only needs to be set if this provider is to be referenced by another batch operation with a partClassRefId. */
  refId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
};

export type BatchOperations__Data__Parts = {
  /** Get or create the given list of parts. The refId will can be used in other operations that accept a partRefId */
  getOrCreate?: InputMaybe<Array<BatchOperations__Data__Parts__GetOrCreate>>;
  /** Update the given list of parts with the paired attributes */
  update?: InputMaybe<Array<BatchOperations__Data__Parts__Update>>;
};

/**
 * Creates the given list of parts or sets the refId to an existing part based on
 * provider and part number.
 *
 * A refId is only required if the part is to be used by something
 * else in a batch.
 *
 * The following set of parameters are mutually exclusive and at
 * least one of each group is required:
 *
 * - providerId or providerRefId
 */
export type BatchOperations__Data__Parts__GetOrCreate = {
  /** A shortcut that creates a one-off PartClass with this as the description and then points this part to that part class. Note that if this is set and part already exists with the given provider and part number, then this is ignored. */
  description: Scalars['String'];
  partNumber: Scalars['String'];
  providerId?: InputMaybe<Scalars['ID']>;
  /** A reference ID to a Provider in one of the get or create operations in the providers section. */
  providerRefId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
  refId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
};

export type BatchOperations__Data__Parts__Update = {
  description?: InputMaybe<Scalars['String']>;
  /** Create a mapping of external application to that application's ID for this part. */
  externalIds?: InputMaybe<Array<BatchOperations__Data__Parts__Update__ExternalIdMapping>>;
  id: Scalars['ID'];
  partNumber?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['ID']>;
};

export type BatchOperations__Data__Parts__Update__ExternalIdMapping = {
  application: ExternalApplication;
  externalId: Scalars['ID'];
};

export type BatchOperations__Data__ProductCategories = {
  /** If a product category with the exact same name (case insensitive) exists, then the already-existing category will be used to fulfill the refId. Otherwise, the category will be created and the newly created instance will be used to fulfill the refId. The refId can be used wherever a productCategoryRefId is accepted */
  getOrCreate?: InputMaybe<Array<BatchOperations__Data__ProductCategories__GetOrCreate>>;
};

/** `parent_id` and `parent_ref_id` are mutually exclusive. */
export type BatchOperations__Data__ProductCategories__GetOrCreate = {
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  /** A refId to another product category in the list of categories to get or create */
  parentRefId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
  /** Only needs to be set if this provider is to be referenced by another batch operation with a productCategoryRefId. */
  refId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
};

export type BatchOperations__Data__Providers = {
  /** Gets or creates the provider unique by name. The refId can be used in other operations that accept a providerRefId */
  getOrCreate?: InputMaybe<Array<BatchOperations__Data__Providers__GetOrCreate>>;
  update?: InputMaybe<Array<BatchOperations__Data__Providers__Update>>;
};

export type BatchOperations__Data__Providers__GetOrCreate = {
  name: Scalars['String'];
  /** Only needs to be set if this provider is to be referenced by another batch operation with a providerRefId. */
  refId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
};

export type BatchOperations__Data__Providers__Update = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type BatchOperations__Data__Stores = {
  update?: InputMaybe<Array<BatchOperations__Data__Stores__Update>>;
};

export type BatchOperations__Data__Stores__Update = {
  addParts?: InputMaybe<Array<BatchOperations__Data__Stores__Update__AddPart>>;
  /** The ID of the store to update */
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/**
 * Allows for adding new parts as well as adding quantities to existing parts within
 * the inventory.
 *
 * If a part given does not exist already in the store, it will be created.
 *
 * If a part already exists, then the quantity given here will be added to the existing
 * store part. Additionally, if any of the other attributes are set, they will be
 * updated on the existing store part.
 *
 * Note that `partId` or `partRefId` is required. If quantity is 0 or None, we will still create the StorePart
 * with any other provided data.
 * All other attributes are optional.
 */
export type BatchOperations__Data__Stores__Update__AddPart = {
  /** The value per unit of this part. Defaults to 0. */
  cost?: InputMaybe<Scalars['Float']>;
  /** Where in the store this part is located. Defaults to null. */
  location?: InputMaybe<Scalars['String']>;
  /** The maximum threshold used to remind the parts manager that they should have no more than this quantity of parts in their store. Defaults to null. */
  max?: InputMaybe<Scalars['Int']>;
  /** The minimum threshold which can be used to alert the parts manager when they need to order more of that part. Defaults to null */
  min?: InputMaybe<Scalars['Int']>;
  /** Any extra information about why this part is in the inventory, what asset it is for, or other notes/gotchas related to it. Defaults to null. */
  note?: InputMaybe<Scalars['String']>;
  /** The ID of an existing Part. */
  partId?: InputMaybe<Scalars['ID']>;
  /** A refId of a parts.create part to be created. Once the part is created, this store can then use that created part in order to populate the inventory. */
  partRefId?: InputMaybe<Scalars['BatchOperations__ReferenceID']>;
  /** How many units of this part to add to the store. */
  quantity: Scalars['Int'];
};

export enum BatchOperations__ErrorCode {
  AlreadyExists = 'ALREADY_EXISTS',
  BadParameter = 'BAD_PARAMETER',
  BadValue = 'BAD_VALUE',
  Duplicate = 'DUPLICATE',
  DuplicateRef = 'DUPLICATE_REF',
  EmptyField = 'EMPTY_FIELD',
  InvalidRef = 'INVALID_REF'
}

export type BatchOperations__Result = IMutationResult & {
  __typename?: 'BatchOperations__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  validationErrors?: Maybe<Array<BatchOperations__Result__ValidationError>>;
};

export type BatchOperations__Result__ValidationError = {
  __typename?: 'BatchOperations__Result__ValidationError';
  /** The enum indicating what went wrong. */
  code: BatchOperations__ErrorCode;
  /** If set, the field that is invalid. */
  field?: Maybe<Scalars['String']>;
  /** The index into the operation array of which item is invalid */
  index: Scalars['Int'];
  /** A human readable description of what went wrong. This should not be shown to the end user directly. Instead, key off of the `code` field to create a message. */
  message: Scalars['String'];
  /** The JSON path to the operation being performed. E.g. 'providers.create' */
  operation: Scalars['String'];
};

export type Branch = StoreInterface & {
  __typename?: 'Branch';
  branchId: Scalars['BigInteger'];
  children: Array<StoreInterface>;
  company: Company;
  companyId: Scalars['Int'];
  /** The date that the store was archived. */
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  /** Get store external application id */
  externalStoreId?: Maybe<Scalars['ID']>;
  /** Get each store's external app ids and app name */
  externalStoreIds: Array<Maybe<ExternalStoreMeta>>;
  id: Scalars['Int'];
  inventoryType?: Maybe<InventoryType>;
  isWarehouse: Scalars['Boolean'];
  name: Scalars['String'];
  /** Number of put-away stations. NULL for non-warehouses; an integer (>= 0) for warehouses. */
  numPutawayStations?: Maybe<Scalars['Int']>;
  parent?: Maybe<StoreInterface>;
  parentId?: Maybe<Scalars['Int']>;
  storeId: Scalars['Int'];
  storeTypeId?: Maybe<Scalars['Int']>;
};


export type BranchExternalStoreIdArgs = {
  app: ExternalApplication;
};

export type BranchV2 = {
  __typename?: 'BranchV2';
  abbreviation?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  dateCreated?: Maybe<Scalars['ArrowField']>;
  dateHardDeleted?: Maybe<Scalars['ArrowField']>;
  dateUpdated?: Maybe<Scalars['ArrowField']>;
  id: Scalars['ID'];
  isMtt: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  resourceMapId?: Maybe<Scalars['String']>;
  resourceMapResourceId?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['Int']>;
  stateName?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['Int']>;
  zipCodeExtended?: Maybe<Scalars['Int']>;
};

export type BranchV2Connection = {
  __typename?: 'BranchV2Connection';
  edges: Array<BranchV2Edge>;
  pageInfo: PageInfo;
};

export type BranchV2Edge = {
  __typename?: 'BranchV2Edge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: BranchV2;
};

export type BranchV2Filter = {
  active?: InputMaybe<Scalars['Boolean']>;
  isMtt?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type BulkImportSession = {
  __typename?: 'BulkImportSession';
  bulkImportSessionId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateReverted?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  importedBy: Scalars['BigInteger'];
  note?: Maybe<Scalars['String']>;
  revertedBy?: Maybe<Scalars['BigInteger']>;
};

/** Input for bulk updating fulfiller notes on multiple line items */
export type BulkUpdateDemandRequestLineItemFulfillerNotesInput = {
  /** The ID of the demand request containing the line items */
  demandRequestId: Scalars['ID'];
  /** Fulfiller notes to apply to all line items (max 1000 chars, null to clear) */
  fulfillerNotes?: InputMaybe<Scalars['String']>;
  /** The IDs of the line items to update */
  lineItemIds: Array<Scalars['ID']>;
};

/** Result of bulk updating fulfiller notes */
export type BulkUpdateDemandRequestLineItemFulfillerNotesResult = IMutationResult & {
  __typename?: 'BulkUpdateDemandRequestLineItemFulfillerNotesResult';
  demandRequest?: Maybe<DemandRequest>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Input type for cancelling demand requests */
export type CancelDemandRequestInput = {
  /** The ID of the demand request to cancel */
  demandRequestId: Scalars['ID'];
};

/** Input type for cancelling demand request line items */
export type CancelDemandRequestLineItemInput = {
  /** The ID of the demand request containing the line item */
  demandRequestId: Scalars['ID'];
  /** The ID of the line item to cancel */
  lineItemId: Scalars['ID'];
};

/** Result type for cancelling demand request line items */
export type CancelDemandRequestLineItemResult = {
  __typename?: 'CancelDemandRequestLineItemResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Input type for cancelling multiple demand request line items */
export type CancelDemandRequestLineItemsInput = {
  /** The ID of the demand request containing the line items */
  demandRequestId: Scalars['ID'];
  /** The IDs of the line items to cancel */
  lineItemIds: Array<Scalars['ID']>;
};

/** Result type for cancelling multiple demand request line items */
export type CancelDemandRequestLineItemsResult = IMutationResult & {
  __typename?: 'CancelDemandRequestLineItemsResult';
  demandRequest?: Maybe<DemandRequest>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Result type for cancelling demand requests */
export type CancelDemandRequestResult = {
  __typename?: 'CancelDemandRequestResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CancelMultiManufacturerProductUpload__Input = {
  /** The session ID of the upload to cancel. Should match the session ID used to start the upload. */
  sessionId: Scalars['ID'];
};

export type CancelMultiManufacturerProductUpload__Result = IMutationResult & {
  __typename?: 'CancelMultiManufacturerProductUpload__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  uploadSession?: Maybe<GlobalProductCatalogUpload>;
};

export type CancelPickOrderInput = {
  pickOrderId: Scalars['ID'];
};

export type CancelPickOrderResult = IMutationResult & {
  __typename?: 'CancelPickOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  pickOrder?: Maybe<PickOrder>;
  success: Scalars['Boolean'];
};

export type CancelPreferredVendorPricingUpload__Input = {
  /** The session ID of the upload to cancel. Should match the session ID used to start the upload. */
  sessionId: Scalars['ID'];
};

export type CancelPreferredVendorPricingUpload__Result = IMutationResult & {
  __typename?: 'CancelPreferredVendorPricingUpload__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  uploadSession?: Maybe<GlobalProductCatalogUpload>;
};

export type CancelReservation__Result = IMutationResult & {
  __typename?: 'CancelReservation__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  reservation?: Maybe<Reservation>;
  success: Scalars['Boolean'];
};

export type CancelTransferOrderInput = {
  /** Notes about the cancellation */
  cancellationNote?: InputMaybe<Scalars['String']>;
  /** The ID of the transfer order to cancel */
  transferOrderId: Scalars['ID'];
};

export type CancelTransferOrderLineItemInput = {
  /** The ID of the transfer order line item to cancel */
  lineItemId: Scalars['ID'];
};

export type CancelTransferOrderLineItemResult = IMutationResult & {
  __typename?: 'CancelTransferOrderLineItemResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  lineItem?: Maybe<TransferOrderLineItem>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CancelTransferOrderResult = IMutationResult & {
  __typename?: 'CancelTransferOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transferOrder?: Maybe<TransferOrder>;
};

export type Company = NamedResourceEntity & {
  __typename?: 'Company';
  adminGroup: Group;
  /** The company's Admin group */
  adminGroupId: Scalars['BigInteger'];
  adminRole: Role;
  /** The company's Admin role */
  adminRoleId: Scalars['BigInteger'];
  company_id: Scalars['Int'];
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** If set, then all transactions require that a WAC is set on all inventory items involved. */
  requiresValidWac: Scalars['Boolean'];
  storeAdminRole?: Maybe<Role>;
  /** The company's default Store Admin role */
  storeAdminRoleId?: Maybe<Scalars['BigInteger']>;
  storeTechRole?: Maybe<Role>;
  /** The company's default Store Tech role */
  storeTechRoleId?: Maybe<Scalars['BigInteger']>;
  userDefaultsGroup: Group;
  /** The company's User Defaults group */
  userDefaultsGroupId: Scalars['BigInteger'];
  userDefaultsRole: Role;
  /** The company's User Defaults role */
  userDefaultsRoleId: Scalars['BigInteger'];
};

/** Input type for completing demand requests */
export type CompleteDemandRequestInput = {
  /** The ID of the demand request to complete */
  demandRequestId: Scalars['ID'];
};

/** Input type for completing demand request line items */
export type CompleteDemandRequestLineItemInput = {
  /** The ID of the demand request containing the line item */
  demandRequestId: Scalars['ID'];
  /** The ID of the line item to complete */
  lineItemId: Scalars['ID'];
};

/** Result type for completing demand request line items */
export type CompleteDemandRequestLineItemResult = {
  __typename?: 'CompleteDemandRequestLineItemResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Input type for completing multiple demand request line items */
export type CompleteDemandRequestLineItemsInput = {
  /** The ID of the demand request containing the line items */
  demandRequestId: Scalars['ID'];
  /** The IDs of the line items to complete */
  lineItemIds: Array<Scalars['ID']>;
};

/** Result type for completing multiple demand request line items */
export type CompleteDemandRequestLineItemsResult = IMutationResult & {
  __typename?: 'CompleteDemandRequestLineItemsResult';
  demandRequest?: Maybe<DemandRequest>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Result type for completing demand requests */
export type CompleteDemandRequestResult = {
  __typename?: 'CompleteDemandRequestResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CompletePickOrderCartonInput = {
  lines: Array<CompletePickOrderCartonLineInput>;
  /** Optional. A carton may be packed and completed before a tracking number exists. */
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CompletePickOrderCartonLineInput = {
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  pickOrderLineId: Scalars['ID'];
  quantityFulfilled: Scalars['Int'];
  quantityUnfulfilled: Scalars['Int'];
};

export type CompletePickOrderInput = {
  cartons: Array<CompletePickOrderCartonInput>;
  pickOrderId: Scalars['ID'];
};

export type CompletePickOrderResult = IMutationResult & {
  __typename?: 'CompletePickOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  pickOrder?: Maybe<PickOrder>;
  success: Scalars['Boolean'];
};

export type ConvertItems__Input = {
  /** The ID of the part from which to convert. */
  fromPartId: Scalars['ID'];
  /** The quantity of the 'from' part of which to convert. Must be less than or equal to 'to_quantity' */
  fromQuantity: Scalars['Int'];
  /** The inventory location that contains the parts to convert. */
  inventoryLocationId: Scalars['ID'];
  /** The ID of the part into which to convert. */
  toPartId: Scalars['ID'];
  /** The quantity to convert into the 'to' part. Must be greater than or equal to 'from_quantity' */
  toQuantity: Scalars['Int'];
};

export type ConvertItems_Result = IMutationResult & {
  __typename?: 'ConvertItems_Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  fromStorePart?: Maybe<StorePart>;
  message: Scalars['String'];
  quantityConverted?: Maybe<Scalars['Int']>;
  quantityConvertedTo?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  toStorePart?: Maybe<StorePart>;
};

export type ConvertParts__Result = IMutationResult & {
  __typename?: 'ConvertParts__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  fromStorePart?: Maybe<StorePart>;
  message: Scalars['String'];
  quantityConverted?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  toStorePart?: Maybe<StorePart>;
};

export type ConvertStoreParts__Input = {
  /** The ID of the part from which to convert. */
  fromPartId: Scalars['ID'];
  /** The inventory location that contains the parts to convert. */
  inventoryLocationId: Scalars['ID'];
  /** The quantity of the 'from' part to convert into the 'to' part. */
  quantity: Scalars['Int'];
  /** The ID of the part into which to convert. */
  toPartId: Scalars['ID'];
};

export enum CountryCode {
  Us = 'US'
}

export type CreateBranch__Result = IMutationResult & {
  __typename?: 'CreateBranch__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The created store */
  store?: Maybe<Store>;
  success: Scalars['Boolean'];
};

export type CreateDemandRequestDeliveryAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Input type for creating demand requests */
export type CreateDemandRequestInput = {
  /** Optional email address to CC on the demand request email */
  ccEmail?: InputMaybe<Scalars['String']>;
  /** Primary contact phone number in E.164 format for coordination */
  contactPhonePrimary?: InputMaybe<Scalars['PhoneNumber']>;
  /** Deliver this request somewhere other than the requesting inventory's branch address. Omit to use the branch address. */
  deliveryAddress?: InputMaybe<CreateDemandRequestDeliveryAddressInput>;
  /** The inventory/store that will fulfill this request. Optional for a stock request, which is routed across distribution centers when omitted or null. */
  fulfillingInventoryId?: InputMaybe<Scalars['ID']>;
  /** The line items for this demand request */
  lineItems: Array<DemandRequestLineItemInput>;
  /** Optional notes about the overall request (max 255 chars) */
  notes?: InputMaybe<Scalars['String']>;
  /** The inventory/store that is making this request */
  requestingInventoryId: Scalars['ID'];
  /** The process the request follows. Defaults to STOCK when omitted. */
  requestType?: InputMaybe<DemandRequestType>;
};

/** Result type for creating demand requests */
export type CreateDemandRequestResult = {
  __typename?: 'CreateDemandRequestResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateDistrict__Input = {
  name: Scalars['String'];
  /** Must be a REGION or COMPANY resource. */
  parentResourceId: Scalars['ID'];
};

export type CreateDistrict__Result = IMutationResult & {
  __typename?: 'CreateDistrict__Result';
  /** The created district. */
  district?: Maybe<District>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateFulfillmentOrderAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCode>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateFulfillmentOrderExternalAppXrefInput = {
  /** The external application this fulfillment order is associated with. */
  applicationId: ExternalApplication;
  /** The external application's identifier for this fulfillment order (e.g. the Shopify order number). */
  theirStringObjectId: Scalars['String'];
};

export type CreateFulfillmentOrderInput = {
  contactEmail?: InputMaybe<Scalars['Email']>;
  contactPhone?: InputMaybe<Scalars['PhoneNumber']>;
  dateNeededBy?: InputMaybe<Scalars['Date']>;
  destinationInventoryId?: InputMaybe<Scalars['ID']>;
  /** Associate this fulfillment order with an external application's identifier (e.g. a Shopify order). */
  externalAppXref?: InputMaybe<CreateFulfillmentOrderExternalAppXrefInput>;
  fulfillingInventoryId: Scalars['ID'];
  fulfillmentType: FulfillmentType;
  lineItems: Array<CreateFulfillmentOrderLineItemInput>;
  mttId?: InputMaybe<Scalars['String']>;
  mttQuadrant?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<CreateFulfillmentOrderAddressInput>;
  sourceOriginatorId?: InputMaybe<Scalars['String']>;
  sourceOriginatorType?: InputMaybe<Scalars['String']>;
};

export type CreateFulfillmentOrderLineItemInput = {
  allocationTargetId?: InputMaybe<Scalars['ID']>;
  allocationTargetTypeId?: InputMaybe<ReservationTargetType>;
  demandRequestLineItemId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  sourceOriginatorId?: InputMaybe<Scalars['String']>;
  sourceOriginatorType?: InputMaybe<Scalars['String']>;
};

export type CreateFulfillmentOrderResult = IMutationResult & {
  __typename?: 'CreateFulfillmentOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateGroup__Result = IMutationResult & {
  __typename?: 'CreateGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  group?: Maybe<Group>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateInventoryLocation__Result = IMutationResult & {
  __typename?: 'CreateInventoryLocation__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  inventoryLocation?: Maybe<InventoryLocation>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateItemMasterInput = {
  equipmentMakeId?: InputMaybe<Scalars['ID']>;
  equipmentModelId?: InputMaybe<Scalars['ID']>;
  flammable: Scalars['Boolean'];
  fragile: Scalars['Boolean'];
  isHazmat: Scalars['Boolean'];
  lithiumIonBattery: Scalars['Boolean'];
  numinaSerialType: NuminaSerialType;
  variants: Array<CreateItemMasterVariantInput>;
};

export type CreateItemMasterResult = IMutationResult & {
  __typename?: 'CreateItemMasterResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  itemMaster?: Maybe<ItemMaster>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateItemMasterVariantInput = {
  conversionRate?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<DimensionsInput>;
  freightClass?: InputMaybe<Scalars['String']>;
  isBase: Scalars['Boolean'];
  isPolybagEligible?: InputMaybe<Scalars['Boolean']>;
  nmfc?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  shippedInOriginalContainer: Scalars['Boolean'];
  siocQuantity?: InputMaybe<Scalars['Int']>;
  uom: ItemMasterVariantUom;
  weight?: InputMaybe<WeightInput>;
};

export type CreateManualAdjustment__Result = IMutationResult & {
  __typename?: 'CreateManualAdjustment__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The manual adjustments that were created. */
  manualAdjustments?: Maybe<Array<Maybe<ManualAdjustment>>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type CreateManualAdjustmentItem = {
  /** The cost per item of the product. */
  costPerItem: Scalars['Decimal'];
  /** The product id */
  productId: Scalars['ID'];
  /** The quantity to be adjusted. This number should always be positive (even if decrementing). This simply needs to be the amount of quantity that is being effected, therefore a negative or 0 amount is not acceptable. */
  quantity: Scalars['PositiveInteger'];
};

export type CreateManualTransferOrderInput = {
  /** The inventory location that is sending the parts */
  fromStoreId: Scalars['ID'];
  /** The line items for this transfer order */
  lineItems: Array<CreateTransferOrderLineItemInput>;
  /** Notes about the overall transfer request */
  requesterNote?: InputMaybe<Scalars['String']>;
  /** The inventory location that will receive the parts */
  toStoreId: Scalars['ID'];
};

export type CreateManualTransferOrderResult = IMutationResult & {
  __typename?: 'CreateManualTransferOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transferOrder?: Maybe<ManualTransferOrder>;
};

export type CreateNamedStoreAsChildOf__Result = IMutationResult & {
  __typename?: 'CreateNamedStoreAsChildOf__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The created named store */
  namedStore?: Maybe<NamedStore>;
  success: Scalars['Boolean'];
};

export type CreateOrUpdateReservation__Result = IMutationResult & {
  __typename?: 'CreateOrUpdateReservation__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  reservation?: Maybe<Reservation>;
  success: Scalars['Boolean'];
};

export type CreatePickOrderInput = {
  assignedToUserId?: InputMaybe<Scalars['ID']>;
  fulfillingInventoryId: Scalars['ID'];
  fulfillmentOrderIds: Array<Scalars['ID']>;
};

export type CreatePickOrderResult = IMutationResult & {
  __typename?: 'CreatePickOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  pickOrder?: Maybe<PickOrder>;
  success: Scalars['Boolean'];
};

export type CreateProduct__Result = IMutationResult & {
  __typename?: 'CreateProduct__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  product?: Maybe<Product>;
  success: Scalars['Boolean'];
};

export type CreateProductCategory__Result = IMutationResult & {
  __typename?: 'CreateProductCategory__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  productCategory?: Maybe<ProductCategory>;
  success: Scalars['Boolean'];
};

export type CreateProductClass__Result = IMutationResult & {
  __typename?: 'CreateProductClass__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  productClass?: Maybe<ProductClass>;
  success: Scalars['Boolean'];
};

export type CreateProductItemMasterDimensionsInput = {
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  unit: DimensionUom;
  width: Scalars['Decimal'];
};

export type CreateProductItemMasterInput = {
  dimensions?: InputMaybe<CreateProductItemMasterDimensionsInput>;
  equipmentMakeId?: InputMaybe<Scalars['ID']>;
  equipmentModelId?: InputMaybe<Scalars['ID']>;
  flammable: Scalars['Boolean'];
  fragile: Scalars['Boolean'];
  freightClass?: InputMaybe<Scalars['String']>;
  isHazmat: Scalars['Boolean'];
  isPolybagEligible?: InputMaybe<Scalars['Boolean']>;
  lithiumIonBattery: Scalars['Boolean'];
  nmfc?: InputMaybe<Scalars['String']>;
  numinaSerialType: NuminaSerialType;
  shippedInOriginalContainer: Scalars['Boolean'];
  siocQuantity?: InputMaybe<Scalars['Int']>;
  uom: ItemMasterVariantUom;
  weight?: InputMaybe<CreateProductItemMasterWeightInput>;
};

export type CreateProductItemMasterWeightInput = {
  amount: Scalars['Decimal'];
  unit: WeightUnit;
};

export type CreateProductListInput = {
  /** Optional metadata about the context (max 15KB) */
  context?: InputMaybe<Scalars['JSON']>;
  /** The items in the product list */
  items: Array<ProductListItemInput>;
};

export type CreateProductListResult = {
  __typename?: 'CreateProductListResult';
  message: Scalars['String'];
  productList?: Maybe<ProductList>;
  success: Scalars['Boolean'];
};

export type CreatePutAwayOrderInput = {
  /** The line items for this put-away order */
  lineItems: Array<CreatePutAwayOrderLineItemInput>;
  /** The human-readable PO number associated with this put-away order. */
  purchaseOrderNumber?: InputMaybe<Scalars['BigInteger']>;
  /** The station at which the put-away will be performed. Defaults to 0 if not provided. */
  putawayStationId?: InputMaybe<Scalars['Int']>;
  /** The ID of the source entity */
  sourceId: Scalars['ID'];
  /** The type of source entity (TRANSFER_ORDER, PURCHASE_ORDER) */
  sourceType: Scalars['String'];
  /** The ID of the store receiving the inventory */
  storeId: Scalars['ID'];
};

export type CreatePutAwayOrderLineItemInput = {
  /** The ID of the product being put away */
  productId: Scalars['ID'];
  /** The quantity being put away */
  quantity: Scalars['Int'];
  /** Number of barcodes to print for this line item. Must not exceed quantity. */
  quantityBarcodesToPrint?: InputMaybe<Scalars['Int']>;
};

export type CreatePutAwayOrderResult = IMutationResult & {
  __typename?: 'CreatePutAwayOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  putAwayOrder?: Maybe<PutAwayOrder>;
  success: Scalars['Boolean'];
};

export type CreateRegion__Input = {
  name: Scalars['String'];
  /** Must be a COMPANY resource. */
  parentResourceId: Scalars['ID'];
};

export type CreateRegion__Result = IMutationResult & {
  __typename?: 'CreateRegion__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The created region. */
  region?: Maybe<Region>;
  success: Scalars['Boolean'];
};

export type CreateRole__Result = IMutationResult & {
  __typename?: 'CreateRole__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The created role if no errors. */
  role?: Maybe<Role>;
  success: Scalars['Boolean'];
};

export type CreateStorePart__Result = IMutationResult & {
  __typename?: 'CreateStorePart__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The newly tracked StorePart. */
  storePart?: Maybe<StorePart>;
  success: Scalars['Boolean'];
};

export type CreateStorePartInput = {
  /** The inventory location that will track the product. */
  inventoryLocationId: Scalars['ID'];
  /** Where in this inventory location the product is located. */
  location?: InputMaybe<Scalars['String']>;
  /** The maximum quantity that this inventory location has set for this product. */
  max?: InputMaybe<Scalars['Int']>;
  /** Any sort of memo or reminders about this product. */
  note?: InputMaybe<Scalars['String']>;
  /** The ID of the product to begin tracking at the given inventory location. */
  productId: Scalars['ID'];
  /** The lower bound of quantity that, when reached, will show an alert that this product needs to be ordered. */
  threshold?: InputMaybe<Scalars['Int']>;
};

export type CreateTransferOrderLineItemInput = {
  /** The identifier of the allocation target */
  allocationTargetId?: InputMaybe<Scalars['Int']>;
  /** The type of allocation target (WORK_ORDER, INVOICE, etc.) */
  allocationTargetType?: InputMaybe<ReservationTargetType>;
  /** Optional sourcing back-link to the demand request line item this transfer order line item was created to satisfy. Null for ad-hoc transfers. */
  demandRequestLineItemId?: InputMaybe<Scalars['ID']>;
  /** Notes for this line item */
  lineNote?: InputMaybe<Scalars['String']>;
  /** The ID of the product to transfer */
  productId: Scalars['ID'];
  /** The quantity of the product requested */
  quantityRequested: Scalars['Int'];
};

export type CreateWeightedAverageCostSnapshot__Result = IMutationResult & {
  __typename?: 'CreateWeightedAverageCostSnapshot__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  weightedAverageCostSnapshot?: Maybe<WeightedAverageCostSnapshot>;
};

/**
 * A pointer at a credit purchase receipt that lives in procurements.
 *
 * Only the identifier is available here; consumers resolve the receipt's
 * details and build any link to it themselves.
 */
export type CreditPurchaseReference = {
  __typename?: 'CreditPurchaseReference';
  id: Scalars['ID'];
};

export enum CurrencyCode {
  Usd = 'USD'
}

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']>;
  /** Paginate first number of items */
  first?: InputMaybe<Scalars['Int']>;
  /** Paginate last number of items */
  last?: InputMaybe<Scalars['Int']>;
};

export type DeleteDistrict__Result = IMutationResult & {
  __typename?: 'DeleteDistrict__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteGroup__Result = IMutationResult & {
  __typename?: 'DeleteGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteProductVendorPricingInput = {
  productVendorPricingId: Scalars['ID'];
};

export type DeleteProductVendorPricingResult = IMutationResult & {
  __typename?: 'DeleteProductVendorPricingResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteRegion__Result = IMutationResult & {
  __typename?: 'DeleteRegion__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteRole__Result = IMutationResult & {
  __typename?: 'DeleteRole__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type DeleteUserPreference__Result = IMutationResult & {
  __typename?: 'DeleteUserPreference__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  /** The updated user preferences minus the deleted one. */
  userPreferences?: Maybe<UserPreference>;
};

export type DemandRequest = {
  __typename?: 'DemandRequest';
  allowSubstitution: Scalars['Boolean'];
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['ID']>;
  cancelledByUser?: Maybe<User>;
  cancelledByUserId?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  completedByUser?: Maybe<User>;
  completedByUserId?: Maybe<Scalars['ID']>;
  contactPhonePrimary?: Maybe<Scalars['String']>;
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['ArrowDateTime'];
  /** An alternate delivery address supplied on the request, for a branch whose Fleet business address is not where it can accept deliveries. Null when the request delivers to the requesting inventory's branch address. */
  deliveryAddress?: Maybe<Address>;
  fulfillingInventory?: Maybe<InventoryLocation>;
  /** The inventory named to fulfill this request. Null for a stock request routed across distribution centers; see owningInventoryId. */
  fulfillingInventoryId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  lineItems: Array<DemandRequestLineItem>;
  notes?: Maybe<Scalars['String']>;
  owningInventory: InventoryLocation;
  /** The inventory that answers for this request: the fulfilling inventory when one was named, otherwise the main distribution center. */
  owningInventoryId: Scalars['ID'];
  requestedByUser: User;
  requestedByUserId: Scalars['ID'];
  requestingInventory: InventoryLocation;
  requestingInventoryId: Scalars['ID'];
  requestNumber: Scalars['BigInteger'];
  /** The process the request follows. STOCK is meant for distribution center fulfillment. */
  requestType: DemandRequestType;
  willCall: Scalars['Boolean'];
};

export type DemandRequestConnection = {
  __typename?: 'DemandRequestConnection';
  edges: Array<DemandRequestEdge>;
  pageInfo: PageInfo;
};

export type DemandRequestEdge = {
  __typename?: 'DemandRequestEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: DemandRequest;
};

export type DemandRequestLineItem = {
  __typename?: 'DemandRequestLineItem';
  allowSubstitution: Scalars['Boolean'];
  cancelledByUser?: Maybe<User>;
  /** ID of the user who cancelled this line item */
  cancelledByUserId?: Maybe<Scalars['ID']>;
  completedByUser?: Maybe<User>;
  /** ID of the user who completed this line item */
  completedByUserId?: Maybe<Scalars['ID']>;
  /** Date when this line item was cancelled */
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  /** Date when this line item was completed */
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  demandRequest: DemandRequest;
  demandRequestId: Scalars['ID'];
  fulfilledQuantity: Scalars['Int'];
  /** Optional notes from the fulfiller for this line item */
  fulfillerNotes?: Maybe<Scalars['String']>;
  fulfillingInventoryQuantityAvailable?: Maybe<Scalars['Int']>;
  /** The StorePart for this line item's product at the demand request's fulfilling inventory, or null if the product is not stocked there. Exposes both available quantity and bin location so callers can evaluate Inventory Item Master readiness without a second query. */
  fulfillingInventoryStorePart?: Maybe<StorePart>;
  fulfillmentOrderLineItems: Array<FulfillmentOrderLineItem>;
  inFlightFulfillmentOrderCount: Scalars['Int'];
  inFlightTransferOrderCount: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  lineItemId: Scalars['ID'];
  lineNotes?: Maybe<Scalars['String']>;
  neededBy?: Maybe<Scalars['Date']>;
  outstandingQuantity: Scalars['Int'];
  product: Part;
  productId: Scalars['ID'];
  quantityRequested: Scalars['Int'];
  sourcingArtifacts: Array<DemandRequestSourcingArtifact>;
  /** Current status of this line item */
  status?: Maybe<DemandRequestLineItemStatus>;
  targetId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<DemandRequestTargetType>;
  transferOrderLineItems: Array<TransferOrderLineItem>;
  willCall: Scalars['Boolean'];
};

/** Input type for creating demand request line items */
export type DemandRequestLineItemInput = {
  /** Whether substitutions are allowed for this specific line item */
  allowSubstitution?: InputMaybe<Scalars['Boolean']>;
  /** Optional notes for this line item (max 1000 chars) */
  lineNotes?: InputMaybe<Scalars['String']>;
  /** The date when this item is needed */
  neededBy?: InputMaybe<Scalars['Date']>;
  /** The ID of the product being requested */
  productId: Scalars['ID'];
  /** The quantity of the product requested */
  quantityRequested: Scalars['Int'];
  /** The identifier of the target (WO-12345, INV-67890, etc.) */
  targetId?: InputMaybe<Scalars['ID']>;
  /** The type of target (WORK_ORDER, INVOICE, ORDER) */
  targetType?: InputMaybe<DemandRequestTargetType>;
  /** Whether this is a will-call line item that the requester will pick up */
  willCall?: InputMaybe<Scalars['Boolean']>;
};

export enum DemandRequestLineItemStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type DemandRequestSourcingArtifact = FulfillmentOrderLineItem | TransferOrderLineItem;

export enum DemandRequestStatus {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Open = 'OPEN'
}

export enum DemandRequestTargetType {
  Invoice = 'INVOICE',
  Order = 'ORDER',
  WorkOrder = 'WORK_ORDER'
}

export enum DemandRequestType {
  Stock = 'STOCK'
}

export type DimensionsInput = {
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  unit: DimensionUom;
  width: Scalars['Decimal'];
};

export enum DimensionUom {
  Cm = 'CM',
  Ft = 'FT',
  In = 'IN'
}

export type District = NamedResourceEntity & {
  __typename?: 'District';
  company: Company;
  /** The company that this resource belongs to */
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  districtId: Scalars['ID'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EffectivePermissionGrant = {
  __typename?: 'EffectivePermissionGrant';
  permission: PermissionMeta;
  /** The concrete node the grant lands on. */
  resource: Resource;
  /** One entry per contributing policy. */
  sources: Array<GrantSource>;
};

export type EquipmentMake = {
  __typename?: 'EquipmentMake';
  deleted: Scalars['Boolean'];
  equipment_make_id: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  popular_equipment_make?: Maybe<Scalars['Boolean']>;
  popular_vehicle_make?: Maybe<Scalars['Boolean']>;
  sort_index?: Maybe<Scalars['Int']>;
};

export type EquipmentMakeConnection = {
  __typename?: 'EquipmentMakeConnection';
  edges: Array<EquipmentMakeEdge>;
  pageInfo: PageInfo;
};

export type EquipmentMakeEdge = {
  __typename?: 'EquipmentMakeEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: EquipmentMake;
};

export type EquipmentMakeFilter = {
  /** Substring match on equipment make name. */
  search?: InputMaybe<Scalars['String']>;
};

export type EquipmentModel = {
  __typename?: 'EquipmentModel';
  dateCreated: Scalars['ArrowField'];
  dateUpdated: Scalars['ArrowField'];
  deleted: Scalars['Boolean'];
  equipment_make_id: Scalars['Int'];
  equipment_model_id: Scalars['Int'];
  equipmentMake: EquipmentMake;
  equipmentMakeId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type EquipmentModelConnection = {
  __typename?: 'EquipmentModelConnection';
  edges: Array<EquipmentModelEdge>;
  pageInfo: PageInfo;
};

export type EquipmentModelEdge = {
  __typename?: 'EquipmentModelEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: EquipmentModel;
};

export type EquipmentModelFilter = {
  /** Filter models by their parent make IDs. */
  equipmentMakeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Substring match on equipment model name. */
  search?: InputMaybe<Scalars['String']>;
};

export type EsBranch = NamedResourceEntity & {
  __typename?: 'EsBranch';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type EsResource = NamedResourceEntity & {
  __typename?: 'ESResource';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum ExternalApplication {
  Shopify = 'SHOPIFY'
}

export type ExternalEntityMeta = {
  application: ExternalApplication;
  id: Scalars['ID'];
};

export type ExternalPartMeta = ExternalEntityMeta & {
  __typename?: 'ExternalPartMeta';
  application: ExternalApplication;
  id: Scalars['ID'];
};

export type ExternalStoreMeta = ExternalEntityMeta & {
  __typename?: 'ExternalStoreMeta';
  application: ExternalApplication;
  id: Scalars['ID'];
};

export type Fulfillment = {
  __typename?: 'Fulfillment';
  cartonNumber?: Maybe<Scalars['Int']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateShipped?: Maybe<Scalars['ArrowDateTime']>;
  id: Scalars['ID'];
  /** What went in this carton, including lines that only report a shortfall (quantityFulfilled 0). */
  lines: Array<FulfillmentLineItem>;
  pickOrderId?: Maybe<Scalars['ID']>;
  /** Numina's carton identifier. Null for a carton packed by hand, which is identified by pickOrderId and cartonNumber instead. */
  rdsCartonId?: Maybe<Scalars['String']>;
  systemTransferOrder?: Maybe<TransferOrder>;
  trackingNumber?: Maybe<Scalars['String']>;
};

export type FulfillmentLineItem = {
  __typename?: 'FulfillmentLineItem';
  dateCreated: Scalars['ArrowDateTime'];
  fulfillment: Fulfillment;
  fulfillmentOrderLineItem: FulfillmentOrderLineItem;
  id: Scalars['ID'];
  quantityFulfilled: Scalars['Int'];
  quantityUnfulfilled: Scalars['Int'];
};

export type FulfillmentOrder = {
  __typename?: 'FulfillmentOrder';
  cancellationFailed: Scalars['Boolean'];
  cancellationFailureMessage?: Maybe<Scalars['String']>;
  cancellationRequestedByUserId?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  contactEmail?: Maybe<Scalars['Email']>;
  contactPhone?: Maybe<Scalars['PhoneNumber']>;
  createdByUserId: Scalars['ID'];
  dateCancellationRequested?: Maybe<Scalars['ArrowDateTime']>;
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateNeededBy?: Maybe<Scalars['Date']>;
  dateSubmittedForFulfillment?: Maybe<Scalars['ArrowDateTime']>;
  dateUpdated: Scalars['ArrowDateTime'];
  /** The demand requests this order's line items were created for, oldest first. Empty for an order that did not come from one (e.g. Shopify). */
  demandRequests: Array<DemandRequest>;
  /** The destination in words, describing whatever `destinationKey` compares: a shipping address for anything shipped, a trailer quadrant for an MTT loadout. */
  destinationDescription: Scalars['String'];
  destinationInventory?: Maybe<InventoryLocation>;
  destinationInventoryId?: Maybe<Scalars['ID']>;
  /** An opaque, comparable rendering of where this order is bound. Two fulfillment orders may share a pick order exactly when their keys are equal, so a client can group a table of orders without reproducing the normalization behind it -- and without being able to disagree with the invariant that governs creation. */
  destinationKey: Scalars['String'];
  /** Get this fulfillment order's external application id (e.g. the Shopify order number). */
  externalOrderId?: Maybe<Scalars['ID']>;
  fulfillingInventory: InventoryLocation;
  fulfillingInventoryId: Scalars['ID'];
  fulfillmentType: FulfillmentType;
  id: Scalars['ID'];
  lineItems: Array<FulfillmentOrderLineItem>;
  mttId?: Maybe<Scalars['String']>;
  mttQuadrant?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orderNumber: Scalars['BigInteger'];
  /** Pick orders that have held this fulfillment order, oldest first. Unfiltered, this is the order's whole picking history. `isOpen: true` narrows it to runs still in progress, which is what stops the order joining another; a run that completed short leaves the remainder outstanding and pickable again. Deliberately not a status list: which statuses count as open is this service's to decide, and a client that spelled them out would answer wrongly the day one is added. */
  pickOrders: Array<PickOrder>;
  shippingAddress?: Maybe<Address>;
  sourceOriginatorId?: Maybe<Scalars['String']>;
  sourceOriginatorType?: Maybe<Scalars['String']>;
  status: FulfillmentOrderStatus;
};


export type FulfillmentOrderExternalOrderIdArgs = {
  app: ExternalApplication;
};


export type FulfillmentOrderPickOrdersArgs = {
  isOpen?: InputMaybe<Scalars['Boolean']>;
};

export type FulfillmentOrderConnection = {
  __typename?: 'FulfillmentOrderConnection';
  edges: Array<FulfillmentOrderEdge>;
  pageInfo: PageInfo;
  /** The total number of items matching the query, ignoring pagination. */
  totalCount: Scalars['Int'];
};

export type FulfillmentOrderEdge = {
  __typename?: 'FulfillmentOrderEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: FulfillmentOrder;
};

export type FulfillmentOrderLineItem = {
  __typename?: 'FulfillmentOrderLineItem';
  allocationTargetId?: Maybe<Scalars['ID']>;
  allocationTargetTypeId?: Maybe<Scalars['ID']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['ArrowDateTime'];
  demandRequestLineItem?: Maybe<DemandRequestLineItem>;
  demandRequestLineItemId?: Maybe<Scalars['ID']>;
  fulfillmentLineItems: Array<FulfillmentLineItem>;
  fulfillmentOrder: FulfillmentOrder;
  fulfillmentOrderId: Scalars['ID'];
  fulfillments: Array<Fulfillment>;
  id: Scalars['ID'];
  isFullyFulfilled: Scalars['Boolean'];
  product: Part;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  quantityFulfilled: Scalars['Int'];
  quantityRemaining: Scalars['Int'];
  sourceOriginatorId?: Maybe<Scalars['String']>;
  sourceOriginatorType?: Maybe<Scalars['String']>;
};

export enum FulfillmentOrderSortField {
  DateCompleted = 'DATE_COMPLETED',
  DateCreated = 'DATE_CREATED',
  DateSubmittedForFulfillment = 'DATE_SUBMITTED_FOR_FULFILLMENT',
  OrderNumber = 'ORDER_NUMBER',
  Status = 'STATUS'
}

export enum FulfillmentOrderStatus {
  CancellationRequested = 'CANCELLATION_REQUESTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  SubmittedForFulfillment = 'SUBMITTED_FOR_FULFILLMENT'
}

export enum FulfillmentType {
  DirectShipment = 'DIRECT_SHIPMENT',
  InventoryTransfer = 'INVENTORY_TRANSFER',
  MttLoadout = 'MTT_LOADOUT'
}

export type FullPartSearch = {
  __typename?: 'FullPartSearch';
  companyOwned: Array<Part>;
  masterList: Array<Part>;
};

export type GenerateResultPresignedUrl__Input = {
  /** Whether to download the original uploaded CSV or the failed-items CSV. */
  fileType: GlobalProductCatalogCsvFileType;
  /** The upload session ID. */
  sessionId: Scalars['ID'];
};

export type GenerateResultPresignedUrl__Result = IMutationResult & {
  __typename?: 'GenerateResultPresignedUrl__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  /** The presigned URL to retrieve the CSV file from. */
  url?: Maybe<Scalars['String']>;
};

export type GenerateUploadPresignedUrl__Input = {
  /** The unique name to use for the CSV file. This should be '[uuid].csv'. */
  csvFilename: Scalars['String'];
};

export type GenerateUploadPresignedUrl__Result = IMutationResult & {
  __typename?: 'GenerateUploadPresignedUrl__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  /** The presigned URL to upload the CSV file to. */
  url?: Maybe<Scalars['String']>;
};

export enum GlobalProductCatalogCsvFileType {
  FailedItems = 'FAILED_ITEMS',
  Uploaded = 'UPLOADED'
}

export type GlobalProductCatalogUpload = {
  __typename?: 'GlobalProductCatalogUpload';
  csvFileKey: Scalars['String'];
  failedItemsCsvKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manufacturer?: Maybe<Manufacturer>;
  manufacturerId: Scalars['ID'];
  progressMetadata?: Maybe<GpcuProgressMetadata>;
  status: GlobalProductCatalogUploadStatus;
  uploadedBy: User;
  uploadedById: Scalars['ID'];
  uploadType?: Maybe<GlobalProductCatalogUploadType>;
};

export type GlobalProductCatalogUploadConnection = {
  __typename?: 'GlobalProductCatalogUploadConnection';
  edges: Array<GlobalProductCatalogUploadEdge>;
  pageInfo: PageInfo;
};

export type GlobalProductCatalogUploadEdge = {
  __typename?: 'GlobalProductCatalogUploadEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: GlobalProductCatalogUpload;
};

export enum GlobalProductCatalogUploadStatus {
  Cancelled = 'CANCELLED',
  CompletedSuccessfully = 'COMPLETED_SUCCESSFULLY',
  CompletedWithFailures = 'COMPLETED_WITH_FAILURES',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING'
}

export enum GlobalProductCatalogUploadType {
  ProductCatalog = 'PRODUCT_CATALOG',
  ProductVendorPricing = 'PRODUCT_VENDOR_PRICING'
}

export type GoodProduct = Product & {
  __typename?: 'GoodProduct';
  /** @deprecated Use productCategory instead. */
  category?: Maybe<ProductCategory>;
  conversionUnit?: Maybe<UnitsOfMeasurementEnum>;
  dateArchived?: Maybe<Scalars['String']>;
  duplicateOf: Product;
  duplicates: Array<Maybe<Product>>;
  /** A single string of all identifiers concatenated in a consistent format. */
  formattedIdentifiers: Scalars['String'];
  hasActiveItemMaster: Scalars['Boolean'];
  id: Scalars['ID'];
  itemMaster?: Maybe<ItemMaster>;
  manufacturer?: Maybe<Manufacturer>;
  manufacturerNumber?: Maybe<Scalars['String']>;
  /** The manufacturer's suggested retail price of this product. */
  msrp?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  preferredVendor?: Maybe<Vendor>;
  preferredVendorPrice?: Maybe<Money>;
  productCategory?: Maybe<ProductCategory>;
  productClass?: Maybe<ProductClass>;
  productClassId?: Maybe<Scalars['ID']>;
  productType: ProductType;
  standardPrice?: Maybe<Money>;
  upc?: Maybe<Scalars['String']>;
  vendors: Array<Vendor>;
  /** The year in which this product was manufactured */
  year?: Maybe<Scalars['Int']>;
};

export type GpcuProgressMetadata = {
  __typename?: 'GPCUProgressMetadata';
  currentAttempt: Scalars['Int'];
  currentLine: Scalars['Int'];
  retries: Array<GpcuRetryAttempt>;
  startedAt: Scalars['String'];
  totalLines: Scalars['Int'];
};

export type GpcuRetryAttempt = {
  __typename?: 'GPCURetryAttempt';
  attempt: Scalars['Int'];
  lastRow: Scalars['String'];
  linesCompleted: Scalars['Int'];
};

export type GrantChange = {
  __typename?: 'GrantChange';
  group: Group;
  permission: PermissionMeta;
  resource: Resource;
};

export type GrantSource = {
  __typename?: 'GrantSource';
  group: Group;
  /** True when `rootResource` differs from the grant's resource. */
  inherited: Scalars['Boolean'];
  role: Role;
  /** The resource the contributing policy is attached to. */
  rootResource: Resource;
};

export type Group = {
  __typename?: 'Group';
  appliedPermissions: Array<UserPermission>;
  company: Company;
  companyId: Scalars['BigInteger'];
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  groupId: Scalars['BigInteger'];
  id: Scalars['Int'];
  name: Scalars['String'];
  policies: Array<Maybe<ResourcePolicy>>;
  spendingLimit?: Maybe<Scalars['Float']>;
  userIds: Array<Maybe<Scalars['Int']>>;
  /** A list of users that belong to this group. */
  users: Array<User>;
};

export type IMutationError = {
  message: Scalars['String'];
};

export type IMutationResult = {
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum IncrementOrDecrement {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT'
}

export type InitializeCompany__Input = {
  /** A list of IDs to assign to the Admin group of the company. These users will have all permissions */
  adminUserIds?: InputMaybe<Array<Scalars['ID']>>;
  companyId: Scalars['ID'];
  name: Scalars['String'];
};

export type InitializeCompany__Result = IMutationResult & {
  __typename?: 'InitializeCompany__Result';
  company?: Maybe<Company>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type InputTransactionItem = {
  /** How much each individual part costs */
  costPerItem: Scalars['Float'];
  itemStatus?: InputMaybe<ItemStatus>;
  partId: Scalars['Int'];
  /** The quantity of the part that was ordered */
  quantity: Scalars['Int'];
  quantityReceived?: InputMaybe<Scalars['Int']>;
};

export type InputUpdateTransactionItem = {
  itemStatus?: InputMaybe<ItemStatus>;
  /** Updates the quantity received */
  quantityReceived?: InputMaybe<Scalars['Int']>;
  transactionItemId: Scalars['Int'];
};

export type InventoryLocation = {
  __typename?: 'InventoryLocation';
  branch: EsBranch;
  branchId: Scalars['ID'];
  /** The branch from inventory's internal Branch context. Prefer this over the legacy `branch` field, which is resolved via the external ES API. */
  branchV2?: Maybe<BranchV2>;
  companyId: Scalars['ID'];
  defaultLocation: Scalars['Boolean'];
  id: Scalars['ID'];
  inventoryType?: Maybe<InventoryType>;
  isWarehouse: Scalars['Boolean'];
  name: Scalars['String'];
  numPutawayStations?: Maybe<Scalars['Int']>;
  /** Mini distribution centers whose served zip codes include this location's branch zip, ordered by id. Empty when none serve it. Not batched: select it for a single location, not across a list. */
  servingMiniDistributionCenters: Array<InventoryLocation>;
  /** How this location operates as a warehouse. Null when it is not one. */
  warehouse?: Maybe<Warehouse>;
  /**
   * The system that picks this warehouse's orders: NUMINA, or MANUAL for a mini-DC picked by hand. Null when the location is not a warehouse.
   * @deprecated Use warehouse.warehouseExecutionSystem instead.
   */
  warehouseExecutionSystem?: Maybe<WarehouseExecutionSystem>;
};

export type InventoryLocationConnection = {
  __typename?: 'InventoryLocationConnection';
  edges: Array<InventoryLocationEdge>;
  pageInfo: PageInfo;
};

export type InventoryLocationEdge = {
  __typename?: 'InventoryLocationEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: InventoryLocation;
};

export enum InventoryType {
  General = 'GENERAL',
  Rental = 'RENTAL'
}

export type Invoice = {
  __typename?: 'Invoice';
  invoice_id: Scalars['Int'];
  invoice_no: Scalars['String'];
  ordered_by_user?: Maybe<User>;
};

export type Item = {
  id: Scalars['ID'];
  inventoryLocation: InventoryLocation;
  itemType: ItemType;
  product: Product;
};

export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<ItemEdge>;
  pageInfo: PageInfo;
};

export type ItemEdge = {
  __typename?: 'ItemEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: Item;
};

/**
 * One movement of a single product in or out of one inventory location.
 *
 * An entry maps to a transaction item rather than a whole transaction: a
 * transaction can move several products at once and only the matching product
 * affects this item.
 */
export type ItemHistoryEntry = {
  __typename?: 'ItemHistoryEntry';
  costPerItem: Scalars['Float'];
  createdByUser: User;
  /** A free-form identifier recorded on the transaction (e.g. a PO or invoice number typed in by hand). */
  customId?: Maybe<Scalars['String']>;
  /** When the entry took effect: the transaction's completion date, its cancellation date for cancelled entries, or its creation date for a transfer that is still in transit, which has no timestamp for the moment it left. An in-transit entry therefore re-dates itself to the completion date once the transfer is received. */
  dateApplied: Scalars['ArrowDateTime'];
  id: Scalars['ID'];
  inventoryLocation: InventoryLocation;
  itemStatus?: Maybe<ItemStatus>;
  memo?: Maybe<Scalars['String']>;
  modifiedByUser: User;
  product: Product;
  /** The signed quantity this entry applied to the inventory location: negative when it left, positive when it arrived. A transfer that is still in transit reports the full quantity that left the sending location. A CANCELLED entry reports the signed quantity that was cancelled, but that quantity never (or no longer) moved inventory — render cancelled entries as no actual change. */
  quantityChange: Scalars['Int'];
  quantityOrdered: Scalars['Int'];
  quantityReceived?: Maybe<Scalars['Int']>;
  /** The real entity behind this entry, when this service can resolve it. */
  source?: Maybe<ItemHistorySource>;
  /** The raw identifier of the entity this entry was recorded against, for the cases where `source` cannot be resolved. */
  sourceId?: Maybe<Scalars['ID']>;
  /** What kind of entity this entry was recorded against. Set even when `source` cannot be resolved. */
  sourceType?: Maybe<ItemHistorySourceType>;
  transaction: Transaction;
  transactionId: Scalars['Int'];
  transactionStatus: TransactionStatus;
  transactionType: TransactionType;
};

export type ItemHistoryEntryConnection = {
  __typename?: 'ItemHistoryEntryConnection';
  edges: Array<ItemHistoryEntryEdge>;
  pageInfo: PageInfo;
  /** The total number of items matching the query, ignoring pagination. */
  totalCount: Scalars['Int'];
};

export type ItemHistoryEntryEdge = {
  __typename?: 'ItemHistoryEntryEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: ItemHistoryEntry;
};

export type ItemHistorySource = Asset | CreditPurchaseReference | InventoryLocation | ManualAdjustment | ManualTransferOrder | OrderReference | Provider | PurchaseOrder | RetailSaleReference | StorePart | SystemTransferOrder | WorkOrderReference;

/**
 * The kind of real-world entity an item history entry was recorded against.
 *
 * This is always populated for entries that point at something, even when the
 * entity itself cannot be resolved into a `source` object.
 */
export enum ItemHistorySourceType {
  Asset = 'ASSET',
  Conversion = 'CONVERSION',
  CreditPurchase = 'CREDIT_PURCHASE',
  InventoryLocation = 'INVENTORY_LOCATION',
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  Merge = 'MERGE',
  Order = 'ORDER',
  Provider = 'PROVIDER',
  PurchaseOrder = 'PURCHASE_ORDER',
  RetailSale = 'RETAIL_SALE',
  TransferOrder = 'TRANSFER_ORDER',
  WorkOrder = 'WORK_ORDER'
}

export type ItemMaster = {
  __typename?: 'ItemMaster';
  baseVariant?: Maybe<ItemMasterVariant>;
  createdByUserId: Scalars['ID'];
  dateCreated: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['ArrowDateTime'];
  equipmentMakeId?: Maybe<Scalars['ID']>;
  equipmentModelId?: Maybe<Scalars['ID']>;
  flammable: Scalars['Boolean'];
  fragile: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHazmat: Scalars['Boolean'];
  lithiumIonBattery: Scalars['Boolean'];
  numinaSerialType: NuminaSerialType;
  productId: Scalars['ID'];
  status: ItemMasterStatus;
  updatedByUserId: Scalars['ID'];
  variants: Array<ItemMasterVariant>;
};

export type ItemMasterConnection = {
  __typename?: 'ItemMasterConnection';
  edges: Array<ItemMasterEdge>;
  pageInfo: PageInfo;
  /** The total number of items matching the query, ignoring pagination. */
  totalCount: Scalars['Int'];
};

export type ItemMasterDimensions = {
  __typename?: 'ItemMasterDimensions';
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  unit: DimensionUom;
  width: Scalars['Decimal'];
};

export type ItemMasterEdge = {
  __typename?: 'ItemMasterEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: ItemMaster;
};

export enum ItemMasterStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type ItemMasterVariant = {
  __typename?: 'ItemMasterVariant';
  conversionRate: Scalars['Int'];
  createdByUserId: Scalars['ID'];
  dateCreated: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['ArrowDateTime'];
  dimensions?: Maybe<ItemMasterDimensions>;
  freightClass?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBase: Scalars['Boolean'];
  isPolybagEligible: Scalars['Boolean'];
  itemMasterId: Scalars['ID'];
  nmfc?: Maybe<Scalars['String']>;
  product: Product;
  productId: Scalars['ID'];
  shippedInOriginalContainer: Scalars['Boolean'];
  siocQuantity?: Maybe<Scalars['Int']>;
  status: ItemMasterVariantStatus;
  uom: ItemMasterVariantUom;
  updatedByUserId: Scalars['ID'];
  weight?: Maybe<ItemMasterWeight>;
};

export enum ItemMasterVariantStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT'
}

export enum ItemMasterVariantUom {
  Case = 'CASE',
  Each = 'EACH',
  Pallet = 'PALLET'
}

export type ItemMasterWeight = {
  __typename?: 'ItemMasterWeight';
  amount: Scalars['Decimal'];
  unit: WeightUnit;
};

export type ItemRental = {
  __typename?: 'ItemRental';
  /** the possibly null date when this rental should end */
  endDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  quantity?: Maybe<Scalars['Int']>;
  rentalStatus?: Maybe<RentalStatus>;
  /** the possibly null date when this rental should start */
  startDate?: Maybe<Scalars['String']>;
};

export type ItemSort = {
  direction: SortDirection;
  field: ItemSortField;
};

export enum ItemSortField {
  AvailableQuantity = 'availableQuantity'
}

export enum ItemStatus {
  BackOrdered = 'BACK_ORDERED',
  Damaged = 'DAMAGED',
  Ordered = 'ORDERED',
  Received = 'RECEIVED',
  Wrong = 'WRONG'
}

export enum ItemType {
  NonSerialized = 'NON_SERIALIZED',
  Serialized = 'SERIALIZED'
}

export type LastTimePriceWasUpdated = {
  __typename?: 'LastTimePriceWasUpdated';
  cost: Money;
  /** The date that this item's cost was updated. */
  date: Scalars['ArrowField'];
};

export type ManualAdjustment = Node & {
  __typename?: 'ManualAdjustment';
  company: Company;
  /** Which company this manual adjustment is for. */
  companyId: Scalars['BigInteger'];
  /** The user who created this object. */
  createdById: Scalars['BigInteger'];
  createdByUser: User;
  dateCreated?: Maybe<Scalars['ArrowField']>;
  dateUpdated?: Maybe<Scalars['ArrowField']>;
  id: Scalars['ID'];
  inventoryLocation?: Maybe<InventoryLocation>;
  item?: Maybe<StorePart>;
  manualAdjustmentId: Scalars['BigInteger'];
  memo?: Maybe<Scalars['String']>;
  /** The user who last modified this object. */
  modifiedById: Scalars['BigInteger'];
  modifiedByUser: User;
  product?: Maybe<Part>;
  purchaseId?: Maybe<Scalars['ID']>;
  purchaseOrderId?: Maybe<Scalars['ID']>;
  quantityChange: Scalars['Int'];
  reason?: Maybe<ManualAdjustmentReasonType>;
  reasonDisplay?: Maybe<Scalars['String']>;
  /** The reason for this manual adjustment. */
  reasonId?: Maybe<Scalars['Int']>;
  transactionItem?: Maybe<TransactionItem>;
  /** The transaction that this manual adjustment data is connected with */
  transactionItemId?: Maybe<Scalars['BigInteger']>;
  vendorId?: Maybe<Scalars['ID']>;
};

export type ManualAdjustmentConnection = {
  __typename?: 'ManualAdjustmentConnection';
  edges: Array<ManualAdjustmentEdge>;
  pageInfo: PageInfo;
};

export type ManualAdjustmentEdge = {
  __typename?: 'ManualAdjustmentEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: ManualAdjustment;
};

export enum ManualAdjustmentOrderBy {
  DateCreated = 'DATE_CREATED',
  DateUpdated = 'DATE_UPDATED',
  Id = 'ID'
}

export type ManualAdjustmentReason = Node & {
  __typename?: 'ManualAdjustmentReason';
  allowDecrement?: Maybe<Scalars['Boolean']>;
  allowIncrement?: Maybe<Scalars['Boolean']>;
  /** How to handle creating/updating cost related to the adjustment */
  costConfigId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manualAdjustmentReasonId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export enum ManualAdjustmentReasonType {
  ConversionError = 'CONVERSION_ERROR',
  CreditCardPurchase = 'CREDIT_CARD_PURCHASE',
  CustomerReturn = 'CUSTOMER_RETURN',
  Damaged = 'DAMAGED',
  EcommercePartsReturn = 'ECOMMERCE_PARTS_RETURN',
  EcommercePartsSale = 'ECOMMERCE_PARTS_SALE',
  ExternalPo = 'EXTERNAL_PO',
  FoundItems = 'FOUND_ITEMS',
  Missing = 'MISSING',
  Obsolete = 'OBSOLETE',
  RefurbishedPart = 'REFURBISHED_PART',
  ReturnToVendor = 'RETURN_TO_VENDOR',
  Stock = 'STOCK',
  TelematicsPartsReturn = 'TELEMATICS_PARTS_RETURN'
}

export type ManualTransferOrder = TransferOrder & {
  __typename?: 'ManualTransferOrder';
  approver?: Maybe<User>;
  approverId?: Maybe<Scalars['ID']>;
  approverNote?: Maybe<Scalars['String']>;
  /** TransactionGroup holding this transfer order's deferred asset transactions; null until an asset leg is started. */
  assetTransactionGroupId?: Maybe<Scalars['ID']>;
  /** Lifecycle of the deferred asset leg of an MTT load/unload; null when no assets are involved. */
  assetTransferStatus?: Maybe<AssetTransferStatus>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancelledById?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  dateApproved?: Maybe<Scalars['ArrowDateTime']>;
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateRejected?: Maybe<Scalars['ArrowDateTime']>;
  dateShipped?: Maybe<Scalars['ArrowDateTime']>;
  dateUpdated: Scalars['ArrowDateTime'];
  demandRequest?: Maybe<DemandRequest>;
  fromInventoryId: Scalars['ID'];
  fromStore?: Maybe<InventoryLocation>;
  id: Scalars['ID'];
  isClosed: Scalars['Boolean'];
  lineItems?: Maybe<Array<TransferOrderLineItem>>;
  receipts: Array<TransferOrderReceipt>;
  requester: User;
  requesterId: Scalars['ID'];
  requesterNote?: Maybe<Scalars['String']>;
  status: TransferOrderStatus;
  toInventoryId: Scalars['ID'];
  toStore?: Maybe<InventoryLocation>;
  trackingNumber?: Maybe<Scalars['String']>;
  transferOrderType: TransferOrderType;
};

export type Manufacturer = {
  __typename?: 'Manufacturer';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MarkPartAsGloballyVerified__Input = {
  partId: Scalars['BigInteger'];
};

export type MarkPartAsGloballyVerified__Result = IMutationResult & {
  __typename?: 'MarkPartAsGloballyVerified__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  part?: Maybe<Part>;
  success: Scalars['Boolean'];
};

export type MarkProviderAsGloballyVerified__Input = {
  providerId: Scalars['BigInteger'];
};

export type MarkProviderAsGloballyVerified__Result = IMutationResult & {
  __typename?: 'MarkProviderAsGloballyVerified__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  provider?: Maybe<Provider>;
  success: Scalars['Boolean'];
};

export type MergeParts__Result = IMutationResult & {
  __typename?: 'MergeParts__Result';
  duplicatePart?: Maybe<Part>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  goodPart?: Maybe<Part>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MergeProducts__Result = IMutationResult & {
  __typename?: 'MergeProducts__Result';
  duplicateProduct?: Maybe<Product>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  goodProduct?: Maybe<Product>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MergeProviders__Result = IMutationResult & {
  __typename?: 'MergeProviders__Result';
  duplicateProvider?: Maybe<Provider>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  goodProvider?: Maybe<Provider>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MobileToolTrailerInventoryItem = Asset | StorePart;

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Decimal'];
  currencyCode: CurrencyCode;
};

export type MoveInventoryLocationTo__Result = IMutationResult & {
  __typename?: 'MoveInventoryLocationTo__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The inventory location at the new location */
  inventoryLocation?: Maybe<InventoryLocation>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type MoveResource__Input = {
  /** An `impactFingerprint` from a prior resourceMoveImpact call. If given, the move is rejected when the impact has materially changed since it was previewed. */
  impactFingerprint?: InputMaybe<Scalars['String']>;
  newParentId: Scalars['ID'];
  /** The region, district, or branch to move. */
  resourceId: Scalars['ID'];
};

export type MoveResource__Result = IMutationResult & {
  __typename?: 'MoveResource__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The moved resource. */
  resource?: Maybe<Resource>;
  success: Scalars['Boolean'];
};

/** The main Mutations object */
export type Mutation = {
  __typename?: 'Mutation';
  /** Activate a DRAFT Item Master variant once its dimensions and weight are complete. */
  activateItemMasterVariant?: Maybe<ActivateItemMasterVariantResult>;
  /** Fold additional same-destination fulfillment orders into an open pick order */
  addFulfillmentOrdersToPickOrder?: Maybe<AddFulfillmentOrdersToPickOrderResult>;
  /** Add a new non-base variant to an existing Item Master. */
  addItemMasterVariant?: Maybe<AddItemMasterVariant__Result>;
  /** Creates a permissions policy giving the given role of permissions to the given resource for the given group. */
  addPolicyToGroup?: Maybe<AddPolicyToGroup__Result>;
  /** Creates or updates a product-vendor relationship. */
  addProductToVendorCatalog?: Maybe<AddProductToVendorCatalogResult>;
  /** Adds a new pricing record to a product-vendor relationship. */
  addProductVendorPricing?: Maybe<AddProductVendorPricingResult>;
  /** Adjust a reservation by a specified amount */
  adjustReservationQuantity: AdjustReservationQuantity__Result;
  /** Approve a transfer order that was created manually */
  approveTransferOrder?: Maybe<ApproveTransferOrderResult>;
  /** Archive (soft-delete) an inventory location. */
  archiveInventoryLocation: ArchiveInventoryLocation__Result;
  /** Archive (soft-delete) a store. */
  archiveStore: ArchiveStore__Result;
  /** Archives the given StorePart, essentially marking it as untracked. */
  archiveStorePart?: Maybe<ArchiveStorePart__Result>;
  /** Assign a demand request to a user */
  assignDemandRequest?: Maybe<AssignDemandRequestResult>;
  /** Assigns the given permissions to the given role ID */
  assignPermissionsToRole?: Maybe<AssignPermissionsToRole__Result>;
  /** Assign a pick order to the person who will pick it */
  assignPickOrder?: Maybe<AssignPickOrderResult>;
  /** Assigns the given user IDs to the given group ID */
  assignUsersToGroup?: Maybe<AssignUsersToGroup__Result>;
  /** Allows for performing bulk operations across multiple different actions. */
  batchOperations?: Maybe<BatchOperations__Result>;
  /** Update fulfiller notes on multiple line items */
  bulkUpdateDemandRequestLineItemFulfillerNotes?: Maybe<BulkUpdateDemandRequestLineItemFulfillerNotesResult>;
  /** Mark a demand request as cancelled */
  cancelDemandRequest?: Maybe<CancelDemandRequestResult>;
  /** Mark a demand request line item as cancelled */
  cancelDemandRequestLineItem?: Maybe<CancelDemandRequestLineItemResult>;
  /** Mark multiple demand request line items as cancelled */
  cancelDemandRequestLineItems?: Maybe<CancelDemandRequestLineItemsResult>;
  /** Cancel an in-progress product upload session. */
  cancelMultiManufacturerProductUpload?: Maybe<CancelMultiManufacturerProductUpload__Result>;
  /** Cancel an open pick order */
  cancelPickOrder?: Maybe<CancelPickOrderResult>;
  /** Cancel an in-progress preferred vendor pricing upload session. */
  cancelPreferredVendorPricingUpload?: Maybe<CancelPreferredVendorPricingUpload__Result>;
  /** Cancel an existing reservation */
  cancelReservation: CancelReservation__Result;
  /** Moves the transaction to CANCELLED. */
  cancelTransaction?: Maybe<Transaction>;
  /** Cancel a transfer order, returning unreceived inventory from outgoing back to available */
  cancelTransferOrder?: Maybe<CancelTransferOrderResult>;
  /** Cancel a single transfer order line item, releasing outstanding outgoing inventory back to available */
  cancelTransferOrderLineItem?: Maybe<CancelTransferOrderLineItemResult>;
  /** Mark a demand request as completed */
  completeDemandRequest?: Maybe<CompleteDemandRequestResult>;
  /** Mark a demand request line item as completed */
  completeDemandRequestLineItem?: Maybe<CompleteDemandRequestLineItemResult>;
  /** Mark multiple demand request line items as completed */
  completeDemandRequestLineItems?: Maybe<CompleteDemandRequestLineItemsResult>;
  /** Turn the picker's packed cartons into one Fulfillment per carton */
  completePickOrder?: Maybe<CompletePickOrderResult>;
  /** Moves the transaction to COMPLETED. */
  completeTransaction?: Maybe<Transaction>;
  /** Converts any number of parts from one type to any number of another within an inventory location's inventory. Typical usage is for one-to-many conversions, e.g. converting 1 box of 100 oil (1 part) filters into 100 oil filters (100 parts). */
  convertItems?: Maybe<ConvertItems_Result>;
  /** Converts parts from one type to another within a inventory locations's inventory. Typical usage of part conversion would be e.g. ordering Genie ABC, but it comes in a Spicer 123 box. This would allow for converting the Genie ABC parts in the inventory locations's inventory to Spicer 123 parts. */
  convertParts?: Maybe<ConvertParts__Result>;
  /** Creates a new Branch. */
  createBranch: CreateBranch__Result;
  /** Create a new demand request with line items */
  createDemandRequest?: Maybe<CreateDemandRequestResult>;
  /** Creates a district whose parent must be a region or the company resource. */
  createDistrict?: Maybe<CreateDistrict__Result>;
  /** Create a new fulfillment order with line items */
  createFulfillmentOrder?: Maybe<CreateFulfillmentOrderResult>;
  /** Creates a group for holding users. Permissions are assigned to the group via a ResourcePolicy which is a mapping of Role (set of permissions) to a particular Resource. */
  createGroup?: Maybe<CreateGroup__Result>;
  /** Creates a new inventory location. */
  createInventoryLocation: CreateInventoryLocation__Result;
  /** Create a new Item Master for an existing base product. */
  createItemMaster?: Maybe<CreateItemMasterResult>;
  /** Creates a manual adjustment for given inventory location and provided product info along with reason. */
  createManualAdjustment?: Maybe<CreateManualAdjustment__Result>;
  /** Create a new manual transfer order with line items */
  createManualTransferOrder?: Maybe<CreateManualTransferOrderResult>;
  /** Creates a new NamedStore as a child of the given StoreInterface ID. */
  createNamedStoreAsChildOf: CreateNamedStoreAsChildOf__Result;
  /** Creates a new reservation of parts for a specific store/target */
  createOrUpdateReservation: CreateOrUpdateReservation__Result;
  /** Creates a part for the given company. Only one part in a company can refer to a given provider part number. A new provider part number will be created if it does not exist. One of compatible_with, description, or part_type_id is required to specify what part type will be associated to the part. Passing description will result in a new part type being created. */
  createPart?: Maybe<Part>;
  /** Open a hand-picking run over one or more same-destination fulfillment orders at a distribution center with no warehouse execution system */
  createPickOrder?: Maybe<CreatePickOrderResult>;
  /** Creates a product for the given company. Only one product in a company can refer to a given manufacturer number. A new manufacturer number will be created if it does not exist. One of name, or product_type_id is required to specify what product type will be associated to the product. */
  createProduct?: Maybe<CreateProduct__Result>;
  /** Creates a category for grouping products */
  createProductCategory?: Maybe<CreateProductCategory__Result>;
  /** Creates a product class. */
  createProductClass?: Maybe<CreateProductClass__Result>;
  /** Create a new product list with items */
  createProductList?: Maybe<CreateProductListResult>;
  /** Creates a provider with the given name */
  createProvider?: Maybe<Provider>;
  /** Create a new put-away order with line items */
  createPutAwayOrder?: Maybe<CreatePutAwayOrderResult>;
  /** Creates a region whose parent must be the company resource. */
  createRegion?: Maybe<CreateRegion__Result>;
  /** Creates a role for the given company. Defaults to the current user's company. */
  createRole?: Maybe<CreateRole__Result>;
  /** Begin tracking a product at an inventory location. If the product was previously archived at this location, it will be revived with the supplied values. */
  createStorePart?: Maybe<CreateStorePart__Result>;
  /** Creates a parts-transfer transaction. This defaults to the PENDING status which acts like a shopping cart. TransactionItems can be added at time of creation or one-by-one with the CreateTransactionItem mutation. Once all items are added to the cart, submit the transaction by using the submitTransaction mutation. To approve the submitted transaction, process the transaction by using the processTransaction mutation. Finally, once all parts have been successfully transferred, complete the transaction by using the completeTransaction mutation. At any point, a transaction can be cancelled with the cancelTransaction mutation. If cancelled, all changes will be rolled back to their original state. Note that parts are not deducted from a store until the transaction has started PROCESSING. */
  createTransaction?: Maybe<Transaction>;
  /** Add a quantity of a specific part to a transaction defaulting to ORDERED status. */
  createTransactionItem?: Maybe<TransactionItem>;
  /** Creates a weighted average cost snapshot override */
  createWeightedAverageCostSnapshotOverride: CreateWeightedAverageCostSnapshot__Result;
  /** Deletes a district. Refuses if it has children or attached policies. */
  deleteDistrict?: Maybe<DeleteDistrict__Result>;
  /** Remove a group from the system. */
  deleteGroup?: Maybe<DeleteGroup__Result>;
  /** Hard-deletes a product-vendor pricing record. */
  deleteProductVendorPricing?: Maybe<DeleteProductVendorPricingResult>;
  /** Deletes a region. Refuses if it has children or attached policies. */
  deleteRegion?: Maybe<DeleteRegion__Result>;
  /** Deletes the given role. */
  deleteRole?: Maybe<DeleteRole__Result>;
  /** Deletes the given user preference. */
  deleteUserPreference: DeleteUserPreference__Result;
  /** Generate a presigned URL for an existing result CSV file. */
  generateResultPresignedUrl: GenerateResultPresignedUrl__Result;
  /** Generate a presigned URL for uploading a CSV file. */
  generateUploadPresignedUrl: GenerateUploadPresignedUrl__Result;
  /** Initializes an existing Track company into the inventory system. */
  initializeCompany?: Maybe<InitializeCompany__Result>;
  /** Marks the given part as verified to be used across all companies known to the system. */
  markPartAsGloballyVerified: MarkPartAsGloballyVerified__Result;
  /** Marks the given provider as verified to be used across all companies known to the system. */
  markProviderAsGloballyVerified: MarkProviderAsGloballyVerified__Result;
  /** Merges the duplicate part into the good part and archives the duplicate part. */
  mergeParts?: Maybe<MergeParts__Result>;
  /** Merges the duplicate product into the good product and archives the duplicate product. */
  mergeProducts?: Maybe<MergeProducts__Result>;
  /** Merges the duplicate provider into good provider. This also effectively merges all duplicate provider parts into the good provider parts, as well as all store parts that use the duplicate provider parts. */
  mergeProviders?: Maybe<MergeProviders__Result>;
  /** Move inventory location from one branch to another. */
  moveInventoryLocationTo: MoveInventoryLocationTo__Result;
  /** Moves a region, district, or branch to a new parent. Stores cannot be moved here; use updateStore instead. */
  moveResource?: Maybe<MoveResource__Result>;
  /** Moves the transaction to PROCESSING. */
  processTransaction?: Maybe<Transaction>;
  /** Update an inventory location to be the default for the branch, replacing the previous default */
  promoteInventoryLocationToDefault: UpdateInventoryLocation__Result;
  /** Update a store to become a parent store. */
  promoteStoreToParent: UpdateStore__Result;
  /** Receive line items on a transfer order */
  receiveTransferOrderLineItems?: Maybe<ReceiveTransferOrderLineItemsResult>;
  /** Record absolute picked counts as the picker works; safe to call repeatedly */
  recordPickedQuantities?: Maybe<RecordPickedQuantitiesResult>;
  /** Reject a transfer order that was created manually */
  rejectTransferOrder?: Maybe<RejectTransferOrderResult>;
  /** Removes the given permissions from the given role ID */
  removePermissionsFromRole?: Maybe<RemovePermissionsFromRole__Result>;
  /** Removes the given policy from its group. */
  removePolicyFromGroup?: Maybe<RemoveResourcePolicyFromGroup__Result>;
  /** Soft-deletes a product-vendor relationship. Pricing records remain intact. */
  removeProductFromVendorCatalog?: Maybe<RemoveProductFromVendorCatalogResult>;
  /** Removes the given user IDs from the given group ID */
  removeUsersFromGroup?: Maybe<RemoveUserFromGroup__Result>;
  /** Takes parts off rent and marks them as sold for the given store/branch. This is effectively a shortcut of calling rentalToStore() and storeToRentalRetailSale(), but has the added benefit of adding both transactions to the same TransactionGroup. Transaction status is COMPLETED for both. */
  rentalToRentalRetailSale?: Maybe<RentalToRentalRetailSale__Result>;
  /** Create a rental to store transaction with optional purchase */
  rentalToStore?: Maybe<RentalToStore__Result>;
  /** Returns parts to the store and/or marks them as sold for the given store/branch. This is effectively a shortcut of calling rentalToStore() and rentalToRentalRetailSale(), but has the added benefit of adding both transactions to the same TransactionGroup. Transaction status is COMPLETED for both. */
  rentalToStoreAndRetailSale?: Maybe<RentalToStoreAndRetailSale__Result>;
  /** Reopen a completed demand request */
  reopenDemandRequest?: Maybe<ReopenDemandRequestResult>;
  /** Reopen a completed demand request line item */
  reopenDemandRequestLineItem?: Maybe<ReopenDemandRequestLineItemResult>;
  /** Reopen multiple demand request line items */
  reopenDemandRequestLineItems?: Maybe<ReopenDemandRequestLineItemsResult>;
  /** Request async cancellation of a fulfillment order via Numina */
  requestFulfillmentOrderCancellation?: Maybe<RequestFulfillmentOrderCancellationResult>;
  /** Reserve multiple inventory items in bulk with partial fulfillment support */
  reserveInventoryItems: ReserveInventoryItemsResult;
  /** Marks a vendor as the preferred vendor for a product. Auto-unsets any previously preferred vendor. */
  setPreferredVendor?: Maybe<SetPreferredVendorResult>;
  /** Start a multi-manufacturer product upload session. */
  startMultiManufacturerProductUpload?: Maybe<StartMultiManufacturerProductUpload__Result>;
  /** Create a store to rental transaction. Default transaction status is COMPLETED. */
  storeToRental?: Maybe<StoreToRental__Result>;
  /** Marks the give parts as sold from a rental and removes them from inventory. Note that rentalToStore should have been called first in order to return the given parts back to the store before this is called to remove them from the store. Default transaction status is COMPLETED. */
  storeToRentalRetailSale?: Maybe<StoreToRentalRetailSale__Result>;
  /** Moves the transaction to SUBMITTED. */
  submitTransaction?: Maybe<Transaction>;
  /** Atomically empty a Mobile Tool Trailer back into a Distribution Center */
  unloadMobileToolTrailer?: Maybe<UnloadMobileToolTrailerResult>;
  /** Update fulfiller notes on a line item */
  updateDemandRequestLineItemFulfillerNotes?: Maybe<UpdateDemandRequestLineItemFulfillerNotesResult>;
  /** Updates a district's name. */
  updateDistrict?: Maybe<UpdateDistrict__Result>;
  /** Updates a group's information. */
  updateGroup?: Maybe<UpdateGroup__Result>;
  /** Update an inventory location's information. */
  updateInventoryLocation: UpdateInventoryLocation__Result;
  /** Update product-level fields and/or variants on an existing Item Master. */
  updateItemMaster?: Maybe<UpdateItemMasterResult>;
  /** Update physical attributes on an existing Item Master variant. */
  updateItemMasterVariant?: Maybe<UpdateItemMasterVariantResult>;
  /** Updates a part for the given company. Only one part in a company can refer to a given provider part number. A new provider part number will be created if it does not exist. One of compatible_with, description, or part_type_id will be used to specify what part type will be associated to the part. Passing description will result in a new part type being created. */
  updatePart?: Maybe<Part>;
  /** Updates a product for the given company. Only one part in a company can refer to a given manufacturer number. A new manufacturer number will be created if it does not exist. One of name, or product_type_id will be used to specify what product type will be associated to the product. */
  updateProduct?: Maybe<UpdateProduct__Result>;
  /** Update the given category with the given attribute updates. */
  updateProductCategory?: Maybe<UpdateProductCategory__Result>;
  /** Updates a product class. */
  updateProductClass?: Maybe<UpdateProductClass__Result>;
  /** Updates an existing product-vendor pricing record by ID. */
  updateProductVendorPricing?: Maybe<UpdateProductVendorPricingResult>;
  /** Updates the given provider with the given name */
  updateProvider?: Maybe<Provider>;
  /** Updates a region's name. */
  updateRegion?: Maybe<UpdateRegion__Result>;
  /** Update the given role with the given attributes. */
  updateRole?: Maybe<UpdateRole__Result>;
  /** Update a store's information. */
  updateStore: UpdateStore__Result;
  /** Updates the given StorePart with the given fields values. */
  updateStorePart?: Maybe<UpdateStorePart__Result>;
  /** Update a transaction item. Note that the costPerItem and the quantityOrdered cannot be updated once the Transaction has been submitted. */
  updateTransactionItem?: Maybe<TransactionItem>;
  /** Create or update the given user preference with the given key value pair. */
  upsertUserPreference: UpsertUserPreference__Result;
};


/** The main Mutations object */
export type MutationActivateItemMasterVariantArgs = {
  input: ActivateItemMasterVariantInput;
};


/** The main Mutations object */
export type MutationAddFulfillmentOrdersToPickOrderArgs = {
  input: AddFulfillmentOrdersToPickOrderInput;
};


/** The main Mutations object */
export type MutationAddItemMasterVariantArgs = {
  input: AddItemMasterVariantInput;
};


/** The main Mutations object */
export type MutationAddPolicyToGroupArgs = {
  groupId: Scalars['Int'];
  resourceId: Scalars['Int'];
  roleId: Scalars['Int'];
};


/** The main Mutations object */
export type MutationAddProductToVendorCatalogArgs = {
  input: AddProductToVendorCatalogInput;
};


/** The main Mutations object */
export type MutationAddProductVendorPricingArgs = {
  input: AddProductVendorPricingInput;
};


/** The main Mutations object */
export type MutationAdjustReservationQuantityArgs = {
  quantityDifference: Scalars['Int'];
  reservationId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationApproveTransferOrderArgs = {
  input: ApproveTransferOrderInput;
};


/** The main Mutations object */
export type MutationArchiveInventoryLocationArgs = {
  inventoryLocationId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationArchiveStoreArgs = {
  storeId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationArchiveStorePartArgs = {
  storePartId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationAssignDemandRequestArgs = {
  input: AssignDemandRequestInput;
};


/** The main Mutations object */
export type MutationAssignPermissionsToRoleArgs = {
  permissions: Array<Permission>;
  roleId: Scalars['Int'];
};


/** The main Mutations object */
export type MutationAssignPickOrderArgs = {
  input: AssignPickOrderInput;
};


/** The main Mutations object */
export type MutationAssignUsersToGroupArgs = {
  groupId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};


/** The main Mutations object */
export type MutationBatchOperationsArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  data: BatchOperations__Data;
};


/** The main Mutations object */
export type MutationBulkUpdateDemandRequestLineItemFulfillerNotesArgs = {
  input: BulkUpdateDemandRequestLineItemFulfillerNotesInput;
};


/** The main Mutations object */
export type MutationCancelDemandRequestArgs = {
  input: CancelDemandRequestInput;
};


/** The main Mutations object */
export type MutationCancelDemandRequestLineItemArgs = {
  input: CancelDemandRequestLineItemInput;
};


/** The main Mutations object */
export type MutationCancelDemandRequestLineItemsArgs = {
  input: CancelDemandRequestLineItemsInput;
};


/** The main Mutations object */
export type MutationCancelMultiManufacturerProductUploadArgs = {
  input: CancelMultiManufacturerProductUpload__Input;
};


/** The main Mutations object */
export type MutationCancelPickOrderArgs = {
  input: CancelPickOrderInput;
};


/** The main Mutations object */
export type MutationCancelPreferredVendorPricingUploadArgs = {
  input: CancelPreferredVendorPricingUpload__Input;
};


/** The main Mutations object */
export type MutationCancelReservationArgs = {
  reservationId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationCancelTransactionArgs = {
  transactionId: Scalars['Int'];
  transactionItems?: InputMaybe<Array<InputUpdateTransactionItem>>;
};


/** The main Mutations object */
export type MutationCancelTransferOrderArgs = {
  input: CancelTransferOrderInput;
};


/** The main Mutations object */
export type MutationCancelTransferOrderLineItemArgs = {
  input: CancelTransferOrderLineItemInput;
};


/** The main Mutations object */
export type MutationCompleteDemandRequestArgs = {
  input: CompleteDemandRequestInput;
};


/** The main Mutations object */
export type MutationCompleteDemandRequestLineItemArgs = {
  input: CompleteDemandRequestLineItemInput;
};


/** The main Mutations object */
export type MutationCompleteDemandRequestLineItemsArgs = {
  input: CompleteDemandRequestLineItemsInput;
};


/** The main Mutations object */
export type MutationCompletePickOrderArgs = {
  input: CompletePickOrderInput;
};


/** The main Mutations object */
export type MutationCompleteTransactionArgs = {
  transactionId: Scalars['Int'];
  transactionItems?: InputMaybe<Array<InputUpdateTransactionItem>>;
};


/** The main Mutations object */
export type MutationConvertItemsArgs = {
  input: ConvertItems__Input;
};


/** The main Mutations object */
export type MutationConvertPartsArgs = {
  input: ConvertStoreParts__Input;
};


/** The main Mutations object */
export type MutationCreateBranchArgs = {
  branchId: Scalars['BigInteger'];
  companyId?: InputMaybe<Scalars['BigInteger']>;
  inventoryType?: InputMaybe<InventoryType>;
  name: Scalars['String'];
};


/** The main Mutations object */
export type MutationCreateDemandRequestArgs = {
  input: CreateDemandRequestInput;
};


/** The main Mutations object */
export type MutationCreateDistrictArgs = {
  input: CreateDistrict__Input;
};


/** The main Mutations object */
export type MutationCreateFulfillmentOrderArgs = {
  input: CreateFulfillmentOrderInput;
};


/** The main Mutations object */
export type MutationCreateGroupArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  spendingLimit?: InputMaybe<Scalars['Float']>;
};


/** The main Mutations object */
export type MutationCreateInventoryLocationArgs = {
  branchId: Scalars['BigInteger'];
  inventoryType?: InputMaybe<InventoryType>;
  name: Scalars['String'];
};


/** The main Mutations object */
export type MutationCreateItemMasterArgs = {
  input: CreateItemMasterInput;
};


/** The main Mutations object */
export type MutationCreateManualAdjustmentArgs = {
  direction?: InputMaybe<IncrementOrDecrement>;
  inventoryLocationId: Scalars['ID'];
  items: Array<InputMaybe<CreateManualAdjustmentItem>>;
  memo?: InputMaybe<Scalars['String']>;
  purchaseId?: InputMaybe<Scalars['ID']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']>;
  reason: ManualAdjustmentReasonType;
  vendorId?: InputMaybe<Scalars['ID']>;
};


/** The main Mutations object */
export type MutationCreateManualTransferOrderArgs = {
  input: CreateManualTransferOrderInput;
};


/** The main Mutations object */
export type MutationCreateNamedStoreAsChildOfArgs = {
  companyId?: InputMaybe<Scalars['BigInteger']>;
  inventoryType?: InputMaybe<InventoryType>;
  name: Scalars['String'];
  parentId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationCreateOrUpdateReservationArgs = {
  inventoryLocationId: Scalars['BigInteger'];
  partId: Scalars['BigInteger'];
  quantity: Scalars['Int'];
  targetId: Scalars['BigInteger'];
  targetTypeId?: InputMaybe<ReservationTargetType>;
};


/** The main Mutations object */
export type MutationCreatePartArgs = {
  companyId?: InputMaybe<Scalars['BigInteger']>;
  conversionUnit?: InputMaybe<UnitsOfMeasurementEnum>;
  description?: InputMaybe<Scalars['String']>;
  msrp?: InputMaybe<Scalars['Decimal']>;
  partNumber: Scalars['String'];
  productClassId?: InputMaybe<Scalars['ID']>;
  providerId: Scalars['BigInteger'];
  skuField?: InputMaybe<Scalars['String']>;
  standardPrice?: InputMaybe<Scalars['Decimal']>;
  upc?: InputMaybe<Scalars['String']>;
};


/** The main Mutations object */
export type MutationCreatePickOrderArgs = {
  input: CreatePickOrderInput;
};


/** The main Mutations object */
export type MutationCreateProductArgs = {
  companyId?: InputMaybe<Scalars['BigInteger']>;
  conversionUnit?: InputMaybe<UnitsOfMeasurementEnum>;
  itemMaster?: InputMaybe<CreateProductItemMasterInput>;
  manufacturerId: Scalars['BigInteger'];
  manufacturerNumber: Scalars['String'];
  msrp?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  productClassId?: InputMaybe<Scalars['ID']>;
  productTypeId?: InputMaybe<ProductType>;
  skuField?: InputMaybe<Scalars['String']>;
  standardPrice?: InputMaybe<Scalars['Decimal']>;
  upc?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


/** The main Mutations object */
export type MutationCreateProductCategoryArgs = {
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['BigInteger']>;
};


/** The main Mutations object */
export type MutationCreateProductClassArgs = {
  catClass: Scalars['String'];
  categoryName: Scalars['String'];
  classification: Scalars['String'];
};


/** The main Mutations object */
export type MutationCreateProductListArgs = {
  input: CreateProductListInput;
};


/** The main Mutations object */
export type MutationCreateProviderArgs = {
  name: Scalars['String'];
  skuField?: InputMaybe<Scalars['String']>;
};


/** The main Mutations object */
export type MutationCreatePutAwayOrderArgs = {
  input: CreatePutAwayOrderInput;
};


/** The main Mutations object */
export type MutationCreateRegionArgs = {
  input: CreateRegion__Input;
};


/** The main Mutations object */
export type MutationCreateRoleArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  spendingLimit?: InputMaybe<Scalars['Float']>;
};


/** The main Mutations object */
export type MutationCreateStorePartArgs = {
  input: CreateStorePartInput;
};


/** The main Mutations object */
export type MutationCreateTransactionArgs = {
  customId?: InputMaybe<Scalars['String']>;
  fromId?: InputMaybe<Scalars['Int']>;
  memo?: InputMaybe<Scalars['String']>;
  toId?: InputMaybe<Scalars['Int']>;
  transactionItems?: InputMaybe<Array<InputTransactionItem>>;
  transactionStatus?: InputMaybe<TransactionStatus>;
  transactionType: TransactionType;
};


/** The main Mutations object */
export type MutationCreateTransactionItemArgs = {
  costPerItem?: InputMaybe<Scalars['Float']>;
  partId: Scalars['Int'];
  quantity: Scalars['Int'];
  transactionId: Scalars['Int'];
};


/** The main Mutations object */
export type MutationCreateWeightedAverageCostSnapshotOverrideArgs = {
  dateApplied: Scalars['ArrowDateTime'];
  inventoryLocationId: Scalars['ID'];
  productId: Scalars['ID'];
  reason: Scalars['String'];
  weightedAverageCost: Scalars['Decimal'];
};


/** The main Mutations object */
export type MutationDeleteDistrictArgs = {
  districtId: Scalars['ID'];
};


/** The main Mutations object */
export type MutationDeleteGroupArgs = {
  groupId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationDeleteProductVendorPricingArgs = {
  input: DeleteProductVendorPricingInput;
};


/** The main Mutations object */
export type MutationDeleteRegionArgs = {
  regionId: Scalars['ID'];
};


/** The main Mutations object */
export type MutationDeleteRoleArgs = {
  roleId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationDeleteUserPreferenceArgs = {
  key: Scalars['String'];
};


/** The main Mutations object */
export type MutationGenerateResultPresignedUrlArgs = {
  input: GenerateResultPresignedUrl__Input;
};


/** The main Mutations object */
export type MutationGenerateUploadPresignedUrlArgs = {
  input: GenerateUploadPresignedUrl__Input;
};


/** The main Mutations object */
export type MutationInitializeCompanyArgs = {
  input: InitializeCompany__Input;
};


/** The main Mutations object */
export type MutationMarkPartAsGloballyVerifiedArgs = {
  input: MarkPartAsGloballyVerified__Input;
};


/** The main Mutations object */
export type MutationMarkProviderAsGloballyVerifiedArgs = {
  input: MarkProviderAsGloballyVerified__Input;
};


/** The main Mutations object */
export type MutationMergePartsArgs = {
  companyId?: InputMaybe<Scalars['BigInteger']>;
  duplicatePartId: Scalars['BigInteger'];
  goodPartId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationMergeProductsArgs = {
  companyId?: InputMaybe<Scalars['BigInteger']>;
  duplicateProductId: Scalars['BigInteger'];
  goodProductId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationMergeProvidersArgs = {
  companyId?: InputMaybe<Scalars['BigInteger']>;
  duplicateProviderId: Scalars['BigInteger'];
  goodProviderId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationMoveInventoryLocationToArgs = {
  branchId: Scalars['BigInteger'];
  inventoryLocationId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationMoveResourceArgs = {
  input: MoveResource__Input;
};


/** The main Mutations object */
export type MutationProcessTransactionArgs = {
  transactionId: Scalars['Int'];
  transactionItems?: InputMaybe<Array<InputUpdateTransactionItem>>;
};


/** The main Mutations object */
export type MutationPromoteInventoryLocationToDefaultArgs = {
  inventoryLocationId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationPromoteStoreToParentArgs = {
  storeId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationReceiveTransferOrderLineItemsArgs = {
  input: ReceiveTransferOrderLineItemsInput;
};


/** The main Mutations object */
export type MutationRecordPickedQuantitiesArgs = {
  input: RecordPickedQuantitiesInput;
};


/** The main Mutations object */
export type MutationRejectTransferOrderArgs = {
  input: RejectTransferOrderInput;
};


/** The main Mutations object */
export type MutationRemovePermissionsFromRoleArgs = {
  permissions: Array<Permission>;
  roleId: Scalars['Int'];
};


/** The main Mutations object */
export type MutationRemovePolicyFromGroupArgs = {
  policyId: Scalars['Int'];
};


/** The main Mutations object */
export type MutationRemoveProductFromVendorCatalogArgs = {
  input: RemoveProductFromVendorCatalogInput;
};


/** The main Mutations object */
export type MutationRemoveUsersFromGroupArgs = {
  groupId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};


/** The main Mutations object */
export type MutationRentalToRentalRetailSaleArgs = {
  branchId?: InputMaybe<Scalars['Int']>;
  inventoryLocationId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['Int'];
  storeId?: InputMaybe<Scalars['Int']>;
  transactionItems: Array<RentalToRentalRetailSaleInputTransactionItem>;
};


/** The main Mutations object */
export type MutationRentalToStoreArgs = {
  branchId?: InputMaybe<Scalars['Int']>;
  inventoryLocationId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['Int'];
  storeId?: InputMaybe<Scalars['Int']>;
  transactionItems: Array<RentalToStoreInputTransactionItem>;
};


/** The main Mutations object */
export type MutationRentalToStoreAndRetailSaleArgs = {
  branchId?: InputMaybe<Scalars['Int']>;
  inventoryLocationId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['Int'];
  storeId?: InputMaybe<Scalars['Int']>;
  transactionItems: Array<RentalToStoreAndRetailSaleInputTransactionItem>;
};


/** The main Mutations object */
export type MutationReopenDemandRequestArgs = {
  input: ReopenDemandRequestInput;
};


/** The main Mutations object */
export type MutationReopenDemandRequestLineItemArgs = {
  input: ReopenDemandRequestLineItemInput;
};


/** The main Mutations object */
export type MutationReopenDemandRequestLineItemsArgs = {
  input: ReopenDemandRequestLineItemsInput;
};


/** The main Mutations object */
export type MutationRequestFulfillmentOrderCancellationArgs = {
  input: RequestFulfillmentOrderCancellationInput;
};


/** The main Mutations object */
export type MutationReserveInventoryItemsArgs = {
  input: ReserveInventoryItemsInput;
};


/** The main Mutations object */
export type MutationSetPreferredVendorArgs = {
  input: SetPreferredVendorInput;
};


/** The main Mutations object */
export type MutationStartMultiManufacturerProductUploadArgs = {
  input: StartMultiManufacturerProductUpload__Input;
};


/** The main Mutations object */
export type MutationStoreToRentalArgs = {
  branchId?: InputMaybe<Scalars['Int']>;
  inventoryLocationId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['Int'];
  storeId?: InputMaybe<Scalars['Int']>;
  transactionItems: Array<StoreToRentalInputTransactionItem>;
};


/** The main Mutations object */
export type MutationStoreToRentalRetailSaleArgs = {
  branchId?: InputMaybe<Scalars['Int']>;
  inventoryLocationId?: InputMaybe<Scalars['Int']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['Int']>;
  transactionItems: Array<StoreToRentalRetailSaleInputTransactionItem>;
};


/** The main Mutations object */
export type MutationSubmitTransactionArgs = {
  transactionId: Scalars['Int'];
  transactionItems?: InputMaybe<Array<InputUpdateTransactionItem>>;
};


/** The main Mutations object */
export type MutationUnloadMobileToolTrailerArgs = {
  input: UnloadMobileToolTrailerInput;
};


/** The main Mutations object */
export type MutationUpdateDemandRequestLineItemFulfillerNotesArgs = {
  input: UpdateDemandRequestLineItemFulfillerNotesInput;
};


/** The main Mutations object */
export type MutationUpdateDistrictArgs = {
  input: UpdateDistrict__Input;
};


/** The main Mutations object */
export type MutationUpdateGroupArgs = {
  input: UpdateGroup__Input;
};


/** The main Mutations object */
export type MutationUpdateInventoryLocationArgs = {
  branchId?: InputMaybe<Scalars['BigInteger']>;
  inventoryLocationId: Scalars['BigInteger'];
  inventoryType?: InputMaybe<InventoryType>;
  name?: InputMaybe<Scalars['String']>;
  numPutawayStations?: InputMaybe<Scalars['Int']>;
  warehouse?: InputMaybe<UpdateInventoryLocationWarehouseInput>;
};


/** The main Mutations object */
export type MutationUpdateItemMasterArgs = {
  input: UpdateItemMasterInput;
};


/** The main Mutations object */
export type MutationUpdateItemMasterVariantArgs = {
  input: UpdateItemMasterVariantInput;
};


/** The main Mutations object */
export type MutationUpdatePartArgs = {
  conversionUnit?: InputMaybe<UnitsOfMeasurementEnum>;
  description?: InputMaybe<Scalars['String']>;
  externalAppXref?: InputMaybe<UpdatePartExternalAppXrefInput>;
  msrp?: InputMaybe<Scalars['Decimal']>;
  partId: Scalars['BigInteger'];
  partNumber?: InputMaybe<Scalars['String']>;
  productClassId?: InputMaybe<Scalars['ID']>;
  providerId?: InputMaybe<Scalars['BigInteger']>;
  skuField?: InputMaybe<Scalars['String']>;
  standardPrice?: InputMaybe<Scalars['Decimal']>;
  upc?: InputMaybe<Scalars['String']>;
};


/** The main Mutations object */
export type MutationUpdateProductArgs = {
  conversionUnit?: InputMaybe<UnitsOfMeasurementEnum>;
  manufacturerId?: InputMaybe<Scalars['BigInteger']>;
  manufacturerNumber?: InputMaybe<Scalars['String']>;
  msrp?: InputMaybe<Scalars['Decimal']>;
  name?: InputMaybe<Scalars['String']>;
  productClassId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['BigInteger'];
  skuField?: InputMaybe<Scalars['String']>;
  standardPrice?: InputMaybe<Scalars['Decimal']>;
  upc?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


/** The main Mutations object */
export type MutationUpdateProductCategoryArgs = {
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['BigInteger']>;
  productCategoryId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationUpdateProductClassArgs = {
  catClass?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
  productClassId: Scalars['ID'];
};


/** The main Mutations object */
export type MutationUpdateProductVendorPricingArgs = {
  input: UpdateProductVendorPricingInput;
};


/** The main Mutations object */
export type MutationUpdateProviderArgs = {
  name?: InputMaybe<Scalars['String']>;
  providerId: Scalars['Int'];
  skuField?: InputMaybe<Scalars['String']>;
};


/** The main Mutations object */
export type MutationUpdateRegionArgs = {
  input: UpdateRegion__Input;
};


/** The main Mutations object */
export type MutationUpdateRoleArgs = {
  input: UpdateRole__Input;
};


/** The main Mutations object */
export type MutationUpdateStoreArgs = {
  inventoryType?: InputMaybe<InventoryType>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['BigInteger']>;
  storeId: Scalars['BigInteger'];
};


/** The main Mutations object */
export type MutationUpdateStorePartArgs = {
  cost?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  storePartId: Scalars['BigInteger'];
  threshold?: InputMaybe<Scalars['Int']>;
};


/** The main Mutations object */
export type MutationUpdateTransactionItemArgs = {
  costPerItem?: InputMaybe<Scalars['Float']>;
  itemStatus?: InputMaybe<ItemStatus>;
  quantityReceived?: InputMaybe<Scalars['Int']>;
  transactionItemId: Scalars['Int'];
};


/** The main Mutations object */
export type MutationUpsertUserPreferenceArgs = {
  key: Scalars['String'];
  value: Scalars['UserPreferencesData'];
};

export type MutationError = IMutationError & {
  __typename?: 'MutationError';
  message: Scalars['String'];
};

export type NamedResourceEntity = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type NamedStore = StoreInterface & {
  __typename?: 'NamedStore';
  children: Array<StoreInterface>;
  company: Company;
  companyId: Scalars['Int'];
  /** The date that the store was archived. */
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  /** Get store external application id */
  externalStoreId?: Maybe<Scalars['ID']>;
  /** Get each store's external app ids and app name */
  externalStoreIds: Array<Maybe<ExternalStoreMeta>>;
  id: Scalars['Int'];
  inventoryType?: Maybe<InventoryType>;
  isWarehouse: Scalars['Boolean'];
  name: Scalars['String'];
  /** Number of put-away stations. NULL for non-warehouses; an integer (>= 0) for warehouses. */
  numPutawayStations?: Maybe<Scalars['Int']>;
  parent?: Maybe<StoreInterface>;
  parentId?: Maybe<Scalars['Int']>;
  storeId: Scalars['Int'];
  storeTypeId?: Maybe<Scalars['Int']>;
};


export type NamedStoreExternalStoreIdArgs = {
  app: ExternalApplication;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export type NonSerializedItem = Item & {
  __typename?: 'NonSerializedItem';
  availableQuantity: Scalars['Int'];
  id: Scalars['ID'];
  inventoryLocation: InventoryLocation;
  itemType: ItemType;
  product: Product;
  quantity: Scalars['Int'];
  /** The total quantity currently out on rent */
  quantityOnRent: Scalars['Int'];
  /** The inventory system's history on what is currently on rent. */
  rentalItems: Array<RentalItem>;
};

export enum NuminaSerialType {
  Asset = 'ASSET',
  Bulk = 'BULK',
  Consumable = 'CONSUMABLE'
}

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * A pointer at an order that lives outside of this service.
 *
 * Only the identifier is available here; consumers resolve the order's details
 * and build any link to it themselves.
 */
export type OrderReference = {
  __typename?: 'OrderReference';
  id: Scalars['ID'];
};

export type OutgoingTransferDetail = {
  __typename?: 'OutgoingTransferDetail';
  /** The outstanding quantity of this part on the transfer order (requested minus received and cancelled) */
  quantity: Scalars['Int'];
  /** The transfer order this part is leaving the store on */
  transferOrderId: Scalars['ID'];
};

/**
 * The Relay compliant `PageInfo` type, containing data necessary to paginate
 * this connection.
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['ConnectionCursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** When paginating backwards, are there more items? */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['ConnectionCursor']>;
};

export type Part = {
  __typename?: 'Part';
  company: Company;
  /** Which company owns this Part description. */
  companyId: Scalars['BigInteger'];
  /** All other parts that have been marked compatible with this part. */
  compatibleWith: Array<Part>;
  conversionUnit?: Maybe<UnitsOfMeasurementEnum>;
  /** Which conversion unit of measurement that this part is related to */
  conversionUnitId?: Maybe<Scalars['Int']>;
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  duplicateOf?: Maybe<Part>;
  /** If set, then this part has been considered a duplicate of this ID. */
  duplicateOfId?: Maybe<Scalars['BigInteger']>;
  /** Parts that were created that are now considered duplicates of this part */
  duplicates: Array<Maybe<Part>>;
  /** Get part external application id */
  externalPartId?: Maybe<Scalars['ID']>;
  /** Get each part's external app ids and app name */
  externalPartIds: Array<Maybe<ExternalPartMeta>>;
  hasActiveItemMaster: Scalars['Boolean'];
  id: Scalars['Int'];
  /** Has this Product been verified for global (cross-company) use? */
  isGlobal: Scalars['Boolean'];
  itemId: Scalars['ID'];
  itemMaster?: Maybe<ItemMaster>;
  itemMasterVariant?: Maybe<ItemMasterVariant>;
  manufacturer?: Maybe<Provider>;
  /** The Manufacturer model family. */
  manufacturerFamilyId?: Maybe<Scalars['Int']>;
  /** The manufacturer that this product belongs to. */
  manufacturerId: Scalars['BigInteger'];
  /** The unique Manufacturer number for this product */
  manufacturerNumber?: Maybe<Scalars['String']>;
  /** The Equipment Model provided by owner */
  model?: Maybe<Scalars['String']>;
  /** The manufacturer's suggested retail price of this part. */
  msrp?: Maybe<Scalars['Decimal']>;
  /** The name of the part */
  name: Scalars['String'];
  partClass: PartClass;
  partId: Scalars['BigInteger'];
  /** The unique Part number for this provider */
  partNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use partClass instead. */
  partType: PartType;
  /** The type of the Part. E.g. Oil Filter for Genie XYZ. */
  partTypeId?: Maybe<Scalars['BigInteger']>;
  preferredVendor?: Maybe<Vendor>;
  preferredVendorPrice?: Maybe<Money>;
  productCategory?: Maybe<ProductCategory>;
  /** The category under which this Product is classified. */
  productCategoryId?: Maybe<Scalars['BigInteger']>;
  productClass?: Maybe<ProductClass>;
  /** Which class this product belongs to. Products in the same class are considered functionally equivalent. */
  productClassId?: Maybe<Scalars['BigInteger']>;
  /** The type of the Product. E.g. Oil Filter for Genie XYZ. */
  productTypeId?: Maybe<Scalars['Int']>;
  provider: Provider;
  /** The provider that this part belongs to. */
  providerId: Scalars['BigInteger'];
  /** @deprecated This field is going away. Use Part.partNumber and Part.provider instead. */
  providerPartNumber: ProviderPartNumber;
  /** @deprecated This field is going away in favor of Part.provider and Part.partNumber */
  providerPartNumberId: Scalars['BigInteger'];
  /** The Stock Keeping Unit id that uniquely identifies this part within this part's company. */
  sku: Scalars['SKU'];
  /** Used in generating an SKU for a part as the [part] field. This field is also special in that it is used to lookup a part. */
  skuField: Scalars['String'];
  standardPrice?: Maybe<Money>;
  /** UPC string for the part. */
  upc?: Maybe<Scalars['String']>;
  vendors: Array<Vendor>;
  /** Has this Part been verified for global (cross-company) use? */
  verifiedGlobally: Scalars['Boolean'];
  /** The Model Year of the product */
  year?: Maybe<Scalars['Int']>;
};


export type PartExternalPartIdArgs = {
  app: ExternalApplication;
};

export type PartClass = {
  __typename?: 'PartClass';
  catClass?: Maybe<Scalars['String']>;
  /** The Class number for this group of parts. The second half of the cat-class number. */
  classNumber?: Maybe<Scalars['String']>;
  /** Which company owns this Part description. */
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  /** The description of this Part, e.g. Oil Filter */
  description: Scalars['String'];
  id: Scalars['Int'];
  /** The URL to the photo for this part. */
  imageUrl?: Maybe<Scalars['String']>;
  partTypeId: Scalars['BigInteger'];
};

export type PartOnWorkOrder = {
  __typename?: 'PartOnWorkOrder';
  costPerItem: Scalars['Float'];
  part: Part;
  partId: Scalars['Int'];
  quantity: Scalars['Int'];
  storePart?: Maybe<StorePart>;
};

export type PartsOrderedDetail = {
  __typename?: 'PartsOrderedDetail';
  /** The PO number that generated the reservation */
  purchaseOrderNumber: Scalars['String'];
  /** Number of parts reserved for the target */
  quantityOrdered: Scalars['Int'];
  /** ID of a supported target type. */
  targetId?: Maybe<Scalars['Int']>;
  /** The type of the target ID */
  targetType?: Maybe<PurchaseOrderTargetType>;
};

/** This is now deprecated in favor of PartClass */
export type PartType = {
  __typename?: 'PartType';
  /** The Class number for this group of parts. The second half of the cat-class number. */
  classNumber?: Maybe<Scalars['String']>;
  /** Which company owns this Part description. */
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  /** The description of this Part, e.g. Oil Filter */
  description: Scalars['String'];
  id: Scalars['Int'];
  /** The URL to the photo for this part. */
  imageUrl?: Maybe<Scalars['String']>;
  partTypeId: Scalars['BigInteger'];
};

export enum Permission {
  CanAdjustReceivedPurchaseOrderLineItemsByBranchId = 'CAN_ADJUST_RECEIVED_PURCHASE_ORDER_LINE_ITEMS_BY_BRANCH_ID',
  CanApprovePartsOnWorkOrderByStoreId = 'CAN_APPROVE_PARTS_ON_WORK_ORDER_BY_STORE_ID',
  CanApprovePartsRemovalFromWorkOrderByStoreId = 'CAN_APPROVE_PARTS_REMOVAL_FROM_WORK_ORDER_BY_STORE_ID',
  CanApprovePartsRentalByStoreId = 'CAN_APPROVE_PARTS_RENTAL_BY_STORE_ID',
  CanApprovePartsRentalReturnByStoreId = 'CAN_APPROVE_PARTS_RENTAL_RETURN_BY_STORE_ID',
  CanApprovePartsReturnByStoreId = 'CAN_APPROVE_PARTS_RETURN_BY_STORE_ID',
  CanApprovePartsTransferByStoreId = 'CAN_APPROVE_PARTS_TRANSFER_BY_STORE_ID',
  CanApprovePurchaseOrderByBranchId = 'CAN_APPROVE_PURCHASE_ORDER_BY_BRANCH_ID',
  CanApprovePurchaseOrderByStoreId = 'CAN_APPROVE_PURCHASE_ORDER_BY_STORE_ID',
  CanArchiveStoreByStoreId = 'CAN_ARCHIVE_STORE_BY_STORE_ID',
  CanAssignExternalAppId = 'CAN_ASSIGN_EXTERNAL_APP_ID',
  CanBulkImport = 'CAN_BULK_IMPORT',
  CanCancelFulfillmentOrderByStoreId = 'CAN_CANCEL_FULFILLMENT_ORDER_BY_STORE_ID',
  CanCancelPartLossByStoreId = 'CAN_CANCEL_PART_LOSS_BY_STORE_ID',
  CanCancelPartObsoleteByStoreId = 'CAN_CANCEL_PART_OBSOLETE_BY_STORE_ID',
  CanCancelPartsOnWorkOrderByStoreId = 'CAN_CANCEL_PARTS_ON_WORK_ORDER_BY_STORE_ID',
  CanCancelPartsRemovalFromWorkOrderByStoreId = 'CAN_CANCEL_PARTS_REMOVAL_FROM_WORK_ORDER_BY_STORE_ID',
  CanCancelPartsRentalByStoreId = 'CAN_CANCEL_PARTS_RENTAL_BY_STORE_ID',
  CanCancelPartsRentalReturnByStoreId = 'CAN_CANCEL_PARTS_RENTAL_RETURN_BY_STORE_ID',
  CanCancelPartsReturnByStoreId = 'CAN_CANCEL_PARTS_RETURN_BY_STORE_ID',
  CanCancelPartsTransferByStoreId = 'CAN_CANCEL_PARTS_TRANSFER_BY_STORE_ID',
  CanCancelPurchaseOrderByStoreId = 'CAN_CANCEL_PURCHASE_ORDER_BY_STORE_ID',
  CanCancelReservationByStoreId = 'CAN_CANCEL_RESERVATION_BY_STORE_ID',
  CanCancelRetailSaleByStoreId = 'CAN_CANCEL_RETAIL_SALE_BY_STORE_ID',
  CanCancelRetailSaleReturnByStoreId = 'CAN_CANCEL_RETAIL_SALE_RETURN_BY_STORE_ID',
  CanCompletePartsTransferByStoreId = 'CAN_COMPLETE_PARTS_TRANSFER_BY_STORE_ID',
  CanCompletePurchaseOrderByStoreId = 'CAN_COMPLETE_PURCHASE_ORDER_BY_STORE_ID',
  CanConvertPartsByStoreId = 'CAN_CONVERT_PARTS_BY_STORE_ID',
  CanCreateChildStoreByParentStoreId = 'CAN_CREATE_CHILD_STORE_BY_PARENT_STORE_ID',
  CanCreateDecrementAdjustmentByStoreId = 'CAN_CREATE_DECREMENT_ADJUSTMENT_BY_STORE_ID',
  CanCreateDemandRequestByStoreId = 'CAN_CREATE_DEMAND_REQUEST_BY_STORE_ID',
  CanCreateEcommerceAdjustmentByStoreId = 'CAN_CREATE_ECOMMERCE_ADJUSTMENT_BY_STORE_ID',
  CanCreateFulfillmentOrderByStoreId = 'CAN_CREATE_FULFILLMENT_ORDER_BY_STORE_ID',
  CanCreateIncrementAdjustmentByStoreId = 'CAN_CREATE_INCREMENT_ADJUSTMENT_BY_STORE_ID',
  CanCreateItemMaster = 'CAN_CREATE_ITEM_MASTER',
  CanCreatePart = 'CAN_CREATE_PART',
  CanCreatePartCategory = 'CAN_CREATE_PART_CATEGORY',
  CanCreatePartNumberForProvider = 'CAN_CREATE_PART_NUMBER_FOR_PROVIDER',
  CanCreatePickOrderByStoreId = 'CAN_CREATE_PICK_ORDER_BY_STORE_ID',
  CanCreatePriceList = 'CAN_CREATE_PRICE_LIST',
  CanCreateProductClass = 'CAN_CREATE_PRODUCT_CLASS',
  CanCreateProvider = 'CAN_CREATE_PROVIDER',
  CanCreatePutAwayOrder = 'CAN_CREATE_PUT_AWAY_ORDER',
  CanCreateRefurbishedAdjustmentByStoreId = 'CAN_CREATE_REFURBISHED_ADJUSTMENT_BY_STORE_ID',
  CanCreateReservationByStoreId = 'CAN_CREATE_RESERVATION_BY_STORE_ID',
  CanCreateTopLevelStore = 'CAN_CREATE_TOP_LEVEL_STORE',
  CanCreateUnverifiedPart = 'CAN_CREATE_UNVERIFIED_PART',
  CanCreateUnverifiedProvider = 'CAN_CREATE_UNVERIFIED_PROVIDER',
  CanDeletePart = 'CAN_DELETE_PART',
  CanDeletePartNumberForProvider = 'CAN_DELETE_PART_NUMBER_FOR_PROVIDER',
  CanDeletePriceList = 'CAN_DELETE_PRICE_LIST',
  CanDeleteProvider = 'CAN_DELETE_PROVIDER',
  CanDeletePurchaseOrderByBranchId = 'CAN_DELETE_PURCHASE_ORDER_BY_BRANCH_ID',
  CanDeleteReceivedPurchaseOrderByBranchId = 'CAN_DELETE_RECEIVED_PURCHASE_ORDER_BY_BRANCH_ID',
  CanEditAllPermissions = 'CAN_EDIT_ALL_PERMISSIONS',
  CanEditDemandRequestByStoreId = 'CAN_EDIT_DEMAND_REQUEST_BY_STORE_ID',
  CanEditItemMaster = 'CAN_EDIT_ITEM_MASTER',
  CanEditPart = 'CAN_EDIT_PART',
  CanEditPartCategory = 'CAN_EDIT_PART_CATEGORY',
  CanEditPriceList = 'CAN_EDIT_PRICE_LIST',
  CanEditProvider = 'CAN_EDIT_PROVIDER',
  CanEditReceivedPurchaseOrderByBranchId = 'CAN_EDIT_RECEIVED_PURCHASE_ORDER_BY_BRANCH_ID',
  CanEditStoreByStoreId = 'CAN_EDIT_STORE_BY_STORE_ID',
  CanEditStorePartsInfoByStoreId = 'CAN_EDIT_STORE_PARTS_INFO_BY_STORE_ID',
  CanInitializeCompany = 'CAN_INITIALIZE_COMPANY',
  CanManagePurchaseLineItemsByBranchId = 'CAN_MANAGE_PURCHASE_LINE_ITEMS_BY_BRANCH_ID',
  CanMarkPartGloballyVerified = 'CAN_MARK_PART_GLOBALLY_VERIFIED',
  CanMarkProviderGloballyVerified = 'CAN_MARK_PROVIDER_GLOBALLY_VERIFIED',
  CanMergeGloballyVerifiedProducts = 'CAN_MERGE_GLOBALLY_VERIFIED_PRODUCTS',
  CanMergeParts = 'CAN_MERGE_PARTS',
  CanMergeProviders = 'CAN_MERGE_PROVIDERS',
  CanOverrideWeightedAverageCostByStoreId = 'CAN_OVERRIDE_WEIGHTED_AVERAGE_COST_BY_STORE_ID',
  CanPurchasePartsForWorkOrderByStoreId = 'CAN_PURCHASE_PARTS_FOR_WORK_ORDER_BY_STORE_ID',
  CanRecordPartLossByStoreId = 'CAN_RECORD_PART_LOSS_BY_STORE_ID',
  CanRecordPartObsoleteByStoreId = 'CAN_RECORD_PART_OBSOLETE_BY_STORE_ID',
  CanRecordRetailSaleByStoreId = 'CAN_RECORD_RETAIL_SALE_BY_STORE_ID',
  CanRecordRetailSaleReturnByStoreId = 'CAN_RECORD_RETAIL_SALE_RETURN_BY_STORE_ID',
  CanRemoveExternalAppId = 'CAN_REMOVE_EXTERNAL_APP_ID',
  CanRequestPartsOnWorkOrderByStoreId = 'CAN_REQUEST_PARTS_ON_WORK_ORDER_BY_STORE_ID',
  CanRequestPartsRemovalFromWorkOrderByStoreId = 'CAN_REQUEST_PARTS_REMOVAL_FROM_WORK_ORDER_BY_STORE_ID',
  CanRevertBulkImport = 'CAN_REVERT_BULK_IMPORT',
  CanSubmitPartsRentalByStoreId = 'CAN_SUBMIT_PARTS_RENTAL_BY_STORE_ID',
  CanSubmitPartsRentalReturnByStoreId = 'CAN_SUBMIT_PARTS_RENTAL_RETURN_BY_STORE_ID',
  CanSubmitPartsReturnByStoreId = 'CAN_SUBMIT_PARTS_RETURN_BY_STORE_ID',
  CanSubmitPartsTransferByStoreId = 'CAN_SUBMIT_PARTS_TRANSFER_BY_STORE_ID',
  CanSubmitPurchaseOrderByBranchId = 'CAN_SUBMIT_PURCHASE_ORDER_BY_BRANCH_ID',
  CanSubmitPurchaseOrderByStoreId = 'CAN_SUBMIT_PURCHASE_ORDER_BY_STORE_ID',
  CanUnloadMobileToolTrailerByStoreId = 'CAN_UNLOAD_MOBILE_TOOL_TRAILER_BY_STORE_ID',
  CanUpdateProductClass = 'CAN_UPDATE_PRODUCT_CLASS',
  CanViewCostCapture = 'CAN_VIEW_COST_CAPTURE',
  CanViewDcAdmin = 'CAN_VIEW_DC_ADMIN',
  CanViewInventory = 'CAN_VIEW_INVENTORY',
  CanViewItemMaster = 'CAN_VIEW_ITEM_MASTER',
  CanViewPart = 'CAN_VIEW_PART'
}

/**
 * A compact representation of a single permission the current user holds and
 * every object ID that permission applies to. Grouping the object IDs under
 * the permission keeps the payload small for users authorized on large numbers
 * of resources.
 */
export type PermissionGrant = {
  __typename?: 'PermissionGrant';
  objectIds: Array<Scalars['TypePreservingID']>;
  permission: Permission;
};

export type PermissionMeta = {
  __typename?: 'PermissionMeta';
  /** The human friendly representation of the permission name */
  friendlyName: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Permission>;
  permissionId: Scalars['ID'];
  resourceType?: Maybe<ResourceType>;
};

export type PickOrder = {
  __typename?: 'PickOrder';
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  createdByUserId: Scalars['ID'];
  dateAssigned?: Maybe<Scalars['ArrowDateTime']>;
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  datePickingStarted?: Maybe<Scalars['ArrowDateTime']>;
  dateUpdated: Scalars['ArrowDateTime'];
  /** Every demand request behind the run's fulfillment orders, oldest first, each once. */
  demandRequests: Array<DemandRequest>;
  /** Where the run is going, rendered for display: the shipping address for anything shipped, or the trailer and quadrant for an MTT loadout. Every fulfillment order in the run shares it. */
  destinationDescription?: Maybe<Scalars['String']>;
  fulfillingInventory: InventoryLocation;
  fulfillingInventoryId: Scalars['ID'];
  fulfillmentOrders: Array<FulfillmentOrder>;
  fulfillments: Array<Fulfillment>;
  id: Scalars['ID'];
  lines: Array<PickOrderLine>;
  /** The run's human-readable handle, rendered PK-<number>. Assigned on creation and never reused. */
  pickOrderNumber: Scalars['BigInteger'];
  /** Where the run is going when it is shipped somewhere. Every fulfillment order in the run shares it; null for an MTT loadout run, which is bound for a trailer quadrant rather than an address. */
  shippingAddress?: Maybe<Address>;
  status: PickOrderStatus;
};

export type PickOrderConnection = {
  __typename?: 'PickOrderConnection';
  edges: Array<PickOrderEdge>;
  pageInfo: PageInfo;
  /** The total number of items matching the query, ignoring pagination. */
  totalCount: Scalars['Int'];
};

export type PickOrderEdge = {
  __typename?: 'PickOrderEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: PickOrder;
};

export type PickOrderLine = {
  __typename?: 'PickOrderLine';
  /** Where the picker was told to go, snapshotted when the pick order was created. */
  binLocation?: Maybe<Scalars['String']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['ArrowDateTime'];
  fulfillmentOrder: FulfillmentOrder;
  fulfillmentOrderLineItem: FulfillmentOrderLineItem;
  fulfillmentOrderLineItemId: Scalars['ID'];
  id: Scalars['ID'];
  /** Whether the fulfillment order this line was picked for has been cancelled. The line is kept as the record of what the picker was told to pick, but it is excluded when the pick order completes - a picker already holding these units needs to put them back. */
  isCancelled: Scalars['Boolean'];
  pickOrderId: Scalars['ID'];
  product: Part;
  productId: Scalars['ID'];
  quantityPicked: Scalars['Int'];
  quantityToPick: Scalars['Int'];
};

export enum PickOrderStatus {
  Assigned = 'ASSIGNED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type Product = {
  /** @deprecated Use productCategory instead. */
  category?: Maybe<ProductCategory>;
  conversionUnit?: Maybe<UnitsOfMeasurementEnum>;
  dateArchived?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  preferredVendor?: Maybe<Vendor>;
  preferredVendorPrice?: Maybe<Money>;
  productCategory?: Maybe<ProductCategory>;
  productClass?: Maybe<ProductClass>;
  productClassId?: Maybe<Scalars['ID']>;
  productType: ProductType;
  vendors: Array<Vendor>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  children?: Maybe<Array<Maybe<ProductCategory>>>;
  /** Which company owns this category */
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<ProductCategory>;
  /** If not set, this denotes that the category is top-level. If set, then this is a subcategory of the given category id */
  parentId?: Maybe<Scalars['BigInteger']>;
  productCategoryId: Scalars['BigInteger'];
};

export type ProductClass = {
  __typename?: 'ProductClass';
  catClass: Scalars['String'];
  categoryName: Scalars['String'];
  classification: Scalars['String'];
  companyId: Scalars['ID'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['ID'];
};

export type ProductClassConnection = {
  __typename?: 'ProductClassConnection';
  edges: Array<ProductClassEdge>;
  pageInfo: PageInfo;
};

export type ProductClassEdge = {
  __typename?: 'ProductClassEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: ProductClass;
};

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
  /** The total number of items matching the query, ignoring pagination. */
  totalCount: Scalars['Int'];
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: Product;
};

export type ProductList = {
  __typename?: 'ProductList';
  companyId: Scalars['ID'];
  context?: Maybe<Scalars['JSON']>;
  createdByUser: User;
  createdByUserId: Scalars['ID'];
  dateCreated: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['ArrowDateTime'];
  id: Scalars['ID'];
  items: Array<ProductListItem>;
};

export type ProductListItem = {
  __typename?: 'ProductListItem';
  context?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  product: Part;
  productId: Scalars['ID'];
  productListId: Scalars['ID'];
  quantity: Scalars['Int'];
  targetId?: Maybe<Scalars['ID']>;
  targetType?: Maybe<ProductListTargetType>;
};

export type ProductListItemInput = {
  /** Optional metadata about this item (max 15KB) */
  context?: InputMaybe<Scalars['JSON']>;
  /** Optional notes about this item */
  notes?: InputMaybe<Scalars['String']>;
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The quantity of the product */
  quantity: Scalars['Int'];
  /** The identifier of the target (WO-12345, INV-67890, etc.) */
  targetId?: InputMaybe<Scalars['ID']>;
  /** The type of target (WORK_ORDER, INVOICE, ORDER) */
  targetType?: InputMaybe<ProductListTargetType>;
};

export enum ProductListTargetType {
  Invoice = 'INVOICE',
  Order = 'ORDER',
  WorkOrder = 'WORK_ORDER'
}

export enum ProductType {
  Good = 'GOOD',
  Service = 'SERVICE'
}

export type ProductVendorPricing = {
  __typename?: 'ProductVendorPricing';
  agreedNetPrice: Scalars['Decimal'];
  id: Scalars['ID'];
  priceEndDate?: Maybe<Scalars['Date']>;
  priceStartDate: Scalars['Date'];
};

export type Provider = {
  __typename?: 'Provider';
  company: Company;
  /** The company that this provider catalog item belongs to. */
  companyId: Scalars['BigInteger'];
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  /** The name to identify this Provider as. */
  name: Scalars['String'];
  /** @deprecated This field is going away. There will soon be a .parts field to look at instead. */
  partNumbers: Array<ProviderPartNumber>;
  providerId: Scalars['BigInteger'];
  /** Used in generating an SKU for a part. This is the [manufacturer] field. */
  skuField: Scalars['String'];
  /** Has this Provider been verified for global (cross-company) use? */
  verifiedGlobally: Scalars['Boolean'];
};

export type ProviderPartNumber = {
  __typename?: 'ProviderPartNumber';
  id: Scalars['ID'];
  partNumber: Scalars['String'];
  provider: Provider;
  providerId: Scalars['Int'];
};

export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  id: Scalars['ID'];
  purchaseOrderNumber?: Maybe<Scalars['String']>;
};

export enum PurchaseOrderTargetType {
  Invoice = 'INVOICE',
  Order = 'ORDER',
  Stock = 'STOCK',
  WorkOrder = 'WORK_ORDER'
}

export type PutAwayOrder = {
  __typename?: 'PutAwayOrder';
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  id: Scalars['ID'];
  lineItems: Array<PutAwayOrderLineItem>;
  purchaseOrderNumber?: Maybe<Scalars['BigInteger']>;
  putawayStationId?: Maybe<Scalars['Int']>;
  quantityProcessed: Scalars['Int'];
  source?: Maybe<PutAwayOrderSource>;
  sourceId: Scalars['ID'];
  sourceType: PutAwayOrderSourceType;
  status: PutAwayOrderStatus;
  store?: Maybe<InventoryLocation>;
  storeId: Scalars['ID'];
};

export type PutAwayOrderConnection = {
  __typename?: 'PutAwayOrderConnection';
  edges: Array<PutAwayOrderEdge>;
  pageInfo: PageInfo;
};

export type PutAwayOrderEdge = {
  __typename?: 'PutAwayOrderEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: PutAwayOrder;
};

export type PutAwayOrderLineItem = {
  __typename?: 'PutAwayOrderLineItem';
  id: Scalars['ID'];
  itemMasterDeficient: Scalars['Boolean'];
  product?: Maybe<Part>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  quantityBarcodesToPrint: Scalars['Int'];
};

export type PutAwayOrderSource = ManualTransferOrder | PurchaseOrder | SystemTransferOrder;

export enum PutAwayOrderSourceType {
  PurchaseOrder = 'PURCHASE_ORDER',
  TransferOrder = 'TRANSFER_ORDER'
}

export enum PutAwayOrderStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** The main Query GraphQL Object */
export type Query = {
  __typename?: 'Query';
  /** Get all permissions known to inventory */
  allPermissions: Array<PermissionMeta>;
  asset?: Maybe<Asset>;
  assets: AssetConnection;
  branches: BranchV2Connection;
  bulkImportSessions: Array<Maybe<BulkImportSession>>;
  /** Get a single demand request by ID */
  demandRequest?: Maybe<DemandRequest>;
  demandRequests: DemandRequestConnection;
  /** Get a single equipment make by ID */
  equipmentMake?: Maybe<EquipmentMake>;
  /** Get a paginated list of equipment makes */
  equipmentMakes: EquipmentMakeConnection;
  /** Get a single equipment model by ID */
  equipmentModel?: Maybe<EquipmentModel>;
  /** Get a paginated list of equipment models */
  equipmentModels: EquipmentModelConnection;
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  fulfillmentOrderByOrderNumber?: Maybe<FulfillmentOrder>;
  fulfillmentOrders: FulfillmentOrderConnection;
  /** Get parts that match the given part number for the current user's company and other companies */
  fullPartSearch?: Maybe<FullPartSearch>;
  /**
   * Get a single Part, using the given external application and the ID of the part in that system.
   * @deprecated We no longer support this functionality, so alwaysreturns Null
   */
  getPartByExternalApplication?: Maybe<Part>;
  /**
   * Get a single store, using the given external application and the ID of the store in that system.
   * @deprecated We no longer support this functionality. Always returns None
   */
  getStoreByExternalApplication?: Maybe<StoreInterface>;
  globalProductCatalogUpload?: Maybe<GlobalProductCatalogUpload>;
  globalProductCatalogUploads: GlobalProductCatalogUploadConnection;
  /** Get a group by its ID. */
  group: Group;
  /** Get all groups for the given company ID (defaults to the current user's ID). */
  groups: Array<Maybe<Group>>;
  inventoryLocations: InventoryLocationConnection;
  invoice: Invoice;
  /** Get a single item by id. */
  item?: Maybe<Item>;
  /** Every transaction that has moved a single item's stock, most recent first. Empty when the item does not exist for the requesting company. */
  itemHistory: ItemHistoryEntryConnection;
  /** Get a single item master by ID */
  itemMaster?: Maybe<ItemMaster>;
  /** Get a paginated list of item masters */
  itemMasters: ItemMasterConnection;
  /** Get a list of items */
  items: ItemConnection;
  /** Get a single manual adjustment by id. */
  manualAdjustment?: Maybe<ManualAdjustment>;
  /** Get a single manual adjustment reason by id. */
  manualAdjustmentReason?: Maybe<ManualAdjustmentReason>;
  /** Returns a list of reasons that are allowed for manual adjustments */
  manualAdjustmentReasons: Array<Maybe<ManualAdjustmentReason>>;
  /** Query all manual adjustments for the company */
  manualAdjustments: ManualAdjustmentConnection;
  /** The assets and store parts currently held at a Mobile Tool Trailer's inventory location. */
  mobileToolTrailerInventoryItems: Array<MobileToolTrailerInventoryItem>;
  node?: Maybe<Node>;
  /** Get a single Part by id. */
  part?: Maybe<Part>;
  partBySku?: Maybe<Part>;
  /** Get a single PartClass by id. */
  partClass?: Maybe<PartClass>;
  /** Query all PartClasses known to the company */
  partClasses: Array<PartClass>;
  /** Query all parts known to the company */
  parts?: Maybe<Array<Part>>;
  /** Get the list of parts that are attached to the given work order. Defaults to showing only completed transactions. Use transactionStatuses to show SUBMITTED or PENDING parts. */
  partsOnWorkOrder?: Maybe<Array<PartOnWorkOrder>>;
  /** Get a single Part by id. */
  partType?: Maybe<PartType>;
  /** Query all part_types known to the company */
  partTypes: Array<PartType>;
  pickOrder?: Maybe<PickOrder>;
  /** Other fulfillment orders at the same distribution center that share a destination with the given order and are not already being picked, so they can be folded into one pick order. */
  pickOrderCandidateFulfillmentOrders: Array<FulfillmentOrder>;
  pickOrders: PickOrderConnection;
  /** Query all ProductCategories known to the company */
  productCategories: Array<ProductCategory>;
  /** Get a single ProductCategory by id. */
  productCategory?: Maybe<ProductCategory>;
  /** Get a single ProductClass by id. */
  productClass?: Maybe<ProductClass>;
  /** Query all ProductClasses known to the company */
  productClasses: ProductClassConnection;
  /** Get a product list by ID */
  productList?: Maybe<ProductList>;
  products: ProductConnection;
  productVendorPrices: Array<ProductVendorPricing>;
  /** Get a single Provider by its ID. */
  provider?: Maybe<Provider>;
  /** Get a list of Providers global to the whole system. */
  providers: Array<Provider>;
  /** Get a single PutAwayOrder by ID */
  putAwayOrder?: Maybe<PutAwayOrder>;
  putAwayOrders: PutAwayOrderConnection;
  /** Get a single Resource by id. */
  resource?: Maybe<Resource>;
  /** Reverse lookup: the policies that grant access to the given resource, whether attached directly or on one of its ancestors. */
  resourceAccess: ResourceAccessEntryConnection;
  /** The direct children of `parentId` (or the company's root resources when `parentId` is omitted). ES is never returned. */
  resourceChildren: Array<Resource>;
  /** Preview the effective-grant impact of moving a resource to a new parent, without persisting anything. */
  resourceMoveImpact: ResourceMoveImpact;
  /** Get Resources for the given company (defaults to current user's company) */
  resources: Array<Resource>;
  restBranches: Array<Branch>;
  restCompany?: Maybe<Company>;
  restEquipmentMake?: Maybe<EquipmentMake>;
  restEquipmentMakes: Array<EquipmentMake>;
  restEquipmentModel?: Maybe<EquipmentModel>;
  restEquipmentModels: Array<EquipmentModel>;
  restUsers: Array<User>;
  /** Get a single Role by id. */
  role?: Maybe<Role>;
  /** Get roles for the given company (defaults to current user's company) */
  roles: Array<Maybe<Role>>;
  /** Path-aware, ranked resource search, scoped to the caller's company. Every whitespace-delimited token in `query` must match some segment of a candidate resource's ancestor path. */
  searchResources: ResourceSearchResultConnection;
  /** Get a single Store by id. */
  store?: Maybe<StoreInterface>;
  /** Get a single Part for a specific Store. Filter by specific storePartId or use the combination of partId and storeId. */
  storePart?: Maybe<StorePart>;
  /** Get a list of Parts for a specific Store. Note that this will not show all parts known to the company if the store has never had the part in its inventory. */
  storeParts: Array<StorePart>;
  stores: Array<StoreInterface>;
  /** Get a single Transaction by ID. */
  transaction?: Maybe<Transaction>;
  /** Get a list of Transactions. */
  transactions?: Maybe<Array<Transaction>>;
  /** Get a single transfer order by ID */
  transferOrder?: Maybe<TransferOrder>;
  transferOrders: TransferOrderConnection;
  user?: Maybe<User>;
  /** Get all permissions for the currently logged-in user */
  userAuthorizations: UserAuthorization;
  /** The effective permission grants for an arbitrary user in the caller's company, with provenance describing which group/role/resource each grant comes from. The given userId is caller-company-only: a user from another company resolves as not-found. */
  userEffectiveGrants: Array<EffectivePermissionGrant>;
  /** Get the currently logged-in user's permission grants as a compact list of (permission, objectIds) pairs, scoped to the user's company. Optionally filter by permissions, resource types, and/or object IDs. */
  userPermissionGrants: Array<PermissionGrant>;
  /** Get a list of user preferences for the authenticated user. */
  userPreferences?: Maybe<UserPreference>;
  users: UserConnection;
  usersById: Array<User>;
  usersSearch: Array<User>;
};


/** The main Query GraphQL Object */
export type QueryAssetArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetFilter>;
  paging?: InputMaybe<CursorPaging>;
};


/** The main Query GraphQL Object */
export type QueryBranchesArgs = {
  filter?: InputMaybe<BranchV2Filter>;
  paging?: InputMaybe<CursorPaging>;
};


/** The main Query GraphQL Object */
export type QueryBulkImportSessionsArgs = {
  bulkImportSessionIds?: InputMaybe<Array<Scalars['Int']>>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QueryDemandRequestArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryDemandRequestsArgs = {
  assignedToIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillingInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillmentOrderNumbers?: InputMaybe<Array<Scalars['BigInteger']>>;
  paging?: InputMaybe<CursorPaging>;
  partIds?: InputMaybe<Array<Scalars['ID']>>;
  requestedByUserIds?: InputMaybe<Array<Scalars['ID']>>;
  requestingInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
  requestNumbers?: InputMaybe<Array<Scalars['Int']>>;
  requestTypes?: InputMaybe<Array<DemandRequestType>>;
  statuses?: InputMaybe<Array<InputMaybe<DemandRequestStatus>>>;
};


/** The main Query GraphQL Object */
export type QueryEquipmentMakeArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryEquipmentMakesArgs = {
  filter?: InputMaybe<EquipmentMakeFilter>;
  paging?: InputMaybe<CursorPaging>;
};


/** The main Query GraphQL Object */
export type QueryEquipmentModelArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryEquipmentModelsArgs = {
  filter?: InputMaybe<EquipmentModelFilter>;
  paging?: InputMaybe<CursorPaging>;
};


/** The main Query GraphQL Object */
export type QueryFulfillmentOrderArgs = {
  fulfillmentOrderId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryFulfillmentOrderByOrderNumberArgs = {
  orderNumber: Scalars['BigInteger'];
};


/** The main Query GraphQL Object */
export type QueryFulfillmentOrdersArgs = {
  dateCreatedAfter?: InputMaybe<Scalars['ArrowDateTime']>;
  dateCreatedBefore?: InputMaybe<Scalars['ArrowDateTime']>;
  demandRequestIds?: InputMaybe<Array<Scalars['ID']>>;
  destinationInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillingInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillmentTypes?: InputMaybe<Array<InputMaybe<FulfillmentType>>>;
  orderNumbers?: InputMaybe<Array<Scalars['BigInteger']>>;
  paging?: InputMaybe<CursorPaging>;
  sortBy?: InputMaybe<FulfillmentOrderSortField>;
  sortDirection?: InputMaybe<SortDirection>;
  statuses?: InputMaybe<Array<InputMaybe<FulfillmentOrderStatus>>>;
  transferOrderIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** The main Query GraphQL Object */
export type QueryFullPartSearchArgs = {
  partNumbers?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryGetPartByExternalApplicationArgs = {
  externalApplication: ExternalApplication;
  partId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryGetStoreByExternalApplicationArgs = {
  externalApplication: ExternalApplication;
  storeId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryGlobalProductCatalogUploadArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryGlobalProductCatalogUploadsArgs = {
  paging?: InputMaybe<CursorPaging>;
  uploadType?: InputMaybe<GlobalProductCatalogUploadType>;
};


/** The main Query GraphQL Object */
export type QueryGroupArgs = {
  groupId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryGroupsArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** The main Query GraphQL Object */
export type QueryInventoryLocationsArgs = {
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  inventoryLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  isMtt?: InputMaybe<Scalars['Boolean']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<CursorPaging>;
  permissions?: InputMaybe<Array<Permission>>;
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryInvoiceArgs = {
  id: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryItemArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryItemHistoryArgs = {
  dateAppliedEnd?: InputMaybe<Scalars['ArrowDateTime']>;
  dateAppliedStart?: InputMaybe<Scalars['ArrowDateTime']>;
  itemId: Scalars['ID'];
  order?: InputMaybe<OrderDirection>;
  paging?: InputMaybe<CursorPaging>;
  transactionStatuses?: InputMaybe<Array<TransactionStatus>>;
  transactionTypes?: InputMaybe<Array<TransactionType>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** The main Query GraphQL Object */
export type QueryItemMasterArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryItemMastersArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  paging?: InputMaybe<CursorPaging>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryItemsArgs = {
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  inventoryLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  paging?: InputMaybe<CursorPaging>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<ItemSort>>;
};


/** The main Query GraphQL Object */
export type QueryManualAdjustmentArgs = {
  manualAdjustmentId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryManualAdjustmentReasonArgs = {
  manualAdjustmentReasonId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryManualAdjustmentReasonsArgs = {
  allowDecrement?: InputMaybe<Scalars['Boolean']>;
  allowIncrement?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryManualAdjustmentsArgs = {
  createdDateEnd?: InputMaybe<Scalars['DateTime']>;
  createdDateStart?: InputMaybe<Scalars['DateTime']>;
  inventoryLocations?: InputMaybe<Array<Scalars['ID']>>;
  items?: InputMaybe<Array<Scalars['ID']>>;
  order?: InputMaybe<OrderDirection>;
  orderBy?: InputMaybe<ManualAdjustmentOrderBy>;
  paging?: InputMaybe<CursorPaging>;
  products?: InputMaybe<Array<Scalars['ID']>>;
  reasons?: InputMaybe<Array<ManualAdjustmentReasonType>>;
  search?: InputMaybe<Scalars['String']>;
  searchMemo?: InputMaybe<Scalars['String']>;
  updatedDateEnd?: InputMaybe<Scalars['DateTime']>;
  updatedDateStart?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<Array<Scalars['ID']>>;
};


/** The main Query GraphQL Object */
export type QueryMobileToolTrailerInventoryItemsArgs = {
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
  inventoryLocationId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryNodeArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryPartArgs = {
  partId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryPartBySkuArgs = {
  sku: Scalars['SKU'];
};


/** The main Query GraphQL Object */
export type QueryPartClassArgs = {
  id: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryPartClassesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  includeGloballyVerified?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QueryPartsArgs = {
  description?: InputMaybe<Scalars['String']>;
  externalApplications?: InputMaybe<Array<ExternalApplication>>;
  includeGloballyVerified?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  partIds?: InputMaybe<Array<Scalars['Int']>>;
  partNumbers?: InputMaybe<Array<Scalars['String']>>;
  partNumbersExact?: InputMaybe<Array<Scalars['String']>>;
  providerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  skus?: InputMaybe<Array<Scalars['SKU']>>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


/** The main Query GraphQL Object */
export type QueryPartsOnWorkOrderArgs = {
  transactionStatuses?: InputMaybe<Array<TransactionStatus>>;
  workOrderId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryPartTypeArgs = {
  partTypeId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryPartTypesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QueryPickOrderArgs = {
  pickOrderId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryPickOrderCandidateFulfillmentOrdersArgs = {
  fulfillmentOrderId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryPickOrdersArgs = {
  assignedToUserIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillingInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
  paging?: InputMaybe<CursorPaging>;
  statuses?: InputMaybe<Array<InputMaybe<PickOrderStatus>>>;
};


/** The main Query GraphQL Object */
export type QueryProductCategoriesArgs = {
  offset?: InputMaybe<Scalars['Int']>;
  productCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QueryProductCategoryArgs = {
  partTypeId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryProductClassArgs = {
  productClassId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryProductClassesArgs = {
  paging?: InputMaybe<CursorPaging>;
  productClassIds?: InputMaybe<Array<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryProductListArgs = {
  listId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryProductsArgs = {
  paging?: InputMaybe<CursorPaging>;
  productTypes?: InputMaybe<Array<ProductType>>;
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryProductVendorPricesArgs = {
  productId: Scalars['ID'];
  vendorId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryProviderArgs = {
  providerId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryProvidersArgs = {
  includeGloballyVerified?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
  providerIds?: InputMaybe<Array<Scalars['Int']>>;
  size?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QueryPutAwayOrderArgs = {
  putAwayOrderId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryPutAwayOrdersArgs = {
  paging?: InputMaybe<CursorPaging>;
  putAwayOrderIds?: InputMaybe<Array<Scalars['ID']>>;
  sourceIds?: InputMaybe<Array<Scalars['String']>>;
  sourceTypes?: InputMaybe<Array<PutAwayOrderSourceType>>;
  statuses?: InputMaybe<Array<PutAwayOrderStatus>>;
  storeIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** The main Query GraphQL Object */
export type QueryResourceArgs = {
  resourceId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryResourceAccessArgs = {
  paging?: InputMaybe<CursorPaging>;
  resourceId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryResourceChildrenArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  parentId?: InputMaybe<Scalars['ID']>;
};


/** The main Query GraphQL Object */
export type QueryResourceMoveImpactArgs = {
  newParentId: Scalars['ID'];
  resourceId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryResourcesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  resourceIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** The main Query GraphQL Object */
export type QueryRestBranchesArgs = {
  companyId: Scalars['BigInteger'];
};


/** The main Query GraphQL Object */
export type QueryRestCompanyArgs = {
  companyId: Scalars['BigInteger'];
};


/** The main Query GraphQL Object */
export type QueryRestEquipmentMakeArgs = {
  id: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryRestEquipmentMakesArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryRestEquipmentModelArgs = {
  id: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryRestEquipmentModelsArgs = {
  equipmentMakeId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
};


/** The main Query GraphQL Object */
export type QueryRestUsersArgs = {
  companyId: Scalars['BigInteger'];
};


/** The main Query GraphQL Object */
export type QueryRoleArgs = {
  roleId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryRolesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QuerySearchResourcesArgs = {
  paging?: InputMaybe<CursorPaging>;
  query: Scalars['String'];
  types?: InputMaybe<Array<ResourceType>>;
};


/** The main Query GraphQL Object */
export type QueryStoreArgs = {
  branchId?: InputMaybe<Scalars['Int']>;
  storeId?: InputMaybe<Scalars['Int']>;
};


/** The main Query GraphQL Object */
export type QueryStorePartArgs = {
  partId?: InputMaybe<Scalars['Int']>;
  storeId?: InputMaybe<Scalars['Int']>;
  storePartId?: InputMaybe<Scalars['BigInteger']>;
};


/** The main Query GraphQL Object */
export type QueryStorePartsArgs = {
  aboveMax?: InputMaybe<Scalars['Boolean']>;
  aboveThreshold?: InputMaybe<Scalars['Boolean']>;
  belowMin?: InputMaybe<Scalars['Boolean']>;
  belowThreshold?: InputMaybe<Scalars['Boolean']>;
  branchIds?: InputMaybe<Array<Scalars['Int']>>;
  excludeDeadStock?: InputMaybe<Scalars['Boolean']>;
  excludeEmpty?: InputMaybe<Scalars['Boolean']>;
  excludeEmptyQuantity?: InputMaybe<Scalars['Boolean']>;
  inventoryLocationBranchIds?: InputMaybe<Array<Scalars['ID']>>;
  inventoryLocationIds?: InputMaybe<Array<Scalars['Int']>>;
  isDeadStock?: InputMaybe<Scalars['Boolean']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  partCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  partDescription?: InputMaybe<Scalars['String']>;
  partExternalApplications?: InputMaybe<Array<ExternalApplication>>;
  partIds?: InputMaybe<Array<Scalars['Int']>>;
  partNumbers?: InputMaybe<Array<Scalars['String']>>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  providerIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<Array<StorePartSort>>;
  storeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  upcs?: InputMaybe<Array<Scalars['String']>>;
};


/** The main Query GraphQL Object */
export type QueryStoresArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']>>;
  externalApplications?: InputMaybe<Array<ExternalApplication>>;
  inventoryTypes?: InputMaybe<Array<InventoryType>>;
  isMtt?: InputMaybe<Scalars['Boolean']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  onlyParent?: InputMaybe<Scalars['Boolean']>;
  permissions?: InputMaybe<Array<Permission>>;
  size?: InputMaybe<Scalars['Int']>;
  storeIds?: InputMaybe<Array<Scalars['Int']>>;
};


/** The main Query GraphQL Object */
export type QueryTransactionArgs = {
  transactionId: Scalars['Int'];
};


/** The main Query GraphQL Object */
export type QueryTransactionsArgs = {
  customIds?: InputMaybe<Array<Scalars['String']>>;
  fromIds?: InputMaybe<Array<Scalars['Int']>>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  toIds?: InputMaybe<Array<Scalars['Int']>>;
  transactionStatuses?: InputMaybe<Array<TransactionStatus>>;
  transactionTypes?: InputMaybe<Array<TransactionType>>;
};


/** The main Query GraphQL Object */
export type QueryTransferOrderArgs = {
  transferOrderId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryTransferOrdersArgs = {
  fromInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillmentIds?: InputMaybe<Array<Scalars['ID']>>;
  fulfillmentOrderNumbers?: InputMaybe<Array<Scalars['String']>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  orderTypes?: InputMaybe<Array<InputMaybe<TransferOrderType>>>;
  paging?: InputMaybe<CursorPaging>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<TransferOrderSort>;
  statuses?: InputMaybe<Array<InputMaybe<TransferOrderStatus>>>;
  toInventoryIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** The main Query GraphQL Object */
export type QueryUserArgs = {
  id: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryUserAuthorizationsArgs = {
  permissions?: InputMaybe<Array<Permission>>;
};


/** The main Query GraphQL Object */
export type QueryUserEffectiveGrantsArgs = {
  permissionIds?: InputMaybe<Array<Scalars['ID']>>;
  resourceId?: InputMaybe<Scalars['ID']>;
  resourceType?: InputMaybe<ResourceType>;
  userId: Scalars['ID'];
};


/** The main Query GraphQL Object */
export type QueryUserPermissionGrantsArgs = {
  objectIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions?: InputMaybe<Array<Permission>>;
  resourceTypes?: InputMaybe<Array<ResourceType>>;
};


/** The main Query GraphQL Object */
export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  paging?: InputMaybe<CursorPaging>;
};


/** The main Query GraphQL Object */
export type QueryUsersByIdArgs = {
  input: Scalars['String'];
};


/** The main Query GraphQL Object */
export type QueryUsersSearchArgs = {
  companyId: Scalars['BigInteger'];
  search: Scalars['String'];
};

export type ReceiveLineItemInput = {
  /** The ID of the line item to receive */
  lineItemId: Scalars['ID'];
  /** The quantity of the line item product received */
  quantityReceived: Scalars['Int'];
};

export type ReceiveTransferOrderLineItemsInput = {
  /** The line items on the transfer order to receive */
  lineItems: Array<ReceiveLineItemInput>;
  /** Notes about the receipt */
  notes?: InputMaybe<Scalars['String']>;
  /** The ID of the transfer order to receive */
  transferOrderId: Scalars['ID'];
};

export type ReceiveTransferOrderLineItemsResult = IMutationResult & {
  __typename?: 'ReceiveTransferOrderLineItemsResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transferOrder?: Maybe<TransferOrder>;
};

export type RecordPickedQuantitiesInput = {
  lines: Array<RecordPickedQuantitiesLineInput>;
  pickOrderId: Scalars['ID'];
};

export type RecordPickedQuantitiesLineInput = {
  pickOrderLineId: Scalars['ID'];
  quantityPicked: Scalars['Int'];
};

export type RecordPickedQuantitiesResult = IMutationResult & {
  __typename?: 'RecordPickedQuantitiesResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  pickOrder?: Maybe<PickOrder>;
  success: Scalars['Boolean'];
};

export type Region = NamedResourceEntity & {
  __typename?: 'Region';
  company: Company;
  /** The company that this resource belongs to */
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  regionId: Scalars['ID'];
};

export type RejectTransferOrderInput = {
  /** Notes about the rejection */
  approverNote?: InputMaybe<Scalars['String']>;
  /** The ID of the transfer order to reject */
  transferOrderId: Scalars['ID'];
};

export type RejectTransferOrderResult = IMutationResult & {
  __typename?: 'RejectTransferOrderResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transferOrder?: Maybe<ManualTransferOrder>;
};

export type RemovePermissionsFromRole__Result = IMutationResult & {
  __typename?: 'RemovePermissionsFromRole__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The Role that had the permissions removed from it. */
  role?: Maybe<Role>;
  success: Scalars['Boolean'];
};

export type RemoveProductFromVendorCatalogInput = {
  productId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type RemoveProductFromVendorCatalogResult = IMutationResult & {
  __typename?: 'RemoveProductFromVendorCatalogResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RemoveResourcePolicyFromGroup__Result = IMutationResult & {
  __typename?: 'RemoveResourcePolicyFromGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The Group that had the policy removed from it. */
  group?: Maybe<Group>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RemoveUserFromGroup__Result = IMutationResult & {
  __typename?: 'RemoveUserFromGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The Group that had the users removed from it. */
  group?: Maybe<Group>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RentalItem = {
  __typename?: 'RentalItem';
  id: Scalars['ID'];
  quantityOnRent: Scalars['Int'];
  rentalId: Scalars['ID'];
};

export enum RentalStatus {
  Billed = 'BILLED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Draft = 'DRAFT',
  NeedsApproval = 'NEEDS_APPROVAL',
  OffRent = 'OFF_RENT',
  OnRent = 'ON_RENT',
  Pending = 'PENDING',
  Reserved = 'RESERVED',
  Scheduled = 'SCHEDULED',
  Unconfirmed = 'UNCONFIRMED'
}

export type RentalToRentalRetailSale__Result = IMutationResult & {
  __typename?: 'RentalToRentalRetailSale__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RentalToRentalRetailSaleInputTransactionItem = {
  /** How much each individual part costs */
  costPerItem: Scalars['Float'];
  itemStatus?: InputMaybe<ItemStatus>;
  partId: Scalars['Int'];
  /** The quantity of the part that was sold */
  quantity: Scalars['Int'];
};

export type RentalToStore__Result = IMutationResult & {
  __typename?: 'RentalToStore__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RentalToStoreAndRetailSale__Result = IMutationResult & {
  __typename?: 'RentalToStoreAndRetailSale__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RentalToStoreAndRetailSaleInputTransactionItem = {
  /** How much each individual part costs */
  costPerItem?: InputMaybe<Scalars['Float']>;
  itemStatus?: InputMaybe<ItemStatus>;
  partId: Scalars['Int'];
  /** The quantity of the part that was returned to the store */
  quantityReturned: Scalars['Int'];
  /** The quantity of the part sold */
  quantitySold?: InputMaybe<Scalars['Int']>;
};

export type RentalToStoreInputTransactionItem = {
  /** How much each individual part costs */
  costPerItem?: InputMaybe<Scalars['Float']>;
  itemStatus?: InputMaybe<ItemStatus>;
  partId: Scalars['Int'];
  /** The quantity of the part that was returned to the store */
  quantity: Scalars['Int'];
};

/** Input type for reopening demand requests */
export type ReopenDemandRequestInput = {
  /** The ID of the demand request to reopen */
  id: Scalars['ID'];
};

/** Input type for reopening demand request line items */
export type ReopenDemandRequestLineItemInput = {
  /** The ID of the demand request containing the line item */
  demandRequestId: Scalars['ID'];
  /** The ID of the line item to reopen */
  lineItemId: Scalars['ID'];
};

/** Result type for reopening demand request line items */
export type ReopenDemandRequestLineItemResult = {
  __typename?: 'ReopenDemandRequestLineItemResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Input type for reopening multiple demand request line items */
export type ReopenDemandRequestLineItemsInput = {
  /** The ID of the demand request containing the line items */
  demandRequestId: Scalars['ID'];
  /** The IDs of the line items to reopen */
  lineItemIds: Array<Scalars['ID']>;
};

/** Result type for reopening multiple demand request line items */
export type ReopenDemandRequestLineItemsResult = IMutationResult & {
  __typename?: 'ReopenDemandRequestLineItemsResult';
  demandRequest?: Maybe<DemandRequest>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Result type for reopening demand requests */
export type ReopenDemandRequestResult = {
  __typename?: 'ReopenDemandRequestResult';
  demandRequest?: Maybe<DemandRequest>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type RequestFulfillmentOrderCancellationInput = {
  fulfillmentOrderId: Scalars['ID'];
};

export type RequestFulfillmentOrderCancellationResult = IMutationResult & {
  __typename?: 'RequestFulfillmentOrderCancellationResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Reservation = {
  __typename?: 'Reservation';
  /** The user who created this object. */
  createdById: Scalars['BigInteger'];
  dateCancelled?: Maybe<Scalars['String']>;
  dateCompleted?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  inventoryLocation: InventoryLocation;
  /** The Inventory Location that contains the Product */
  inventoryLocationId: Scalars['BigInteger'];
  /** The user who last modified this object. */
  modifiedById: Scalars['BigInteger'];
  part?: Maybe<Part>;
  /** The Part being reserved */
  partId: Scalars['BigInteger'];
  /** Number of parts reserved */
  quantity: Scalars['Int'];
  reservationId: Scalars['BigInteger'];
  store?: Maybe<Store>;
  /** The Store making the reservation */
  storeId: Scalars['BigInteger'];
  targetId?: Maybe<Scalars['BigInteger']>;
  targetType: ReservationTargetType;
  /** @deprecated This field is going away. Use targetType */
  targetTypeId?: Maybe<Scalars['Int']>;
  targetUuidId?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export enum ReservationTargetType {
  FulfillmentOrder = 'FULFILLMENT_ORDER',
  Invoice = 'INVOICE',
  Order = 'ORDER',
  WorkOrder = 'WORK_ORDER'
}

export enum ReserveInventoryItemsFailedReservationReason {
  InsufficientQuantity = 'INSUFFICIENT_QUANTITY',
  ReservationConflict = 'RESERVATION_CONFLICT'
}

export type ReserveInventoryItemsInput = {
  /** Which Inventory or Store should these items be reserved in? */
  inventoryLocationId: Scalars['BigInteger'];
  /** The list of items you wish to reserve */
  items: Array<ReserveInventoryItemsInputItem>;
  /** The ID of the entity that these items should be reserved for */
  targetId: Scalars['BigInteger'];
  /** Since "target" is a polymorphic entity, we need to know how to interpret the ID */
  targetTypeId: ReservationTargetType;
};

export type ReserveInventoryItemsInputItem = {
  /** Which product (aka part) to reserve */
  productId: Scalars['BigInteger'];
  /** How many should be reserved? (Must be greater than 0) */
  quantity: Scalars['Int'];
};

export type ReserveInventoryItemsResult = IMutationResult & {
  __typename?: 'ReserveInventoryItemsResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  failedReservations?: Maybe<Array<Maybe<ReserveInventoryItemsResultFailedReservations>>>;
  fullReservations?: Maybe<Array<Maybe<Reservation>>>;
  message: Scalars['String'];
  partialReservations?: Maybe<Array<Maybe<ReserveInventoryItemsResultPartialReservations>>>;
  success: Scalars['Boolean'];
};

export type ReserveInventoryItemsResultFailedReservations = {
  __typename?: 'ReserveInventoryItemsResultFailedReservations';
  failureReason: ReserveInventoryItemsFailedReservationReason;
  item?: Maybe<StorePart>;
  productId: Scalars['BigInteger'];
  quantity: Scalars['Int'];
};

export type ReserveInventoryItemsResultPartialReservations = {
  __typename?: 'ReserveInventoryItemsResultPartialReservations';
  item: StorePart;
  productId: Scalars['BigInteger'];
  quantityNotReserved: Scalars['Int'];
  reservation: Reservation;
};

export type Resource = {
  __typename?: 'Resource';
  /** This resource's ancestor chain, ordered COMPANY down to immediate parent (self excluded), for breadcrumb display. Batched: one bounded recursive walk resolves every resource requested in a tick. */
  ancestors: Array<Resource>;
  /** The number of direct children this resource has, so the tree can render an expand affordance without fetching them. */
  childCount: Scalars['Int'];
  /** The company that this resource belongs to */
  companyId: Scalars['BigInteger'];
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  /** The underlying entity that this resource represents */
  entity?: Maybe<NamedResourceEntity>;
  id: Scalars['Int'];
  /** The actual DB record foreign key */
  objectId: Scalars['BigInteger'];
  /** The parent in the hierarchy of resources */
  parentId?: Maybe<Scalars['BigInteger']>;
  resourceId: Scalars['BigInteger'];
  resourceType?: Maybe<ResourceType>;
};

export type ResourceAccessEntry = {
  __typename?: 'ResourceAccessEntry';
  group: Group;
  /** True when `rootResource` differs from the queried resource. */
  inherited: Scalars['Boolean'];
  permission: PermissionMeta;
  role: Role;
  /** The resource the contributing policy is attached to. */
  rootResource: Resource;
};

export type ResourceAccessEntryConnection = {
  __typename?: 'ResourceAccessEntryConnection';
  edges: Array<ResourceAccessEntryEdge>;
  pageInfo: PageInfo;
};

export type ResourceAccessEntryEdge = {
  __typename?: 'ResourceAccessEntryEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: ResourceAccessEntry;
};

export type ResourceMoveImpact = {
  __typename?: 'ResourceMoveImpact';
  /** The size of the moved node's subtree (including itself). */
  affectedResourceCount: Scalars['Int'];
  /** Grants the subtree would gain if the move were committed. */
  gained: Array<GrantChange>;
  /** Pass this to moveResource's input to reject the move if the impact has materially changed since this preview. */
  impactFingerprint?: Maybe<Scalars['String']>;
  /** Grants the subtree would lose if the move were committed. */
  revoked: Array<GrantChange>;
  valid: Scalars['Boolean'];
  /** Set when `valid` is false, describing why the move is invalid. */
  validationError?: Maybe<Scalars['String']>;
};

export type ResourcePolicy = {
  __typename?: 'ResourcePolicy';
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  group: Group;
  /** The group to tie the given resource(s) for the given role */
  groupId: Scalars['BigInteger'];
  id: Scalars['Int'];
  resource: Resource;
  /** The root resource to apply this policy to. All child resources will inherit the given role permissions */
  resourceId: Scalars['BigInteger'];
  resourcePolicyId: Scalars['ID'];
  role: Role;
  /** The set of permissions to apply to the given resources for the given group. */
  roleId: Scalars['BigInteger'];
};

export type ResourceSearchResult = {
  __typename?: 'ResourceSearchResult';
  /** Ancestors, company to parent, for display. */
  path: Array<Resource>;
  /** Exact > prefix > substring; own-name matches outrank ancestor matches. */
  rank: Scalars['Float'];
  resource: Resource;
};

export type ResourceSearchResultConnection = {
  __typename?: 'ResourceSearchResultConnection';
  edges: Array<ResourceSearchResultEdge>;
  pageInfo: PageInfo;
};

export type ResourceSearchResultEdge = {
  __typename?: 'ResourceSearchResultEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: ResourceSearchResult;
};

export enum ResourceType {
  Branch = 'BRANCH',
  Company = 'COMPANY',
  District = 'DISTRICT',
  Es = 'ES',
  Region = 'REGION',
  Store = 'STORE'
}

/**
 * A pointer at a retail sale that lives outside of this service.
 *
 * Only the identifier is available here; consumers resolve the sale's details
 * and build any link to it themselves.
 */
export type RetailSaleReference = {
  __typename?: 'RetailSaleReference';
  id: Scalars['ID'];
};

export type Role = {
  __typename?: 'Role';
  company: Company;
  /** The company that this role belongs to */
  companyId: Scalars['BigInteger'];
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  permissions: Array<Maybe<PermissionMeta>>;
  roleId: Scalars['BigInteger'];
  spendingLimit?: Maybe<Scalars['Float']>;
};

export type SetPreferredVendorInput = {
  productId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type SetPreferredVendorResult = IMutationResult & {
  __typename?: 'SetPreferredVendorResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartMultiManufacturerProductUpload__Input = {
  /** The S3 bucket key for the CSV file. For better debugging, this should match passed in session ID. */
  csvFileKey: Scalars['String'];
  /** The session ID of the upload. For better debugging, this should match the session ID in the CSV file. */
  sessionId: Scalars['ID'];
};

export type StartMultiManufacturerProductUpload__Result = IMutationResult & {
  __typename?: 'StartMultiManufacturerProductUpload__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  uploadSession?: Maybe<GlobalProductCatalogUpload>;
};

export type Store = NamedResourceEntity & StoreInterface & {
  __typename?: 'Store';
  children: Array<StoreInterface>;
  company: Company;
  companyId: Scalars['Int'];
  /** The date that the store was archived. */
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  /** Get store external application id */
  externalStoreId?: Maybe<Scalars['ID']>;
  /** Get each store's external app ids and app name */
  externalStoreIds: Array<Maybe<ExternalStoreMeta>>;
  id: Scalars['Int'];
  inventoryType?: Maybe<InventoryType>;
  isWarehouse: Scalars['Boolean'];
  name: Scalars['String'];
  /** Number of put-away stations. NULL for non-warehouses; an integer (>= 0) for warehouses. */
  numPutawayStations?: Maybe<Scalars['Int']>;
  parent?: Maybe<StoreInterface>;
  parentId?: Maybe<Scalars['Int']>;
  storeId: Scalars['Int'];
  storeTypeId?: Maybe<Scalars['Int']>;
};


export type StoreExternalStoreIdArgs = {
  app: ExternalApplication;
};

export type StoreInterface = {
  children: Array<StoreInterface>;
  company: Company;
  companyId: Scalars['Int'];
  dateCreated?: Maybe<Scalars['String']>;
  dateUpdated?: Maybe<Scalars['String']>;
  /** Get store external application id */
  externalStoreId?: Maybe<Scalars['ID']>;
  /** Get each store's external app ids and app name */
  externalStoreIds: Array<Maybe<ExternalStoreMeta>>;
  id: Scalars['Int'];
  inventoryType?: Maybe<InventoryType>;
  isWarehouse: Scalars['Boolean'];
  name: Scalars['String'];
  parent?: Maybe<StoreInterface>;
  parentId?: Maybe<Scalars['Int']>;
  storeId: Scalars['Int'];
  storeTypeId?: Maybe<Scalars['Int']>;
};


export type StoreInterfaceExternalStoreIdArgs = {
  app: ExternalApplication;
};

export type StorePart = {
  __typename?: 'StorePart';
  /** Item asset */
  assetId?: Maybe<Scalars['BigInteger']>;
  /** The number of parts available minus any reservations for the part. NOTE: This is currently just a point to quantity. */
  availableQuantity: Scalars['Int'];
  /** All child stores that contain the same part. */
  children?: Maybe<Array<StorePart>>;
  /** The cost of the part as last recorded by this store. */
  cost?: Maybe<Scalars['Float']>;
  /** Custom Name of Item Asset */
  customName?: Maybe<Scalars['String']>;
  /** When this item was archived, or null while it is active. */
  dateArchived?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['String'];
  dateLastActive: Scalars['ArrowDateTime'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  /** If non-null, shows how many parts are in the process of being transferred to this store. Null if this part is not being transferred */
  incomingPartsTransferQuantity?: Maybe<Scalars['Int']>;
  inventoryLocation: InventoryLocation;
  /** The Inventory Location that contains the Product */
  inventoryLocationId: Scalars['BigInteger'];
  /** True if this item has been archived (e.g. it was absorbed by a product merge). Archived items no longer appear in inventory but remain readable from historical references such as item history. */
  isArchived: Scalars['Boolean'];
  /** True if the store part is dead stock (inactive for 180+ days and has quantity > 0), otherwise False */
  isDeadStock: Scalars['Boolean'];
  /** A list of rentals which indicate that some items are out of inventory due to one or more rentals. */
  itemsOnRent: Array<ItemRental>;
  /** Item type */
  itemTypeId?: Maybe<Scalars['Int']>;
  /** The last time a price was entered for this item. */
  lastTimePriceWasUpdated?: Maybe<LastTimePriceWasUpdated>;
  /** A descriptive name that describes where in the Store this part is located */
  location?: Maybe<Scalars['String']>;
  /** How many of this part should be on hand after ordering. */
  max?: Maybe<Scalars['Int']>;
  /** Additional information that helps the inventory manager understand the reasoning for the part in their inventory. */
  note?: Maybe<Scalars['String']>;
  /** Open reservations for this store part. i.e. Reservations that are not cancelled or completed. */
  openReservations?: Maybe<Array<Reservation>>;
  /** The quantity of this part that is reserved to be transferred out of this store and is unavailable for other usages */
  outgoingQuantity: Scalars['Int'];
  /** The open outgoing transfers for this part, what transfer order they are on, and the outstanding quantity on each */
  outgoingTransferDetails?: Maybe<Array<OutgoingTransferDetail>>;
  part: Part;
  /** The Part that the store contains */
  partId: Scalars['BigInteger'];
  /** If non-null, shows how many parts have been ordered. Null if the part has not been ordered. */
  partsOrdered?: Maybe<Scalars['Int']>;
  /** The number of parts ordered, what PO they came from, and what target they were intended for */
  partsOrderedDetails?: Maybe<Array<PartsOrderedDetail>>;
  /** How many of this Part is on hand. */
  quantity: Scalars['Int'];
  /** The total quantity currently out on rent */
  quantityOnRent: Scalars['Int'];
  /** The inventory system's history on what is currently on rent. */
  rentalItems: Array<RentalItem>;
  rentalLocation?: Maybe<Store>;
  /** The Store ('Rental Location') that rents the Product */
  rentalLocationId?: Maybe<Scalars['BigInteger']>;
  /** The number of parts reserved for intended target type if both targetId and targetType are provided, otherwise, returns the total reserved quantity. */
  reservedQuantity: Scalars['Int'];
  /** Serial number of Unique item */
  serialNumber?: Maybe<Scalars['String']>;
  store: StoreInterface;
  /** The Store that contains the Part */
  storeId: Scalars['BigInteger'];
  storePartId: Scalars['BigInteger'];
  /** The minimum number of this Part before more needs to be ordered. */
  threshold?: Maybe<Scalars['Int']>;
  /** The sum of the quantities for this part at this store and all child stores */
  total: Scalars['Int'];
  weightedAverageCost?: Maybe<Money>;
};


export type StorePartReservedQuantityArgs = {
  targetId?: InputMaybe<Scalars['Int']>;
  targetType?: InputMaybe<ReservationTargetType>;
};

export type StorePartSort = {
  direction: SortDirection;
  field: StorePartSortField;
};

export enum StorePartSortField {
  AvailableQuantity = 'availableQuantity',
  BranchId = 'branchId',
  Id = 'id',
  InventoryLocationName = 'inventoryLocationName',
  PartName = 'partName'
}

export type StoreToRental__Result = IMutationResult & {
  __typename?: 'StoreToRental__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type StoreToRentalInputTransactionItem = {
  /** How much each individual part costs */
  costPerItem?: InputMaybe<Scalars['Float']>;
  itemStatus?: InputMaybe<ItemStatus>;
  partId: Scalars['Int'];
  /** The quantity of the part that is being rented out by the inventory location */
  quantity: Scalars['Int'];
};

export type StoreToRentalRetailSale__Result = IMutationResult & {
  __typename?: 'StoreToRentalRetailSale__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The transaction indicating the parts have been sold, removing the parts from the store's inventory */
  rentalRetailSale?: Maybe<Transaction>;
  success: Scalars['Boolean'];
};

export type StoreToRentalRetailSaleInputTransactionItem = {
  /** How much each individual part costs */
  costPerItem: Scalars['Float'];
  itemStatus?: InputMaybe<ItemStatus>;
  partId: Scalars['Int'];
  /** The quantity of the part that was sold */
  quantity: Scalars['Int'];
};

export type SystemTransferOrder = TransferOrder & {
  __typename?: 'SystemTransferOrder';
  /** TransactionGroup holding this transfer order's deferred asset transactions; null until an asset leg is started. */
  assetTransactionGroupId?: Maybe<Scalars['ID']>;
  assetTransactions?: Maybe<Array<AssetTransfer>>;
  /** Lifecycle of the deferred asset leg of an MTT load/unload; null when no assets are involved. */
  assetTransferStatus?: Maybe<AssetTransferStatus>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancelledById?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateShipped?: Maybe<Scalars['ArrowDateTime']>;
  dateUpdated: Scalars['ArrowDateTime'];
  demandRequest?: Maybe<DemandRequest>;
  fromInventoryId: Scalars['ID'];
  fromStore?: Maybe<InventoryLocation>;
  fulfillment?: Maybe<Fulfillment>;
  fulfillmentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isClosed: Scalars['Boolean'];
  lineItems?: Maybe<Array<TransferOrderLineItem>>;
  receipts: Array<TransferOrderReceipt>;
  status: TransferOrderStatus;
  toInventoryId: Scalars['ID'];
  toStore?: Maybe<InventoryLocation>;
  trackingNumber?: Maybe<Scalars['String']>;
  transferOrderType: TransferOrderType;
};

export type Transaction = {
  __typename?: 'Transaction';
  company: Company;
  /** The company that this transaction belongs to. */
  companyId: Scalars['BigInteger'];
  /** The user who created this transaction */
  createdBy: Scalars['BigInteger'];
  createdByUser: User;
  /** An extra identifier to be stored with the transaction (e.g. PO#, Invoice#, etc */
  customId?: Maybe<Scalars['String']>;
  dateCancelled?: Maybe<Scalars['String']>;
  dateCompleted?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  from?: Maybe<TransactionEntity>;
  fromId?: Maybe<Scalars['BigInteger']>;
  fromUuidId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  memo?: Maybe<Scalars['String']>;
  /** The user who modified this transaction */
  modifiedBy: Scalars['BigInteger'];
  modifiedByUser: User;
  splitFrom?: Maybe<Scalars['Int']>;
  to?: Maybe<TransactionEntity>;
  toId?: Maybe<Scalars['BigInteger']>;
  toUuidId?: Maybe<Scalars['String']>;
  transactionGroupId: Scalars['BigInteger'];
  transactionId: Scalars['Int'];
  transactionItems?: Maybe<Array<Maybe<TransactionItem>>>;
  transactionStatus?: Maybe<TransactionStatus>;
  transactionType?: Maybe<TransactionType>;
  weightedAverageCostSnapshots?: Maybe<Array<Maybe<WeightedAverageCostSnapshot>>>;
};

export type TransactionEntity = Branch | NamedStore | Provider;

export type TransactionItem = {
  __typename?: 'TransactionItem';
  costPerItem: Scalars['Float'];
  /** The user who created this transaction item */
  createdBy: Scalars['BigInteger'];
  createdByUser: User;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  itemStatus?: Maybe<ItemStatus>;
  /** The user who modified this transaction item */
  modifiedBy: Scalars['BigInteger'];
  modifiedByUser: User;
  part?: Maybe<Part>;
  partId: Scalars['BigInteger'];
  quantityOrdered: Scalars['Int'];
  quantityReceived?: Maybe<Scalars['Int']>;
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['Int'];
  transactionItemId: Scalars['BigInteger'];
  wacSnapshot?: Maybe<WeightedAverageCostSnapshot>;
  wacSnapshotId?: Maybe<Scalars['BigInteger']>;
};

export enum TransactionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Split = 'SPLIT',
  Submitted = 'SUBMITTED'
}

export enum TransactionType {
  AdjustToStore = 'ADJUST_TO_STORE',
  AssetToStore = 'ASSET_TO_STORE',
  BatchAddToStore = 'BATCH_ADD_TO_STORE',
  BatchSyncToStore = 'BATCH_SYNC_TO_STORE',
  ConversionToStore = 'CONVERSION_TO_STORE',
  CreditPurchaseToStore = 'CREDIT_PURCHASE_TO_STORE',
  DirectShipmentToStore = 'DIRECT_SHIPMENT_TO_STORE',
  OrderToStore = 'ORDER_TO_STORE',
  ProviderToStore = 'PROVIDER_TO_STORE',
  PurchaseOrderToStore = 'PURCHASE_ORDER_TO_STORE',
  RentalToStore = 'RENTAL_TO_STORE',
  RetailSaleToStore = 'RETAIL_SALE_TO_STORE',
  StoreToAdjust = 'STORE_TO_ADJUST',
  StoreToAsset = 'STORE_TO_ASSET',
  StoreToBatchSync = 'STORE_TO_BATCH_SYNC',
  StoreToConversion = 'STORE_TO_CONVERSION',
  StoreToCreditPurchase = 'STORE_TO_CREDIT_PURCHASE',
  StoreToDirectShipment = 'STORE_TO_DIRECT_SHIPMENT',
  StoreToLoss = 'STORE_TO_LOSS',
  StoreToObsolete = 'STORE_TO_OBSOLETE',
  StoreToOrder = 'STORE_TO_ORDER',
  StoreToProvider = 'STORE_TO_PROVIDER',
  StoreToPurchaseOrder = 'STORE_TO_PURCHASE_ORDER',
  StoreToRental = 'STORE_TO_RENTAL',
  StoreToRentalLoss = 'STORE_TO_RENTAL_LOSS',
  StoreToRentalRetailSale = 'STORE_TO_RENTAL_RETAIL_SALE',
  StoreToRetailSale = 'STORE_TO_RETAIL_SALE',
  StoreToStore = 'STORE_TO_STORE',
  StoreToWorkOrder = 'STORE_TO_WORK_ORDER',
  WorkOrderToStore = 'WORK_ORDER_TO_STORE'
}

export type TransferOrder = {
  /** TransactionGroup holding this transfer order's deferred asset transactions; null until an asset leg is started. */
  assetTransactionGroupId?: Maybe<Scalars['ID']>;
  /** Lifecycle of the deferred asset leg of an MTT load/unload; null when no assets are involved. */
  assetTransferStatus?: Maybe<AssetTransferStatus>;
  cancellationNote?: Maybe<Scalars['String']>;
  cancelledById?: Maybe<Scalars['ID']>;
  companyId: Scalars['ID'];
  dateCancelled?: Maybe<Scalars['ArrowDateTime']>;
  dateCompleted?: Maybe<Scalars['ArrowDateTime']>;
  dateCreated: Scalars['ArrowDateTime'];
  dateShipped?: Maybe<Scalars['ArrowDateTime']>;
  dateUpdated: Scalars['ArrowDateTime'];
  demandRequest?: Maybe<DemandRequest>;
  fromInventoryId: Scalars['ID'];
  fromStore?: Maybe<InventoryLocation>;
  id: Scalars['ID'];
  isClosed: Scalars['Boolean'];
  lineItems?: Maybe<Array<TransferOrderLineItem>>;
  receipts: Array<TransferOrderReceipt>;
  status: TransferOrderStatus;
  toInventoryId: Scalars['ID'];
  toStore?: Maybe<InventoryLocation>;
  trackingNumber?: Maybe<Scalars['String']>;
  transferOrderType: TransferOrderType;
};

export type TransferOrderConnection = {
  __typename?: 'TransferOrderConnection';
  edges: Array<TransferOrderEdge>;
  pageInfo: PageInfo;
  /** The total number of items matching the query, ignoring pagination. */
  totalCount: Scalars['Int'];
};

export type TransferOrderEdge = {
  __typename?: 'TransferOrderEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: TransferOrder;
};

export type TransferOrderLineItem = {
  __typename?: 'TransferOrderLineItem';
  allocationTargetId?: Maybe<Scalars['ID']>;
  allocationTargetType?: Maybe<ReservationTargetType>;
  demandRequestLineItem?: Maybe<DemandRequestLineItem>;
  demandRequestLineItemId?: Maybe<Scalars['ID']>;
  lineItemId: Scalars['ID'];
  lineNote?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  quantityCancelled?: Maybe<Scalars['Int']>;
  quantityReceived?: Maybe<Scalars['Int']>;
  quantityRequested: Scalars['Int'];
  transferOrder?: Maybe<TransferOrder>;
  transferOrderId: Scalars['ID'];
};

export type TransferOrderReceipt = {
  __typename?: 'TransferOrderReceipt';
  dateReceived: Scalars['ArrowDateTime'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  receiptItems: Array<TransferOrderReceiptLineItem>;
  receivedBy: User;
  receivedById: Scalars['ID'];
  transaction: Transaction;
  transactionId: Scalars['ID'];
  transferOrder: TransferOrder;
  transferOrderId: Scalars['ID'];
};

export type TransferOrderReceiptLineItem = {
  __typename?: 'TransferOrderReceiptLineItem';
  id: Scalars['ID'];
  lineItem: TransferOrderLineItem;
  lineItemId: Scalars['ID'];
  quantityReceived: Scalars['Int'];
  receipt: TransferOrderReceipt;
  receiptId: Scalars['ID'];
};

export type TransferOrderSort = {
  direction: SortDirection;
  field: TransferOrderSortField;
};

export enum TransferOrderSortField {
  DateCreated = 'DATE_CREATED',
  DateUpdated = 'DATE_UPDATED'
}

export enum TransferOrderStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InTransit = 'IN_TRANSIT',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum TransferOrderType {
  Manual = 'MANUAL',
  System = 'SYSTEM'
}

export enum UnitsOfMeasurementEnum {
  Bag = 'BAG',
  Barrel = 'BARREL',
  Bottle = 'BOTTLE',
  Bowl = 'BOWL',
  Box = 'BOX',
  Bucket = 'BUCKET',
  Bundle = 'BUNDLE',
  Can = 'CAN',
  Card = 'CARD',
  Carton = 'CARTON',
  Case = 'CASE',
  Centimeter = 'CENTIMETER',
  CubicFoot = 'CUBIC_FOOT',
  CubicMeter = 'CUBIC_METER',
  Dozen = 'DOZEN',
  Drum = 'DRUM',
  Each = 'EACH',
  Feet = 'FEET',
  FluidOunce = 'FLUID_OUNCE',
  Gallon = 'GALLON',
  Gallon_5 = 'GALLON_5',
  Inches = 'INCHES',
  Keg_50Kilograms = 'KEG_50_KILOGRAMS',
  Keg_60Liters = 'KEG_60_LITERS',
  Kilogram = 'KILOGRAM',
  Kit = 'KIT',
  Liter = 'LITER',
  Lot = 'LOT',
  Meter = 'METER',
  Millimeter = 'MILLIMETER',
  Ounce = 'OUNCE',
  Pack = 'PACK',
  PackOf_100 = 'PACK_OF_100',
  PackOf_50 = 'PACK_OF_50',
  Pair = 'PAIR',
  Pallet = 'PALLET',
  Piece = 'PIECE',
  Pint = 'PINT',
  Pound = 'POUND',
  Quart = 'QUART',
  Rack = 'RACK',
  Roll = 'ROLL',
  Set = 'SET',
  SetOf_3 = 'SET_OF_3',
  SetOf_4 = 'SET_OF_4',
  SetOf_5 = 'SET_OF_5',
  Sheet = 'SHEET',
  Single = 'SINGLE',
  Skid = 'SKID',
  Spool = 'SPOOL',
  SquareFoot = 'SQUARE_FOOT',
  SquareMeter = 'SQUARE_METER',
  Tube = 'TUBE',
  Yard = 'YARD'
}

export type UnloadMobileToolTrailerInput = {
  /** The assets selected to unload from the trailer */
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The Mobile Tool Trailer's inventory location */
  fromInventoryLocationId: Scalars['ID'];
  /** The products and quantities selected to unload from the trailer */
  products?: InputMaybe<Array<UnloadMobileToolTrailerProductInput>>;
  /** The receiving Distribution Center's inventory location */
  toInventoryLocationId: Scalars['ID'];
};

export type UnloadMobileToolTrailerProductInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UnloadMobileToolTrailerResult = IMutationResult & {
  __typename?: 'UnloadMobileToolTrailerResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  transferOrder?: Maybe<TransferOrder>;
};

/** Input for updating fulfiller notes on a line item */
export type UpdateDemandRequestLineItemFulfillerNotesInput = {
  /** The ID of the demand request containing the line item */
  demandRequestId: Scalars['ID'];
  /** Fulfiller notes for this line item (max 1000 chars, null to clear) */
  fulfillerNotes?: InputMaybe<Scalars['String']>;
  /** The line item to update */
  lineItemId: Scalars['ID'];
};

/** Result of updating fulfiller notes */
export type UpdateDemandRequestLineItemFulfillerNotesResult = IMutationResult & {
  __typename?: 'UpdateDemandRequestLineItemFulfillerNotesResult';
  demandRequest?: Maybe<DemandRequest>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateDistrict__Input = {
  districtId: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateDistrict__Result = IMutationResult & {
  __typename?: 'UpdateDistrict__Result';
  /** The updated district. */
  district?: Maybe<District>;
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateGroup__Input = {
  groupId: Scalars['BigInteger'];
  name?: InputMaybe<Scalars['String']>;
  spendingLimit?: InputMaybe<Scalars['Float']>;
};

export type UpdateGroup__Result = IMutationResult & {
  __typename?: 'UpdateGroup__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  /** The updated group */
  group?: Maybe<Group>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateInventoryLocation__Result = IMutationResult & {
  __typename?: 'UpdateInventoryLocation__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  inventoryLocation?: Maybe<InventoryLocation>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateInventoryLocationWarehouseInput = {
  /** 5-digit zip codes whose stock requests are routed to this mini-DC first. Replaces the whole list. Omit to leave unchanged. */
  servedZipCodes?: InputMaybe<Array<Scalars['String']>>;
  /** The system that picks the warehouse's orders: NUMINA, or MANUAL for a mini-DC picked by hand. Changing it affects only fulfillment orders submitted afterwards. */
  warehouseExecutionSystem: WarehouseExecutionSystem;
};

export type UpdateItemMasterDimensionsInput = {
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  unit: DimensionUom;
  width: Scalars['Decimal'];
};

export type UpdateItemMasterInput = {
  equipmentMakeId?: InputMaybe<Scalars['ID']>;
  equipmentModelId?: InputMaybe<Scalars['ID']>;
  flammable?: InputMaybe<Scalars['Boolean']>;
  fragile?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isHazmat?: InputMaybe<Scalars['Boolean']>;
  itemMasterId: Scalars['ID'];
  lithiumIonBattery?: InputMaybe<Scalars['Boolean']>;
  numinaSerialType?: InputMaybe<NuminaSerialType>;
  variants?: InputMaybe<Array<UpdateItemMasterVariantsItemInput>>;
};

export type UpdateItemMasterResult = IMutationResult & {
  __typename?: 'UpdateItemMasterResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  itemMaster?: Maybe<ItemMaster>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateItemMasterVariantDimensionsInput = {
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  unit: DimensionUom;
  width: Scalars['Decimal'];
};

export type UpdateItemMasterVariantInput = {
  conversionRate?: InputMaybe<Scalars['Int']>;
  dimensions?: InputMaybe<UpdateItemMasterVariantDimensionsInput>;
  freightClass?: InputMaybe<Scalars['String']>;
  isPolybagEligible?: InputMaybe<Scalars['Boolean']>;
  itemMasterVariantId: Scalars['ID'];
  nmfc?: InputMaybe<Scalars['String']>;
  shippedInOriginalContainer?: InputMaybe<Scalars['Boolean']>;
  siocQuantity?: InputMaybe<Scalars['Int']>;
  uom?: InputMaybe<ItemMasterVariantUom>;
  weight?: InputMaybe<UpdateItemMasterVariantWeightInput>;
};

export type UpdateItemMasterVariantResult = IMutationResult & {
  __typename?: 'UpdateItemMasterVariantResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  itemMaster?: Maybe<ItemMaster>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateItemMasterVariantsItemInput = {
  conversionRate?: InputMaybe<Scalars['Int']>;
  dimensions: UpdateItemMasterDimensionsInput;
  freightClass?: InputMaybe<Scalars['String']>;
  isBase: Scalars['Boolean'];
  /** Omit to keep the variant's current value for this product (false for a product that has no variant yet). */
  isPolybagEligible?: InputMaybe<Scalars['Boolean']>;
  nmfc?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  shippedInOriginalContainer: Scalars['Boolean'];
  siocQuantity?: InputMaybe<Scalars['Int']>;
  uom: ItemMasterVariantUom;
  weight: UpdateItemMasterWeightInput;
};

export type UpdateItemMasterVariantWeightInput = {
  amount: Scalars['Decimal'];
  unit: WeightUnit;
};

export type UpdateItemMasterWeightInput = {
  amount: Scalars['Decimal'];
  unit: WeightUnit;
};

export type UpdatePartExternalAppXrefInput = {
  /** The external application this product is associated with. */
  applicationId: ExternalApplication;
  /** The external application's identifier for this product (e.g. the Shopify inventory item gid). */
  theirStringObjectId: Scalars['String'];
};

export type UpdateProduct__Result = IMutationResult & {
  __typename?: 'UpdateProduct__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  product?: Maybe<Product>;
  success: Scalars['Boolean'];
};

export type UpdateProductCategory__Result = IMutationResult & {
  __typename?: 'UpdateProductCategory__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  productCategory?: Maybe<ProductCategory>;
  success: Scalars['Boolean'];
};

export type UpdateProductClass__Result = IMutationResult & {
  __typename?: 'UpdateProductClass__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  productClass?: Maybe<ProductClass>;
  success: Scalars['Boolean'];
};

export type UpdateProductVendorPricingInput = {
  agreedNetPrice?: InputMaybe<Scalars['Decimal']>;
  makeIndefinite?: InputMaybe<Scalars['Boolean']>;
  priceEndDate?: InputMaybe<Scalars['Date']>;
  priceStartDate?: InputMaybe<Scalars['Date']>;
  productVendorPricingId: Scalars['ID'];
};

export type UpdateProductVendorPricingResult = IMutationResult & {
  __typename?: 'UpdateProductVendorPricingResult';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateRegion__Input = {
  name: Scalars['String'];
  regionId: Scalars['ID'];
};

export type UpdateRegion__Result = IMutationResult & {
  __typename?: 'UpdateRegion__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The updated region. */
  region?: Maybe<Region>;
  success: Scalars['Boolean'];
};

export type UpdateRole__Input = {
  name?: InputMaybe<Scalars['String']>;
  roleId: Scalars['BigInteger'];
  spendingLimit?: InputMaybe<Scalars['Float']>;
};

export type UpdateRole__Result = IMutationResult & {
  __typename?: 'UpdateRole__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The updated role */
  role?: Maybe<Role>;
  success: Scalars['Boolean'];
};

export type UpdateStore__Result = IMutationResult & {
  __typename?: 'UpdateStore__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The updated store */
  store?: Maybe<StoreInterface>;
  success: Scalars['Boolean'];
};

export type UpdateStorePart__Result = IMutationResult & {
  __typename?: 'UpdateStorePart__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  /** The updated StorePart */
  storePart?: Maybe<StorePart>;
  success: Scalars['Boolean'];
};

export type UpsertUserPreference__Result = IMutationResult & {
  __typename?: 'UpsertUserPreference__Result';
  /** If set, a list of errors that occurred during the operation. These errors should expand on the IMutationResult.message. */
  errors?: Maybe<Array<IMutationError>>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
  /** The updated user preferences. */
  userPreferences?: Maybe<UserPreference>;
};

export type User = {
  __typename?: 'User';
  cellPhoneNumber?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['ID']>;
  dateCreated?: Maybe<Scalars['ArrowField']>;
  dateHardDeleted?: Maybe<Scalars['ArrowField']>;
  dateUpdated?: Maybe<Scalars['ArrowField']>;
  deleted: Scalars['Boolean'];
  email_address?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  employeeId?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_name: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  user_id: Scalars['Int'];
  username: Scalars['String'];
  userTypeId: Scalars['Int'];
};

export type UserAuthorization = {
  __typename?: 'UserAuthorization';
  groups: Array<Group>;
  permissions: Array<UserPermission>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor?: Maybe<Scalars['ConnectionCursor']>;
  node: User;
};

export type UserFilter = {
  branchIds?: InputMaybe<Array<Scalars['ID']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  friendlyName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  objectId?: Maybe<Scalars['Int']>;
};

export type UserPreference = {
  __typename?: 'UserPreference';
  preferences: Scalars['UserPreferencesData'];
  userId: Scalars['Int'];
};

export type Vendor = {
  __typename?: 'Vendor';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  /** 5-digit zip codes whose stock requests are routed to this warehouse first, sorted. Only a mini-DC (MANUAL) is routed to by zip. */
  servedZipCodes: Array<Scalars['String']>;
  /** The system that picks this warehouse's orders: NUMINA, or MANUAL for a mini-DC picked by hand. */
  warehouseExecutionSystem: WarehouseExecutionSystem;
};

export enum WarehouseExecutionSystem {
  Manual = 'MANUAL',
  Numina = 'NUMINA'
}

export type WeightedAverageCostSnapshot = {
  __typename?: 'WeightedAverageCostSnapshot';
  /** The user who created this object. */
  createdById: Scalars['BigInteger'];
  createdByUser: User;
  dateApplied: Scalars['String'];
  dateArchived?: Maybe<Scalars['String']>;
  dateCreated: Scalars['String'];
  dateUpdated: Scalars['String'];
  id: Scalars['Int'];
  incomingCostPerItem: Money;
  incomingQuantity: Scalars['Int'];
  inventoryLocation: InventoryLocation;
  inventoryLocationId: Scalars['BigInteger'];
  /** A flag to determine if the snapshot is the most recently created (Date Applied) snapshot for the inventory location id and product id */
  isCurrent: Scalars['Boolean'];
  /** A flag to determine whether the WAC represents a hard set */
  isOverride: Scalars['Boolean'];
  /** Determines whether this WAC Snapshot was created as a result of a normal user workflow or as a result of a system side-effect. For example, when moving inventory locations, we create a new location and essentially copy all WAC information to that new location. This would be a system generated WAC snapshot and would have a value of True */
  isSystemGenerated: Scalars['Boolean'];
  /** The user who last modified this object. */
  modifiedById: Scalars['BigInteger'];
  modifiedByUser: User;
  product: Product;
  productId: Scalars['BigInteger'];
  /** The reason for creating an override snapshot */
  reason?: Maybe<Scalars['String']>;
  totalQuantity: Scalars['Int'];
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['Int']>;
  wacSnapshotId: Scalars['BigInteger'];
  weightedAverageCost: Money;
};

export type WeightInput = {
  amount: Scalars['Decimal'];
  unit: WeightUnit;
};

export enum WeightUnit {
  Kg = 'KG',
  Lb = 'LB',
  Oz = 'OZ'
}

/**
 * A pointer at a work order that lives outside of this service.
 *
 * Only the identifier is available here; consumers resolve the work order's
 * details and build any link to it themselves.
 */
export type WorkOrderReference = {
  __typename?: 'WorkOrderReference';
  id: Scalars['ID'];
};

export type DetailedTransactionItemFragment = { __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null };

export type DetailedTransactionFragment = { __typename: 'Transaction', id: number, fromId?: any | null, toId?: any | null, dateCreated: string, dateCompleted?: string | null, dateCancelled?: string | null, createdBy: any, modifiedBy: any, memo?: string | null, customId?: string | null, transactionStatus?: TransactionStatus | null, transactionType?: TransactionType | null, from?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, to?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, transactionItems?: Array<{ __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null } | null> | null };

export type TransactionEntityFields_Branch_Fragment = { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean };

export type TransactionEntityFields_NamedStore_Fragment = { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean };

export type TransactionEntityFields_Provider_Fragment = { __typename?: 'Provider', id: number, providerName: string };

export type TransactionEntityFieldsFragment = TransactionEntityFields_Branch_Fragment | TransactionEntityFields_NamedStore_Fragment | TransactionEntityFields_Provider_Fragment;

export type PartOnWorkOrderFieldsFragment = { __typename?: 'PartOnWorkOrder', quantity: number, costPerItem: number, part: { __typename?: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } };

export type PartOnWorkOrderPartDetailsFragment = { __typename?: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } };

export type PartDetailsFragment = { __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> };

export type PickOrderSummaryFragment = { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, city?: string | null, state?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, lines: Array<{ __typename?: 'PickOrderLine', id: string, productId: string, quantityToPick: number }>, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string } }> }> };

export type PickOrderDetailFragment = { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, lines: Array<{ __typename?: 'PickOrderLine', id: string, quantityToPick: number, quantityPicked: number, binLocation?: string | null, isCancelled: boolean, fulfillmentOrderLineItemId: string, productId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, quantityFulfilled: number, quantityUnfulfilled: number, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any }, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', lineItemId: string, demandRequest: { __typename?: 'DemandRequest', id: string, requestNumber: any } } | null } }> }>, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> };

export type StoreInterfaceFragment_Branch_ = { __typename: 'Branch', branchId: any, id: number, name: string, companyId: number, storeId: number, inventoryType?: InventoryType | null, company: { __typename?: 'Company', id: number }, parent?: { __typename: 'Branch', id: number, name: string, inventoryType?: InventoryType | null } | { __typename: 'NamedStore', id: number, name: string, inventoryType?: InventoryType | null } | { __typename: 'Store', id: number, name: string, inventoryType?: InventoryType | null } | null, children: Array<{ __typename: 'Branch', branchId: any, id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } | { __typename: 'NamedStore', id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } | { __typename: 'Store', id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null }> };

export type StoreInterfaceFragment_NamedStore_ = { __typename: 'NamedStore', id: number, name: string, companyId: number, storeId: number, inventoryType?: InventoryType | null, company: { __typename?: 'Company', id: number }, parent?: { __typename: 'Branch', id: number, name: string, inventoryType?: InventoryType | null } | { __typename: 'NamedStore', id: number, name: string, inventoryType?: InventoryType | null } | { __typename: 'Store', id: number, name: string, inventoryType?: InventoryType | null } | null, children: Array<{ __typename: 'Branch', branchId: any, id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } | { __typename: 'NamedStore', id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } | { __typename: 'Store', id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null }> };

export type StoreInterfaceFragment_Store_ = { __typename: 'Store', id: number, name: string, companyId: number, storeId: number, inventoryType?: InventoryType | null, company: { __typename?: 'Company', id: number }, parent?: { __typename: 'Branch', id: number, name: string, inventoryType?: InventoryType | null } | { __typename: 'NamedStore', id: number, name: string, inventoryType?: InventoryType | null } | { __typename: 'Store', id: number, name: string, inventoryType?: InventoryType | null } | null, children: Array<{ __typename: 'Branch', branchId: any, id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } | { __typename: 'NamedStore', id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } | { __typename: 'Store', id: number, name: string, inventoryType?: InventoryType | null, parent?: { __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null }> };

export type StoreInterfaceFragment = StoreInterfaceFragment_Branch_ | StoreInterfaceFragment_NamedStore_ | StoreInterfaceFragment_Store_;

export type CreateFulfillmentOrderMutationVariables = Exact<{
  input: CreateFulfillmentOrderInput;
}>;


export type CreateFulfillmentOrderMutation = { __typename?: 'Mutation', createFulfillmentOrder?: { __typename?: 'CreateFulfillmentOrderResult', success: boolean, message: string, fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } | null } | null };

export type RequestFulfillmentOrderCancellationMutationVariables = Exact<{
  input: RequestFulfillmentOrderCancellationInput;
}>;


export type RequestFulfillmentOrderCancellationMutation = { __typename?: 'Mutation', requestFulfillmentOrderCancellation?: { __typename?: 'RequestFulfillmentOrderCancellationResult', success: boolean, message: string, fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, status: FulfillmentOrderStatus, cancellationFailed: boolean, cancellationFailureMessage?: string | null } | null } | null };

export type UnloadMobileToolTrailerMutationVariables = Exact<{
  input: UnloadMobileToolTrailerInput;
}>;


export type UnloadMobileToolTrailerMutation = { __typename?: 'Mutation', unloadMobileToolTrailer?: { __typename?: 'UnloadMobileToolTrailerResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus } | null } | null };

export type ArchiveInventoryLocationMutationVariables = Exact<{
  inventoryLocationId: Scalars['BigInteger'];
}>;


export type ArchiveInventoryLocationMutation = { __typename?: 'Mutation', archiveInventoryLocation: { __typename?: 'ArchiveInventoryLocation__Result', success: boolean, message: string } };

export type CreateInventoryLocationMutationVariables = Exact<{
  branchId: Scalars['BigInteger'];
  name: Scalars['String'];
  inventoryType?: InputMaybe<InventoryType>;
}>;


export type CreateInventoryLocationMutation = { __typename?: 'Mutation', createInventoryLocation: { __typename?: 'CreateInventoryLocation__Result', success: boolean, message: string } };

export type MoveInventoryLocationToMutationVariables = Exact<{
  inventoryLocationId: Scalars['BigInteger'];
  branchId: Scalars['BigInteger'];
}>;


export type MoveInventoryLocationToMutation = { __typename?: 'Mutation', moveInventoryLocationTo: { __typename?: 'MoveInventoryLocationTo__Result', success: boolean, message: string, inventoryLocation?: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string, defaultLocation: boolean, companyId: string, isWarehouse: boolean, branch: { __typename?: 'EsBranch', id: number, name: string } } | null } };

export type PromoteInventoryLocationToDefaultMutationVariables = Exact<{
  inventoryLocationId: Scalars['BigInteger'];
}>;


export type PromoteInventoryLocationToDefaultMutation = { __typename?: 'Mutation', promoteInventoryLocationToDefault: { __typename?: 'UpdateInventoryLocation__Result', success: boolean, message: string, inventoryLocation?: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string, defaultLocation: boolean, companyId: string, isWarehouse: boolean, branch: { __typename?: 'EsBranch', id: number, name: string } } | null } };

export type UpdateInventoryLocationMutationVariables = Exact<{
  inventoryLocationId: Scalars['BigInteger'];
  branchId?: InputMaybe<Scalars['BigInteger']>;
  name?: InputMaybe<Scalars['String']>;
  inventoryType?: InputMaybe<InventoryType>;
}>;


export type UpdateInventoryLocationMutation = { __typename?: 'Mutation', updateInventoryLocation: { __typename?: 'UpdateInventoryLocation__Result', success: boolean, message: string, inventoryLocation?: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string, defaultLocation: boolean, companyId: string, isWarehouse: boolean, branch: { __typename?: 'EsBranch', id: number, name: string } } | null } };

export type UpdateInventoryLocationWarehouseMutationVariables = Exact<{
  inventoryLocationId: Scalars['BigInteger'];
  warehouse?: InputMaybe<UpdateInventoryLocationWarehouseInput>;
}>;


export type UpdateInventoryLocationWarehouseMutation = { __typename?: 'Mutation', updateInventoryLocation: { __typename?: 'UpdateInventoryLocation__Result', success: boolean, message: string, inventoryLocation?: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string, defaultLocation: boolean, companyId: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', warehouseExecutionSystem: WarehouseExecutionSystem, servedZipCodes: Array<string> } | null, branch: { __typename?: 'EsBranch', id: number, name: string } } | null } };

export type ActivateItemMasterVariantMutationVariables = Exact<{
  input: ActivateItemMasterVariantInput;
}>;


export type ActivateItemMasterVariantMutation = { __typename?: 'Mutation', activateItemMasterVariant?: { __typename?: 'ActivateItemMasterVariantResult', success: boolean, message: string, itemMaster?: { __typename?: 'ItemMaster', id: string } | null } | null };

export type AddItemMasterVariantMutationVariables = Exact<{
  input: AddItemMasterVariantInput;
}>;


export type AddItemMasterVariantMutation = { __typename?: 'Mutation', addItemMasterVariant?: { __typename?: 'AddItemMasterVariant__Result', success: boolean, message: string, itemMaster?: { __typename?: 'ItemMaster', id: string, variants: Array<{ __typename?: 'ItemMasterVariant', id: string, isBase: boolean, conversionRate: number, freightClass?: string | null, nmfc?: string | null, shippedInOriginalContainer: boolean, siocQuantity?: number | null, isPolybagEligible: boolean, dimensions?: { __typename?: 'ItemMasterDimensions', length: any, width: any, height: any, unit: DimensionUom } | null, weight?: { __typename?: 'ItemMasterWeight', amount: any, unit: WeightUnit } | null }> } | null } | null };

export type CreateItemMasterMutationVariables = Exact<{
  input: CreateItemMasterInput;
}>;


export type CreateItemMasterMutation = { __typename?: 'Mutation', createItemMaster?: { __typename?: 'CreateItemMasterResult', success: boolean, message: string, itemMaster?: { __typename?: 'ItemMaster', id: string, isActive: boolean, flammable: boolean, fragile: boolean, lithiumIonBattery: boolean, isHazmat: boolean, numinaSerialType: NuminaSerialType, equipmentMakeId?: string | null, equipmentModelId?: string | null, variants: Array<{ __typename?: 'ItemMasterVariant', id: string, isBase: boolean }> } | null } | null };

export type CreateProductWithItemMasterMutationVariables = Exact<{
  manufacturerId: Scalars['BigInteger'];
  manufacturerNumber: Scalars['String'];
  name: Scalars['String'];
  msrp?: InputMaybe<Scalars['Decimal']>;
  conversionUnit?: InputMaybe<UnitsOfMeasurementEnum>;
  productClassId?: InputMaybe<Scalars['ID']>;
  itemMaster?: InputMaybe<CreateProductItemMasterInput>;
}>;


export type CreateProductWithItemMasterMutation = { __typename?: 'Mutation', createProduct?: { __typename?: 'CreateProduct__Result', success: boolean, message: string, product?: { __typename?: 'GoodProduct', id: string, name: string, itemMaster?: { __typename?: 'ItemMaster', id: string } | null } | null } | null };

export type UpdateItemMasterVariantMutationVariables = Exact<{
  input: UpdateItemMasterVariantInput;
}>;


export type UpdateItemMasterVariantMutation = { __typename?: 'Mutation', updateItemMasterVariant?: { __typename?: 'UpdateItemMasterVariantResult', success: boolean, message: string, itemMaster?: { __typename?: 'ItemMaster', id: string, variants: Array<{ __typename?: 'ItemMasterVariant', id: string, isBase: boolean, uom: ItemMasterVariantUom, conversionRate: number, freightClass?: string | null, nmfc?: string | null, shippedInOriginalContainer: boolean, siocQuantity?: number | null, isPolybagEligible: boolean, dimensions?: { __typename?: 'ItemMasterDimensions', length: any, width: any, height: any, unit: DimensionUom } | null, weight?: { __typename?: 'ItemMasterWeight', amount: any, unit: WeightUnit } | null }> } | null } | null };

export type UpdateItemMasterMutationVariables = Exact<{
  input: UpdateItemMasterInput;
}>;


export type UpdateItemMasterMutation = { __typename?: 'Mutation', updateItemMaster?: { __typename?: 'UpdateItemMasterResult', success: boolean, message: string, itemMaster?: { __typename?: 'ItemMaster', id: string, isActive: boolean, flammable: boolean, fragile: boolean, lithiumIonBattery: boolean, isHazmat: boolean, numinaSerialType: NuminaSerialType, equipmentMakeId?: string | null, equipmentModelId?: string | null } | null } | null };

export type CreateManualAdjustmentMutationVariables = Exact<{
  direction?: InputMaybe<IncrementOrDecrement>;
  inventoryLocationId: Scalars['ID'];
  items: Array<InputMaybe<CreateManualAdjustmentItem>> | InputMaybe<CreateManualAdjustmentItem>;
  memo?: InputMaybe<Scalars['String']>;
  reason: ManualAdjustmentReasonType;
  vendorId?: InputMaybe<Scalars['ID']>;
  purchaseOrderId?: InputMaybe<Scalars['ID']>;
  purchaseId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateManualAdjustmentMutation = { __typename?: 'Mutation', createManualAdjustment?: { __typename?: 'CreateManualAdjustment__Result', success: boolean, message: string, manualAdjustments?: Array<{ __typename?: 'ManualAdjustment', id: string, reason?: ManualAdjustmentReasonType | null, reasonDisplay?: string | null, quantityChange: number, memo?: string | null, vendorId?: string | null, purchaseOrderId?: string | null, purchaseId?: string | null } | null> | null } | null };

export type CreatePartMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  partNumber: Scalars['String'];
  providerId: Scalars['BigInteger'];
  upc?: InputMaybe<Scalars['String']>;
  standardPrice?: InputMaybe<Scalars['Decimal']>;
  msrp?: InputMaybe<Scalars['Decimal']>;
  productClassId?: InputMaybe<Scalars['ID']>;
}>;


export type CreatePartMutation = { __typename?: 'Mutation', createPart?: { __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> } | null };

export type MergePartsMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['BigInteger']>;
  goodPartId: Scalars['BigInteger'];
  duplicatePartId: Scalars['BigInteger'];
}>;


export type MergePartsMutation = { __typename?: 'Mutation', mergeParts?: { __typename?: 'MergeParts__Result', success: boolean, message: string } | null };

export type UpdatePartMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  partId: Scalars['BigInteger'];
  partNumber?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['BigInteger']>;
  upc?: InputMaybe<Scalars['String']>;
  standardPrice?: InputMaybe<Scalars['Decimal']>;
  msrp?: InputMaybe<Scalars['Decimal']>;
  productClassId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdatePartMutation = { __typename?: 'Mutation', updatePart?: { __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> } | null };

export type AddPolicyToGroupMutationVariables = Exact<{
  groupId: Scalars['Int'];
  resourceId: Scalars['Int'];
  roleId: Scalars['Int'];
}>;


export type AddPolicyToGroupMutation = { __typename?: 'Mutation', addPolicyToGroup?: { __typename?: 'AddPolicyToGroup__Result', success: boolean, message: string, group?: { __typename?: 'Group', id: number, name: string, userIds: Array<number | null>, policies: Array<{ __typename?: 'ResourcePolicy', id: number, role: { __typename?: 'Role', id: number, name: string, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null } | null> }, resource: { __typename?: 'Resource', id: number, objectId: any, parentId?: any | null, companyId: any, resourceType?: ResourceType | null } } | null> } | null } | null };

export type AssignUsersToGroupMutationVariables = Exact<{
  userIds: Array<Scalars['Int']> | Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type AssignUsersToGroupMutation = { __typename?: 'Mutation', assignUsersToGroup?: { __typename?: 'AssignUsersToGroup__Result', success: boolean, message: string, group?: { __typename?: 'Group', id: number, userIds: Array<number | null> } | null } | null };

export type CreateGroupMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  spendingLimit?: InputMaybe<Scalars['Float']>;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'CreateGroup__Result', success: boolean, message: string, group?: { __typename?: 'Group', id: number, name: string, spendingLimit?: number | null } | null, errors?: Array<{ __typename: 'MutationError', message: string }> | null } | null };

export type DeleteGroupMutationVariables = Exact<{
  groupId: Scalars['BigInteger'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup?: { __typename: 'DeleteGroup__Result', success: boolean, message: string, errors?: Array<{ __typename: 'MutationError', message: string }> | null } | null };

export type RemovePolicyFromGroupMutationVariables = Exact<{
  policyId: Scalars['Int'];
}>;


export type RemovePolicyFromGroupMutation = { __typename?: 'Mutation', removePolicyFromGroup?: { __typename?: 'RemoveResourcePolicyFromGroup__Result', success: boolean, message: string, group?: { __typename?: 'Group', id: number, name: string, userIds: Array<number | null>, policies: Array<{ __typename?: 'ResourcePolicy', id: number, role: { __typename?: 'Role', id: number, name: string, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null } | null> }, resource: { __typename?: 'Resource', id: number, objectId: any, parentId?: any | null, companyId: any, resourceType?: ResourceType | null } } | null> } | null } | null };

export type RemoveUsersFromGroupMutationVariables = Exact<{
  userIds: Array<Scalars['Int']> | Scalars['Int'];
  groupId: Scalars['Int'];
}>;


export type RemoveUsersFromGroupMutation = { __typename?: 'Mutation', removeUsersFromGroup?: { __typename?: 'RemoveUserFromGroup__Result', success: boolean, message: string, group?: { __typename?: 'Group', id: number, userIds: Array<number | null> } | null } | null };

export type AssignPermissionsToRoleMutationVariables = Exact<{
  permissions: Array<Permission> | Permission;
  roleId: Scalars['Int'];
}>;


export type AssignPermissionsToRoleMutation = { __typename?: 'Mutation', assignPermissionsToRole?: { __typename?: 'AssignPermissionsToRole__Result', success: boolean, message: string, role?: { __typename?: 'Role', id: number, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null, friendlyName: string } | null> } | null } | null };

export type CreateRoleMutationVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  spendingLimit?: InputMaybe<Scalars['Float']>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'CreateRole__Result', success: boolean, message: string, role?: { __typename: 'Role', id: number, name: string, spendingLimit?: number | null, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null, friendlyName: string } | null> } | null } | null };

export type RemovePermissionsFromRoleMutationVariables = Exact<{
  permissions: Array<Permission> | Permission;
  roleId: Scalars['Int'];
}>;


export type RemovePermissionsFromRoleMutation = { __typename?: 'Mutation', removePermissionsFromRole?: { __typename?: 'RemovePermissionsFromRole__Result', success: boolean, message: string, role?: { __typename?: 'Role', id: number, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null, friendlyName: string } | null> } | null } | null };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['BigInteger'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: { __typename: 'DeleteRole__Result', success: boolean, message: string } | null };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRole__Input;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'UpdateRole__Result', success: boolean, message: string, role?: { __typename?: 'Role', id: number, name: string, spendingLimit?: number | null } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroup__Input;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'UpdateGroup__Result', success: boolean, message: string, group?: { __typename?: 'Group', id: number, name: string, spendingLimit?: number | null } | null, errors?: Array<{ __typename: 'MutationError', message: string }> | null } | null };

export type AddFulfillmentOrdersToPickOrderMutationVariables = Exact<{
  input: AddFulfillmentOrdersToPickOrderInput;
}>;


export type AddFulfillmentOrdersToPickOrderMutation = { __typename?: 'Mutation', addFulfillmentOrdersToPickOrder?: { __typename?: 'AddFulfillmentOrdersToPickOrderResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, lines: Array<{ __typename?: 'PickOrderLine', id: string, quantityToPick: number, quantityPicked: number, binLocation?: string | null, isCancelled: boolean, fulfillmentOrderLineItemId: string, productId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, quantityFulfilled: number, quantityUnfulfilled: number, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any }, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', lineItemId: string, demandRequest: { __typename?: 'DemandRequest', id: string, requestNumber: any } } | null } }> }>, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> } | null } | null };

export type AssignPickOrderMutationVariables = Exact<{
  input: AssignPickOrderInput;
}>;


export type AssignPickOrderMutation = { __typename?: 'Mutation', assignPickOrder?: { __typename?: 'AssignPickOrderResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, city?: string | null, state?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, lines: Array<{ __typename?: 'PickOrderLine', id: string, productId: string, quantityToPick: number }>, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string } }> }> } | null } | null };

export type CancelPickOrderMutationVariables = Exact<{
  input: CancelPickOrderInput;
}>;


export type CancelPickOrderMutation = { __typename?: 'Mutation', cancelPickOrder?: { __typename?: 'CancelPickOrderResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, city?: string | null, state?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, lines: Array<{ __typename?: 'PickOrderLine', id: string, productId: string, quantityToPick: number }>, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string } }> }> } | null } | null };

export type CompletePickOrderMutationVariables = Exact<{
  input: CompletePickOrderInput;
}>;


export type CompletePickOrderMutation = { __typename?: 'Mutation', completePickOrder?: { __typename?: 'CompletePickOrderResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, lines: Array<{ __typename?: 'PickOrderLine', id: string, quantityToPick: number, quantityPicked: number, binLocation?: string | null, isCancelled: boolean, fulfillmentOrderLineItemId: string, productId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, quantityFulfilled: number, quantityUnfulfilled: number, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any }, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', lineItemId: string, demandRequest: { __typename?: 'DemandRequest', id: string, requestNumber: any } } | null } }> }>, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> } | null } | null };

export type CreatePickOrderMutationVariables = Exact<{
  input: CreatePickOrderInput;
}>;


export type CreatePickOrderMutation = { __typename?: 'Mutation', createPickOrder?: { __typename?: 'CreatePickOrderResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, lines: Array<{ __typename?: 'PickOrderLine', id: string, quantityToPick: number, quantityPicked: number, binLocation?: string | null, isCancelled: boolean, fulfillmentOrderLineItemId: string, productId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, quantityFulfilled: number, quantityUnfulfilled: number, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any }, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', lineItemId: string, demandRequest: { __typename?: 'DemandRequest', id: string, requestNumber: any } } | null } }> }>, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> } | null } | null };

export type RecordPickedQuantitiesMutationVariables = Exact<{
  input: RecordPickedQuantitiesInput;
}>;


export type RecordPickedQuantitiesMutation = { __typename?: 'Mutation', recordPickedQuantities?: { __typename?: 'RecordPickedQuantitiesResult', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, lines: Array<{ __typename?: 'PickOrderLine', id: string, quantityToPick: number, quantityPicked: number, binLocation?: string | null, isCancelled: boolean, fulfillmentOrderLineItemId: string, productId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, quantityFulfilled: number, quantityUnfulfilled: number, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any }, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', lineItemId: string, demandRequest: { __typename?: 'DemandRequest', id: string, requestNumber: any } } | null } }> }>, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> } | null } | null };

export type CreateProductCategoryMutationVariables = Exact<{
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['BigInteger']>;
}>;


export type CreateProductCategoryMutation = { __typename?: 'Mutation', createProductCategory?: { __typename?: 'CreateProductCategory__Result', success: boolean, message: string, productCategory?: { __typename?: 'ProductCategory', id: string, name: string, parentId?: any | null, productCategoryId: any } | null } | null };

export type UpdateProductCategoryMutationVariables = Exact<{
  productCategoryId: Scalars['BigInteger'];
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['BigInteger']>;
}>;


export type UpdateProductCategoryMutation = { __typename?: 'Mutation', updateProductCategory?: { __typename?: 'UpdateProductCategory__Result', success: boolean, message: string, productCategory?: { __typename?: 'ProductCategory', id: string, name: string, parentId?: any | null, productCategoryId: any } | null } | null };

export type CreateProductClassMutationVariables = Exact<{
  catClass: Scalars['String'];
  categoryName: Scalars['String'];
  classification: Scalars['String'];
}>;


export type CreateProductClassMutation = { __typename?: 'Mutation', createProductClass?: { __typename?: 'CreateProductClass__Result', success: boolean, message: string, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null } | null };

export type UpdateProductClassMutationVariables = Exact<{
  productClassId: Scalars['ID'];
  catClass?: InputMaybe<Scalars['String']>;
  categoryName?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProductClassMutation = { __typename?: 'Mutation', updateProductClass?: { __typename?: 'UpdateProductClass__Result', success: boolean, message: string, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null } | null };

export type CreateProviderMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateProviderMutation = { __typename?: 'Mutation', createProvider?: { __typename?: 'Provider', id: number, name: string } | null };

export type MergeProvidersMutationVariables = Exact<{
  goodProviderId: Scalars['BigInteger'];
  duplicateProviderId: Scalars['BigInteger'];
  companyId?: InputMaybe<Scalars['BigInteger']>;
}>;


export type MergeProvidersMutation = { __typename?: 'Mutation', mergeProviders?: { __typename?: 'MergeProviders__Result', success: boolean, message: string, goodProvider?: { __typename?: 'Provider', id: number, name: string } | null, duplicateProvider?: { __typename?: 'Provider', id: number, name: string } | null } | null };

export type UpdateProviderMutationVariables = Exact<{
  providerId: Scalars['Int'];
  name: Scalars['String'];
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider?: { __typename?: 'Provider', id: number, name: string } | null };

export type CancelReservationMutationVariables = Exact<{
  reservationId: Scalars['BigInteger'];
}>;


export type CancelReservationMutation = { __typename?: 'Mutation', cancelReservation: { __typename?: 'CancelReservation__Result', success: boolean, message: string, reservation?: { __typename: 'Reservation', reservationId: any } | null } };

export type ConvertPartManyToManyMutationVariables = Exact<{
  inventoryLocationId: Scalars['ID'];
  fromPartId: Scalars['ID'];
  toPartId: Scalars['ID'];
  fromQuantity: Scalars['Int'];
  toQuantity: Scalars['Int'];
}>;


export type ConvertPartManyToManyMutation = { __typename?: 'Mutation', convertItems?: { __typename?: 'ConvertItems_Result', success: boolean, message: string, quantityConverted?: number | null, quantityConvertedTo?: number | null, fromStorePart?: { __typename?: 'StorePart', cost?: number | null, part: { __typename?: 'Part', partNumber?: string | null }, weightedAverageCost?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null } | null, toStorePart?: { __typename?: 'StorePart', cost?: number | null, part: { __typename?: 'Part', partNumber?: string | null }, weightedAverageCost?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null } | null } | null };

export type ConvertPartsMutationVariables = Exact<{
  inventoryLocationId: Scalars['ID'];
  fromPartId: Scalars['ID'];
  toPartId: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type ConvertPartsMutation = { __typename?: 'Mutation', convertParts?: { __typename?: 'ConvertParts__Result', success: boolean, message: string, quantityConverted?: number | null, fromStorePart?: { __typename?: 'StorePart', id: number, quantity: number, availableQuantity: number } | null, toStorePart?: { __typename?: 'StorePart', id: number, quantity: number, availableQuantity: number } | null } | null };

export type CreateStorePartMutationVariables = Exact<{
  input: CreateStorePartInput;
}>;


export type CreateStorePartMutation = { __typename?: 'Mutation', createStorePart?: { __typename?: 'CreateStorePart__Result', success: boolean, message: string, storePart?: { __typename?: 'StorePart', id: number, storePartId: any, inventoryLocationId: any, location?: string | null, partId: any, inventoryLocation: { __typename?: 'InventoryLocation', id: string, name: string } } | null } | null };

export type DeleteItemMutationVariables = Exact<{
  id: Scalars['BigInteger'];
}>;


export type DeleteItemMutation = { __typename?: 'Mutation', archiveStorePart?: { __typename?: 'ArchiveStorePart__Result', success: boolean, message: string } | null };

export type UpdateStorePartMutationVariables = Exact<{
  storePartId: Scalars['BigInteger'];
  cost?: InputMaybe<Scalars['Float']>;
  location?: InputMaybe<Scalars['String']>;
  max?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateStorePartMutation = { __typename?: 'Mutation', updateStorePart?: { __typename?: 'UpdateStorePart__Result', success: boolean, message: string, storePart?: { __typename?: 'StorePart', id: number, cost?: number | null, location?: string | null, max?: number | null, note?: string | null, threshold?: number | null } | null } | null };

export type CreateWeightedAverageCostOverrideMutationVariables = Exact<{
  dateApplied: Scalars['ArrowDateTime'];
  inventoryLocationId: Scalars['ID'];
  productId: Scalars['ID'];
  reason: Scalars['String'];
  weightedAverageCost: Scalars['Decimal'];
}>;


export type CreateWeightedAverageCostOverrideMutation = { __typename?: 'Mutation', createWeightedAverageCostSnapshotOverride: { __typename?: 'CreateWeightedAverageCostSnapshot__Result', success: boolean, message: string } };

export type CancelTransactionMutationVariables = Exact<{
  transactionId: Scalars['Int'];
}>;


export type CancelTransactionMutation = { __typename?: 'Mutation', cancelTransaction?: { __typename: 'Transaction', id: number, fromId?: any | null, toId?: any | null, dateCreated: string, dateCompleted?: string | null, dateCancelled?: string | null, createdBy: any, modifiedBy: any, memo?: string | null, customId?: string | null, transactionStatus?: TransactionStatus | null, transactionType?: TransactionType | null, from?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, to?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, transactionItems?: Array<{ __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null } | null> | null } | null };

export type CompleteTransactionMutationVariables = Exact<{
  transactionId: Scalars['Int'];
  transactionItems?: InputMaybe<Array<InputUpdateTransactionItem> | InputUpdateTransactionItem>;
}>;


export type CompleteTransactionMutation = { __typename?: 'Mutation', completeTransaction?: { __typename: 'Transaction', id: number, fromId?: any | null, toId?: any | null, dateCreated: string, dateCompleted?: string | null, dateCancelled?: string | null, createdBy: any, modifiedBy: any, memo?: string | null, customId?: string | null, transactionStatus?: TransactionStatus | null, transactionType?: TransactionType | null, from?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, to?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, transactionItems?: Array<{ __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null } | null> | null } | null };

export type CreateTransactionMutationVariables = Exact<{
  fromId?: InputMaybe<Scalars['Int']>;
  toId?: InputMaybe<Scalars['Int']>;
  transactionItems?: InputMaybe<Array<InputTransactionItem> | InputTransactionItem>;
  transactionType: TransactionType;
  customId?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  transactionStatus?: InputMaybe<TransactionStatus>;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction?: { __typename: 'Transaction', id: number, fromId?: any | null, toId?: any | null, dateCreated: string, dateCompleted?: string | null, dateCancelled?: string | null, createdBy: any, modifiedBy: any, memo?: string | null, customId?: string | null, transactionStatus?: TransactionStatus | null, transactionType?: TransactionType | null, from?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, to?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, transactionItems?: Array<{ __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null } | null> | null } | null };

export type ProcessTransactionMutationVariables = Exact<{
  transactionId: Scalars['Int'];
}>;


export type ProcessTransactionMutation = { __typename?: 'Mutation', processTransaction?: { __typename: 'Transaction', id: number, fromId?: any | null, toId?: any | null, dateCreated: string, dateCompleted?: string | null, dateCancelled?: string | null, createdBy: any, modifiedBy: any, memo?: string | null, customId?: string | null, transactionStatus?: TransactionStatus | null, transactionType?: TransactionType | null, from?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, to?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, transactionItems?: Array<{ __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null } | null> | null } | null };

export type ApproveTransferOrderMutationVariables = Exact<{
  input: ApproveTransferOrderInput;
}>;


export type ApproveTransferOrderMutation = { __typename?: 'Mutation', approveTransferOrder?: { __typename?: 'ApproveTransferOrderResult', success: boolean, message: string, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, dateApproved?: any | null, approverNote?: string | null, approver?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type CancelTransferOrderMutationVariables = Exact<{
  input: CancelTransferOrderInput;
}>;


export type CancelTransferOrderMutation = { __typename?: 'Mutation', cancelTransferOrder?: { __typename?: 'CancelTransferOrderResult', success: boolean, message: string, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, cancellationNote?: string | null, dateCancelled?: any | null } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, cancellationNote?: string | null, dateCancelled?: any | null } | null } | null };

export type CreateManualTransferOrderMutationVariables = Exact<{
  input: CreateManualTransferOrderInput;
}>;


export type CreateManualTransferOrderMutation = { __typename?: 'Mutation', createManualTransferOrder?: { __typename?: 'CreateManualTransferOrderResult', success: boolean, message: string, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | null } | null };

export type ReceiveTransferOrderLineItemsMutationVariables = Exact<{
  input: ReceiveTransferOrderLineItemsInput;
}>;


export type ReceiveTransferOrderLineItemsMutation = { __typename?: 'Mutation', receiveTransferOrderLineItems?: { __typename?: 'ReceiveTransferOrderLineItemsResult', success: boolean, message: string, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus } | null } | null };

export type RejectTransferOrderMutationVariables = Exact<{
  input: RejectTransferOrderInput;
}>;


export type RejectTransferOrderMutation = { __typename?: 'Mutation', rejectTransferOrder?: { __typename?: 'RejectTransferOrderResult', success: boolean, message: string, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, dateRejected?: any | null, approverNote?: string | null, approver?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type UpsertUserPreferenceMutationVariables = Exact<{
  key: Scalars['String'];
  value: Scalars['UserPreferencesData'];
}>;


export type UpsertUserPreferenceMutation = { __typename?: 'Mutation', upsertUserPreference: { __typename?: 'UpsertUserPreference__Result', success: boolean, message: string, errors?: Array<{ __typename?: 'MutationError', message: string }> | null } };

export type BranchesQueryVariables = Exact<{
  companyId: Scalars['BigInteger'];
}>;


export type BranchesQuery = { __typename?: 'Query', branches: Array<{ __typename?: 'Branch', id: number, name: string }> };

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['BigInteger'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', company_id: number, name: string } | null };

export type DistributionCentersQueryVariables = Exact<{
  paging?: InputMaybe<CursorPaging>;
}>;


export type DistributionCentersQuery = { __typename?: 'Query', inventoryLocations: { __typename?: 'InventoryLocationConnection', edges: Array<{ __typename?: 'InventoryLocationEdge', node: { __typename?: 'InventoryLocation', id: string, name: string, warehouse?: { __typename?: 'Warehouse', warehouseExecutionSystem: WarehouseExecutionSystem } | null, branch: { __typename?: 'EsBranch', id: number, name: string } } }> } };

export type EquipmentMakesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type EquipmentMakesQuery = { __typename?: 'Query', equipmentMakes: Array<{ __typename?: 'EquipmentMake', equipment_make_id: number, name: string }> };

export type EquipmentMakeByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type EquipmentMakeByIdQuery = { __typename?: 'Query', equipmentMake?: { __typename?: 'EquipmentMake', equipment_make_id: number, name: string } | null };

export type EquipmentModelsQueryVariables = Exact<{
  equipmentMakeId: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type EquipmentModelsQuery = { __typename?: 'Query', equipmentModels: Array<{ __typename?: 'EquipmentModel', equipment_model_id: number, name: string, equipment_make_id: number }> };

export type EquipmentModelByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type EquipmentModelByIdQuery = { __typename?: 'Query', equipmentModel?: { __typename?: 'EquipmentModel', equipment_model_id: number, name: string, equipment_make_id: number } | null };

export type FulfillmentOrderByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['BigInteger'];
}>;


export type FulfillmentOrderByOrderNumberQuery = { __typename?: 'Query', fulfillmentOrderByOrderNumber?: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any, status: FulfillmentOrderStatus, fulfillmentType: FulfillmentType, dateCreated: any, dateUpdated: any, dateSubmittedForFulfillment?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, dateCancellationRequested?: any | null, mttId?: string | null, mttQuadrant?: string | null, notes?: string | null, contactEmail?: any | null, contactPhone?: any | null, destinationDescription: string, externalShopifyOrderId?: string | null, shippingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, destinationInventory?: { __typename?: 'InventoryLocation', id: string, name: string } | null, pickOrders: Array<{ __typename?: 'PickOrder', id: string, pickOrderNumber: any }>, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', id: string, quantity: number, quantityFulfilled: number, quantityRemaining: number, isFullyFulfilled: boolean, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', demandRequest: { __typename?: 'DemandRequest', requestNumber: any } } | null, product: { __typename?: 'Part', id: number, name: string, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentLineItems: Array<{ __typename?: 'FulfillmentLineItem', quantityFulfilled: number, quantityUnfulfilled: number, fulfillment: { __typename?: 'Fulfillment', id: string, dateShipped?: any | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | null } }> }> } | null };

export type FulfillmentOrderCancellationStatusQueryVariables = Exact<{
  fulfillmentOrderId: Scalars['ID'];
}>;


export type FulfillmentOrderCancellationStatusQuery = { __typename?: 'Query', fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, status: FulfillmentOrderStatus, cancellationFailed: boolean, cancellationFailureMessage?: string | null } | null };

export type FulfillmentOrderQueryVariables = Exact<{
  fulfillmentOrderId: Scalars['ID'];
}>;


export type FulfillmentOrderQuery = { __typename?: 'Query', fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any, status: FulfillmentOrderStatus, fulfillmentType: FulfillmentType, dateCreated: any, dateUpdated: any, dateSubmittedForFulfillment?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, dateCancellationRequested?: any | null, mttId?: string | null, mttQuadrant?: string | null, notes?: string | null, contactEmail?: any | null, contactPhone?: any | null, shippingAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, destinationInventory?: { __typename?: 'InventoryLocation', id: string, name: string } | null, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', id: string, quantity: number, quantityFulfilled: number, quantityRemaining: number, isFullyFulfilled: boolean, product: { __typename?: 'Part', id: number, name: string, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentLineItems: Array<{ __typename?: 'FulfillmentLineItem', quantityFulfilled: number, quantityUnfulfilled: number, fulfillment: { __typename?: 'Fulfillment', id: string, dateShipped?: any | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | null } }> }> } | null };

export type MobileToolTrailerInventoryItemsQueryVariables = Exact<{
  inventoryLocationId: Scalars['ID'];
  includeEmpty?: InputMaybe<Scalars['Boolean']>;
}>;


export type MobileToolTrailerInventoryItemsQuery = { __typename?: 'Query', mobileToolTrailerInventoryItems: Array<{ __typename: 'Asset', id: string, equipmentMakeId?: string | null, equipmentModelId?: string | null, serialNumber?: string | null, name?: string | null, equipmentMake?: { __typename?: 'EquipmentMake', id: string, name: string } | null, equipmentModel?: { __typename?: 'EquipmentModel', id: string, name: string } | null } | { __typename: 'StorePart', quantity: number, availableQuantity: number, reservedQuantity: number, outgoingQuantity: number, storePartId: number, part: { __typename?: 'Part', id: number, partNumber?: string | null, name: string } }> };

export type MttLocationsQueryVariables = Exact<{
  paging?: InputMaybe<CursorPaging>;
}>;


export type MttLocationsQuery = { __typename?: 'Query', branches: { __typename?: 'BranchV2Connection', edges: Array<{ __typename?: 'BranchV2Edge', node: { __typename?: 'BranchV2', id: string, name: string, active: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: any | null } } };

export type MobileToolTrailerTransferOrdersQueryVariables = Exact<{
  fromInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  toInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type MobileToolTrailerTransferOrdersQuery = { __typename?: 'Query', transferOrders: { __typename?: 'TransferOrderConnection', edges: Array<{ __typename?: 'TransferOrderEdge', cursor?: any | null, node: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, assetTransferStatus?: AssetTransferStatus | null, dateCreated: any, fromStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, toStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, lineItems?: Array<{ __typename?: 'TransferOrderLineItem', lineItemId: string, quantityRequested: number }> | null } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, assetTransferStatus?: AssetTransferStatus | null, dateCreated: any, assetTransactions?: Array<{ __typename?: 'AssetTransfer', status: AssetTransferItemStatus, asset?: { __typename?: 'Asset', name?: string | null } | null }> | null, fromStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, toStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, lineItems?: Array<{ __typename?: 'TransferOrderLineItem', lineItemId: string, quantityRequested: number }> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type FullPartSearchQueryVariables = Exact<{
  partNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type FullPartSearchQuery = { __typename?: 'Query', fullPartSearch?: { __typename?: 'FullPartSearch', companyOwned: Array<{ __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> }>, masterList: Array<{ __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> }> } | null };

export type InventoryLocationWarehouseQueryVariables = Exact<{
  inventoryLocationId: Scalars['ID'];
}>;


export type InventoryLocationWarehouseQuery = { __typename?: 'Query', inventoryLocations: { __typename?: 'InventoryLocationConnection', edges: Array<{ __typename?: 'InventoryLocationEdge', node: { __typename?: 'InventoryLocation', id: string, isWarehouse: boolean, warehouse?: { __typename?: 'Warehouse', warehouseExecutionSystem: WarehouseExecutionSystem, servedZipCodes: Array<string> } | null } }> } };

export type InventoryLocationsQueryVariables = Exact<{
  branchIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<CursorPaging>;
  permissions?: InputMaybe<Array<Permission> | Permission>;
  inventoryLocationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  isWarehouse?: InputMaybe<Scalars['Boolean']>;
}>;


export type InventoryLocationsQuery = { __typename?: 'Query', inventoryLocations: { __typename?: 'InventoryLocationConnection', edges: Array<{ __typename?: 'InventoryLocationEdge', node: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string, defaultLocation: boolean, inventoryType?: InventoryType | null, companyId: string, isWarehouse: boolean, branch: { __typename?: 'EsBranch', id: number, name: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type InvoiceQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', invoice_id: number, invoice_no: string, ordered_by_user?: { __typename?: 'User', user_id: number, first_name: string, last_name: string } | null } };

export type ItemHistoryQueryVariables = Exact<{
  itemId: Scalars['ID'];
  paging?: InputMaybe<CursorPaging>;
  order?: InputMaybe<OrderDirection>;
}>;


export type ItemHistoryQuery = { __typename?: 'Query', itemHistory: { __typename?: 'ItemHistoryEntryConnection', totalCount: number, edges: Array<{ __typename?: 'ItemHistoryEntryEdge', cursor?: any | null, node: { __typename?: 'ItemHistoryEntry', id: string, transactionId: number, dateApplied: any, transactionStatus: TransactionStatus, transactionType: TransactionType, quantityChange: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, memo?: string | null, customId?: string | null, sourceType?: ItemHistorySourceType | null, sourceId?: string | null, source?: { __typename?: 'Asset', id: string } | { __typename?: 'CreditPurchaseReference', id: string } | { __typename?: 'InventoryLocation', id: string, name: string } | { __typename?: 'ManualAdjustment', id: string, reasonDisplay?: string | null } | { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'OrderReference', id: string } | { __typename?: 'Provider', name: string } | { __typename?: 'PurchaseOrder', id: string, purchaseOrderNumber?: string | null } | { __typename?: 'RetailSaleReference', id: string } | { __typename?: 'StorePart', storePartId: any, isArchived: boolean, part: { __typename?: 'Part', name: string, partNumber?: string | null } } | { __typename?: 'SystemTransferOrder', id: string } | { __typename?: 'WorkOrderReference', id: string } | null, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type ItemMasterReadinessQueryVariables = Exact<{
  partIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type ItemMasterReadinessQuery = { __typename?: 'Query', storeParts: Array<{ __typename?: 'StorePart', id: number, storePartId: any, storeId: any, inventoryLocationId: any, partId: any, location?: string | null, quantity: number, inventoryLocation: { __typename?: 'InventoryLocation', id: string, name: string, branch: { __typename?: 'EsBranch', id: number, name: string } } }> };

export type ItemMastersQueryVariables = Exact<{
  paging?: InputMaybe<CursorPaging>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ItemMastersQuery = { __typename?: 'Query', itemMasters: { __typename?: 'ItemMasterConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: any | null }, edges: Array<{ __typename?: 'ItemMasterEdge', node: { __typename?: 'ItemMaster', id: string, isActive: boolean, flammable: boolean, fragile: boolean, lithiumIonBattery: boolean, isHazmat: boolean, numinaSerialType: NuminaSerialType, variants: Array<{ __typename?: 'ItemMasterVariant', id: string, isBase: boolean, uom: ItemMasterVariantUom, dimensions?: { __typename?: 'ItemMasterDimensions', length: any, width: any, height: any, unit: DimensionUom } | null, weight?: { __typename?: 'ItemMasterWeight', amount: any, unit: WeightUnit } | null, product: { __typename?: 'GoodProduct', id: string, name: string, msrp?: any | null, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, manufacturer?: { __typename?: 'Manufacturer', id: string, name: string } | null, preferredVendor?: { __typename?: 'Vendor', id: string, name?: string | null } | null } }> } }> } };

export type ItemMasterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ItemMasterQuery = { __typename?: 'Query', itemMaster?: { __typename?: 'ItemMaster', id: string, isActive: boolean, flammable: boolean, fragile: boolean, lithiumIonBattery: boolean, isHazmat: boolean, numinaSerialType: NuminaSerialType, equipmentMakeId?: string | null, equipmentModelId?: string | null, productId: string, dateCreated: any, dateUpdated: any, variants: Array<{ __typename?: 'ItemMasterVariant', id: string, isBase: boolean, uom: ItemMasterVariantUom, conversionRate: number, freightClass?: string | null, nmfc?: string | null, shippedInOriginalContainer: boolean, siocQuantity?: number | null, isPolybagEligible: boolean, dimensions?: { __typename?: 'ItemMasterDimensions', length: any, width: any, height: any, unit: DimensionUom } | null, weight?: { __typename?: 'ItemMasterWeight', amount: any, unit: WeightUnit } | null, product: { __typename?: 'GoodProduct', id: string, name: string, manufacturerNumber?: string | null, manufacturer?: { __typename?: 'Manufacturer', id: string, name: string } | null } }> } | null };

export type ManualAdjustmentReasonsQueryVariables = Exact<{
  allowIncrement?: InputMaybe<Scalars['Boolean']>;
  allowDecrement?: InputMaybe<Scalars['Boolean']>;
}>;


export type ManualAdjustmentReasonsQuery = { __typename?: 'Query', manualAdjustmentReasons: Array<{ __typename?: 'ManualAdjustmentReason', id: string, reason?: string | null, description?: string | null, allowIncrement?: boolean | null, allowDecrement?: boolean | null } | null> };

export type ManualAdjustmentsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<ManualAdjustmentReasonType> | ManualAdjustmentReasonType>;
  inventoryLocations?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  createdDateStart?: InputMaybe<Scalars['DateTime']>;
  createdDateEnd?: InputMaybe<Scalars['DateTime']>;
  order?: InputMaybe<OrderDirection>;
  orderBy?: InputMaybe<ManualAdjustmentOrderBy>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type ManualAdjustmentsQuery = { __typename?: 'Query', manualAdjustments: { __typename?: 'ManualAdjustmentConnection', edges: Array<{ __typename?: 'ManualAdjustmentEdge', cursor?: any | null, node: { __typename?: 'ManualAdjustment', id: string, dateCreated?: any | null, reason?: ManualAdjustmentReasonType | null, reasonDisplay?: string | null, quantityChange: number, memo?: string | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, product?: { __typename?: 'Part', id: number, manufacturerNumber?: string | null, partClass: { __typename?: 'PartClass', description: string } } | null, inventoryLocation?: { __typename?: 'InventoryLocation', id: string, name: string } | null, transactionItem?: { __typename?: 'TransactionItem', transactionId: number } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type PartsOnWorkOrderDetailedQueryVariables = Exact<{
  workOrderId: Scalars['Int'];
  transactionStatuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
}>;


export type PartsOnWorkOrderDetailedQuery = { __typename?: 'Query', partsOnWorkOrder?: Array<{ __typename?: 'PartOnWorkOrder', quantity: number, costPerItem: number, part: { __typename?: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } }> | null };

export type PartsOnWorkOrderSummaryQueryVariables = Exact<{
  workOrderId: Scalars['Int'];
  transactionStatuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
}>;


export type PartsOnWorkOrderSummaryQuery = { __typename?: 'Query', partsOnWorkOrder?: Array<{ __typename?: 'PartOnWorkOrder', quantity: number, costPerItem: number }> | null };

export type PartsQueryVariables = Exact<{
  partIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  partNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type PartsQuery = { __typename?: 'Query', parts?: Array<{ __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, itemMasterVariant?: { __typename?: 'ItemMasterVariant', id: string, weight?: { __typename?: 'ItemMasterWeight', amount: any, unit: WeightUnit } | null } | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> }> | null };

export type AllPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPermissionsQuery = { __typename?: 'Query', allPermissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null, friendlyName: string, resourceType?: ResourceType | null }> };

export type GroupQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GroupQuery = { __typename?: 'Query', group: { __typename?: 'Group', id: number, name: string, spendingLimit?: number | null, users: Array<{ __typename?: 'User', companyId?: string | null, id: string, firstName?: string | null, lastName?: string | null }>, policies: Array<{ __typename?: 'ResourcePolicy', id: number, role: { __typename?: 'Role', id: number, name: string, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null } | null> }, resource: { __typename?: 'Resource', id: number, objectId: any, parentId?: any | null, companyId: any, resourceType?: ResourceType | null, entity?: { __typename?: 'Company', id: number, name: string } | { __typename?: 'District', id: number, name: string } | { __typename?: 'EsBranch', id: number, name: string } | { __typename?: 'ESResource', id: number, name: string } | { __typename?: 'Region', id: number, name: string } | { __typename?: 'Store', id: number, name: string } | null } } | null> } };

export type GroupsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type GroupsQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id: number, name: string, spendingLimit?: number | null } | null> };

export type ResourcesQueryVariables = Exact<{
  resourceIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type ResourcesQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Resource', id: number, resourceType?: ResourceType | null, entity?: { __typename?: 'Company', id: number, name: string } | { __typename?: 'District', id: number, name: string } | { __typename?: 'EsBranch', id: number, name: string } | { __typename?: 'ESResource', id: number, name: string } | { __typename?: 'Region', id: number, name: string } | { __typename?: 'Store', id: number, name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'NamedStore', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | { __typename?: 'Store', name: string, parent?: { __typename?: 'Branch', name: string } | { __typename?: 'NamedStore', name: string } | { __typename?: 'Store', name: string } | null } | null } | null } | null } | null }> };

export type RolesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: number, name: string, spendingLimit?: number | null, permissions: Array<{ __typename?: 'PermissionMeta', id: number, name?: Permission | null, friendlyName: string, resourceType?: ResourceType | null } | null> } | null> };

export type PickOrderAssigneesQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type PickOrderAssigneesQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string } }> } };

export type PickOrderCandidateFulfillmentOrdersQueryVariables = Exact<{
  fulfillmentOrderId: Scalars['ID'];
}>;


export type PickOrderCandidateFulfillmentOrdersQuery = { __typename?: 'Query', pickOrderCandidateFulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, status: FulfillmentOrderStatus, fulfillmentType: FulfillmentType, dateSubmittedForFulfillment?: any | null, destinationInventory?: { __typename?: 'InventoryLocation', id: string, name: string } | null, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', id: string, quantity: number, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null } }> }> };

export type PickOrderQueryVariables = Exact<{
  pickOrderId: Scalars['ID'];
}>;


export type PickOrderQuery = { __typename?: 'Query', pickOrder?: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, country?: CountryCode | null } | null, lines: Array<{ __typename?: 'PickOrderLine', id: string, quantityToPick: number, quantityPicked: number, binLocation?: string | null, isCancelled: boolean, fulfillmentOrderLineItemId: string, productId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, quantityFulfilled: number, quantityUnfulfilled: number, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, product: { __typename?: 'Part', id: number, name: string, partNumber?: string | null, manufacturerNumber?: string | null, provider: { __typename?: 'Provider', id: number, name: string } }, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any }, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', lineItemId: string, demandRequest: { __typename?: 'DemandRequest', id: string, requestNumber: any } } | null } }> }>, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> } | null };

export type PickOrdersQueryVariables = Exact<{
  fulfillingInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  statuses?: InputMaybe<Array<InputMaybe<PickOrderStatus>> | InputMaybe<PickOrderStatus>>;
  assignedToUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type PickOrdersQuery = { __typename?: 'Query', pickOrders: { __typename?: 'PickOrderConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: any | null }, edges: Array<{ __typename?: 'PickOrderEdge', cursor?: any | null, node: { __typename?: 'PickOrder', id: string, pickOrderNumber: any, status: PickOrderStatus, fulfillingInventoryId: string, assignedToUserId?: string | null, destinationDescription?: string | null, dateCreated: any, dateAssigned?: any | null, datePickingStarted?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, shippingAddress?: { __typename?: 'Address', name?: string | null, companyName?: string | null, city?: string | null, state?: string | null } | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string }, lines: Array<{ __typename?: 'PickOrderLine', id: string, productId: string, quantityToPick: number }>, fulfillmentOrders: Array<{ __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateNeededBy?: any | null, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }> }>, demandRequests: Array<{ __typename?: 'DemandRequest', id: string, requestNumber: any }>, fulfillments: Array<{ __typename?: 'Fulfillment', id: string, cartonNumber?: number | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string } | { __typename?: 'SystemTransferOrder', id: string } | null, lines: Array<{ __typename?: 'FulfillmentLineItem', id: string, fulfillmentOrderLineItem: { __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string } }> }> } }> } };

export type ProductCategoriesQueryVariables = Exact<{
  productCategoryIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type ProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, parentId?: any | null, productCategoryId: any }> };

export type ProductClassesQueryVariables = Exact<{
  productClassIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type ProductClassesQuery = { __typename?: 'Query', productClasses: { __typename?: 'ProductClassConnection', edges: Array<{ __typename?: 'ProductClassEdge', cursor?: any | null, node: { __typename?: 'ProductClass', id: string, dateCreated: string, catClass: string, categoryName: string, classification: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type ProductsQueryVariables = Exact<{
  paging?: InputMaybe<CursorPaging>;
  search?: InputMaybe<Scalars['String']>;
  productTypes?: InputMaybe<Array<ProductType> | ProductType>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductConnection', totalCount: number, edges: Array<{ __typename?: 'ProductEdge', node: { __typename?: 'GoodProduct', id: string, manufacturerNumber?: string | null, name: string, upc?: string | null, msrp?: any | null, year?: number | null, productType: ProductType, manufacturer?: { __typename?: 'Manufacturer', id: string, name: string } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type ProviderQueryVariables = Exact<{
  providerId: Scalars['Int'];
}>;


export type ProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id: number, name: string } | null };

export type ProvidersQueryVariables = Exact<{
  size?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  providerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  names?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ProvidersQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id: number, name: string }> };

export type ServingMiniDistributionCentersQueryVariables = Exact<{
  inventoryLocationId: Scalars['ID'];
}>;


export type ServingMiniDistributionCentersQuery = { __typename?: 'Query', inventoryLocations: { __typename?: 'InventoryLocationConnection', edges: Array<{ __typename?: 'InventoryLocationEdge', node: { __typename?: 'InventoryLocation', id: string, servingMiniDistributionCenters: Array<{ __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean }> } }> } };

export type FulfillingInventoryStorePartsQueryVariables = Exact<{
  storeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  partIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type FulfillingInventoryStorePartsQuery = { __typename?: 'Query', storeParts: Array<{ __typename?: 'StorePart', id: number, partId: any, location?: string | null, availableQuantity: number }> };

export type StorePartDetailsQueryVariables = Exact<{
  storePartId?: InputMaybe<Scalars['BigInteger']>;
  partId?: InputMaybe<Scalars['Int']>;
  storeId?: InputMaybe<Scalars['Int']>;
}>;


export type StorePartDetailsQuery = { __typename?: 'Query', storePart?: { __typename: 'StorePart', id: number, cost?: number | null, quantity: number, availableQuantity: number, threshold?: number | null, max?: number | null, partsOrdered?: number | null, incomingPartsTransferQuantity?: number | null, location?: string | null, note?: string | null, partsOrderedDetails?: Array<{ __typename?: 'PartsOrderedDetail', quantityOrdered: number, purchaseOrderNumber: string, targetType?: PurchaseOrderTargetType | null, targetId?: number | null }> | null, openReservations?: Array<{ __typename?: 'Reservation', reservationId: any, quantity: number, targetType: ReservationTargetType, targetId?: any | null, fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } | null }> | null, outgoingTransferDetails?: Array<{ __typename?: 'OutgoingTransferDetail', transferOrderId: string, quantity: number }> | null, part: { __typename?: 'Part', id: number, itemId: string, providerId: any, partNumber?: string | null, upc?: string | null, msrp?: any | null, sku: any, name: string, model?: string | null, year?: number | null, isGlobal: boolean, verifiedGlobally: boolean, dateCreated: string, dateUpdated: string, dateArchived?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null, productClass?: { __typename?: 'ProductClass', id: string, catClass: string, categoryName: string, classification: string } | null, company: { __typename?: 'Company', id: number, name: string }, vendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null }> }, inventoryLocation: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string }, rentalItems: Array<{ __typename?: 'RentalItem', id: string, rentalId: string, quantityOnRent: number }>, weightedAverageCost?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null } | null };

export type StorePartQuantityCostQueryVariables = Exact<{
  storeId: Scalars['Int'];
  partId: Scalars['Int'];
}>;


export type StorePartQuantityCostQuery = { __typename?: 'Query', storePart?: { __typename: 'StorePart', id: number, cost?: number | null, quantity: number } | null };

export type StorePartsQueryVariables = Exact<{
  branchIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  storeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  aboveMax?: InputMaybe<Scalars['Boolean']>;
  belowMin?: InputMaybe<Scalars['Boolean']>;
  isDeadStock?: InputMaybe<Scalars['Boolean']>;
  providerIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  partNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  excludeEmpty?: InputMaybe<Scalars['Boolean']>;
  sorting?: InputMaybe<Array<StorePartSort> | StorePartSort>;
}>;


export type StorePartsQuery = { __typename?: 'Query', storeParts: Array<{ __typename: 'StorePart', cost?: number | null, id: number, location?: string | null, max?: number | null, note?: string | null, quantity: number, availableQuantity: number, threshold?: number | null, partsOrdered?: number | null, incomingPartsTransferQuantity?: number | null, total: number, quantityOnRent: number, part: { __typename: 'Part', hasActiveItemMaster: boolean, id: number, partNumber?: string | null, msrp?: any | null, upc?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null }, inventoryLocation: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string }, partsOrderedDetails?: Array<{ __typename?: 'PartsOrderedDetail', quantityOrdered: number, purchaseOrderNumber: string, targetType?: PurchaseOrderTargetType | null, targetId?: number | null }> | null, openReservations?: Array<{ __typename?: 'Reservation', reservationId: any, quantity: number, targetType: ReservationTargetType, targetId?: any | null, fulfillmentOrder?: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } | null }> | null, outgoingTransferDetails?: Array<{ __typename?: 'OutgoingTransferDetail', transferOrderId: string, quantity: number }> | null, rentalItems: Array<{ __typename?: 'RentalItem', id: string, rentalId: string, quantityOnRent: number }>, weightedAverageCost?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null }> };

export type PartSummaryFragment = { __typename: 'Part', id: number, partNumber?: string | null, msrp?: any | null, upc?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, standardPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null };

export type StoresByPermissionQueryVariables = Exact<{
  permissions?: InputMaybe<Array<Permission> | Permission>;
}>;


export type StoresByPermissionQuery = { __typename?: 'Query', stores: Array<{ __typename?: 'Branch', id: number, name: string } | { __typename?: 'NamedStore', id: number, name: string } | { __typename?: 'Store', id: number, name: string }> };

export type NeedsApprovalTransactionsQueryVariables = Exact<{
  fromIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  toIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  transactionTypes?: InputMaybe<Array<TransactionType> | TransactionType>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type NeedsApprovalTransactionsQuery = { __typename?: 'Query', transactions?: Array<{ __typename: 'Transaction', id: number, transactionType?: TransactionType | null, toId?: any | null, fromId?: any | null }> | null };

export type TransactionsQueryVariables = Exact<{
  fromIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  toIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  transactionTypes?: InputMaybe<Array<TransactionType> | TransactionType>;
  transactionStatuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  customIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type TransactionsQuery = { __typename?: 'Query', transactions?: Array<{ __typename: 'Transaction', id: number, fromId?: any | null, toId?: any | null, dateCreated: string, dateCompleted?: string | null, dateCancelled?: string | null, createdBy: any, modifiedBy: any, memo?: string | null, customId?: string | null, transactionStatus?: TransactionStatus | null, transactionType?: TransactionType | null, from?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, to?: { __typename?: 'Branch', id: number, branchId: any, name: string, companyId: number, isWarehouse: boolean } | { __typename?: 'NamedStore', id: number, companyId: number, name: string, isWarehouse: boolean } | { __typename?: 'Provider', id: number, providerName: string } | null, createdByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, modifiedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string }, transactionItems?: Array<{ __typename: 'TransactionItem', id: number, quantityOrdered: number, quantityReceived?: number | null, costPerItem: number, itemStatus?: ItemStatus | null, part?: { __typename: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } | null, wacSnapshot?: { __typename?: 'WeightedAverageCostSnapshot', weightedAverageCost: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } } | null } | null> | null }> | null };

export type TransferOrderQueryVariables = Exact<{
  transferOrderId: Scalars['ID'];
}>;


export type TransferOrderQuery = { __typename?: 'Query', transferOrder?: { __typename?: 'ManualTransferOrder', requesterNote?: string | null, approverNote?: string | null, dateApproved?: any | null, dateRejected?: any | null, id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType, dateCreated: any, dateUpdated: any, dateShipped?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, isClosed: boolean, trackingNumber?: string | null, cancellationNote?: string | null, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, approver?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, fromStore?: { __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean } | null, toStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, demandRequest?: { __typename?: 'DemandRequest', id: string, requestNumber: any } | null, lineItems?: Array<{ __typename?: 'TransferOrderLineItem', lineItemId: string, productId: string, quantityRequested: number, quantityReceived?: number | null, lineNote?: string | null, allocationTargetType?: ReservationTargetType | null, allocationTargetId?: string | null, product?: { __typename?: 'GoodProduct', name: string, manufacturerNumber?: string | null, id: string, manufacturer?: { __typename?: 'Manufacturer', name: string } | null } | null }> | null, receipts: Array<{ __typename?: 'TransferOrderReceipt', id: string, dateReceived: any, notes?: string | null, receivedBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, receiptItems: Array<{ __typename?: 'TransferOrderReceiptLineItem', id: string, lineItemId: string, quantityReceived: number }> }> } | { __typename?: 'SystemTransferOrder', fulfillmentId?: string | null, assetTransferStatus?: AssetTransferStatus | null, id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType, dateCreated: any, dateUpdated: any, dateShipped?: any | null, dateCompleted?: any | null, dateCancelled?: any | null, isClosed: boolean, trackingNumber?: string | null, cancellationNote?: string | null, assetTransactions?: Array<{ __typename?: 'AssetTransfer', id: string, assetTransferOrderId?: string | null, assetTransferOrderNumber?: number | null, asset?: { __typename?: 'Asset', id: string, equipmentMake?: { __typename?: 'EquipmentMake', name: string } | null, equipmentModel?: { __typename?: 'EquipmentModel', name: string } | null } | null }> | null, fromStore?: { __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean } | null, toStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, demandRequest?: { __typename?: 'DemandRequest', id: string, requestNumber: any } | null, lineItems?: Array<{ __typename?: 'TransferOrderLineItem', lineItemId: string, productId: string, quantityRequested: number, quantityReceived?: number | null, lineNote?: string | null, allocationTargetType?: ReservationTargetType | null, allocationTargetId?: string | null, product?: { __typename?: 'GoodProduct', name: string, manufacturerNumber?: string | null, id: string, manufacturer?: { __typename?: 'Manufacturer', name: string } | null } | null }> | null, receipts: Array<{ __typename?: 'TransferOrderReceipt', id: string, dateReceived: any, notes?: string | null, receivedBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, receiptItems: Array<{ __typename?: 'TransferOrderReceiptLineItem', id: string, lineItemId: string, quantityReceived: number }> }> } | null };

export type TransferOrdersQueryVariables = Exact<{
  fromInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  toInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderTypes?: InputMaybe<Array<InputMaybe<TransferOrderType>> | InputMaybe<TransferOrderType>>;
  statuses?: InputMaybe<Array<InputMaybe<TransferOrderStatus>> | InputMaybe<TransferOrderStatus>>;
  isClosed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  fulfillmentOrderNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type TransferOrdersQuery = { __typename?: 'Query', transferOrders: { __typename?: 'TransferOrderConnection', totalCount: number, edges: Array<{ __typename?: 'TransferOrderEdge', node: { __typename?: 'ManualTransferOrder', requesterNote?: string | null, id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType, trackingNumber?: string | null, dateCreated: any, dateUpdated: any, dateShipped?: any | null, dateCompleted?: any | null, isClosed: boolean, requester: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, fromStore?: { __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean } | null, toStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, demandRequest?: { __typename?: 'DemandRequest', id: string, requestNumber: any } | null, receipts: Array<{ __typename?: 'TransferOrderReceipt', id: string }> } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType, trackingNumber?: string | null, dateCreated: any, dateUpdated: any, dateShipped?: any | null, dateCompleted?: any | null, isClosed: boolean, fromStore?: { __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean } | null, toStore?: { __typename?: 'InventoryLocation', id: string, name: string } | null, demandRequest?: { __typename?: 'DemandRequest', id: string, requestNumber: any } | null, receipts: Array<{ __typename?: 'TransferOrderReceipt', id: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type UserPermissionGrantsQueryVariables = Exact<{
  permissions?: InputMaybe<Array<Permission> | Permission>;
  resourceTypes?: InputMaybe<Array<ResourceType> | ResourceType>;
  objectIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UserPermissionGrantsQuery = { __typename?: 'Query', userPermissionGrants: Array<{ __typename?: 'PermissionGrant', permission: Permission, objectIds: Array<any> }> };

export type UserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPreferencesQuery = { __typename?: 'Query', userPreferences?: { __typename?: 'UserPreference', preferences: any } | null };

export type UsersSearchQueryVariables = Exact<{
  companyId: Scalars['BigInteger'];
  search: Scalars['String'];
}>;


export type UsersSearchQuery = { __typename?: 'Query', usersSearch: Array<{ __typename?: 'User', user_id: number, first_name: string, last_name: string, email_address?: string | null }> };

export type UsersQueryVariables = Exact<{
  companyId: Scalars['BigInteger'];
}>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', user_id: number, first_name: string, last_name: string, email_address?: string | null }> };

export type DcAdminFulfillmentOrdersQueryVariables = Exact<{
  fulfillingInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  destinationInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  statuses?: InputMaybe<Array<InputMaybe<FulfillmentOrderStatus>> | InputMaybe<FulfillmentOrderStatus>>;
  orderNumbers?: InputMaybe<Array<Scalars['BigInteger']> | Scalars['BigInteger']>;
  demandRequestIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  transferOrderIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  dateCreatedAfter?: InputMaybe<Scalars['ArrowDateTime']>;
  dateCreatedBefore?: InputMaybe<Scalars['ArrowDateTime']>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type DcAdminFulfillmentOrdersQuery = { __typename?: 'Query', fulfillmentOrders: { __typename?: 'FulfillmentOrderConnection', totalCount: number, edges: Array<{ __typename?: 'FulfillmentOrderEdge', node: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any, status: FulfillmentOrderStatus, fulfillmentType: FulfillmentType, dateCreated: any, dateSubmittedForFulfillment?: any | null, dateCompleted?: any | null, mttId?: string | null, destinationKey: string, destinationDescription: string, externalShopifyOrderId?: string | null, destinationInventory?: { __typename?: 'InventoryLocation', id: string, name: string } | null, pickOrders: Array<{ __typename?: 'PickOrder', id: string, pickOrderNumber: any }>, lineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', id: string, quantity: number, quantityFulfilled: number, demandRequestLineItem?: { __typename?: 'DemandRequestLineItem', demandRequest: { __typename?: 'DemandRequest', requestNumber: any } } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export type AssignDemandRequestMutationVariables = Exact<{
  input: AssignDemandRequestInput;
}>;


export type AssignDemandRequestMutation = { __typename?: 'Mutation', assignDemandRequest?: { __typename?: 'AssignDemandRequestResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUserId?: string | null, dateUpdated: any, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type BulkUpdateDemandRequestLineItemFulfillerNotesMutationVariables = Exact<{
  input: BulkUpdateDemandRequestLineItemFulfillerNotesInput;
}>;


export type BulkUpdateDemandRequestLineItemFulfillerNotesMutation = { __typename?: 'Mutation', bulkUpdateDemandRequestLineItemFulfillerNotes?: { __typename?: 'BulkUpdateDemandRequestLineItemFulfillerNotesResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, fulfillerNotes?: string | null }> } | null } | null };

export type CancelDemandRequestLineItemMutationVariables = Exact<{
  input: CancelDemandRequestLineItemInput;
}>;


export type CancelDemandRequestLineItemMutation = { __typename?: 'Mutation', cancelDemandRequestLineItem?: { __typename?: 'CancelDemandRequestLineItemResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, dateCompleted?: any | null, dateCancelled?: any | null, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type CancelDemandRequestLineItemsMutationVariables = Exact<{
  input: CancelDemandRequestLineItemsInput;
}>;


export type CancelDemandRequestLineItemsMutation = { __typename?: 'Mutation', cancelDemandRequestLineItems?: { __typename?: 'CancelDemandRequestLineItemsResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, dateCompleted?: any | null, dateCancelled?: any | null, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type CancelDemandRequestMutationVariables = Exact<{
  input: CancelDemandRequestInput;
}>;


export type CancelDemandRequestMutation = { __typename?: 'Mutation', cancelDemandRequest?: { __typename?: 'CancelDemandRequestResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, dateCompleted?: any | null, dateCancelled?: any | null, dateUpdated: any, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type CompleteDemandRequestMutationVariables = Exact<{
  input: CompleteDemandRequestInput;
}>;


export type CompleteDemandRequestMutation = { __typename?: 'Mutation', completeDemandRequest?: { __typename?: 'CompleteDemandRequestResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, dateCompleted?: any | null, completedByUserId?: string | null, dateUpdated: any, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type CompleteDemandRequestLineItemMutationVariables = Exact<{
  input: CompleteDemandRequestLineItemInput;
}>;


export type CompleteDemandRequestLineItemMutation = { __typename?: 'Mutation', completeDemandRequestLineItem?: { __typename?: 'CompleteDemandRequestLineItemResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type CompleteDemandRequestLineItemsMutationVariables = Exact<{
  input: CompleteDemandRequestLineItemsInput;
}>;


export type CompleteDemandRequestLineItemsMutation = { __typename?: 'Mutation', completeDemandRequestLineItems?: { __typename?: 'CompleteDemandRequestLineItemsResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type CreateDemandRequestMutationVariables = Exact<{
  input: CreateDemandRequestInput;
}>;


export type CreateDemandRequestMutation = { __typename?: 'Mutation', createDemandRequest?: { __typename?: 'CreateDemandRequestResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', companyId: string, contactPhonePrimary?: string | null, fulfillingInventoryId?: string | null, requestingInventoryId: string, notes?: string | null } | null } | null };

export type CreateProductListMutationVariables = Exact<{
  input: CreateProductListInput;
}>;


export type CreateProductListMutation = { __typename?: 'Mutation', createProductList?: { __typename?: 'CreateProductListResult', success: boolean, message: string, productList?: { __typename?: 'ProductList', id: string, context?: any | null, items: Array<{ __typename?: 'ProductListItem', productId: string, quantity: number, targetId?: string | null, targetType?: ProductListTargetType | null, notes?: string | null }> } | null } | null };

export type ReopenDemandRequestMutationVariables = Exact<{
  input: ReopenDemandRequestInput;
}>;


export type ReopenDemandRequestMutation = { __typename?: 'Mutation', reopenDemandRequest?: { __typename?: 'ReopenDemandRequestResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, dateCompleted?: any | null, completedByUserId?: string | null, dateUpdated: any, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type ReopenDemandRequestLineItemMutationVariables = Exact<{
  input: ReopenDemandRequestLineItemInput;
}>;


export type ReopenDemandRequestLineItemMutation = { __typename?: 'Mutation', reopenDemandRequestLineItem?: { __typename?: 'ReopenDemandRequestLineItemResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type ReopenDemandRequestLineItemsMutationVariables = Exact<{
  input: ReopenDemandRequestLineItemsInput;
}>;


export type ReopenDemandRequestLineItemsMutation = { __typename?: 'Mutation', reopenDemandRequestLineItems?: { __typename?: 'ReopenDemandRequestLineItemsResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, status?: DemandRequestLineItemStatus | null }> } | null } | null };

export type UpdateDemandRequestLineItemFulfillerNotesMutationVariables = Exact<{
  input: UpdateDemandRequestLineItemFulfillerNotesInput;
}>;


export type UpdateDemandRequestLineItemFulfillerNotesMutation = { __typename?: 'Mutation', updateDemandRequestLineItemFulfillerNotes?: { __typename?: 'UpdateDemandRequestLineItemFulfillerNotesResult', success: boolean, message: string, demandRequest?: { __typename?: 'DemandRequest', id: string, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, fulfillerNotes?: string | null }> } | null } | null };

export type DemandRequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DemandRequestQuery = { __typename?: 'Query', demandRequest?: { __typename: 'DemandRequest', id: string, requestNumber: any, requestType: DemandRequestType, contactPhonePrimary?: string | null, notes?: string | null, dateCreated: any, dateCompleted?: any | null, dateCancelled?: any | null, requestedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, emailAddress: string, companyId?: string | null }, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, completedByUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, cancelledByUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, deliveryAddress?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null } | null, requestingInventory: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string, branchV2?: { __typename?: 'BranchV2', isMtt: boolean } | null }, fulfillingInventory?: { __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean } | null, owningInventory: { __typename?: 'InventoryLocation', id: string, name: string, isWarehouse: boolean }, lineItems: Array<{ __typename?: 'DemandRequestLineItem', lineItemId: string, productId: string, quantityRequested: number, status?: DemandRequestLineItemStatus | null, targetType?: DemandRequestTargetType | null, targetId?: string | null, lineNotes?: string | null, fulfillerNotes?: string | null, neededBy?: any | null, allowSubstitution: boolean, willCall: boolean, dateCancelled?: any | null, fulfilledQuantity: number, outstandingQuantity: number, inFlightFulfillmentOrderCount: number, inFlightTransferOrderCount: number, isCompleted: boolean, fulfillingInventoryStorePart?: { __typename?: 'StorePart', id: number, availableQuantity: number, location?: string | null } | null, cancelledByUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, product: { __typename?: 'Part', id: number, partNumber?: string | null, manufacturerNumber?: string | null, name: string, hasActiveItemMaster: boolean, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string }, preferredVendor?: { __typename?: 'Vendor', name?: string | null } | null, preferredVendorPrice?: { __typename?: 'Money', amount: any, currencyCode: CurrencyCode } | null }, fulfillmentOrderLineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', id: string, fulfillmentOrderId: string, quantity: number, isFullyFulfilled: boolean, quantityFulfilled: number, fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any, dateSubmittedForFulfillment?: any | null, dateCreated: any, status: FulfillmentOrderStatus, dateCompleted?: any | null, fulfillingInventory: { __typename?: 'InventoryLocation', id: string, name: string } }, product: { __typename?: 'Part', id: number, partNumber?: string | null, name: string }, fulfillmentLineItems: Array<{ __typename?: 'FulfillmentLineItem', quantityFulfilled: number, quantityUnfulfilled: number, fulfillment: { __typename?: 'Fulfillment', id: string, dateShipped?: any | null, trackingNumber?: string | null, systemTransferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType } | null } }> }>, transferOrderLineItems: Array<{ __typename?: 'TransferOrderLineItem', lineItemId: string, transferOrderId: string, quantityRequested: number, product?: { __typename?: 'GoodProduct', id: string, name: string, manufacturerNumber?: string | null } | null, transferOrder?: { __typename?: 'ManualTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType, dateCreated: any } | { __typename?: 'SystemTransferOrder', id: string, status: TransferOrderStatus, transferOrderType: TransferOrderType, dateCreated: any } | null }> }> } | null };

export type DemandRequestsQueryVariables = Exact<{
  requestingInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  fulfillingInventoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  statuses?: InputMaybe<Array<InputMaybe<DemandRequestStatus>> | InputMaybe<DemandRequestStatus>>;
  assignedToIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  requestedByUserIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  requestNumbers?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  fulfillmentOrderNumbers?: InputMaybe<Array<Scalars['BigInteger']> | Scalars['BigInteger']>;
  partIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  requestTypes?: InputMaybe<Array<DemandRequestType> | DemandRequestType>;
  paging?: InputMaybe<CursorPaging>;
}>;


export type DemandRequestsQuery = { __typename?: 'Query', demandRequests: { __typename: 'DemandRequestConnection', edges: Array<{ __typename?: 'DemandRequestEdge', node: { __typename: 'DemandRequest', id: string, companyId: string, requestNumber: any, requestType: DemandRequestType, requestingInventoryId: string, fulfillingInventoryId?: string | null, owningInventoryId: string, contactPhonePrimary?: string | null, notes?: string | null, dateCreated: any, requestedByUserId: string, dateCompleted?: any | null, completedByUserId?: string | null, dateCancelled?: any | null, requestedByUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, assignedToUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, completedByUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, cancelledByUser?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, requestingInventory: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string }, fulfillingInventory?: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string } | null, owningInventory: { __typename?: 'InventoryLocation', id: string, name: string, branchId: string }, lineItems: Array<{ __typename?: 'DemandRequestLineItem', productId: string, quantityRequested: number, targetType?: DemandRequestTargetType | null, targetId?: string | null, lineNotes?: string | null, neededBy?: any | null, fulfillmentOrderLineItems: Array<{ __typename?: 'FulfillmentOrderLineItem', fulfillmentOrder: { __typename?: 'FulfillmentOrder', id: string, orderNumber: any } }>, product: { __typename?: 'Part', id: number, partNumber?: string | null, partClass: { __typename?: 'PartClass', id: number, description: string }, provider: { __typename?: 'Provider', id: number, name: string } } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: any | null, endCursor?: any | null } } };

export const TransactionEntityFieldsFragmentDoc = gql`
    fragment TransactionEntityFields on TransactionEntity {
  ... on Provider {
    id
    providerName: name
  }
  ... on Branch {
    id
    branchId
    name
    companyId
    isWarehouse
  }
  ... on NamedStore {
    id
    companyId
    name
    isWarehouse
  }
}
    `;
export const DetailedTransactionItemFragmentDoc = gql`
    fragment DetailedTransactionItem on TransactionItem {
  id
  __typename
  quantityOrdered
  quantityReceived
  costPerItem
  itemStatus
  part {
    id
    __typename
    partClass {
      id
      description
    }
    partNumber
    provider {
      id
      name
    }
  }
  wacSnapshot {
    weightedAverageCost {
      amount
      currencyCode
    }
  }
}
    `;
export const DetailedTransactionFragmentDoc = gql`
    fragment DetailedTransaction on Transaction {
  id
  __typename
  fromId
  toId
  from {
    ...TransactionEntityFields
  }
  to {
    ...TransactionEntityFields
  }
  dateCreated
  dateCompleted
  dateCancelled
  createdBy
  createdByUser {
    id
    firstName
    lastName
    emailAddress
  }
  modifiedBy
  modifiedByUser {
    id
    firstName
    lastName
    emailAddress
  }
  memo
  customId
  transactionStatus
  transactionType
  transactionItems {
    ...DetailedTransactionItem
  }
}
    ${TransactionEntityFieldsFragmentDoc}
${DetailedTransactionItemFragmentDoc}`;
export const PartOnWorkOrderPartDetailsFragmentDoc = gql`
    fragment PartOnWorkOrderPartDetails on Part {
  id
  partClass {
    id
    description
  }
  partNumber
  provider {
    id
    name
  }
}
    `;
export const PartOnWorkOrderFieldsFragmentDoc = gql`
    fragment PartOnWorkOrderFields on PartOnWorkOrder {
  part {
    ...PartOnWorkOrderPartDetails
  }
  quantity
  costPerItem
}
    ${PartOnWorkOrderPartDetailsFragmentDoc}`;
export const PartDetailsFragmentDoc = gql`
    fragment PartDetails on Part {
  id
  itemId
  providerId
  partNumber
  partClass {
    id
    description
  }
  provider {
    id
    name
  }
  upc
  standardPrice {
    amount
    currencyCode
  }
  msrp
  productClass {
    id
    catClass
    categoryName
    classification
  }
  sku
  name
  model
  year
  isGlobal
  verifiedGlobally
  company {
    id
    name
  }
  dateCreated
  dateUpdated
  dateArchived
  vendors {
    id
    name
  }
}
    `;
export const PickOrderSummaryFragmentDoc = gql`
    fragment PickOrderSummaryFragment on PickOrder {
  id
  pickOrderNumber
  status
  fulfillingInventoryId
  assignedToUserId
  assignedToUser {
    id
    firstName
    lastName
  }
  destinationDescription
  shippingAddress {
    name
    companyName
    city
    state
  }
  dateCreated
  dateAssigned
  datePickingStarted
  dateCompleted
  dateCancelled
  fulfillingInventory {
    id
    name
  }
  lines {
    id
    productId
    quantityToPick
  }
  fulfillmentOrders {
    id
    orderNumber
    dateNeededBy
    demandRequests {
      id
      requestNumber
    }
  }
  demandRequests {
    id
    requestNumber
  }
  fulfillments {
    id
    cartonNumber
    systemTransferOrder {
      id
    }
    lines {
      id
      fulfillmentOrderLineItem {
        id
        fulfillmentOrderId
      }
    }
  }
}
    `;
export const PickOrderDetailFragmentDoc = gql`
    fragment PickOrderDetailFragment on PickOrder {
  ...PickOrderSummaryFragment
  shippingAddress {
    name
    companyName
    line1
    line2
    city
    state
    postalCode
    country
  }
  lines {
    id
    quantityToPick
    quantityPicked
    binLocation
    isCancelled
    fulfillmentOrderLineItemId
    product {
      id
      name
      partNumber
      manufacturerNumber
      provider {
        id
        name
      }
    }
    fulfillmentOrder {
      id
      orderNumber
    }
  }
  fulfillments {
    id
    cartonNumber
    trackingNumber
    systemTransferOrder {
      id
    }
    lines {
      id
      quantityFulfilled
      quantityUnfulfilled
      fulfillmentOrderLineItem {
        id
        fulfillmentOrderId
        product {
          id
          name
          partNumber
          manufacturerNumber
          provider {
            id
            name
          }
        }
        fulfillmentOrder {
          id
          orderNumber
        }
        demandRequestLineItem {
          lineItemId
          demandRequest {
            id
            requestNumber
          }
        }
      }
    }
  }
}
    ${PickOrderSummaryFragmentDoc}`;
export const StoreInterfaceFragmentDoc = gql`
    fragment StoreInterfaceFragment on StoreInterface {
  id
  name
  companyId
  company {
    id
  }
  storeId
  inventoryType
  parent {
    id
    name
    inventoryType
    __typename
  }
  children {
    id
    name
    inventoryType
    parent {
      id
      name
    }
    __typename
    ... on Branch {
      branchId
    }
  }
  ... on Branch {
    branchId
  }
  __typename
}
    `;
export const PartSummaryFragmentDoc = gql`
    fragment PartSummaryFragment on Part {
  id
  partNumber
  partClass {
    id
    description
  }
  provider {
    id
    name
  }
  msrp
  upc
  standardPrice {
    amount
    currencyCode
  }
  __typename
}
    `;
export const CreateFulfillmentOrderDocument = gql`
    mutation CreateFulfillmentOrder($input: CreateFulfillmentOrderInput!) {
  createFulfillmentOrder(input: $input) {
    success
    message
    fulfillmentOrder {
      id
      orderNumber
    }
  }
}
    `;
export type CreateFulfillmentOrderMutationFn = ApolloReactCommon.MutationFunction<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>;

/**
 * __useCreateFulfillmentOrderMutation__
 *
 * To run a mutation, you first call `useCreateFulfillmentOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFulfillmentOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFulfillmentOrderMutation, { data, loading, error }] = useCreateFulfillmentOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFulfillmentOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>(CreateFulfillmentOrderDocument, options);
      }
export type CreateFulfillmentOrderMutationHookResult = ReturnType<typeof useCreateFulfillmentOrderMutation>;
export type CreateFulfillmentOrderMutationResult = ApolloReactCommon.MutationResult<CreateFulfillmentOrderMutation>;
export type CreateFulfillmentOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFulfillmentOrderMutation, CreateFulfillmentOrderMutationVariables>;
export const RequestFulfillmentOrderCancellationDocument = gql`
    mutation RequestFulfillmentOrderCancellation($input: RequestFulfillmentOrderCancellationInput!) {
  requestFulfillmentOrderCancellation(input: $input) {
    success
    message
    fulfillmentOrder {
      id
      status
      cancellationFailed
      cancellationFailureMessage
    }
  }
}
    `;
export type RequestFulfillmentOrderCancellationMutationFn = ApolloReactCommon.MutationFunction<RequestFulfillmentOrderCancellationMutation, RequestFulfillmentOrderCancellationMutationVariables>;

/**
 * __useRequestFulfillmentOrderCancellationMutation__
 *
 * To run a mutation, you first call `useRequestFulfillmentOrderCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFulfillmentOrderCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFulfillmentOrderCancellationMutation, { data, loading, error }] = useRequestFulfillmentOrderCancellationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestFulfillmentOrderCancellationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestFulfillmentOrderCancellationMutation, RequestFulfillmentOrderCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestFulfillmentOrderCancellationMutation, RequestFulfillmentOrderCancellationMutationVariables>(RequestFulfillmentOrderCancellationDocument, options);
      }
export type RequestFulfillmentOrderCancellationMutationHookResult = ReturnType<typeof useRequestFulfillmentOrderCancellationMutation>;
export type RequestFulfillmentOrderCancellationMutationResult = ApolloReactCommon.MutationResult<RequestFulfillmentOrderCancellationMutation>;
export type RequestFulfillmentOrderCancellationMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestFulfillmentOrderCancellationMutation, RequestFulfillmentOrderCancellationMutationVariables>;
export const UnloadMobileToolTrailerDocument = gql`
    mutation UnloadMobileToolTrailer($input: UnloadMobileToolTrailerInput!) {
  unloadMobileToolTrailer(input: $input) {
    success
    message
    errors {
      message
    }
    transferOrder {
      id
      status
    }
  }
}
    `;
export type UnloadMobileToolTrailerMutationFn = ApolloReactCommon.MutationFunction<UnloadMobileToolTrailerMutation, UnloadMobileToolTrailerMutationVariables>;

/**
 * __useUnloadMobileToolTrailerMutation__
 *
 * To run a mutation, you first call `useUnloadMobileToolTrailerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnloadMobileToolTrailerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unloadMobileToolTrailerMutation, { data, loading, error }] = useUnloadMobileToolTrailerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnloadMobileToolTrailerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnloadMobileToolTrailerMutation, UnloadMobileToolTrailerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnloadMobileToolTrailerMutation, UnloadMobileToolTrailerMutationVariables>(UnloadMobileToolTrailerDocument, options);
      }
export type UnloadMobileToolTrailerMutationHookResult = ReturnType<typeof useUnloadMobileToolTrailerMutation>;
export type UnloadMobileToolTrailerMutationResult = ApolloReactCommon.MutationResult<UnloadMobileToolTrailerMutation>;
export type UnloadMobileToolTrailerMutationOptions = ApolloReactCommon.BaseMutationOptions<UnloadMobileToolTrailerMutation, UnloadMobileToolTrailerMutationVariables>;
export const ArchiveInventoryLocationDocument = gql`
    mutation ArchiveInventoryLocation($inventoryLocationId: BigInteger!) {
  archiveInventoryLocation(inventoryLocationId: $inventoryLocationId) {
    success
    message
  }
}
    `;
export type ArchiveInventoryLocationMutationFn = ApolloReactCommon.MutationFunction<ArchiveInventoryLocationMutation, ArchiveInventoryLocationMutationVariables>;

/**
 * __useArchiveInventoryLocationMutation__
 *
 * To run a mutation, you first call `useArchiveInventoryLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveInventoryLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveInventoryLocationMutation, { data, loading, error }] = useArchiveInventoryLocationMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *   },
 * });
 */
export function useArchiveInventoryLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveInventoryLocationMutation, ArchiveInventoryLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveInventoryLocationMutation, ArchiveInventoryLocationMutationVariables>(ArchiveInventoryLocationDocument, options);
      }
export type ArchiveInventoryLocationMutationHookResult = ReturnType<typeof useArchiveInventoryLocationMutation>;
export type ArchiveInventoryLocationMutationResult = ApolloReactCommon.MutationResult<ArchiveInventoryLocationMutation>;
export type ArchiveInventoryLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveInventoryLocationMutation, ArchiveInventoryLocationMutationVariables>;
export const CreateInventoryLocationDocument = gql`
    mutation CreateInventoryLocation($branchId: BigInteger!, $name: String!, $inventoryType: InventoryType) {
  createInventoryLocation(branchId: $branchId, name: $name, inventoryType: $inventoryType) {
    success
    message
  }
}
    `;
export type CreateInventoryLocationMutationFn = ApolloReactCommon.MutationFunction<CreateInventoryLocationMutation, CreateInventoryLocationMutationVariables>;

/**
 * __useCreateInventoryLocationMutation__
 *
 * To run a mutation, you first call `useCreateInventoryLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryLocationMutation, { data, loading, error }] = useCreateInventoryLocationMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      name: // value for 'name'
 *      inventoryType: // value for 'inventoryType'
 *   },
 * });
 */
export function useCreateInventoryLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInventoryLocationMutation, CreateInventoryLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInventoryLocationMutation, CreateInventoryLocationMutationVariables>(CreateInventoryLocationDocument, options);
      }
export type CreateInventoryLocationMutationHookResult = ReturnType<typeof useCreateInventoryLocationMutation>;
export type CreateInventoryLocationMutationResult = ApolloReactCommon.MutationResult<CreateInventoryLocationMutation>;
export type CreateInventoryLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInventoryLocationMutation, CreateInventoryLocationMutationVariables>;
export const MoveInventoryLocationToDocument = gql`
    mutation MoveInventoryLocationTo($inventoryLocationId: BigInteger!, $branchId: BigInteger!) {
  moveInventoryLocationTo(inventoryLocationId: $inventoryLocationId, branchId: $branchId) {
    success
    message
    inventoryLocation {
      id
      name
      branchId
      defaultLocation
      companyId
      isWarehouse
      branch {
        id
        name
      }
    }
  }
}
    `;
export type MoveInventoryLocationToMutationFn = ApolloReactCommon.MutationFunction<MoveInventoryLocationToMutation, MoveInventoryLocationToMutationVariables>;

/**
 * __useMoveInventoryLocationToMutation__
 *
 * To run a mutation, you first call `useMoveInventoryLocationToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveInventoryLocationToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveInventoryLocationToMutation, { data, loading, error }] = useMoveInventoryLocationToMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useMoveInventoryLocationToMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveInventoryLocationToMutation, MoveInventoryLocationToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveInventoryLocationToMutation, MoveInventoryLocationToMutationVariables>(MoveInventoryLocationToDocument, options);
      }
export type MoveInventoryLocationToMutationHookResult = ReturnType<typeof useMoveInventoryLocationToMutation>;
export type MoveInventoryLocationToMutationResult = ApolloReactCommon.MutationResult<MoveInventoryLocationToMutation>;
export type MoveInventoryLocationToMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveInventoryLocationToMutation, MoveInventoryLocationToMutationVariables>;
export const PromoteInventoryLocationToDefaultDocument = gql`
    mutation PromoteInventoryLocationToDefault($inventoryLocationId: BigInteger!) {
  promoteInventoryLocationToDefault(inventoryLocationId: $inventoryLocationId) {
    success
    message
    inventoryLocation {
      id
      name
      branchId
      defaultLocation
      companyId
      isWarehouse
      branch {
        id
        name
      }
    }
  }
}
    `;
export type PromoteInventoryLocationToDefaultMutationFn = ApolloReactCommon.MutationFunction<PromoteInventoryLocationToDefaultMutation, PromoteInventoryLocationToDefaultMutationVariables>;

/**
 * __usePromoteInventoryLocationToDefaultMutation__
 *
 * To run a mutation, you first call `usePromoteInventoryLocationToDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteInventoryLocationToDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteInventoryLocationToDefaultMutation, { data, loading, error }] = usePromoteInventoryLocationToDefaultMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *   },
 * });
 */
export function usePromoteInventoryLocationToDefaultMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PromoteInventoryLocationToDefaultMutation, PromoteInventoryLocationToDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PromoteInventoryLocationToDefaultMutation, PromoteInventoryLocationToDefaultMutationVariables>(PromoteInventoryLocationToDefaultDocument, options);
      }
export type PromoteInventoryLocationToDefaultMutationHookResult = ReturnType<typeof usePromoteInventoryLocationToDefaultMutation>;
export type PromoteInventoryLocationToDefaultMutationResult = ApolloReactCommon.MutationResult<PromoteInventoryLocationToDefaultMutation>;
export type PromoteInventoryLocationToDefaultMutationOptions = ApolloReactCommon.BaseMutationOptions<PromoteInventoryLocationToDefaultMutation, PromoteInventoryLocationToDefaultMutationVariables>;
export const UpdateInventoryLocationDocument = gql`
    mutation UpdateInventoryLocation($inventoryLocationId: BigInteger!, $branchId: BigInteger, $name: String, $inventoryType: InventoryType) {
  updateInventoryLocation(inventoryLocationId: $inventoryLocationId, branchId: $branchId, name: $name, inventoryType: $inventoryType) {
    success
    message
    inventoryLocation {
      id
      name
      branchId
      defaultLocation
      companyId
      isWarehouse
      branch {
        id
        name
      }
    }
  }
}
    `;
export type UpdateInventoryLocationMutationFn = ApolloReactCommon.MutationFunction<UpdateInventoryLocationMutation, UpdateInventoryLocationMutationVariables>;

/**
 * __useUpdateInventoryLocationMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryLocationMutation, { data, loading, error }] = useUpdateInventoryLocationMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      branchId: // value for 'branchId'
 *      name: // value for 'name'
 *      inventoryType: // value for 'inventoryType'
 *   },
 * });
 */
export function useUpdateInventoryLocationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInventoryLocationMutation, UpdateInventoryLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInventoryLocationMutation, UpdateInventoryLocationMutationVariables>(UpdateInventoryLocationDocument, options);
      }
export type UpdateInventoryLocationMutationHookResult = ReturnType<typeof useUpdateInventoryLocationMutation>;
export type UpdateInventoryLocationMutationResult = ApolloReactCommon.MutationResult<UpdateInventoryLocationMutation>;
export type UpdateInventoryLocationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInventoryLocationMutation, UpdateInventoryLocationMutationVariables>;
export const UpdateInventoryLocationWarehouseDocument = gql`
    mutation UpdateInventoryLocationWarehouse($inventoryLocationId: BigInteger!, $warehouse: UpdateInventoryLocationWarehouseInput) {
  updateInventoryLocation(inventoryLocationId: $inventoryLocationId, warehouse: $warehouse) {
    success
    message
    inventoryLocation {
      id
      name
      branchId
      defaultLocation
      companyId
      isWarehouse
      warehouse {
        warehouseExecutionSystem
        servedZipCodes
      }
      branch {
        id
        name
      }
    }
  }
}
    `;
export type UpdateInventoryLocationWarehouseMutationFn = ApolloReactCommon.MutationFunction<UpdateInventoryLocationWarehouseMutation, UpdateInventoryLocationWarehouseMutationVariables>;

/**
 * __useUpdateInventoryLocationWarehouseMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryLocationWarehouseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryLocationWarehouseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryLocationWarehouseMutation, { data, loading, error }] = useUpdateInventoryLocationWarehouseMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      warehouse: // value for 'warehouse'
 *   },
 * });
 */
export function useUpdateInventoryLocationWarehouseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInventoryLocationWarehouseMutation, UpdateInventoryLocationWarehouseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInventoryLocationWarehouseMutation, UpdateInventoryLocationWarehouseMutationVariables>(UpdateInventoryLocationWarehouseDocument, options);
      }
export type UpdateInventoryLocationWarehouseMutationHookResult = ReturnType<typeof useUpdateInventoryLocationWarehouseMutation>;
export type UpdateInventoryLocationWarehouseMutationResult = ApolloReactCommon.MutationResult<UpdateInventoryLocationWarehouseMutation>;
export type UpdateInventoryLocationWarehouseMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInventoryLocationWarehouseMutation, UpdateInventoryLocationWarehouseMutationVariables>;
export const ActivateItemMasterVariantDocument = gql`
    mutation ActivateItemMasterVariant($input: ActivateItemMasterVariantInput!) {
  activateItemMasterVariant(input: $input) {
    success
    message
    itemMaster {
      id
    }
  }
}
    `;
export type ActivateItemMasterVariantMutationFn = ApolloReactCommon.MutationFunction<ActivateItemMasterVariantMutation, ActivateItemMasterVariantMutationVariables>;

/**
 * __useActivateItemMasterVariantMutation__
 *
 * To run a mutation, you first call `useActivateItemMasterVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateItemMasterVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateItemMasterVariantMutation, { data, loading, error }] = useActivateItemMasterVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateItemMasterVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateItemMasterVariantMutation, ActivateItemMasterVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateItemMasterVariantMutation, ActivateItemMasterVariantMutationVariables>(ActivateItemMasterVariantDocument, options);
      }
export type ActivateItemMasterVariantMutationHookResult = ReturnType<typeof useActivateItemMasterVariantMutation>;
export type ActivateItemMasterVariantMutationResult = ApolloReactCommon.MutationResult<ActivateItemMasterVariantMutation>;
export type ActivateItemMasterVariantMutationOptions = ApolloReactCommon.BaseMutationOptions<ActivateItemMasterVariantMutation, ActivateItemMasterVariantMutationVariables>;
export const AddItemMasterVariantDocument = gql`
    mutation AddItemMasterVariant($input: AddItemMasterVariantInput!) {
  addItemMasterVariant(input: $input) {
    success
    message
    itemMaster {
      id
      variants {
        id
        isBase
        conversionRate
        freightClass
        nmfc
        shippedInOriginalContainer
        siocQuantity
        isPolybagEligible
        dimensions {
          length
          width
          height
          unit
        }
        weight {
          amount
          unit
        }
      }
    }
  }
}
    `;
export type AddItemMasterVariantMutationFn = ApolloReactCommon.MutationFunction<AddItemMasterVariantMutation, AddItemMasterVariantMutationVariables>;

/**
 * __useAddItemMasterVariantMutation__
 *
 * To run a mutation, you first call `useAddItemMasterVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemMasterVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemMasterVariantMutation, { data, loading, error }] = useAddItemMasterVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddItemMasterVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddItemMasterVariantMutation, AddItemMasterVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddItemMasterVariantMutation, AddItemMasterVariantMutationVariables>(AddItemMasterVariantDocument, options);
      }
export type AddItemMasterVariantMutationHookResult = ReturnType<typeof useAddItemMasterVariantMutation>;
export type AddItemMasterVariantMutationResult = ApolloReactCommon.MutationResult<AddItemMasterVariantMutation>;
export type AddItemMasterVariantMutationOptions = ApolloReactCommon.BaseMutationOptions<AddItemMasterVariantMutation, AddItemMasterVariantMutationVariables>;
export const CreateItemMasterDocument = gql`
    mutation CreateItemMaster($input: CreateItemMasterInput!) {
  createItemMaster(input: $input) {
    success
    message
    itemMaster {
      id
      isActive
      flammable
      fragile
      lithiumIonBattery
      isHazmat
      numinaSerialType
      equipmentMakeId
      equipmentModelId
      variants {
        id
        isBase
      }
    }
  }
}
    `;
export type CreateItemMasterMutationFn = ApolloReactCommon.MutationFunction<CreateItemMasterMutation, CreateItemMasterMutationVariables>;

/**
 * __useCreateItemMasterMutation__
 *
 * To run a mutation, you first call `useCreateItemMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateItemMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createItemMasterMutation, { data, loading, error }] = useCreateItemMasterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateItemMasterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateItemMasterMutation, CreateItemMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateItemMasterMutation, CreateItemMasterMutationVariables>(CreateItemMasterDocument, options);
      }
export type CreateItemMasterMutationHookResult = ReturnType<typeof useCreateItemMasterMutation>;
export type CreateItemMasterMutationResult = ApolloReactCommon.MutationResult<CreateItemMasterMutation>;
export type CreateItemMasterMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateItemMasterMutation, CreateItemMasterMutationVariables>;
export const CreateProductWithItemMasterDocument = gql`
    mutation CreateProductWithItemMaster($manufacturerId: BigInteger!, $manufacturerNumber: String!, $name: String!, $msrp: Decimal, $conversionUnit: UnitsOfMeasurementEnum, $productClassId: ID, $itemMaster: CreateProductItemMasterInput) {
  createProduct(manufacturerId: $manufacturerId, manufacturerNumber: $manufacturerNumber, name: $name, msrp: $msrp, conversionUnit: $conversionUnit, productClassId: $productClassId, productTypeId: GOOD, itemMaster: $itemMaster) {
    success
    message
    product {
      ... on GoodProduct {
        id
        name
        itemMaster {
          id
        }
      }
    }
  }
}
    `;
export type CreateProductWithItemMasterMutationFn = ApolloReactCommon.MutationFunction<CreateProductWithItemMasterMutation, CreateProductWithItemMasterMutationVariables>;

/**
 * __useCreateProductWithItemMasterMutation__
 *
 * To run a mutation, you first call `useCreateProductWithItemMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductWithItemMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductWithItemMasterMutation, { data, loading, error }] = useCreateProductWithItemMasterMutation({
 *   variables: {
 *      manufacturerId: // value for 'manufacturerId'
 *      manufacturerNumber: // value for 'manufacturerNumber'
 *      name: // value for 'name'
 *      msrp: // value for 'msrp'
 *      conversionUnit: // value for 'conversionUnit'
 *      productClassId: // value for 'productClassId'
 *      itemMaster: // value for 'itemMaster'
 *   },
 * });
 */
export function useCreateProductWithItemMasterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductWithItemMasterMutation, CreateProductWithItemMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductWithItemMasterMutation, CreateProductWithItemMasterMutationVariables>(CreateProductWithItemMasterDocument, options);
      }
export type CreateProductWithItemMasterMutationHookResult = ReturnType<typeof useCreateProductWithItemMasterMutation>;
export type CreateProductWithItemMasterMutationResult = ApolloReactCommon.MutationResult<CreateProductWithItemMasterMutation>;
export type CreateProductWithItemMasterMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProductWithItemMasterMutation, CreateProductWithItemMasterMutationVariables>;
export const UpdateItemMasterVariantDocument = gql`
    mutation UpdateItemMasterVariant($input: UpdateItemMasterVariantInput!) {
  updateItemMasterVariant(input: $input) {
    success
    message
    itemMaster {
      id
      variants {
        id
        isBase
        uom
        conversionRate
        freightClass
        nmfc
        shippedInOriginalContainer
        siocQuantity
        isPolybagEligible
        dimensions {
          length
          width
          height
          unit
        }
        weight {
          amount
          unit
        }
      }
    }
  }
}
    `;
export type UpdateItemMasterVariantMutationFn = ApolloReactCommon.MutationFunction<UpdateItemMasterVariantMutation, UpdateItemMasterVariantMutationVariables>;

/**
 * __useUpdateItemMasterVariantMutation__
 *
 * To run a mutation, you first call `useUpdateItemMasterVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemMasterVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemMasterVariantMutation, { data, loading, error }] = useUpdateItemMasterVariantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemMasterVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateItemMasterVariantMutation, UpdateItemMasterVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateItemMasterVariantMutation, UpdateItemMasterVariantMutationVariables>(UpdateItemMasterVariantDocument, options);
      }
export type UpdateItemMasterVariantMutationHookResult = ReturnType<typeof useUpdateItemMasterVariantMutation>;
export type UpdateItemMasterVariantMutationResult = ApolloReactCommon.MutationResult<UpdateItemMasterVariantMutation>;
export type UpdateItemMasterVariantMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateItemMasterVariantMutation, UpdateItemMasterVariantMutationVariables>;
export const UpdateItemMasterDocument = gql`
    mutation UpdateItemMaster($input: UpdateItemMasterInput!) {
  updateItemMaster(input: $input) {
    success
    message
    itemMaster {
      id
      isActive
      flammable
      fragile
      lithiumIonBattery
      isHazmat
      numinaSerialType
      equipmentMakeId
      equipmentModelId
    }
  }
}
    `;
export type UpdateItemMasterMutationFn = ApolloReactCommon.MutationFunction<UpdateItemMasterMutation, UpdateItemMasterMutationVariables>;

/**
 * __useUpdateItemMasterMutation__
 *
 * To run a mutation, you first call `useUpdateItemMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItemMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItemMasterMutation, { data, loading, error }] = useUpdateItemMasterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItemMasterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateItemMasterMutation, UpdateItemMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateItemMasterMutation, UpdateItemMasterMutationVariables>(UpdateItemMasterDocument, options);
      }
export type UpdateItemMasterMutationHookResult = ReturnType<typeof useUpdateItemMasterMutation>;
export type UpdateItemMasterMutationResult = ApolloReactCommon.MutationResult<UpdateItemMasterMutation>;
export type UpdateItemMasterMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateItemMasterMutation, UpdateItemMasterMutationVariables>;
export const CreateManualAdjustmentDocument = gql`
    mutation CreateManualAdjustment($direction: IncrementOrDecrement, $inventoryLocationId: ID!, $items: [CreateManualAdjustmentItem]!, $memo: String, $reason: ManualAdjustmentReasonType!, $vendorId: ID, $purchaseOrderId: ID, $purchaseId: ID) {
  createManualAdjustment(direction: $direction, inventoryLocationId: $inventoryLocationId, items: $items, memo: $memo, reason: $reason, vendorId: $vendorId, purchaseOrderId: $purchaseOrderId, purchaseId: $purchaseId) {
    success
    message
    manualAdjustments {
      id
      reason
      reasonDisplay
      quantityChange
      memo
      vendorId
      purchaseOrderId
      purchaseId
    }
  }
}
    `;
export type CreateManualAdjustmentMutationFn = ApolloReactCommon.MutationFunction<CreateManualAdjustmentMutation, CreateManualAdjustmentMutationVariables>;

/**
 * __useCreateManualAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateManualAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualAdjustmentMutation, { data, loading, error }] = useCreateManualAdjustmentMutation({
 *   variables: {
 *      direction: // value for 'direction'
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      items: // value for 'items'
 *      memo: // value for 'memo'
 *      reason: // value for 'reason'
 *      vendorId: // value for 'vendorId'
 *      purchaseOrderId: // value for 'purchaseOrderId'
 *      purchaseId: // value for 'purchaseId'
 *   },
 * });
 */
export function useCreateManualAdjustmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateManualAdjustmentMutation, CreateManualAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateManualAdjustmentMutation, CreateManualAdjustmentMutationVariables>(CreateManualAdjustmentDocument, options);
      }
export type CreateManualAdjustmentMutationHookResult = ReturnType<typeof useCreateManualAdjustmentMutation>;
export type CreateManualAdjustmentMutationResult = ApolloReactCommon.MutationResult<CreateManualAdjustmentMutation>;
export type CreateManualAdjustmentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateManualAdjustmentMutation, CreateManualAdjustmentMutationVariables>;
export const CreatePartDocument = gql`
    mutation CreatePart($description: String, $partNumber: String!, $providerId: BigInteger!, $upc: String, $standardPrice: Decimal, $msrp: Decimal, $productClassId: ID) {
  createPart(description: $description, partNumber: $partNumber, providerId: $providerId, upc: $upc, standardPrice: $standardPrice, msrp: $msrp, productClassId: $productClassId) {
    ...PartDetails
  }
}
    ${PartDetailsFragmentDoc}`;
export type CreatePartMutationFn = ApolloReactCommon.MutationFunction<CreatePartMutation, CreatePartMutationVariables>;

/**
 * __useCreatePartMutation__
 *
 * To run a mutation, you first call `useCreatePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartMutation, { data, loading, error }] = useCreatePartMutation({
 *   variables: {
 *      description: // value for 'description'
 *      partNumber: // value for 'partNumber'
 *      providerId: // value for 'providerId'
 *      upc: // value for 'upc'
 *      standardPrice: // value for 'standardPrice'
 *      msrp: // value for 'msrp'
 *      productClassId: // value for 'productClassId'
 *   },
 * });
 */
export function useCreatePartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePartMutation, CreatePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePartMutation, CreatePartMutationVariables>(CreatePartDocument, options);
      }
export type CreatePartMutationHookResult = ReturnType<typeof useCreatePartMutation>;
export type CreatePartMutationResult = ApolloReactCommon.MutationResult<CreatePartMutation>;
export type CreatePartMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePartMutation, CreatePartMutationVariables>;
export const MergePartsDocument = gql`
    mutation MergeParts($companyId: BigInteger, $goodPartId: BigInteger!, $duplicatePartId: BigInteger!) {
  mergeParts(companyId: $companyId, goodPartId: $goodPartId, duplicatePartId: $duplicatePartId) {
    success
    message
  }
}
    `;
export type MergePartsMutationFn = ApolloReactCommon.MutationFunction<MergePartsMutation, MergePartsMutationVariables>;

/**
 * __useMergePartsMutation__
 *
 * To run a mutation, you first call `useMergePartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePartsMutation, { data, loading, error }] = useMergePartsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      goodPartId: // value for 'goodPartId'
 *      duplicatePartId: // value for 'duplicatePartId'
 *   },
 * });
 */
export function useMergePartsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergePartsMutation, MergePartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergePartsMutation, MergePartsMutationVariables>(MergePartsDocument, options);
      }
export type MergePartsMutationHookResult = ReturnType<typeof useMergePartsMutation>;
export type MergePartsMutationResult = ApolloReactCommon.MutationResult<MergePartsMutation>;
export type MergePartsMutationOptions = ApolloReactCommon.BaseMutationOptions<MergePartsMutation, MergePartsMutationVariables>;
export const UpdatePartDocument = gql`
    mutation UpdatePart($description: String, $partId: BigInteger!, $partNumber: String, $providerId: BigInteger, $upc: String, $standardPrice: Decimal, $msrp: Decimal, $productClassId: ID) {
  updatePart(description: $description, partId: $partId, partNumber: $partNumber, providerId: $providerId, upc: $upc, standardPrice: $standardPrice, msrp: $msrp, productClassId: $productClassId) {
    ...PartDetails
  }
}
    ${PartDetailsFragmentDoc}`;
export type UpdatePartMutationFn = ApolloReactCommon.MutationFunction<UpdatePartMutation, UpdatePartMutationVariables>;

/**
 * __useUpdatePartMutation__
 *
 * To run a mutation, you first call `useUpdatePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartMutation, { data, loading, error }] = useUpdatePartMutation({
 *   variables: {
 *      description: // value for 'description'
 *      partId: // value for 'partId'
 *      partNumber: // value for 'partNumber'
 *      providerId: // value for 'providerId'
 *      upc: // value for 'upc'
 *      standardPrice: // value for 'standardPrice'
 *      msrp: // value for 'msrp'
 *      productClassId: // value for 'productClassId'
 *   },
 * });
 */
export function useUpdatePartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePartMutation, UpdatePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePartMutation, UpdatePartMutationVariables>(UpdatePartDocument, options);
      }
export type UpdatePartMutationHookResult = ReturnType<typeof useUpdatePartMutation>;
export type UpdatePartMutationResult = ApolloReactCommon.MutationResult<UpdatePartMutation>;
export type UpdatePartMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdatePartMutation, UpdatePartMutationVariables>;
export const AddPolicyToGroupDocument = gql`
    mutation AddPolicyToGroup($groupId: Int!, $resourceId: Int!, $roleId: Int!) {
  addPolicyToGroup(groupId: $groupId, resourceId: $resourceId, roleId: $roleId) {
    success
    message
    group {
      id
      name
      userIds
      policies {
        id
        role {
          id
          name
          permissions {
            id
            name
          }
        }
        resource {
          id
          objectId
          parentId
          companyId
          resourceType
        }
      }
    }
  }
}
    `;
export type AddPolicyToGroupMutationFn = ApolloReactCommon.MutationFunction<AddPolicyToGroupMutation, AddPolicyToGroupMutationVariables>;

/**
 * __useAddPolicyToGroupMutation__
 *
 * To run a mutation, you first call `useAddPolicyToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPolicyToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPolicyToGroupMutation, { data, loading, error }] = useAddPolicyToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      resourceId: // value for 'resourceId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAddPolicyToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPolicyToGroupMutation, AddPolicyToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPolicyToGroupMutation, AddPolicyToGroupMutationVariables>(AddPolicyToGroupDocument, options);
      }
export type AddPolicyToGroupMutationHookResult = ReturnType<typeof useAddPolicyToGroupMutation>;
export type AddPolicyToGroupMutationResult = ApolloReactCommon.MutationResult<AddPolicyToGroupMutation>;
export type AddPolicyToGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPolicyToGroupMutation, AddPolicyToGroupMutationVariables>;
export const AssignUsersToGroupDocument = gql`
    mutation AssignUsersToGroup($userIds: [Int!]!, $groupId: Int!) {
  assignUsersToGroup(userIds: $userIds, groupId: $groupId) {
    success
    message
    group {
      id
      userIds
    }
  }
}
    `;
export type AssignUsersToGroupMutationFn = ApolloReactCommon.MutationFunction<AssignUsersToGroupMutation, AssignUsersToGroupMutationVariables>;

/**
 * __useAssignUsersToGroupMutation__
 *
 * To run a mutation, you first call `useAssignUsersToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignUsersToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignUsersToGroupMutation, { data, loading, error }] = useAssignUsersToGroupMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAssignUsersToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignUsersToGroupMutation, AssignUsersToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignUsersToGroupMutation, AssignUsersToGroupMutationVariables>(AssignUsersToGroupDocument, options);
      }
export type AssignUsersToGroupMutationHookResult = ReturnType<typeof useAssignUsersToGroupMutation>;
export type AssignUsersToGroupMutationResult = ApolloReactCommon.MutationResult<AssignUsersToGroupMutation>;
export type AssignUsersToGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignUsersToGroupMutation, AssignUsersToGroupMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($companyId: Int, $name: String!, $spendingLimit: Float) {
  createGroup(companyId: $companyId, name: $name, spendingLimit: $spendingLimit) {
    success
    message
    group {
      id
      name
      spendingLimit
    }
    errors {
      message
      __typename
    }
  }
}
    `;
export type CreateGroupMutationFn = ApolloReactCommon.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      spendingLimit: // value for 'spendingLimit'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = ApolloReactCommon.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation DeleteGroup($groupId: BigInteger!) {
  deleteGroup(groupId: $groupId) {
    success
    message
    errors {
      message
      __typename
    }
    __typename
  }
}
    `;
export type DeleteGroupMutationFn = ApolloReactCommon.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = ApolloReactCommon.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const RemovePolicyFromGroupDocument = gql`
    mutation RemovePolicyFromGroup($policyId: Int!) {
  removePolicyFromGroup(policyId: $policyId) {
    success
    message
    group {
      id
      name
      userIds
      policies {
        id
        role {
          id
          name
          permissions {
            id
            name
          }
        }
        resource {
          id
          objectId
          parentId
          companyId
          resourceType
        }
      }
    }
  }
}
    `;
export type RemovePolicyFromGroupMutationFn = ApolloReactCommon.MutationFunction<RemovePolicyFromGroupMutation, RemovePolicyFromGroupMutationVariables>;

/**
 * __useRemovePolicyFromGroupMutation__
 *
 * To run a mutation, you first call `useRemovePolicyFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePolicyFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePolicyFromGroupMutation, { data, loading, error }] = useRemovePolicyFromGroupMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useRemovePolicyFromGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePolicyFromGroupMutation, RemovePolicyFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemovePolicyFromGroupMutation, RemovePolicyFromGroupMutationVariables>(RemovePolicyFromGroupDocument, options);
      }
export type RemovePolicyFromGroupMutationHookResult = ReturnType<typeof useRemovePolicyFromGroupMutation>;
export type RemovePolicyFromGroupMutationResult = ApolloReactCommon.MutationResult<RemovePolicyFromGroupMutation>;
export type RemovePolicyFromGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<RemovePolicyFromGroupMutation, RemovePolicyFromGroupMutationVariables>;
export const RemoveUsersFromGroupDocument = gql`
    mutation RemoveUsersFromGroup($userIds: [Int!]!, $groupId: Int!) {
  removeUsersFromGroup(userIds: $userIds, groupId: $groupId) {
    success
    message
    group {
      id
      userIds
    }
  }
}
    `;
export type RemoveUsersFromGroupMutationFn = ApolloReactCommon.MutationFunction<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;

/**
 * __useRemoveUsersFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromGroupMutation, { data, loading, error }] = useRemoveUsersFromGroupMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useRemoveUsersFromGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>(RemoveUsersFromGroupDocument, options);
      }
export type RemoveUsersFromGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationResult = ApolloReactCommon.MutationResult<RemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;
export const AssignPermissionsToRoleDocument = gql`
    mutation AssignPermissionsToRole($permissions: [Permission!]!, $roleId: Int!) {
  assignPermissionsToRole(permissions: $permissions, roleId: $roleId) {
    success
    message
    role {
      id
      permissions {
        id
        name
        friendlyName
      }
    }
  }
}
    `;
export type AssignPermissionsToRoleMutationFn = ApolloReactCommon.MutationFunction<AssignPermissionsToRoleMutation, AssignPermissionsToRoleMutationVariables>;

/**
 * __useAssignPermissionsToRoleMutation__
 *
 * To run a mutation, you first call `useAssignPermissionsToRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPermissionsToRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPermissionsToRoleMutation, { data, loading, error }] = useAssignPermissionsToRoleMutation({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAssignPermissionsToRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignPermissionsToRoleMutation, AssignPermissionsToRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignPermissionsToRoleMutation, AssignPermissionsToRoleMutationVariables>(AssignPermissionsToRoleDocument, options);
      }
export type AssignPermissionsToRoleMutationHookResult = ReturnType<typeof useAssignPermissionsToRoleMutation>;
export type AssignPermissionsToRoleMutationResult = ApolloReactCommon.MutationResult<AssignPermissionsToRoleMutation>;
export type AssignPermissionsToRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignPermissionsToRoleMutation, AssignPermissionsToRoleMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($companyId: Int, $name: String, $spendingLimit: Float) {
  createRole(companyId: $companyId, name: $name, spendingLimit: $spendingLimit) {
    success
    message
    role {
      id
      name
      spendingLimit
      permissions {
        id
        name
        friendlyName
      }
      __typename
    }
  }
}
    `;
export type CreateRoleMutationFn = ApolloReactCommon.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      name: // value for 'name'
 *      spendingLimit: // value for 'spendingLimit'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = ApolloReactCommon.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const RemovePermissionsFromRoleDocument = gql`
    mutation RemovePermissionsFromRole($permissions: [Permission!]!, $roleId: Int!) {
  removePermissionsFromRole(permissions: $permissions, roleId: $roleId) {
    success
    message
    role {
      id
      permissions {
        id
        name
        friendlyName
      }
    }
  }
}
    `;
export type RemovePermissionsFromRoleMutationFn = ApolloReactCommon.MutationFunction<RemovePermissionsFromRoleMutation, RemovePermissionsFromRoleMutationVariables>;

/**
 * __useRemovePermissionsFromRoleMutation__
 *
 * To run a mutation, you first call `useRemovePermissionsFromRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionsFromRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermissionsFromRoleMutation, { data, loading, error }] = useRemovePermissionsFromRoleMutation({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRemovePermissionsFromRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemovePermissionsFromRoleMutation, RemovePermissionsFromRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemovePermissionsFromRoleMutation, RemovePermissionsFromRoleMutationVariables>(RemovePermissionsFromRoleDocument, options);
      }
export type RemovePermissionsFromRoleMutationHookResult = ReturnType<typeof useRemovePermissionsFromRoleMutation>;
export type RemovePermissionsFromRoleMutationResult = ApolloReactCommon.MutationResult<RemovePermissionsFromRoleMutation>;
export type RemovePermissionsFromRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<RemovePermissionsFromRoleMutation, RemovePermissionsFromRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleId: BigInteger!) {
  deleteRole(roleId: $roleId) {
    success
    message
    __typename
  }
}
    `;
export type DeleteRoleMutationFn = ApolloReactCommon.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = ApolloReactCommon.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRole__Input!) {
  updateRole(input: $input) {
    success
    message
    role {
      id
      name
      spendingLimit
    }
  }
}
    `;
export type UpdateRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = ApolloReactCommon.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroup__Input!) {
  updateGroup(input: $input) {
    success
    message
    group {
      id
      name
      spendingLimit
    }
    errors {
      message
      __typename
    }
  }
}
    `;
export type UpdateGroupMutationFn = ApolloReactCommon.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = ApolloReactCommon.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const AddFulfillmentOrdersToPickOrderDocument = gql`
    mutation AddFulfillmentOrdersToPickOrder($input: AddFulfillmentOrdersToPickOrderInput!) {
  addFulfillmentOrdersToPickOrder(input: $input) {
    success
    message
    errors {
      message
    }
    pickOrder {
      ...PickOrderDetailFragment
    }
  }
}
    ${PickOrderDetailFragmentDoc}`;
export type AddFulfillmentOrdersToPickOrderMutationFn = ApolloReactCommon.MutationFunction<AddFulfillmentOrdersToPickOrderMutation, AddFulfillmentOrdersToPickOrderMutationVariables>;

/**
 * __useAddFulfillmentOrdersToPickOrderMutation__
 *
 * To run a mutation, you first call `useAddFulfillmentOrdersToPickOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFulfillmentOrdersToPickOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFulfillmentOrdersToPickOrderMutation, { data, loading, error }] = useAddFulfillmentOrdersToPickOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFulfillmentOrdersToPickOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFulfillmentOrdersToPickOrderMutation, AddFulfillmentOrdersToPickOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFulfillmentOrdersToPickOrderMutation, AddFulfillmentOrdersToPickOrderMutationVariables>(AddFulfillmentOrdersToPickOrderDocument, options);
      }
export type AddFulfillmentOrdersToPickOrderMutationHookResult = ReturnType<typeof useAddFulfillmentOrdersToPickOrderMutation>;
export type AddFulfillmentOrdersToPickOrderMutationResult = ApolloReactCommon.MutationResult<AddFulfillmentOrdersToPickOrderMutation>;
export type AddFulfillmentOrdersToPickOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFulfillmentOrdersToPickOrderMutation, AddFulfillmentOrdersToPickOrderMutationVariables>;
export const AssignPickOrderDocument = gql`
    mutation AssignPickOrder($input: AssignPickOrderInput!) {
  assignPickOrder(input: $input) {
    success
    message
    errors {
      message
    }
    pickOrder {
      ...PickOrderSummaryFragment
    }
  }
}
    ${PickOrderSummaryFragmentDoc}`;
export type AssignPickOrderMutationFn = ApolloReactCommon.MutationFunction<AssignPickOrderMutation, AssignPickOrderMutationVariables>;

/**
 * __useAssignPickOrderMutation__
 *
 * To run a mutation, you first call `useAssignPickOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPickOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPickOrderMutation, { data, loading, error }] = useAssignPickOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPickOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignPickOrderMutation, AssignPickOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignPickOrderMutation, AssignPickOrderMutationVariables>(AssignPickOrderDocument, options);
      }
export type AssignPickOrderMutationHookResult = ReturnType<typeof useAssignPickOrderMutation>;
export type AssignPickOrderMutationResult = ApolloReactCommon.MutationResult<AssignPickOrderMutation>;
export type AssignPickOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignPickOrderMutation, AssignPickOrderMutationVariables>;
export const CancelPickOrderDocument = gql`
    mutation CancelPickOrder($input: CancelPickOrderInput!) {
  cancelPickOrder(input: $input) {
    success
    message
    errors {
      message
    }
    pickOrder {
      ...PickOrderSummaryFragment
    }
  }
}
    ${PickOrderSummaryFragmentDoc}`;
export type CancelPickOrderMutationFn = ApolloReactCommon.MutationFunction<CancelPickOrderMutation, CancelPickOrderMutationVariables>;

/**
 * __useCancelPickOrderMutation__
 *
 * To run a mutation, you first call `useCancelPickOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPickOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPickOrderMutation, { data, loading, error }] = useCancelPickOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPickOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelPickOrderMutation, CancelPickOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelPickOrderMutation, CancelPickOrderMutationVariables>(CancelPickOrderDocument, options);
      }
export type CancelPickOrderMutationHookResult = ReturnType<typeof useCancelPickOrderMutation>;
export type CancelPickOrderMutationResult = ApolloReactCommon.MutationResult<CancelPickOrderMutation>;
export type CancelPickOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelPickOrderMutation, CancelPickOrderMutationVariables>;
export const CompletePickOrderDocument = gql`
    mutation CompletePickOrder($input: CompletePickOrderInput!) {
  completePickOrder(input: $input) {
    success
    message
    errors {
      message
    }
    pickOrder {
      ...PickOrderDetailFragment
    }
  }
}
    ${PickOrderDetailFragmentDoc}`;
export type CompletePickOrderMutationFn = ApolloReactCommon.MutationFunction<CompletePickOrderMutation, CompletePickOrderMutationVariables>;

/**
 * __useCompletePickOrderMutation__
 *
 * To run a mutation, you first call `useCompletePickOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePickOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePickOrderMutation, { data, loading, error }] = useCompletePickOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletePickOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompletePickOrderMutation, CompletePickOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompletePickOrderMutation, CompletePickOrderMutationVariables>(CompletePickOrderDocument, options);
      }
export type CompletePickOrderMutationHookResult = ReturnType<typeof useCompletePickOrderMutation>;
export type CompletePickOrderMutationResult = ApolloReactCommon.MutationResult<CompletePickOrderMutation>;
export type CompletePickOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CompletePickOrderMutation, CompletePickOrderMutationVariables>;
export const CreatePickOrderDocument = gql`
    mutation CreatePickOrder($input: CreatePickOrderInput!) {
  createPickOrder(input: $input) {
    success
    message
    errors {
      message
    }
    pickOrder {
      ...PickOrderDetailFragment
    }
  }
}
    ${PickOrderDetailFragmentDoc}`;
export type CreatePickOrderMutationFn = ApolloReactCommon.MutationFunction<CreatePickOrderMutation, CreatePickOrderMutationVariables>;

/**
 * __useCreatePickOrderMutation__
 *
 * To run a mutation, you first call `useCreatePickOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePickOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPickOrderMutation, { data, loading, error }] = useCreatePickOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePickOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePickOrderMutation, CreatePickOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePickOrderMutation, CreatePickOrderMutationVariables>(CreatePickOrderDocument, options);
      }
export type CreatePickOrderMutationHookResult = ReturnType<typeof useCreatePickOrderMutation>;
export type CreatePickOrderMutationResult = ApolloReactCommon.MutationResult<CreatePickOrderMutation>;
export type CreatePickOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePickOrderMutation, CreatePickOrderMutationVariables>;
export const RecordPickedQuantitiesDocument = gql`
    mutation RecordPickedQuantities($input: RecordPickedQuantitiesInput!) {
  recordPickedQuantities(input: $input) {
    success
    message
    errors {
      message
    }
    pickOrder {
      ...PickOrderDetailFragment
    }
  }
}
    ${PickOrderDetailFragmentDoc}`;
export type RecordPickedQuantitiesMutationFn = ApolloReactCommon.MutationFunction<RecordPickedQuantitiesMutation, RecordPickedQuantitiesMutationVariables>;

/**
 * __useRecordPickedQuantitiesMutation__
 *
 * To run a mutation, you first call `useRecordPickedQuantitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPickedQuantitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPickedQuantitiesMutation, { data, loading, error }] = useRecordPickedQuantitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordPickedQuantitiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RecordPickedQuantitiesMutation, RecordPickedQuantitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RecordPickedQuantitiesMutation, RecordPickedQuantitiesMutationVariables>(RecordPickedQuantitiesDocument, options);
      }
export type RecordPickedQuantitiesMutationHookResult = ReturnType<typeof useRecordPickedQuantitiesMutation>;
export type RecordPickedQuantitiesMutationResult = ApolloReactCommon.MutationResult<RecordPickedQuantitiesMutation>;
export type RecordPickedQuantitiesMutationOptions = ApolloReactCommon.BaseMutationOptions<RecordPickedQuantitiesMutation, RecordPickedQuantitiesMutationVariables>;
export const CreateProductCategoryDocument = gql`
    mutation CreateProductCategory($name: String!, $parentId: BigInteger) {
  createProductCategory(name: $name, parentId: $parentId) {
    success
    message
    productCategory {
      id
      name
      parentId
      productCategoryId
    }
  }
}
    `;
export type CreateProductCategoryMutationFn = ApolloReactCommon.MutationFunction<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>;

/**
 * __useCreateProductCategoryMutation__
 *
 * To run a mutation, you first call `useCreateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductCategoryMutation, { data, loading, error }] = useCreateProductCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateProductCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>(CreateProductCategoryDocument, options);
      }
export type CreateProductCategoryMutationHookResult = ReturnType<typeof useCreateProductCategoryMutation>;
export type CreateProductCategoryMutationResult = ApolloReactCommon.MutationResult<CreateProductCategoryMutation>;
export type CreateProductCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProductCategoryMutation, CreateProductCategoryMutationVariables>;
export const UpdateProductCategoryDocument = gql`
    mutation UpdateProductCategory($productCategoryId: BigInteger!, $name: String, $parentId: BigInteger) {
  updateProductCategory(productCategoryId: $productCategoryId, name: $name, parentId: $parentId) {
    success
    message
    productCategory {
      id
      name
      parentId
      productCategoryId
    }
  }
}
    `;
export type UpdateProductCategoryMutationFn = ApolloReactCommon.MutationFunction<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>;

/**
 * __useUpdateProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoryMutation, { data, loading, error }] = useUpdateProductCategoryMutation({
 *   variables: {
 *      productCategoryId: // value for 'productCategoryId'
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useUpdateProductCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>(UpdateProductCategoryDocument, options);
      }
export type UpdateProductCategoryMutationHookResult = ReturnType<typeof useUpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationResult = ApolloReactCommon.MutationResult<UpdateProductCategoryMutation>;
export type UpdateProductCategoryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductCategoryMutation, UpdateProductCategoryMutationVariables>;
export const CreateProductClassDocument = gql`
    mutation CreateProductClass($catClass: String!, $categoryName: String!, $classification: String!) {
  createProductClass(catClass: $catClass, categoryName: $categoryName, classification: $classification) {
    success
    message
    productClass {
      id
      catClass
      categoryName
      classification
    }
  }
}
    `;
export type CreateProductClassMutationFn = ApolloReactCommon.MutationFunction<CreateProductClassMutation, CreateProductClassMutationVariables>;

/**
 * __useCreateProductClassMutation__
 *
 * To run a mutation, you first call `useCreateProductClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductClassMutation, { data, loading, error }] = useCreateProductClassMutation({
 *   variables: {
 *      catClass: // value for 'catClass'
 *      categoryName: // value for 'categoryName'
 *      classification: // value for 'classification'
 *   },
 * });
 */
export function useCreateProductClassMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductClassMutation, CreateProductClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductClassMutation, CreateProductClassMutationVariables>(CreateProductClassDocument, options);
      }
export type CreateProductClassMutationHookResult = ReturnType<typeof useCreateProductClassMutation>;
export type CreateProductClassMutationResult = ApolloReactCommon.MutationResult<CreateProductClassMutation>;
export type CreateProductClassMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProductClassMutation, CreateProductClassMutationVariables>;
export const UpdateProductClassDocument = gql`
    mutation UpdateProductClass($productClassId: ID!, $catClass: String, $categoryName: String, $classification: String) {
  updateProductClass(productClassId: $productClassId, catClass: $catClass, categoryName: $categoryName, classification: $classification) {
    success
    message
    productClass {
      id
      catClass
      categoryName
      classification
    }
  }
}
    `;
export type UpdateProductClassMutationFn = ApolloReactCommon.MutationFunction<UpdateProductClassMutation, UpdateProductClassMutationVariables>;

/**
 * __useUpdateProductClassMutation__
 *
 * To run a mutation, you first call `useUpdateProductClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductClassMutation, { data, loading, error }] = useUpdateProductClassMutation({
 *   variables: {
 *      productClassId: // value for 'productClassId'
 *      catClass: // value for 'catClass'
 *      categoryName: // value for 'categoryName'
 *      classification: // value for 'classification'
 *   },
 * });
 */
export function useUpdateProductClassMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductClassMutation, UpdateProductClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductClassMutation, UpdateProductClassMutationVariables>(UpdateProductClassDocument, options);
      }
export type UpdateProductClassMutationHookResult = ReturnType<typeof useUpdateProductClassMutation>;
export type UpdateProductClassMutationResult = ApolloReactCommon.MutationResult<UpdateProductClassMutation>;
export type UpdateProductClassMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProductClassMutation, UpdateProductClassMutationVariables>;
export const CreateProviderDocument = gql`
    mutation CreateProvider($name: String!) {
  createProvider(name: $name) {
    id
    name
  }
}
    `;
export type CreateProviderMutationFn = ApolloReactCommon.MutationFunction<CreateProviderMutation, CreateProviderMutationVariables>;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument, options);
      }
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = ApolloReactCommon.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProviderMutation, CreateProviderMutationVariables>;
export const MergeProvidersDocument = gql`
    mutation MergeProviders($goodProviderId: BigInteger!, $duplicateProviderId: BigInteger!, $companyId: BigInteger) {
  mergeProviders(goodProviderId: $goodProviderId, duplicateProviderId: $duplicateProviderId, companyId: $companyId) {
    success
    message
    goodProvider {
      id
      name
    }
    duplicateProvider {
      id
      name
    }
  }
}
    `;
export type MergeProvidersMutationFn = ApolloReactCommon.MutationFunction<MergeProvidersMutation, MergeProvidersMutationVariables>;

/**
 * __useMergeProvidersMutation__
 *
 * To run a mutation, you first call `useMergeProvidersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeProvidersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeProvidersMutation, { data, loading, error }] = useMergeProvidersMutation({
 *   variables: {
 *      goodProviderId: // value for 'goodProviderId'
 *      duplicateProviderId: // value for 'duplicateProviderId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useMergeProvidersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeProvidersMutation, MergeProvidersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeProvidersMutation, MergeProvidersMutationVariables>(MergeProvidersDocument, options);
      }
export type MergeProvidersMutationHookResult = ReturnType<typeof useMergeProvidersMutation>;
export type MergeProvidersMutationResult = ApolloReactCommon.MutationResult<MergeProvidersMutation>;
export type MergeProvidersMutationOptions = ApolloReactCommon.BaseMutationOptions<MergeProvidersMutation, MergeProvidersMutationVariables>;
export const UpdateProviderDocument = gql`
    mutation UpdateProvider($providerId: Int!, $name: String!) {
  updateProvider(providerId: $providerId, name: $name) {
    id
    name
  }
}
    `;
export type UpdateProviderMutationFn = ApolloReactCommon.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = ApolloReactCommon.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const CancelReservationDocument = gql`
    mutation CancelReservation($reservationId: BigInteger!) {
  cancelReservation(reservationId: $reservationId) {
    success
    message
    reservation {
      reservationId
      __typename
    }
  }
}
    `;
export type CancelReservationMutationFn = ApolloReactCommon.MutationFunction<CancelReservationMutation, CancelReservationMutationVariables>;

/**
 * __useCancelReservationMutation__
 *
 * To run a mutation, you first call `useCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReservationMutation, { data, loading, error }] = useCancelReservationMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useCancelReservationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelReservationMutation, CancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelReservationMutation, CancelReservationMutationVariables>(CancelReservationDocument, options);
      }
export type CancelReservationMutationHookResult = ReturnType<typeof useCancelReservationMutation>;
export type CancelReservationMutationResult = ApolloReactCommon.MutationResult<CancelReservationMutation>;
export type CancelReservationMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelReservationMutation, CancelReservationMutationVariables>;
export const ConvertPartManyToManyDocument = gql`
    mutation ConvertPartManyToMany($inventoryLocationId: ID!, $fromPartId: ID!, $toPartId: ID!, $fromQuantity: Int!, $toQuantity: Int!) {
  convertItems(input: {inventoryLocationId: $inventoryLocationId, fromPartId: $fromPartId, toPartId: $toPartId, fromQuantity: $fromQuantity, toQuantity: $toQuantity}) {
    success
    message
    fromStorePart {
      part {
        partNumber
      }
      cost
      weightedAverageCost {
        amount
        currencyCode
      }
    }
    quantityConverted
    toStorePart {
      part {
        partNumber
      }
      cost
      weightedAverageCost {
        amount
        currencyCode
      }
    }
    quantityConvertedTo
  }
}
    `;
export type ConvertPartManyToManyMutationFn = ApolloReactCommon.MutationFunction<ConvertPartManyToManyMutation, ConvertPartManyToManyMutationVariables>;

/**
 * __useConvertPartManyToManyMutation__
 *
 * To run a mutation, you first call `useConvertPartManyToManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertPartManyToManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertPartManyToManyMutation, { data, loading, error }] = useConvertPartManyToManyMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      fromPartId: // value for 'fromPartId'
 *      toPartId: // value for 'toPartId'
 *      fromQuantity: // value for 'fromQuantity'
 *      toQuantity: // value for 'toQuantity'
 *   },
 * });
 */
export function useConvertPartManyToManyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertPartManyToManyMutation, ConvertPartManyToManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConvertPartManyToManyMutation, ConvertPartManyToManyMutationVariables>(ConvertPartManyToManyDocument, options);
      }
export type ConvertPartManyToManyMutationHookResult = ReturnType<typeof useConvertPartManyToManyMutation>;
export type ConvertPartManyToManyMutationResult = ApolloReactCommon.MutationResult<ConvertPartManyToManyMutation>;
export type ConvertPartManyToManyMutationOptions = ApolloReactCommon.BaseMutationOptions<ConvertPartManyToManyMutation, ConvertPartManyToManyMutationVariables>;
export const ConvertPartsDocument = gql`
    mutation ConvertParts($inventoryLocationId: ID!, $fromPartId: ID!, $toPartId: ID!, $quantity: Int!) {
  convertParts(input: {inventoryLocationId: $inventoryLocationId, fromPartId: $fromPartId, toPartId: $toPartId, quantity: $quantity}) {
    success
    message
    fromStorePart {
      id
      quantity
      availableQuantity
    }
    toStorePart {
      id
      quantity
      availableQuantity
    }
    quantityConverted
  }
}
    `;
export type ConvertPartsMutationFn = ApolloReactCommon.MutationFunction<ConvertPartsMutation, ConvertPartsMutationVariables>;

/**
 * __useConvertPartsMutation__
 *
 * To run a mutation, you first call `useConvertPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertPartsMutation, { data, loading, error }] = useConvertPartsMutation({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      fromPartId: // value for 'fromPartId'
 *      toPartId: // value for 'toPartId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useConvertPartsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertPartsMutation, ConvertPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConvertPartsMutation, ConvertPartsMutationVariables>(ConvertPartsDocument, options);
      }
export type ConvertPartsMutationHookResult = ReturnType<typeof useConvertPartsMutation>;
export type ConvertPartsMutationResult = ApolloReactCommon.MutationResult<ConvertPartsMutation>;
export type ConvertPartsMutationOptions = ApolloReactCommon.BaseMutationOptions<ConvertPartsMutation, ConvertPartsMutationVariables>;
export const CreateStorePartDocument = gql`
    mutation CreateStorePart($input: CreateStorePartInput!) {
  createStorePart(input: $input) {
    success
    message
    storePart {
      id
      storePartId
      inventoryLocationId
      location
      partId
      inventoryLocation {
        id
        name
      }
    }
  }
}
    `;
export type CreateStorePartMutationFn = ApolloReactCommon.MutationFunction<CreateStorePartMutation, CreateStorePartMutationVariables>;

/**
 * __useCreateStorePartMutation__
 *
 * To run a mutation, you first call `useCreateStorePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStorePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStorePartMutation, { data, loading, error }] = useCreateStorePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStorePartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStorePartMutation, CreateStorePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStorePartMutation, CreateStorePartMutationVariables>(CreateStorePartDocument, options);
      }
export type CreateStorePartMutationHookResult = ReturnType<typeof useCreateStorePartMutation>;
export type CreateStorePartMutationResult = ApolloReactCommon.MutationResult<CreateStorePartMutation>;
export type CreateStorePartMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStorePartMutation, CreateStorePartMutationVariables>;
export const DeleteItemDocument = gql`
    mutation DeleteItem($id: BigInteger!) {
  archiveStorePart(storePartId: $id) {
    success
    message
  }
}
    `;
export type DeleteItemMutationFn = ApolloReactCommon.MutationFunction<DeleteItemMutation, DeleteItemMutationVariables>;

/**
 * __useDeleteItemMutation__
 *
 * To run a mutation, you first call `useDeleteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteItemMutation, { data, loading, error }] = useDeleteItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteItemMutation, DeleteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteItemMutation, DeleteItemMutationVariables>(DeleteItemDocument, options);
      }
export type DeleteItemMutationHookResult = ReturnType<typeof useDeleteItemMutation>;
export type DeleteItemMutationResult = ApolloReactCommon.MutationResult<DeleteItemMutation>;
export type DeleteItemMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteItemMutation, DeleteItemMutationVariables>;
export const UpdateStorePartDocument = gql`
    mutation UpdateStorePart($storePartId: BigInteger!, $cost: Float, $location: String, $max: Int, $note: String, $threshold: Int) {
  updateStorePart(storePartId: $storePartId, cost: $cost, location: $location, max: $max, note: $note, threshold: $threshold) {
    success
    message
    storePart {
      id
      cost
      location
      max
      note
      threshold
    }
  }
}
    `;
export type UpdateStorePartMutationFn = ApolloReactCommon.MutationFunction<UpdateStorePartMutation, UpdateStorePartMutationVariables>;

/**
 * __useUpdateStorePartMutation__
 *
 * To run a mutation, you first call `useUpdateStorePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStorePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStorePartMutation, { data, loading, error }] = useUpdateStorePartMutation({
 *   variables: {
 *      storePartId: // value for 'storePartId'
 *      cost: // value for 'cost'
 *      location: // value for 'location'
 *      max: // value for 'max'
 *      note: // value for 'note'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useUpdateStorePartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStorePartMutation, UpdateStorePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStorePartMutation, UpdateStorePartMutationVariables>(UpdateStorePartDocument, options);
      }
export type UpdateStorePartMutationHookResult = ReturnType<typeof useUpdateStorePartMutation>;
export type UpdateStorePartMutationResult = ApolloReactCommon.MutationResult<UpdateStorePartMutation>;
export type UpdateStorePartMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStorePartMutation, UpdateStorePartMutationVariables>;
export const CreateWeightedAverageCostOverrideDocument = gql`
    mutation CreateWeightedAverageCostOverride($dateApplied: ArrowDateTime!, $inventoryLocationId: ID!, $productId: ID!, $reason: String!, $weightedAverageCost: Decimal!) {
  createWeightedAverageCostSnapshotOverride(dateApplied: $dateApplied, inventoryLocationId: $inventoryLocationId, productId: $productId, reason: $reason, weightedAverageCost: $weightedAverageCost) {
    success
    message
  }
}
    `;
export type CreateWeightedAverageCostOverrideMutationFn = ApolloReactCommon.MutationFunction<CreateWeightedAverageCostOverrideMutation, CreateWeightedAverageCostOverrideMutationVariables>;

/**
 * __useCreateWeightedAverageCostOverrideMutation__
 *
 * To run a mutation, you first call `useCreateWeightedAverageCostOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWeightedAverageCostOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWeightedAverageCostOverrideMutation, { data, loading, error }] = useCreateWeightedAverageCostOverrideMutation({
 *   variables: {
 *      dateApplied: // value for 'dateApplied'
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      productId: // value for 'productId'
 *      reason: // value for 'reason'
 *      weightedAverageCost: // value for 'weightedAverageCost'
 *   },
 * });
 */
export function useCreateWeightedAverageCostOverrideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWeightedAverageCostOverrideMutation, CreateWeightedAverageCostOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWeightedAverageCostOverrideMutation, CreateWeightedAverageCostOverrideMutationVariables>(CreateWeightedAverageCostOverrideDocument, options);
      }
export type CreateWeightedAverageCostOverrideMutationHookResult = ReturnType<typeof useCreateWeightedAverageCostOverrideMutation>;
export type CreateWeightedAverageCostOverrideMutationResult = ApolloReactCommon.MutationResult<CreateWeightedAverageCostOverrideMutation>;
export type CreateWeightedAverageCostOverrideMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateWeightedAverageCostOverrideMutation, CreateWeightedAverageCostOverrideMutationVariables>;
export const CancelTransactionDocument = gql`
    mutation CancelTransaction($transactionId: Int!) {
  cancelTransaction(transactionId: $transactionId) {
    ...DetailedTransaction
  }
}
    ${DetailedTransactionFragmentDoc}`;
export type CancelTransactionMutationFn = ApolloReactCommon.MutationFunction<CancelTransactionMutation, CancelTransactionMutationVariables>;

/**
 * __useCancelTransactionMutation__
 *
 * To run a mutation, you first call `useCancelTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransactionMutation, { data, loading, error }] = useCancelTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useCancelTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelTransactionMutation, CancelTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelTransactionMutation, CancelTransactionMutationVariables>(CancelTransactionDocument, options);
      }
export type CancelTransactionMutationHookResult = ReturnType<typeof useCancelTransactionMutation>;
export type CancelTransactionMutationResult = ApolloReactCommon.MutationResult<CancelTransactionMutation>;
export type CancelTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelTransactionMutation, CancelTransactionMutationVariables>;
export const CompleteTransactionDocument = gql`
    mutation CompleteTransaction($transactionId: Int!, $transactionItems: [InputUpdateTransactionItem!]) {
  completeTransaction(transactionId: $transactionId, transactionItems: $transactionItems) {
    ...DetailedTransaction
  }
}
    ${DetailedTransactionFragmentDoc}`;
export type CompleteTransactionMutationFn = ApolloReactCommon.MutationFunction<CompleteTransactionMutation, CompleteTransactionMutationVariables>;

/**
 * __useCompleteTransactionMutation__
 *
 * To run a mutation, you first call `useCompleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTransactionMutation, { data, loading, error }] = useCompleteTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      transactionItems: // value for 'transactionItems'
 *   },
 * });
 */
export function useCompleteTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteTransactionMutation, CompleteTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteTransactionMutation, CompleteTransactionMutationVariables>(CompleteTransactionDocument, options);
      }
export type CompleteTransactionMutationHookResult = ReturnType<typeof useCompleteTransactionMutation>;
export type CompleteTransactionMutationResult = ApolloReactCommon.MutationResult<CompleteTransactionMutation>;
export type CompleteTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteTransactionMutation, CompleteTransactionMutationVariables>;
export const CreateTransactionMutationDocument = gql`
    mutation CreateTransactionMutation($fromId: Int, $toId: Int, $transactionItems: [InputTransactionItem!], $transactionType: TransactionType!, $customId: String, $memo: String, $transactionStatus: TransactionStatus) {
  createTransaction(fromId: $fromId, toId: $toId, transactionItems: $transactionItems, customId: $customId, memo: $memo, transactionStatus: $transactionStatus, transactionType: $transactionType) {
    ...DetailedTransaction
  }
}
    ${DetailedTransactionFragmentDoc}`;
export type CreateTransactionMutationMutationFn = ApolloReactCommon.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      fromId: // value for 'fromId'
 *      toId: // value for 'toId'
 *      transactionItems: // value for 'transactionItems'
 *      transactionType: // value for 'transactionType'
 *      customId: // value for 'customId'
 *      memo: // value for 'memo'
 *      transactionStatus: // value for 'transactionStatus'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionMutationDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationMutationResult = ApolloReactCommon.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const ProcessTransactionDocument = gql`
    mutation ProcessTransaction($transactionId: Int!) {
  processTransaction(transactionId: $transactionId) {
    ...DetailedTransaction
  }
}
    ${DetailedTransactionFragmentDoc}`;
export type ProcessTransactionMutationFn = ApolloReactCommon.MutationFunction<ProcessTransactionMutation, ProcessTransactionMutationVariables>;

/**
 * __useProcessTransactionMutation__
 *
 * To run a mutation, you first call `useProcessTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processTransactionMutation, { data, loading, error }] = useProcessTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useProcessTransactionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProcessTransactionMutation, ProcessTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProcessTransactionMutation, ProcessTransactionMutationVariables>(ProcessTransactionDocument, options);
      }
export type ProcessTransactionMutationHookResult = ReturnType<typeof useProcessTransactionMutation>;
export type ProcessTransactionMutationResult = ApolloReactCommon.MutationResult<ProcessTransactionMutation>;
export type ProcessTransactionMutationOptions = ApolloReactCommon.BaseMutationOptions<ProcessTransactionMutation, ProcessTransactionMutationVariables>;
export const ApproveTransferOrderDocument = gql`
    mutation ApproveTransferOrder($input: ApproveTransferOrderInput!) {
  approveTransferOrder(input: $input) {
    success
    message
    transferOrder {
      id
      status
      dateApproved
      approver {
        id
        firstName
        lastName
      }
      approverNote
    }
  }
}
    `;
export type ApproveTransferOrderMutationFn = ApolloReactCommon.MutationFunction<ApproveTransferOrderMutation, ApproveTransferOrderMutationVariables>;

/**
 * __useApproveTransferOrderMutation__
 *
 * To run a mutation, you first call `useApproveTransferOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTransferOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTransferOrderMutation, { data, loading, error }] = useApproveTransferOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveTransferOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveTransferOrderMutation, ApproveTransferOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveTransferOrderMutation, ApproveTransferOrderMutationVariables>(ApproveTransferOrderDocument, options);
      }
export type ApproveTransferOrderMutationHookResult = ReturnType<typeof useApproveTransferOrderMutation>;
export type ApproveTransferOrderMutationResult = ApolloReactCommon.MutationResult<ApproveTransferOrderMutation>;
export type ApproveTransferOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ApproveTransferOrderMutation, ApproveTransferOrderMutationVariables>;
export const CancelTransferOrderDocument = gql`
    mutation CancelTransferOrder($input: CancelTransferOrderInput!) {
  cancelTransferOrder(input: $input) {
    success
    message
    transferOrder {
      id
      status
      cancellationNote
      dateCancelled
    }
  }
}
    `;
export type CancelTransferOrderMutationFn = ApolloReactCommon.MutationFunction<CancelTransferOrderMutation, CancelTransferOrderMutationVariables>;

/**
 * __useCancelTransferOrderMutation__
 *
 * To run a mutation, you first call `useCancelTransferOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransferOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransferOrderMutation, { data, loading, error }] = useCancelTransferOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelTransferOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelTransferOrderMutation, CancelTransferOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelTransferOrderMutation, CancelTransferOrderMutationVariables>(CancelTransferOrderDocument, options);
      }
export type CancelTransferOrderMutationHookResult = ReturnType<typeof useCancelTransferOrderMutation>;
export type CancelTransferOrderMutationResult = ApolloReactCommon.MutationResult<CancelTransferOrderMutation>;
export type CancelTransferOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelTransferOrderMutation, CancelTransferOrderMutationVariables>;
export const CreateManualTransferOrderDocument = gql`
    mutation CreateManualTransferOrder($input: CreateManualTransferOrderInput!) {
  createManualTransferOrder(input: $input) {
    success
    message
    transferOrder {
      id
      status
      transferOrderType
    }
  }
}
    `;
export type CreateManualTransferOrderMutationFn = ApolloReactCommon.MutationFunction<CreateManualTransferOrderMutation, CreateManualTransferOrderMutationVariables>;

/**
 * __useCreateManualTransferOrderMutation__
 *
 * To run a mutation, you first call `useCreateManualTransferOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualTransferOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualTransferOrderMutation, { data, loading, error }] = useCreateManualTransferOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualTransferOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateManualTransferOrderMutation, CreateManualTransferOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateManualTransferOrderMutation, CreateManualTransferOrderMutationVariables>(CreateManualTransferOrderDocument, options);
      }
export type CreateManualTransferOrderMutationHookResult = ReturnType<typeof useCreateManualTransferOrderMutation>;
export type CreateManualTransferOrderMutationResult = ApolloReactCommon.MutationResult<CreateManualTransferOrderMutation>;
export type CreateManualTransferOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateManualTransferOrderMutation, CreateManualTransferOrderMutationVariables>;
export const ReceiveTransferOrderLineItemsDocument = gql`
    mutation ReceiveTransferOrderLineItems($input: ReceiveTransferOrderLineItemsInput!) {
  receiveTransferOrderLineItems(input: $input) {
    success
    message
    transferOrder {
      id
      status
    }
  }
}
    `;
export type ReceiveTransferOrderLineItemsMutationFn = ApolloReactCommon.MutationFunction<ReceiveTransferOrderLineItemsMutation, ReceiveTransferOrderLineItemsMutationVariables>;

/**
 * __useReceiveTransferOrderLineItemsMutation__
 *
 * To run a mutation, you first call `useReceiveTransferOrderLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReceiveTransferOrderLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [receiveTransferOrderLineItemsMutation, { data, loading, error }] = useReceiveTransferOrderLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReceiveTransferOrderLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReceiveTransferOrderLineItemsMutation, ReceiveTransferOrderLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReceiveTransferOrderLineItemsMutation, ReceiveTransferOrderLineItemsMutationVariables>(ReceiveTransferOrderLineItemsDocument, options);
      }
export type ReceiveTransferOrderLineItemsMutationHookResult = ReturnType<typeof useReceiveTransferOrderLineItemsMutation>;
export type ReceiveTransferOrderLineItemsMutationResult = ApolloReactCommon.MutationResult<ReceiveTransferOrderLineItemsMutation>;
export type ReceiveTransferOrderLineItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReceiveTransferOrderLineItemsMutation, ReceiveTransferOrderLineItemsMutationVariables>;
export const RejectTransferOrderDocument = gql`
    mutation RejectTransferOrder($input: RejectTransferOrderInput!) {
  rejectTransferOrder(input: $input) {
    success
    message
    transferOrder {
      id
      status
      dateRejected
      approver {
        id
        firstName
        lastName
      }
      approverNote
    }
  }
}
    `;
export type RejectTransferOrderMutationFn = ApolloReactCommon.MutationFunction<RejectTransferOrderMutation, RejectTransferOrderMutationVariables>;

/**
 * __useRejectTransferOrderMutation__
 *
 * To run a mutation, you first call `useRejectTransferOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTransferOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTransferOrderMutation, { data, loading, error }] = useRejectTransferOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectTransferOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RejectTransferOrderMutation, RejectTransferOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RejectTransferOrderMutation, RejectTransferOrderMutationVariables>(RejectTransferOrderDocument, options);
      }
export type RejectTransferOrderMutationHookResult = ReturnType<typeof useRejectTransferOrderMutation>;
export type RejectTransferOrderMutationResult = ApolloReactCommon.MutationResult<RejectTransferOrderMutation>;
export type RejectTransferOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<RejectTransferOrderMutation, RejectTransferOrderMutationVariables>;
export const UpsertUserPreferenceDocument = gql`
    mutation UpsertUserPreference($key: String!, $value: UserPreferencesData!) {
  upsertUserPreference(key: $key, value: $value) {
    success
    message
    errors {
      message
    }
  }
}
    `;
export type UpsertUserPreferenceMutationFn = ApolloReactCommon.MutationFunction<UpsertUserPreferenceMutation, UpsertUserPreferenceMutationVariables>;

/**
 * __useUpsertUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpsertUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserPreferenceMutation, { data, loading, error }] = useUpsertUserPreferenceMutation({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertUserPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertUserPreferenceMutation, UpsertUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUserPreferenceMutation, UpsertUserPreferenceMutationVariables>(UpsertUserPreferenceDocument, options);
      }
export type UpsertUserPreferenceMutationHookResult = ReturnType<typeof useUpsertUserPreferenceMutation>;
export type UpsertUserPreferenceMutationResult = ApolloReactCommon.MutationResult<UpsertUserPreferenceMutation>;
export type UpsertUserPreferenceMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertUserPreferenceMutation, UpsertUserPreferenceMutationVariables>;
export const BranchesDocument = gql`
    query Branches($companyId: BigInteger!) {
  branches: restBranches(companyId: $companyId) @rest(type: "Branch", path: "/companies/{args.companyId}/branches?active=true") {
    id
    name
  }
}
    `;

/**
 * __useBranchesQuery__
 *
 * To run a query within a React component, call `useBranchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBranchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBranchesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBranchesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BranchesQuery, BranchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BranchesQuery, BranchesQueryVariables>(BranchesDocument, options);
      }
export function useBranchesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BranchesQuery, BranchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BranchesQuery, BranchesQueryVariables>(BranchesDocument, options);
        }
export type BranchesQueryHookResult = ReturnType<typeof useBranchesQuery>;
export type BranchesLazyQueryHookResult = ReturnType<typeof useBranchesLazyQuery>;
export type BranchesQueryResult = ApolloReactCommon.QueryResult<BranchesQuery, BranchesQueryVariables>;
export const CompanyDocument = gql`
    query Company($companyId: BigInteger!) {
  company: restCompany(companyId: $companyId) @rest(type: "Company", path: "/companies/{args.companyId}") {
    company_id
    name
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanyQueryResult = ApolloReactCommon.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const DistributionCentersDocument = gql`
    query DistributionCenters($paging: CursorPaging) {
  inventoryLocations(isWarehouse: true, paging: $paging) {
    edges {
      node {
        id
        name
        warehouse {
          warehouseExecutionSystem
        }
        branch {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useDistributionCentersQuery__
 *
 * To run a query within a React component, call `useDistributionCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionCentersQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useDistributionCentersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DistributionCentersQuery, DistributionCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DistributionCentersQuery, DistributionCentersQueryVariables>(DistributionCentersDocument, options);
      }
export function useDistributionCentersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DistributionCentersQuery, DistributionCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DistributionCentersQuery, DistributionCentersQueryVariables>(DistributionCentersDocument, options);
        }
export type DistributionCentersQueryHookResult = ReturnType<typeof useDistributionCentersQuery>;
export type DistributionCentersLazyQueryHookResult = ReturnType<typeof useDistributionCentersLazyQuery>;
export type DistributionCentersQueryResult = ApolloReactCommon.QueryResult<DistributionCentersQuery, DistributionCentersQueryVariables>;
export const EquipmentMakesDocument = gql`
    query EquipmentMakes($name: String) {
  equipmentMakes: restEquipmentMakes(name: $name) @rest(type: "EquipmentMake", path: "/equipment-makes?name={args.name}") {
    equipment_make_id
    name
  }
}
    `;

/**
 * __useEquipmentMakesQuery__
 *
 * To run a query within a React component, call `useEquipmentMakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentMakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentMakesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEquipmentMakesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EquipmentMakesQuery, EquipmentMakesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EquipmentMakesQuery, EquipmentMakesQueryVariables>(EquipmentMakesDocument, options);
      }
export function useEquipmentMakesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EquipmentMakesQuery, EquipmentMakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EquipmentMakesQuery, EquipmentMakesQueryVariables>(EquipmentMakesDocument, options);
        }
export type EquipmentMakesQueryHookResult = ReturnType<typeof useEquipmentMakesQuery>;
export type EquipmentMakesLazyQueryHookResult = ReturnType<typeof useEquipmentMakesLazyQuery>;
export type EquipmentMakesQueryResult = ApolloReactCommon.QueryResult<EquipmentMakesQuery, EquipmentMakesQueryVariables>;
export const EquipmentMakeByIdDocument = gql`
    query EquipmentMakeById($id: Int!) {
  equipmentMake: restEquipmentMake(id: $id) @rest(type: "EquipmentMake", path: "/equipment-make/{args.id}") {
    equipment_make_id
    name
  }
}
    `;

/**
 * __useEquipmentMakeByIdQuery__
 *
 * To run a query within a React component, call `useEquipmentMakeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentMakeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentMakeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipmentMakeByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EquipmentMakeByIdQuery, EquipmentMakeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EquipmentMakeByIdQuery, EquipmentMakeByIdQueryVariables>(EquipmentMakeByIdDocument, options);
      }
export function useEquipmentMakeByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EquipmentMakeByIdQuery, EquipmentMakeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EquipmentMakeByIdQuery, EquipmentMakeByIdQueryVariables>(EquipmentMakeByIdDocument, options);
        }
export type EquipmentMakeByIdQueryHookResult = ReturnType<typeof useEquipmentMakeByIdQuery>;
export type EquipmentMakeByIdLazyQueryHookResult = ReturnType<typeof useEquipmentMakeByIdLazyQuery>;
export type EquipmentMakeByIdQueryResult = ApolloReactCommon.QueryResult<EquipmentMakeByIdQuery, EquipmentMakeByIdQueryVariables>;
export const EquipmentModelsDocument = gql`
    query EquipmentModels($equipmentMakeId: Int!, $name: String) {
  equipmentModels: restEquipmentModels(equipmentMakeId: $equipmentMakeId, name: $name) @rest(type: "EquipmentModel", path: "/equipment-models?equipment_make_id={args.equipmentMakeId}&name={args.name}") {
    equipment_model_id
    name
    equipment_make_id
  }
}
    `;

/**
 * __useEquipmentModelsQuery__
 *
 * To run a query within a React component, call `useEquipmentModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentModelsQuery({
 *   variables: {
 *      equipmentMakeId: // value for 'equipmentMakeId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEquipmentModelsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EquipmentModelsQuery, EquipmentModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EquipmentModelsQuery, EquipmentModelsQueryVariables>(EquipmentModelsDocument, options);
      }
export function useEquipmentModelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EquipmentModelsQuery, EquipmentModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EquipmentModelsQuery, EquipmentModelsQueryVariables>(EquipmentModelsDocument, options);
        }
export type EquipmentModelsQueryHookResult = ReturnType<typeof useEquipmentModelsQuery>;
export type EquipmentModelsLazyQueryHookResult = ReturnType<typeof useEquipmentModelsLazyQuery>;
export type EquipmentModelsQueryResult = ApolloReactCommon.QueryResult<EquipmentModelsQuery, EquipmentModelsQueryVariables>;
export const EquipmentModelByIdDocument = gql`
    query EquipmentModelById($id: Int!) {
  equipmentModel: restEquipmentModel(id: $id) @rest(type: "EquipmentModel", path: "/equipment-model/{args.id}") {
    equipment_model_id
    name
    equipment_make_id
  }
}
    `;

/**
 * __useEquipmentModelByIdQuery__
 *
 * To run a query within a React component, call `useEquipmentModelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentModelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentModelByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEquipmentModelByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EquipmentModelByIdQuery, EquipmentModelByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EquipmentModelByIdQuery, EquipmentModelByIdQueryVariables>(EquipmentModelByIdDocument, options);
      }
export function useEquipmentModelByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EquipmentModelByIdQuery, EquipmentModelByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EquipmentModelByIdQuery, EquipmentModelByIdQueryVariables>(EquipmentModelByIdDocument, options);
        }
export type EquipmentModelByIdQueryHookResult = ReturnType<typeof useEquipmentModelByIdQuery>;
export type EquipmentModelByIdLazyQueryHookResult = ReturnType<typeof useEquipmentModelByIdLazyQuery>;
export type EquipmentModelByIdQueryResult = ApolloReactCommon.QueryResult<EquipmentModelByIdQuery, EquipmentModelByIdQueryVariables>;
export const FulfillmentOrderByOrderNumberDocument = gql`
    query FulfillmentOrderByOrderNumber($orderNumber: BigInteger!) {
  fulfillmentOrderByOrderNumber(orderNumber: $orderNumber) {
    id
    orderNumber
    status
    fulfillmentType
    dateCreated
    dateUpdated
    dateSubmittedForFulfillment
    dateCompleted
    dateCancelled
    dateCancellationRequested
    mttId
    mttQuadrant
    notes
    contactEmail
    contactPhone
    externalShopifyOrderId: externalOrderId(app: SHOPIFY)
    shippingAddress {
      line1
      line2
      city
      state
      postalCode
      country
    }
    fulfillingInventory {
      id
      name
    }
    destinationInventory {
      id
      name
    }
    destinationDescription
    pickOrders(isOpen: true) {
      id
      pickOrderNumber
    }
    lineItems {
      id
      quantity
      quantityFulfilled
      quantityRemaining
      isFullyFulfilled
      demandRequestLineItem {
        demandRequest {
          requestNumber
        }
      }
      product {
        id
        name
        manufacturerNumber
        provider {
          id
          name
        }
      }
      fulfillmentLineItems {
        quantityFulfilled
        quantityUnfulfilled
        fulfillment {
          id
          dateShipped
          trackingNumber
          systemTransferOrder {
            id
            status
            transferOrderType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFulfillmentOrderByOrderNumberQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useFulfillmentOrderByOrderNumberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FulfillmentOrderByOrderNumberQuery, FulfillmentOrderByOrderNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FulfillmentOrderByOrderNumberQuery, FulfillmentOrderByOrderNumberQueryVariables>(FulfillmentOrderByOrderNumberDocument, options);
      }
export function useFulfillmentOrderByOrderNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FulfillmentOrderByOrderNumberQuery, FulfillmentOrderByOrderNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FulfillmentOrderByOrderNumberQuery, FulfillmentOrderByOrderNumberQueryVariables>(FulfillmentOrderByOrderNumberDocument, options);
        }
export type FulfillmentOrderByOrderNumberQueryHookResult = ReturnType<typeof useFulfillmentOrderByOrderNumberQuery>;
export type FulfillmentOrderByOrderNumberLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderByOrderNumberLazyQuery>;
export type FulfillmentOrderByOrderNumberQueryResult = ApolloReactCommon.QueryResult<FulfillmentOrderByOrderNumberQuery, FulfillmentOrderByOrderNumberQueryVariables>;
export const FulfillmentOrderCancellationStatusDocument = gql`
    query FulfillmentOrderCancellationStatus($fulfillmentOrderId: ID!) {
  fulfillmentOrder(fulfillmentOrderId: $fulfillmentOrderId) {
    id
    status
    cancellationFailed
    cancellationFailureMessage
  }
}
    `;

/**
 * __useFulfillmentOrderCancellationStatusQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderCancellationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderCancellationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderCancellationStatusQuery({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *   },
 * });
 */
export function useFulfillmentOrderCancellationStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FulfillmentOrderCancellationStatusQuery, FulfillmentOrderCancellationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FulfillmentOrderCancellationStatusQuery, FulfillmentOrderCancellationStatusQueryVariables>(FulfillmentOrderCancellationStatusDocument, options);
      }
export function useFulfillmentOrderCancellationStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FulfillmentOrderCancellationStatusQuery, FulfillmentOrderCancellationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FulfillmentOrderCancellationStatusQuery, FulfillmentOrderCancellationStatusQueryVariables>(FulfillmentOrderCancellationStatusDocument, options);
        }
export type FulfillmentOrderCancellationStatusQueryHookResult = ReturnType<typeof useFulfillmentOrderCancellationStatusQuery>;
export type FulfillmentOrderCancellationStatusLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderCancellationStatusLazyQuery>;
export type FulfillmentOrderCancellationStatusQueryResult = ApolloReactCommon.QueryResult<FulfillmentOrderCancellationStatusQuery, FulfillmentOrderCancellationStatusQueryVariables>;
export const FulfillmentOrderDocument = gql`
    query FulfillmentOrder($fulfillmentOrderId: ID!) {
  fulfillmentOrder(fulfillmentOrderId: $fulfillmentOrderId) {
    id
    orderNumber
    status
    fulfillmentType
    dateCreated
    dateUpdated
    dateSubmittedForFulfillment
    dateCompleted
    dateCancelled
    dateCancellationRequested
    mttId
    mttQuadrant
    notes
    contactEmail
    contactPhone
    shippingAddress {
      line1
      line2
      city
      state
      postalCode
      country
    }
    fulfillingInventory {
      id
      name
    }
    destinationInventory {
      id
      name
    }
    lineItems {
      id
      quantity
      quantityFulfilled
      quantityRemaining
      isFullyFulfilled
      product {
        id
        name
        manufacturerNumber
        provider {
          id
          name
        }
      }
      fulfillmentLineItems {
        quantityFulfilled
        quantityUnfulfilled
        fulfillment {
          id
          dateShipped
          trackingNumber
          systemTransferOrder {
            id
            status
            transferOrderType
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFulfillmentOrderQuery__
 *
 * To run a query within a React component, call `useFulfillmentOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillmentOrderQuery({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *   },
 * });
 */
export function useFulfillmentOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>(FulfillmentOrderDocument, options);
      }
export function useFulfillmentOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>(FulfillmentOrderDocument, options);
        }
export type FulfillmentOrderQueryHookResult = ReturnType<typeof useFulfillmentOrderQuery>;
export type FulfillmentOrderLazyQueryHookResult = ReturnType<typeof useFulfillmentOrderLazyQuery>;
export type FulfillmentOrderQueryResult = ApolloReactCommon.QueryResult<FulfillmentOrderQuery, FulfillmentOrderQueryVariables>;
export const MobileToolTrailerInventoryItemsDocument = gql`
    query MobileToolTrailerInventoryItems($inventoryLocationId: ID!, $includeEmpty: Boolean) {
  mobileToolTrailerInventoryItems(inventoryLocationId: $inventoryLocationId, includeEmpty: $includeEmpty) {
    __typename
    ... on Asset {
      id
      equipmentMakeId
      equipmentModelId
      equipmentMake {
        id
        name
      }
      equipmentModel {
        id
        name
      }
      serialNumber
      name
    }
    ... on StorePart {
      storePartId: id
      quantity
      availableQuantity
      reservedQuantity
      outgoingQuantity
      part {
        id
        partNumber
        name
      }
    }
  }
}
    `;

/**
 * __useMobileToolTrailerInventoryItemsQuery__
 *
 * To run a query within a React component, call `useMobileToolTrailerInventoryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileToolTrailerInventoryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileToolTrailerInventoryItemsQuery({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *      includeEmpty: // value for 'includeEmpty'
 *   },
 * });
 */
export function useMobileToolTrailerInventoryItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MobileToolTrailerInventoryItemsQuery, MobileToolTrailerInventoryItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MobileToolTrailerInventoryItemsQuery, MobileToolTrailerInventoryItemsQueryVariables>(MobileToolTrailerInventoryItemsDocument, options);
      }
export function useMobileToolTrailerInventoryItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MobileToolTrailerInventoryItemsQuery, MobileToolTrailerInventoryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MobileToolTrailerInventoryItemsQuery, MobileToolTrailerInventoryItemsQueryVariables>(MobileToolTrailerInventoryItemsDocument, options);
        }
export type MobileToolTrailerInventoryItemsQueryHookResult = ReturnType<typeof useMobileToolTrailerInventoryItemsQuery>;
export type MobileToolTrailerInventoryItemsLazyQueryHookResult = ReturnType<typeof useMobileToolTrailerInventoryItemsLazyQuery>;
export type MobileToolTrailerInventoryItemsQueryResult = ApolloReactCommon.QueryResult<MobileToolTrailerInventoryItemsQuery, MobileToolTrailerInventoryItemsQueryVariables>;
export const MttLocationsDocument = gql`
    query MttLocations($paging: CursorPaging) {
  branches(filter: {isMtt: true, active: true}, paging: $paging) {
    edges {
      node {
        id
        name
        active
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useMttLocationsQuery__
 *
 * To run a query within a React component, call `useMttLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMttLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMttLocationsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useMttLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MttLocationsQuery, MttLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MttLocationsQuery, MttLocationsQueryVariables>(MttLocationsDocument, options);
      }
export function useMttLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MttLocationsQuery, MttLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MttLocationsQuery, MttLocationsQueryVariables>(MttLocationsDocument, options);
        }
export type MttLocationsQueryHookResult = ReturnType<typeof useMttLocationsQuery>;
export type MttLocationsLazyQueryHookResult = ReturnType<typeof useMttLocationsLazyQuery>;
export type MttLocationsQueryResult = ApolloReactCommon.QueryResult<MttLocationsQuery, MttLocationsQueryVariables>;
export const MobileToolTrailerTransferOrdersDocument = gql`
    query MobileToolTrailerTransferOrders($fromInventoryIds: [ID!], $toInventoryIds: [ID!], $paging: CursorPaging) {
  transferOrders(orderTypes: [SYSTEM], fromInventoryIds: $fromInventoryIds, toInventoryIds: $toInventoryIds, paging: $paging, sort: {field: DATE_CREATED, direction: DESC}) {
    edges {
      cursor
      node {
        id
        status
        assetTransferStatus
        dateCreated
        fromStore {
          id
          name
        }
        toStore {
          id
          name
        }
        lineItems {
          lineItemId
          quantityRequested
        }
        ... on SystemTransferOrder {
          assetTransactions {
            status
            asset {
              name
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useMobileToolTrailerTransferOrdersQuery__
 *
 * To run a query within a React component, call `useMobileToolTrailerTransferOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMobileToolTrailerTransferOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMobileToolTrailerTransferOrdersQuery({
 *   variables: {
 *      fromInventoryIds: // value for 'fromInventoryIds'
 *      toInventoryIds: // value for 'toInventoryIds'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useMobileToolTrailerTransferOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MobileToolTrailerTransferOrdersQuery, MobileToolTrailerTransferOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MobileToolTrailerTransferOrdersQuery, MobileToolTrailerTransferOrdersQueryVariables>(MobileToolTrailerTransferOrdersDocument, options);
      }
export function useMobileToolTrailerTransferOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MobileToolTrailerTransferOrdersQuery, MobileToolTrailerTransferOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MobileToolTrailerTransferOrdersQuery, MobileToolTrailerTransferOrdersQueryVariables>(MobileToolTrailerTransferOrdersDocument, options);
        }
export type MobileToolTrailerTransferOrdersQueryHookResult = ReturnType<typeof useMobileToolTrailerTransferOrdersQuery>;
export type MobileToolTrailerTransferOrdersLazyQueryHookResult = ReturnType<typeof useMobileToolTrailerTransferOrdersLazyQuery>;
export type MobileToolTrailerTransferOrdersQueryResult = ApolloReactCommon.QueryResult<MobileToolTrailerTransferOrdersQuery, MobileToolTrailerTransferOrdersQueryVariables>;
export const FullPartSearchDocument = gql`
    query FullPartSearch($partNumbers: [String!], $search: String) {
  fullPartSearch(partNumbers: $partNumbers, search: $search) {
    companyOwned {
      ...PartDetails
    }
    masterList {
      ...PartDetails
    }
  }
}
    ${PartDetailsFragmentDoc}`;

/**
 * __useFullPartSearchQuery__
 *
 * To run a query within a React component, call `useFullPartSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullPartSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullPartSearchQuery({
 *   variables: {
 *      partNumbers: // value for 'partNumbers'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFullPartSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FullPartSearchQuery, FullPartSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FullPartSearchQuery, FullPartSearchQueryVariables>(FullPartSearchDocument, options);
      }
export function useFullPartSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FullPartSearchQuery, FullPartSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FullPartSearchQuery, FullPartSearchQueryVariables>(FullPartSearchDocument, options);
        }
export type FullPartSearchQueryHookResult = ReturnType<typeof useFullPartSearchQuery>;
export type FullPartSearchLazyQueryHookResult = ReturnType<typeof useFullPartSearchLazyQuery>;
export type FullPartSearchQueryResult = ApolloReactCommon.QueryResult<FullPartSearchQuery, FullPartSearchQueryVariables>;
export const InventoryLocationWarehouseDocument = gql`
    query InventoryLocationWarehouse($inventoryLocationId: ID!) {
  inventoryLocations(inventoryLocationIds: [$inventoryLocationId]) {
    edges {
      node {
        id
        isWarehouse
        warehouse {
          warehouseExecutionSystem
          servedZipCodes
        }
      }
    }
  }
}
    `;

/**
 * __useInventoryLocationWarehouseQuery__
 *
 * To run a query within a React component, call `useInventoryLocationWarehouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryLocationWarehouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryLocationWarehouseQuery({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *   },
 * });
 */
export function useInventoryLocationWarehouseQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InventoryLocationWarehouseQuery, InventoryLocationWarehouseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InventoryLocationWarehouseQuery, InventoryLocationWarehouseQueryVariables>(InventoryLocationWarehouseDocument, options);
      }
export function useInventoryLocationWarehouseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryLocationWarehouseQuery, InventoryLocationWarehouseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InventoryLocationWarehouseQuery, InventoryLocationWarehouseQueryVariables>(InventoryLocationWarehouseDocument, options);
        }
export type InventoryLocationWarehouseQueryHookResult = ReturnType<typeof useInventoryLocationWarehouseQuery>;
export type InventoryLocationWarehouseLazyQueryHookResult = ReturnType<typeof useInventoryLocationWarehouseLazyQuery>;
export type InventoryLocationWarehouseQueryResult = ApolloReactCommon.QueryResult<InventoryLocationWarehouseQuery, InventoryLocationWarehouseQueryVariables>;
export const InventoryLocationsDocument = gql`
    query InventoryLocations($branchIds: [ID!], $search: String, $paging: CursorPaging, $permissions: [Permission!], $inventoryLocationIds: [ID!], $isWarehouse: Boolean) {
  inventoryLocations(branchIds: $branchIds, search: $search, paging: $paging, permissions: $permissions, inventoryLocationIds: $inventoryLocationIds, isWarehouse: $isWarehouse) {
    edges {
      node {
        id
        name
        branchId
        branch {
          id
          name
        }
        defaultLocation
        inventoryType
        companyId
        isWarehouse
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useInventoryLocationsQuery__
 *
 * To run a query within a React component, call `useInventoryLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryLocationsQuery({
 *   variables: {
 *      branchIds: // value for 'branchIds'
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *      permissions: // value for 'permissions'
 *      inventoryLocationIds: // value for 'inventoryLocationIds'
 *      isWarehouse: // value for 'isWarehouse'
 *   },
 * });
 */
export function useInventoryLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InventoryLocationsQuery, InventoryLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InventoryLocationsQuery, InventoryLocationsQueryVariables>(InventoryLocationsDocument, options);
      }
export function useInventoryLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InventoryLocationsQuery, InventoryLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InventoryLocationsQuery, InventoryLocationsQueryVariables>(InventoryLocationsDocument, options);
        }
export type InventoryLocationsQueryHookResult = ReturnType<typeof useInventoryLocationsQuery>;
export type InventoryLocationsLazyQueryHookResult = ReturnType<typeof useInventoryLocationsLazyQuery>;
export type InventoryLocationsQueryResult = ApolloReactCommon.QueryResult<InventoryLocationsQuery, InventoryLocationsQueryVariables>;
export const InvoiceDocument = gql`
    query Invoice($id: Int!) {
  invoice(id: $id) @rest(type: "InvoicePayload", path: "/invoices/{args.id}") {
    invoice_id
    invoice_no
    ordered_by_user {
      user_id
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = ApolloReactCommon.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const ItemHistoryDocument = gql`
    query ItemHistory($itemId: ID!, $paging: CursorPaging, $order: OrderDirection) {
  itemHistory(itemId: $itemId, paging: $paging, order: $order) {
    edges {
      node {
        id
        transactionId
        dateApplied
        transactionStatus
        transactionType
        quantityChange
        quantityOrdered
        quantityReceived
        costPerItem
        itemStatus
        memo
        customId
        sourceType
        sourceId
        source {
          ... on PurchaseOrder {
            id
            purchaseOrderNumber
          }
          ... on ManualTransferOrder {
            id
          }
          ... on SystemTransferOrder {
            id
          }
          ... on InventoryLocation {
            id
            name
          }
          ... on WorkOrderReference {
            id
          }
          ... on OrderReference {
            id
          }
          ... on Asset {
            id
          }
          ... on ManualAdjustment {
            id
            reasonDisplay
          }
          ... on Provider {
            name
          }
          ... on StorePart {
            storePartId
            isArchived
            part {
              name
              partNumber
            }
          }
          ... on CreditPurchaseReference {
            id
          }
          ... on RetailSaleReference {
            id
          }
        }
        modifiedByUser {
          id
          firstName
          lastName
          emailAddress
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useItemHistoryQuery__
 *
 * To run a query within a React component, call `useItemHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemHistoryQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      paging: // value for 'paging'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useItemHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemHistoryQuery, ItemHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemHistoryQuery, ItemHistoryQueryVariables>(ItemHistoryDocument, options);
      }
export function useItemHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemHistoryQuery, ItemHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemHistoryQuery, ItemHistoryQueryVariables>(ItemHistoryDocument, options);
        }
export type ItemHistoryQueryHookResult = ReturnType<typeof useItemHistoryQuery>;
export type ItemHistoryLazyQueryHookResult = ReturnType<typeof useItemHistoryLazyQuery>;
export type ItemHistoryQueryResult = ApolloReactCommon.QueryResult<ItemHistoryQuery, ItemHistoryQueryVariables>;
export const ItemMasterReadinessDocument = gql`
    query ItemMasterReadiness($partIds: [Int!]!) {
  storeParts(partIds: $partIds, isWarehouse: true) {
    id
    storePartId
    storeId
    inventoryLocationId
    partId
    location
    quantity
    inventoryLocation {
      id
      name
      branch {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useItemMasterReadinessQuery__
 *
 * To run a query within a React component, call `useItemMasterReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemMasterReadinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMasterReadinessQuery({
 *   variables: {
 *      partIds: // value for 'partIds'
 *   },
 * });
 */
export function useItemMasterReadinessQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemMasterReadinessQuery, ItemMasterReadinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemMasterReadinessQuery, ItemMasterReadinessQueryVariables>(ItemMasterReadinessDocument, options);
      }
export function useItemMasterReadinessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemMasterReadinessQuery, ItemMasterReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemMasterReadinessQuery, ItemMasterReadinessQueryVariables>(ItemMasterReadinessDocument, options);
        }
export type ItemMasterReadinessQueryHookResult = ReturnType<typeof useItemMasterReadinessQuery>;
export type ItemMasterReadinessLazyQueryHookResult = ReturnType<typeof useItemMasterReadinessLazyQuery>;
export type ItemMasterReadinessQueryResult = ApolloReactCommon.QueryResult<ItemMasterReadinessQuery, ItemMasterReadinessQueryVariables>;
export const ItemMastersDocument = gql`
    query ItemMasters($paging: CursorPaging, $isActive: Boolean, $search: String) {
  itemMasters(paging: $paging, isActive: $isActive, search: $search) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        id
        isActive
        flammable
        fragile
        lithiumIonBattery
        isHazmat
        numinaSerialType
        variants {
          id
          isBase
          uom
          dimensions {
            length
            width
            height
            unit
          }
          weight {
            amount
            unit
          }
          product {
            ... on GoodProduct {
              id
              name
              msrp
              standardPrice {
                amount
                currencyCode
              }
              manufacturer {
                id
                name
              }
              preferredVendor {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useItemMastersQuery__
 *
 * To run a query within a React component, call `useItemMastersQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemMastersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMastersQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      isActive: // value for 'isActive'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useItemMastersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemMastersQuery, ItemMastersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemMastersQuery, ItemMastersQueryVariables>(ItemMastersDocument, options);
      }
export function useItemMastersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemMastersQuery, ItemMastersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemMastersQuery, ItemMastersQueryVariables>(ItemMastersDocument, options);
        }
export type ItemMastersQueryHookResult = ReturnType<typeof useItemMastersQuery>;
export type ItemMastersLazyQueryHookResult = ReturnType<typeof useItemMastersLazyQuery>;
export type ItemMastersQueryResult = ApolloReactCommon.QueryResult<ItemMastersQuery, ItemMastersQueryVariables>;
export const ItemMasterDocument = gql`
    query ItemMaster($id: ID!) {
  itemMaster(id: $id) {
    id
    isActive
    flammable
    fragile
    lithiumIonBattery
    isHazmat
    numinaSerialType
    equipmentMakeId
    equipmentModelId
    productId
    dateCreated
    dateUpdated
    variants {
      id
      isBase
      uom
      conversionRate
      freightClass
      nmfc
      shippedInOriginalContainer
      siocQuantity
      isPolybagEligible
      dimensions {
        length
        width
        height
        unit
      }
      weight {
        amount
        unit
      }
      product {
        ... on GoodProduct {
          id
          name
          manufacturerNumber
          manufacturer {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useItemMasterQuery__
 *
 * To run a query within a React component, call `useItemMasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemMasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemMasterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useItemMasterQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemMasterQuery, ItemMasterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemMasterQuery, ItemMasterQueryVariables>(ItemMasterDocument, options);
      }
export function useItemMasterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemMasterQuery, ItemMasterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemMasterQuery, ItemMasterQueryVariables>(ItemMasterDocument, options);
        }
export type ItemMasterQueryHookResult = ReturnType<typeof useItemMasterQuery>;
export type ItemMasterLazyQueryHookResult = ReturnType<typeof useItemMasterLazyQuery>;
export type ItemMasterQueryResult = ApolloReactCommon.QueryResult<ItemMasterQuery, ItemMasterQueryVariables>;
export const ManualAdjustmentReasonsDocument = gql`
    query ManualAdjustmentReasons($allowIncrement: Boolean, $allowDecrement: Boolean) {
  manualAdjustmentReasons(allowIncrement: $allowIncrement, allowDecrement: $allowDecrement) {
    id
    reason
    description
    allowIncrement
    allowDecrement
  }
}
    `;

/**
 * __useManualAdjustmentReasonsQuery__
 *
 * To run a query within a React component, call `useManualAdjustmentReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualAdjustmentReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualAdjustmentReasonsQuery({
 *   variables: {
 *      allowIncrement: // value for 'allowIncrement'
 *      allowDecrement: // value for 'allowDecrement'
 *   },
 * });
 */
export function useManualAdjustmentReasonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ManualAdjustmentReasonsQuery, ManualAdjustmentReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManualAdjustmentReasonsQuery, ManualAdjustmentReasonsQueryVariables>(ManualAdjustmentReasonsDocument, options);
      }
export function useManualAdjustmentReasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManualAdjustmentReasonsQuery, ManualAdjustmentReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManualAdjustmentReasonsQuery, ManualAdjustmentReasonsQueryVariables>(ManualAdjustmentReasonsDocument, options);
        }
export type ManualAdjustmentReasonsQueryHookResult = ReturnType<typeof useManualAdjustmentReasonsQuery>;
export type ManualAdjustmentReasonsLazyQueryHookResult = ReturnType<typeof useManualAdjustmentReasonsLazyQuery>;
export type ManualAdjustmentReasonsQueryResult = ApolloReactCommon.QueryResult<ManualAdjustmentReasonsQuery, ManualAdjustmentReasonsQueryVariables>;
export const ManualAdjustmentsDocument = gql`
    query ManualAdjustments($search: String, $reasons: [ManualAdjustmentReasonType!], $inventoryLocations: [ID!], $createdDateStart: DateTime, $createdDateEnd: DateTime, $order: OrderDirection, $orderBy: ManualAdjustmentOrderBy, $paging: CursorPaging) {
  manualAdjustments(search: $search, reasons: $reasons, inventoryLocations: $inventoryLocations, createdDateStart: $createdDateStart, createdDateEnd: $createdDateEnd, order: $order, orderBy: $orderBy, paging: $paging) {
    edges {
      node {
        id
        dateCreated
        createdByUser {
          id
          firstName
          lastName
        }
        reason
        reasonDisplay
        product {
          id
          manufacturerNumber
          partClass {
            description
          }
        }
        quantityChange
        memo
        inventoryLocation {
          id
          name
        }
        transactionItem {
          transactionId
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useManualAdjustmentsQuery__
 *
 * To run a query within a React component, call `useManualAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualAdjustmentsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      reasons: // value for 'reasons'
 *      inventoryLocations: // value for 'inventoryLocations'
 *      createdDateStart: // value for 'createdDateStart'
 *      createdDateEnd: // value for 'createdDateEnd'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useManualAdjustmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ManualAdjustmentsQuery, ManualAdjustmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManualAdjustmentsQuery, ManualAdjustmentsQueryVariables>(ManualAdjustmentsDocument, options);
      }
export function useManualAdjustmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManualAdjustmentsQuery, ManualAdjustmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManualAdjustmentsQuery, ManualAdjustmentsQueryVariables>(ManualAdjustmentsDocument, options);
        }
export type ManualAdjustmentsQueryHookResult = ReturnType<typeof useManualAdjustmentsQuery>;
export type ManualAdjustmentsLazyQueryHookResult = ReturnType<typeof useManualAdjustmentsLazyQuery>;
export type ManualAdjustmentsQueryResult = ApolloReactCommon.QueryResult<ManualAdjustmentsQuery, ManualAdjustmentsQueryVariables>;
export const PartsOnWorkOrderDetailedDocument = gql`
    query PartsOnWorkOrderDetailed($workOrderId: Int!, $transactionStatuses: [TransactionStatus!]) {
  partsOnWorkOrder(workOrderId: $workOrderId, transactionStatuses: $transactionStatuses) {
    part {
      ...PartOnWorkOrderPartDetails
    }
    quantity
    costPerItem
  }
}
    ${PartOnWorkOrderPartDetailsFragmentDoc}`;

/**
 * __usePartsOnWorkOrderDetailedQuery__
 *
 * To run a query within a React component, call `usePartsOnWorkOrderDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartsOnWorkOrderDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsOnWorkOrderDetailedQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      transactionStatuses: // value for 'transactionStatuses'
 *   },
 * });
 */
export function usePartsOnWorkOrderDetailedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PartsOnWorkOrderDetailedQuery, PartsOnWorkOrderDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PartsOnWorkOrderDetailedQuery, PartsOnWorkOrderDetailedQueryVariables>(PartsOnWorkOrderDetailedDocument, options);
      }
export function usePartsOnWorkOrderDetailedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PartsOnWorkOrderDetailedQuery, PartsOnWorkOrderDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PartsOnWorkOrderDetailedQuery, PartsOnWorkOrderDetailedQueryVariables>(PartsOnWorkOrderDetailedDocument, options);
        }
export type PartsOnWorkOrderDetailedQueryHookResult = ReturnType<typeof usePartsOnWorkOrderDetailedQuery>;
export type PartsOnWorkOrderDetailedLazyQueryHookResult = ReturnType<typeof usePartsOnWorkOrderDetailedLazyQuery>;
export type PartsOnWorkOrderDetailedQueryResult = ApolloReactCommon.QueryResult<PartsOnWorkOrderDetailedQuery, PartsOnWorkOrderDetailedQueryVariables>;
export const PartsOnWorkOrderSummaryDocument = gql`
    query PartsOnWorkOrderSummary($workOrderId: Int!, $transactionStatuses: [TransactionStatus!]) {
  partsOnWorkOrder(workOrderId: $workOrderId, transactionStatuses: $transactionStatuses) {
    quantity
    costPerItem
  }
}
    `;

/**
 * __usePartsOnWorkOrderSummaryQuery__
 *
 * To run a query within a React component, call `usePartsOnWorkOrderSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartsOnWorkOrderSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsOnWorkOrderSummaryQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      transactionStatuses: // value for 'transactionStatuses'
 *   },
 * });
 */
export function usePartsOnWorkOrderSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PartsOnWorkOrderSummaryQuery, PartsOnWorkOrderSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PartsOnWorkOrderSummaryQuery, PartsOnWorkOrderSummaryQueryVariables>(PartsOnWorkOrderSummaryDocument, options);
      }
export function usePartsOnWorkOrderSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PartsOnWorkOrderSummaryQuery, PartsOnWorkOrderSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PartsOnWorkOrderSummaryQuery, PartsOnWorkOrderSummaryQueryVariables>(PartsOnWorkOrderSummaryDocument, options);
        }
export type PartsOnWorkOrderSummaryQueryHookResult = ReturnType<typeof usePartsOnWorkOrderSummaryQuery>;
export type PartsOnWorkOrderSummaryLazyQueryHookResult = ReturnType<typeof usePartsOnWorkOrderSummaryLazyQuery>;
export type PartsOnWorkOrderSummaryQueryResult = ApolloReactCommon.QueryResult<PartsOnWorkOrderSummaryQuery, PartsOnWorkOrderSummaryQueryVariables>;
export const PartsDocument = gql`
    query Parts($partIds: [Int!], $partNumbers: [String!], $description: String, $search: String, $offset: Int, $size: Int) {
  parts(partIds: $partIds, partNumbers: $partNumbers, description: $description, search: $search, offset: $offset, size: $size) {
    ...PartDetails
    itemMasterVariant {
      id
      weight {
        amount
        unit
      }
    }
  }
}
    ${PartDetailsFragmentDoc}`;

/**
 * __usePartsQuery__
 *
 * To run a query within a React component, call `usePartsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsQuery({
 *   variables: {
 *      partIds: // value for 'partIds'
 *      partNumbers: // value for 'partNumbers'
 *      description: // value for 'description'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function usePartsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PartsQuery, PartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PartsQuery, PartsQueryVariables>(PartsDocument, options);
      }
export function usePartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PartsQuery, PartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PartsQuery, PartsQueryVariables>(PartsDocument, options);
        }
export type PartsQueryHookResult = ReturnType<typeof usePartsQuery>;
export type PartsLazyQueryHookResult = ReturnType<typeof usePartsLazyQuery>;
export type PartsQueryResult = ApolloReactCommon.QueryResult<PartsQuery, PartsQueryVariables>;
export const AllPermissionsDocument = gql`
    query AllPermissions {
  allPermissions {
    id
    name
    friendlyName
    resourceType
  }
}
    `;

/**
 * __useAllPermissionsQuery__
 *
 * To run a query within a React component, call `useAllPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPermissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllPermissionsQuery, AllPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllPermissionsQuery, AllPermissionsQueryVariables>(AllPermissionsDocument, options);
      }
export function useAllPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllPermissionsQuery, AllPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllPermissionsQuery, AllPermissionsQueryVariables>(AllPermissionsDocument, options);
        }
export type AllPermissionsQueryHookResult = ReturnType<typeof useAllPermissionsQuery>;
export type AllPermissionsLazyQueryHookResult = ReturnType<typeof useAllPermissionsLazyQuery>;
export type AllPermissionsQueryResult = ApolloReactCommon.QueryResult<AllPermissionsQuery, AllPermissionsQueryVariables>;
export const GroupDocument = gql`
    query Group($groupId: Int!) {
  group(groupId: $groupId) {
    id
    name
    users {
      companyId
      id
      firstName
      lastName
    }
    spendingLimit
    policies {
      id
      role {
        id
        name
        permissions {
          id
          name
        }
      }
      resource {
        id
        objectId
        parentId
        companyId
        resourceType
        entity {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupQuery, GroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
      }
export function useGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
        }
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupQueryResult = ApolloReactCommon.QueryResult<GroupQuery, GroupQueryVariables>;
export const GroupsDocument = gql`
    query Groups($companyId: Int) {
  groups(companyId: $companyId) {
    id
    name
    spendingLimit
  }
}
    `;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
      }
export function useGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsQueryResult = ApolloReactCommon.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const ResourcesDocument = gql`
    query Resources($resourceIds: [Int!], $companyId: Int) {
  resources(resourceIds: $resourceIds, companyId: $companyId) {
    id
    resourceType
    entity {
      id
      name
      ... on StoreInterface {
        parent {
          name
          parent {
            name
            parent {
              name
              parent {
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      resourceIds: // value for 'resourceIds'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useResourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
      }
export function useResourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
        }
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>;
export type ResourcesLazyQueryHookResult = ReturnType<typeof useResourcesLazyQuery>;
export type ResourcesQueryResult = ApolloReactCommon.QueryResult<ResourcesQuery, ResourcesQueryVariables>;
export const RolesDocument = gql`
    query Roles($companyId: Int) {
  roles(companyId: $companyId) {
    id
    name
    spendingLimit
    permissions {
      id
      name
      friendlyName
      resourceType
    }
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = ApolloReactCommon.QueryResult<RolesQuery, RolesQueryVariables>;
export const PickOrderAssigneesDocument = gql`
    query PickOrderAssignees($search: String!) {
  users(filter: {search: $search, deleted: false}, paging: {first: 25}) {
    edges {
      node {
        id
        firstName
        lastName
        emailAddress
      }
    }
  }
}
    `;

/**
 * __usePickOrderAssigneesQuery__
 *
 * To run a query within a React component, call `usePickOrderAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickOrderAssigneesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickOrderAssigneesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePickOrderAssigneesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PickOrderAssigneesQuery, PickOrderAssigneesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PickOrderAssigneesQuery, PickOrderAssigneesQueryVariables>(PickOrderAssigneesDocument, options);
      }
export function usePickOrderAssigneesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PickOrderAssigneesQuery, PickOrderAssigneesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PickOrderAssigneesQuery, PickOrderAssigneesQueryVariables>(PickOrderAssigneesDocument, options);
        }
export type PickOrderAssigneesQueryHookResult = ReturnType<typeof usePickOrderAssigneesQuery>;
export type PickOrderAssigneesLazyQueryHookResult = ReturnType<typeof usePickOrderAssigneesLazyQuery>;
export type PickOrderAssigneesQueryResult = ApolloReactCommon.QueryResult<PickOrderAssigneesQuery, PickOrderAssigneesQueryVariables>;
export const PickOrderCandidateFulfillmentOrdersDocument = gql`
    query PickOrderCandidateFulfillmentOrders($fulfillmentOrderId: ID!) {
  pickOrderCandidateFulfillmentOrders(fulfillmentOrderId: $fulfillmentOrderId) {
    id
    orderNumber
    status
    fulfillmentType
    dateSubmittedForFulfillment
    destinationInventory {
      id
      name
    }
    lineItems {
      id
      quantity
      product {
        id
        name
        partNumber
      }
    }
  }
}
    `;

/**
 * __usePickOrderCandidateFulfillmentOrdersQuery__
 *
 * To run a query within a React component, call `usePickOrderCandidateFulfillmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickOrderCandidateFulfillmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickOrderCandidateFulfillmentOrdersQuery({
 *   variables: {
 *      fulfillmentOrderId: // value for 'fulfillmentOrderId'
 *   },
 * });
 */
export function usePickOrderCandidateFulfillmentOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PickOrderCandidateFulfillmentOrdersQuery, PickOrderCandidateFulfillmentOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PickOrderCandidateFulfillmentOrdersQuery, PickOrderCandidateFulfillmentOrdersQueryVariables>(PickOrderCandidateFulfillmentOrdersDocument, options);
      }
export function usePickOrderCandidateFulfillmentOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PickOrderCandidateFulfillmentOrdersQuery, PickOrderCandidateFulfillmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PickOrderCandidateFulfillmentOrdersQuery, PickOrderCandidateFulfillmentOrdersQueryVariables>(PickOrderCandidateFulfillmentOrdersDocument, options);
        }
export type PickOrderCandidateFulfillmentOrdersQueryHookResult = ReturnType<typeof usePickOrderCandidateFulfillmentOrdersQuery>;
export type PickOrderCandidateFulfillmentOrdersLazyQueryHookResult = ReturnType<typeof usePickOrderCandidateFulfillmentOrdersLazyQuery>;
export type PickOrderCandidateFulfillmentOrdersQueryResult = ApolloReactCommon.QueryResult<PickOrderCandidateFulfillmentOrdersQuery, PickOrderCandidateFulfillmentOrdersQueryVariables>;
export const PickOrderDocument = gql`
    query PickOrder($pickOrderId: ID!) {
  pickOrder(pickOrderId: $pickOrderId) {
    ...PickOrderDetailFragment
  }
}
    ${PickOrderDetailFragmentDoc}`;

/**
 * __usePickOrderQuery__
 *
 * To run a query within a React component, call `usePickOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickOrderQuery({
 *   variables: {
 *      pickOrderId: // value for 'pickOrderId'
 *   },
 * });
 */
export function usePickOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PickOrderQuery, PickOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PickOrderQuery, PickOrderQueryVariables>(PickOrderDocument, options);
      }
export function usePickOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PickOrderQuery, PickOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PickOrderQuery, PickOrderQueryVariables>(PickOrderDocument, options);
        }
export type PickOrderQueryHookResult = ReturnType<typeof usePickOrderQuery>;
export type PickOrderLazyQueryHookResult = ReturnType<typeof usePickOrderLazyQuery>;
export type PickOrderQueryResult = ApolloReactCommon.QueryResult<PickOrderQuery, PickOrderQueryVariables>;
export const PickOrdersDocument = gql`
    query PickOrders($fulfillingInventoryIds: [ID!], $statuses: [PickOrderStatus], $assignedToUserIds: [ID!], $paging: CursorPaging) {
  pickOrders(fulfillingInventoryIds: $fulfillingInventoryIds, statuses: $statuses, assignedToUserIds: $assignedToUserIds, paging: $paging) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...PickOrderSummaryFragment
      }
    }
  }
}
    ${PickOrderSummaryFragmentDoc}`;

/**
 * __usePickOrdersQuery__
 *
 * To run a query within a React component, call `usePickOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickOrdersQuery({
 *   variables: {
 *      fulfillingInventoryIds: // value for 'fulfillingInventoryIds'
 *      statuses: // value for 'statuses'
 *      assignedToUserIds: // value for 'assignedToUserIds'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function usePickOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PickOrdersQuery, PickOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PickOrdersQuery, PickOrdersQueryVariables>(PickOrdersDocument, options);
      }
export function usePickOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PickOrdersQuery, PickOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PickOrdersQuery, PickOrdersQueryVariables>(PickOrdersDocument, options);
        }
export type PickOrdersQueryHookResult = ReturnType<typeof usePickOrdersQuery>;
export type PickOrdersLazyQueryHookResult = ReturnType<typeof usePickOrdersLazyQuery>;
export type PickOrdersQueryResult = ApolloReactCommon.QueryResult<PickOrdersQuery, PickOrdersQueryVariables>;
export const ProductCategoriesQueryDocument = gql`
    query ProductCategoriesQuery($productCategoryIds: [Int!], $search: String, $offset: Int, $size: Int) {
  productCategories(productCategoryIds: $productCategoryIds, search: $search, offset: $offset, size: $size) {
    id
    name
    parentId
    productCategoryId
  }
}
    `;

/**
 * __useProductCategoriesQuery__
 *
 * To run a query within a React component, call `useProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesQuery({
 *   variables: {
 *      productCategoryIds: // value for 'productCategoryIds'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useProductCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesQueryDocument, options);
      }
export function useProductCategoriesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesQueryDocument, options);
        }
export type ProductCategoriesQueryHookResult = ReturnType<typeof useProductCategoriesQuery>;
export type ProductCategoriesQueryLazyQueryHookResult = ReturnType<typeof useProductCategoriesQueryLazyQuery>;
export type ProductCategoriesQueryQueryResult = ApolloReactCommon.QueryResult<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const ProductClassesDocument = gql`
    query ProductClasses($productClassIds: [ID!], $search: String, $paging: CursorPaging) {
  productClasses(productClassIds: $productClassIds, search: $search, paging: $paging) {
    edges {
      node {
        id
        dateCreated
        catClass
        categoryName
        classification
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useProductClassesQuery__
 *
 * To run a query within a React component, call `useProductClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductClassesQuery({
 *   variables: {
 *      productClassIds: // value for 'productClassIds'
 *      search: // value for 'search'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useProductClassesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductClassesQuery, ProductClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductClassesQuery, ProductClassesQueryVariables>(ProductClassesDocument, options);
      }
export function useProductClassesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductClassesQuery, ProductClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductClassesQuery, ProductClassesQueryVariables>(ProductClassesDocument, options);
        }
export type ProductClassesQueryHookResult = ReturnType<typeof useProductClassesQuery>;
export type ProductClassesLazyQueryHookResult = ReturnType<typeof useProductClassesLazyQuery>;
export type ProductClassesQueryResult = ApolloReactCommon.QueryResult<ProductClassesQuery, ProductClassesQueryVariables>;
export const ProductsDocument = gql`
    query Products($paging: CursorPaging, $search: String, $productTypes: [ProductType!]) {
  products(paging: $paging, search: $search, productTypes: $productTypes) {
    edges {
      node {
        ... on GoodProduct {
          id
          manufacturerNumber
          name
          upc
          msrp
          year
          productType
          manufacturer {
            id
            name
          }
          productClass {
            id
            catClass
            categoryName
            classification
          }
          standardPrice {
            amount
            currencyCode
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      search: // value for 'search'
 *      productTypes: // value for 'productTypes'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = ApolloReactCommon.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ProviderDocument = gql`
    query Provider($providerId: Int!) {
  provider(providerId: $providerId) {
    id
    name
  }
}
    `;

/**
 * __useProviderQuery__
 *
 * To run a query within a React component, call `useProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useProviderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
      }
export function useProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
        }
export type ProviderQueryHookResult = ReturnType<typeof useProviderQuery>;
export type ProviderLazyQueryHookResult = ReturnType<typeof useProviderLazyQuery>;
export type ProviderQueryResult = ApolloReactCommon.QueryResult<ProviderQuery, ProviderQueryVariables>;
export const ProvidersDocument = gql`
    query Providers($size: Int, $offset: Int, $providerIds: [Int!], $names: [String!]) {
  providers(providerIds: $providerIds, names: $names, size: $size, offset: $offset) {
    id
    name
  }
}
    `;

/**
 * __useProvidersQuery__
 *
 * To run a query within a React component, call `useProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersQuery({
 *   variables: {
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      providerIds: // value for 'providerIds'
 *      names: // value for 'names'
 *   },
 * });
 */
export function useProvidersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
      }
export function useProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
        }
export type ProvidersQueryHookResult = ReturnType<typeof useProvidersQuery>;
export type ProvidersLazyQueryHookResult = ReturnType<typeof useProvidersLazyQuery>;
export type ProvidersQueryResult = ApolloReactCommon.QueryResult<ProvidersQuery, ProvidersQueryVariables>;
export const ServingMiniDistributionCentersDocument = gql`
    query ServingMiniDistributionCenters($inventoryLocationId: ID!) {
  inventoryLocations(inventoryLocationIds: [$inventoryLocationId]) {
    edges {
      node {
        id
        servingMiniDistributionCenters {
          id
          name
          isWarehouse
        }
      }
    }
  }
}
    `;

/**
 * __useServingMiniDistributionCentersQuery__
 *
 * To run a query within a React component, call `useServingMiniDistributionCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServingMiniDistributionCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServingMiniDistributionCentersQuery({
 *   variables: {
 *      inventoryLocationId: // value for 'inventoryLocationId'
 *   },
 * });
 */
export function useServingMiniDistributionCentersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServingMiniDistributionCentersQuery, ServingMiniDistributionCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServingMiniDistributionCentersQuery, ServingMiniDistributionCentersQueryVariables>(ServingMiniDistributionCentersDocument, options);
      }
export function useServingMiniDistributionCentersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServingMiniDistributionCentersQuery, ServingMiniDistributionCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServingMiniDistributionCentersQuery, ServingMiniDistributionCentersQueryVariables>(ServingMiniDistributionCentersDocument, options);
        }
export type ServingMiniDistributionCentersQueryHookResult = ReturnType<typeof useServingMiniDistributionCentersQuery>;
export type ServingMiniDistributionCentersLazyQueryHookResult = ReturnType<typeof useServingMiniDistributionCentersLazyQuery>;
export type ServingMiniDistributionCentersQueryResult = ApolloReactCommon.QueryResult<ServingMiniDistributionCentersQuery, ServingMiniDistributionCentersQueryVariables>;
export const FulfillingInventoryStorePartsDocument = gql`
    query FulfillingInventoryStoreParts($storeIds: [Int!], $partIds: [Int!]) {
  storeParts(storeIds: $storeIds, partIds: $partIds) {
    id
    partId
    location
    availableQuantity
  }
}
    `;

/**
 * __useFulfillingInventoryStorePartsQuery__
 *
 * To run a query within a React component, call `useFulfillingInventoryStorePartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFulfillingInventoryStorePartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFulfillingInventoryStorePartsQuery({
 *   variables: {
 *      storeIds: // value for 'storeIds'
 *      partIds: // value for 'partIds'
 *   },
 * });
 */
export function useFulfillingInventoryStorePartsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FulfillingInventoryStorePartsQuery, FulfillingInventoryStorePartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FulfillingInventoryStorePartsQuery, FulfillingInventoryStorePartsQueryVariables>(FulfillingInventoryStorePartsDocument, options);
      }
export function useFulfillingInventoryStorePartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FulfillingInventoryStorePartsQuery, FulfillingInventoryStorePartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FulfillingInventoryStorePartsQuery, FulfillingInventoryStorePartsQueryVariables>(FulfillingInventoryStorePartsDocument, options);
        }
export type FulfillingInventoryStorePartsQueryHookResult = ReturnType<typeof useFulfillingInventoryStorePartsQuery>;
export type FulfillingInventoryStorePartsLazyQueryHookResult = ReturnType<typeof useFulfillingInventoryStorePartsLazyQuery>;
export type FulfillingInventoryStorePartsQueryResult = ApolloReactCommon.QueryResult<FulfillingInventoryStorePartsQuery, FulfillingInventoryStorePartsQueryVariables>;
export const StorePartDetailsDocument = gql`
    query StorePartDetails($storePartId: BigInteger, $partId: Int, $storeId: Int) {
  storePart(storePartId: $storePartId, partId: $partId, storeId: $storeId) {
    id
    cost
    quantity
    availableQuantity
    threshold
    max
    partsOrdered
    partsOrderedDetails {
      quantityOrdered
      purchaseOrderNumber
      targetType
      targetId
    }
    incomingPartsTransferQuantity
    location
    note
    openReservations {
      reservationId
      quantity
      targetType
      targetId
      fulfillmentOrder {
        id
        orderNumber
      }
    }
    outgoingTransferDetails {
      transferOrderId
      quantity
    }
    part {
      ...PartDetails
    }
    inventoryLocation {
      id
      name
      branchId
    }
    rentalItems {
      id
      rentalId
      quantityOnRent
    }
    weightedAverageCost {
      amount
      currencyCode
    }
    __typename
  }
}
    ${PartDetailsFragmentDoc}`;

/**
 * __useStorePartDetailsQuery__
 *
 * To run a query within a React component, call `useStorePartDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorePartDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorePartDetailsQuery({
 *   variables: {
 *      storePartId: // value for 'storePartId'
 *      partId: // value for 'partId'
 *      storeId: // value for 'storeId'
 *   },
 * });
 */
export function useStorePartDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StorePartDetailsQuery, StorePartDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorePartDetailsQuery, StorePartDetailsQueryVariables>(StorePartDetailsDocument, options);
      }
export function useStorePartDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorePartDetailsQuery, StorePartDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorePartDetailsQuery, StorePartDetailsQueryVariables>(StorePartDetailsDocument, options);
        }
export type StorePartDetailsQueryHookResult = ReturnType<typeof useStorePartDetailsQuery>;
export type StorePartDetailsLazyQueryHookResult = ReturnType<typeof useStorePartDetailsLazyQuery>;
export type StorePartDetailsQueryResult = ApolloReactCommon.QueryResult<StorePartDetailsQuery, StorePartDetailsQueryVariables>;
export const StorePartQuantityCostDocument = gql`
    query StorePartQuantityCost($storeId: Int!, $partId: Int!) {
  storePart(storeId: $storeId, partId: $partId) {
    id
    cost
    quantity
    __typename
  }
}
    `;

/**
 * __useStorePartQuantityCostQuery__
 *
 * To run a query within a React component, call `useStorePartQuantityCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorePartQuantityCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorePartQuantityCostQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function useStorePartQuantityCostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StorePartQuantityCostQuery, StorePartQuantityCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorePartQuantityCostQuery, StorePartQuantityCostQueryVariables>(StorePartQuantityCostDocument, options);
      }
export function useStorePartQuantityCostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorePartQuantityCostQuery, StorePartQuantityCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorePartQuantityCostQuery, StorePartQuantityCostQueryVariables>(StorePartQuantityCostDocument, options);
        }
export type StorePartQuantityCostQueryHookResult = ReturnType<typeof useStorePartQuantityCostQuery>;
export type StorePartQuantityCostLazyQueryHookResult = ReturnType<typeof useStorePartQuantityCostLazyQuery>;
export type StorePartQuantityCostQueryResult = ApolloReactCommon.QueryResult<StorePartQuantityCostQuery, StorePartQuantityCostQueryVariables>;
export const StorePartsDocument = gql`
    query StoreParts($branchIds: [Int!], $storeIds: [Int!], $aboveMax: Boolean, $belowMin: Boolean, $isDeadStock: Boolean, $providerIds: [Int!], $partDescription: String, $partIds: [Int!], $partNumbers: [String!], $search: String, $size: Int, $offset: Int, $excludeEmpty: Boolean, $sorting: [StorePartSort!]) {
  storeParts(branchIds: $branchIds, storeIds: $storeIds, aboveMax: $aboveMax, belowMin: $belowMin, isDeadStock: $isDeadStock, providerIds: $providerIds, partDescription: $partDescription, partIds: $partIds, partNumbers: $partNumbers, search: $search, size: $size, offset: $offset, excludeEmpty: $excludeEmpty, sorting: $sorting) {
    cost
    id
    location
    max
    part {
      ...PartSummaryFragment
      hasActiveItemMaster
    }
    inventoryLocation {
      id
      name
      branchId
    }
    note
    quantity
    availableQuantity
    threshold
    partsOrdered
    partsOrderedDetails {
      quantityOrdered
      purchaseOrderNumber
      targetType
      targetId
    }
    incomingPartsTransferQuantity
    total
    openReservations {
      reservationId
      quantity
      targetType
      targetId
      fulfillmentOrder {
        id
        orderNumber
      }
    }
    outgoingTransferDetails {
      transferOrderId
      quantity
    }
    quantityOnRent
    rentalItems {
      id
      rentalId
      quantityOnRent
    }
    weightedAverageCost {
      amount
      currencyCode
    }
    __typename
  }
}
    ${PartSummaryFragmentDoc}`;

/**
 * __useStorePartsQuery__
 *
 * To run a query within a React component, call `useStorePartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorePartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorePartsQuery({
 *   variables: {
 *      branchIds: // value for 'branchIds'
 *      storeIds: // value for 'storeIds'
 *      aboveMax: // value for 'aboveMax'
 *      belowMin: // value for 'belowMin'
 *      isDeadStock: // value for 'isDeadStock'
 *      providerIds: // value for 'providerIds'
 *      partDescription: // value for 'partDescription'
 *      partIds: // value for 'partIds'
 *      partNumbers: // value for 'partNumbers'
 *      search: // value for 'search'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      excludeEmpty: // value for 'excludeEmpty'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useStorePartsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StorePartsQuery, StorePartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorePartsQuery, StorePartsQueryVariables>(StorePartsDocument, options);
      }
export function useStorePartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorePartsQuery, StorePartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorePartsQuery, StorePartsQueryVariables>(StorePartsDocument, options);
        }
export type StorePartsQueryHookResult = ReturnType<typeof useStorePartsQuery>;
export type StorePartsLazyQueryHookResult = ReturnType<typeof useStorePartsLazyQuery>;
export type StorePartsQueryResult = ApolloReactCommon.QueryResult<StorePartsQuery, StorePartsQueryVariables>;
export const StoresByPermissionDocument = gql`
    query StoresByPermission($permissions: [Permission!]) {
  stores(permissions: $permissions) {
    id
    name
  }
}
    `;

/**
 * __useStoresByPermissionQuery__
 *
 * To run a query within a React component, call `useStoresByPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresByPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresByPermissionQuery({
 *   variables: {
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useStoresByPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StoresByPermissionQuery, StoresByPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoresByPermissionQuery, StoresByPermissionQueryVariables>(StoresByPermissionDocument, options);
      }
export function useStoresByPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoresByPermissionQuery, StoresByPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoresByPermissionQuery, StoresByPermissionQueryVariables>(StoresByPermissionDocument, options);
        }
export type StoresByPermissionQueryHookResult = ReturnType<typeof useStoresByPermissionQuery>;
export type StoresByPermissionLazyQueryHookResult = ReturnType<typeof useStoresByPermissionLazyQuery>;
export type StoresByPermissionQueryResult = ApolloReactCommon.QueryResult<StoresByPermissionQuery, StoresByPermissionQueryVariables>;
export const NeedsApprovalTransactionsDocument = gql`
    query NeedsApprovalTransactions($fromIds: [Int!], $toIds: [Int!], $transactionTypes: [TransactionType!], $size: Int) {
  transactions(transactionStatuses: [SUBMITTED], fromIds: $fromIds, toIds: $toIds, transactionTypes: $transactionTypes, size: $size) {
    id
    transactionType
    toId
    fromId
    __typename
  }
}
    `;

/**
 * __useNeedsApprovalTransactionsQuery__
 *
 * To run a query within a React component, call `useNeedsApprovalTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeedsApprovalTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeedsApprovalTransactionsQuery({
 *   variables: {
 *      fromIds: // value for 'fromIds'
 *      toIds: // value for 'toIds'
 *      transactionTypes: // value for 'transactionTypes'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useNeedsApprovalTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NeedsApprovalTransactionsQuery, NeedsApprovalTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NeedsApprovalTransactionsQuery, NeedsApprovalTransactionsQueryVariables>(NeedsApprovalTransactionsDocument, options);
      }
export function useNeedsApprovalTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NeedsApprovalTransactionsQuery, NeedsApprovalTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NeedsApprovalTransactionsQuery, NeedsApprovalTransactionsQueryVariables>(NeedsApprovalTransactionsDocument, options);
        }
export type NeedsApprovalTransactionsQueryHookResult = ReturnType<typeof useNeedsApprovalTransactionsQuery>;
export type NeedsApprovalTransactionsLazyQueryHookResult = ReturnType<typeof useNeedsApprovalTransactionsLazyQuery>;
export type NeedsApprovalTransactionsQueryResult = ApolloReactCommon.QueryResult<NeedsApprovalTransactionsQuery, NeedsApprovalTransactionsQueryVariables>;
export const TransactionsDocument = gql`
    query Transactions($fromIds: [Int!], $toIds: [Int!], $transactionTypes: [TransactionType!], $transactionStatuses: [TransactionStatus!], $customIds: [String!], $search: String, $offset: Int, $size: Int) {
  transactions(fromIds: $fromIds, toIds: $toIds, transactionTypes: $transactionTypes, transactionStatuses: $transactionStatuses, customIds: $customIds, search: $search, offset: $offset, size: $size) {
    ...DetailedTransaction
  }
}
    ${DetailedTransactionFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      fromIds: // value for 'fromIds'
 *      toIds: // value for 'toIds'
 *      transactionTypes: // value for 'transactionTypes'
 *      transactionStatuses: // value for 'transactionStatuses'
 *      customIds: // value for 'customIds'
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsQueryResult = ApolloReactCommon.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const TransferOrderDocument = gql`
    query TransferOrder($transferOrderId: ID!) {
  transferOrder(transferOrderId: $transferOrderId) {
    id
    status
    transferOrderType
    fromStore {
      id
      name
      isWarehouse
    }
    toStore {
      id
      name
    }
    dateCreated
    dateUpdated
    dateShipped
    dateCompleted
    dateCancelled
    isClosed
    trackingNumber
    demandRequest {
      id
      requestNumber
    }
    cancellationNote
    lineItems {
      lineItemId
      productId
      product {
        id
        ... on GoodProduct {
          name
          manufacturerNumber
          manufacturer {
            name
          }
        }
      }
      quantityRequested
      quantityReceived
      lineNote
      allocationTargetType
      allocationTargetId
    }
    receipts {
      id
      dateReceived
      notes
      receivedBy {
        id
        firstName
        lastName
      }
      receiptItems {
        id
        lineItemId
        quantityReceived
      }
    }
    ... on ManualTransferOrder {
      requester {
        id
        firstName
        lastName
      }
      requesterNote
      approver {
        id
        firstName
        lastName
      }
      approverNote
      dateApproved
      dateRejected
    }
    ... on SystemTransferOrder {
      fulfillmentId
      assetTransferStatus
      assetTransactions {
        id
        assetTransferOrderId
        assetTransferOrderNumber
        asset {
          id
          equipmentMake {
            name
          }
          equipmentModel {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useTransferOrderQuery__
 *
 * To run a query within a React component, call `useTransferOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferOrderQuery({
 *   variables: {
 *      transferOrderId: // value for 'transferOrderId'
 *   },
 * });
 */
export function useTransferOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TransferOrderQuery, TransferOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TransferOrderQuery, TransferOrderQueryVariables>(TransferOrderDocument, options);
      }
export function useTransferOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransferOrderQuery, TransferOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TransferOrderQuery, TransferOrderQueryVariables>(TransferOrderDocument, options);
        }
export type TransferOrderQueryHookResult = ReturnType<typeof useTransferOrderQuery>;
export type TransferOrderLazyQueryHookResult = ReturnType<typeof useTransferOrderLazyQuery>;
export type TransferOrderQueryResult = ApolloReactCommon.QueryResult<TransferOrderQuery, TransferOrderQueryVariables>;
export const TransferOrdersDocument = gql`
    query TransferOrders($fromInventoryIds: [ID!], $toInventoryIds: [ID!], $orderTypes: [TransferOrderType], $statuses: [TransferOrderStatus], $isClosed: Boolean, $search: String, $fulfillmentOrderNumbers: [String!], $paging: CursorPaging) {
  transferOrders(fromInventoryIds: $fromInventoryIds, toInventoryIds: $toInventoryIds, orderTypes: $orderTypes, statuses: $statuses, isClosed: $isClosed, search: $search, fulfillmentOrderNumbers: $fulfillmentOrderNumbers, paging: $paging) {
    edges {
      node {
        id
        status
        transferOrderType
        fromStore {
          id
          name
          isWarehouse
        }
        toStore {
          id
          name
        }
        trackingNumber
        demandRequest {
          id
          requestNumber
        }
        dateCreated
        dateUpdated
        dateShipped
        dateCompleted
        isClosed
        receipts {
          id
        }
        ... on ManualTransferOrder {
          requester {
            id
            firstName
            lastName
          }
          requesterNote
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useTransferOrdersQuery__
 *
 * To run a query within a React component, call `useTransferOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferOrdersQuery({
 *   variables: {
 *      fromInventoryIds: // value for 'fromInventoryIds'
 *      toInventoryIds: // value for 'toInventoryIds'
 *      orderTypes: // value for 'orderTypes'
 *      statuses: // value for 'statuses'
 *      isClosed: // value for 'isClosed'
 *      search: // value for 'search'
 *      fulfillmentOrderNumbers: // value for 'fulfillmentOrderNumbers'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useTransferOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TransferOrdersQuery, TransferOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TransferOrdersQuery, TransferOrdersQueryVariables>(TransferOrdersDocument, options);
      }
export function useTransferOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TransferOrdersQuery, TransferOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TransferOrdersQuery, TransferOrdersQueryVariables>(TransferOrdersDocument, options);
        }
export type TransferOrdersQueryHookResult = ReturnType<typeof useTransferOrdersQuery>;
export type TransferOrdersLazyQueryHookResult = ReturnType<typeof useTransferOrdersLazyQuery>;
export type TransferOrdersQueryResult = ApolloReactCommon.QueryResult<TransferOrdersQuery, TransferOrdersQueryVariables>;
export const UserPermissionGrantsDocument = gql`
    query UserPermissionGrants($permissions: [Permission!], $resourceTypes: [ResourceType!], $objectIds: [ID!]) {
  userPermissionGrants(permissions: $permissions, resourceTypes: $resourceTypes, objectIds: $objectIds) {
    permission
    objectIds
  }
}
    `;

/**
 * __useUserPermissionGrantsQuery__
 *
 * To run a query within a React component, call `useUserPermissionGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionGrantsQuery({
 *   variables: {
 *      permissions: // value for 'permissions'
 *      resourceTypes: // value for 'resourceTypes'
 *      objectIds: // value for 'objectIds'
 *   },
 * });
 */
export function useUserPermissionGrantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserPermissionGrantsQuery, UserPermissionGrantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserPermissionGrantsQuery, UserPermissionGrantsQueryVariables>(UserPermissionGrantsDocument, options);
      }
export function useUserPermissionGrantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserPermissionGrantsQuery, UserPermissionGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserPermissionGrantsQuery, UserPermissionGrantsQueryVariables>(UserPermissionGrantsDocument, options);
        }
export type UserPermissionGrantsQueryHookResult = ReturnType<typeof useUserPermissionGrantsQuery>;
export type UserPermissionGrantsLazyQueryHookResult = ReturnType<typeof useUserPermissionGrantsLazyQuery>;
export type UserPermissionGrantsQueryResult = ApolloReactCommon.QueryResult<UserPermissionGrantsQuery, UserPermissionGrantsQueryVariables>;
export const UserPreferencesDocument = gql`
    query UserPreferences {
  userPreferences {
    preferences
  }
}
    `;

/**
 * __useUserPreferencesQuery__
 *
 * To run a query within a React component, call `useUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserPreferencesQuery, UserPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserPreferencesQuery, UserPreferencesQueryVariables>(UserPreferencesDocument, options);
      }
export function useUserPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserPreferencesQuery, UserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserPreferencesQuery, UserPreferencesQueryVariables>(UserPreferencesDocument, options);
        }
export type UserPreferencesQueryHookResult = ReturnType<typeof useUserPreferencesQuery>;
export type UserPreferencesLazyQueryHookResult = ReturnType<typeof useUserPreferencesLazyQuery>;
export type UserPreferencesQueryResult = ApolloReactCommon.QueryResult<UserPreferencesQuery, UserPreferencesQueryVariables>;
export const UsersSearchDocument = gql`
    query UsersSearch($companyId: BigInteger!, $search: String!) {
  usersSearch(companyId: $companyId, search: $search) @rest(type: "User", path: "/companies/{args.companyId}/users?search={args.search}") {
    user_id
    first_name
    last_name
    email_address
  }
}
    `;

/**
 * __useUsersSearchQuery__
 *
 * To run a query within a React component, call `useUsersSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersSearchQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useUsersSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersSearchQuery, UsersSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersSearchQuery, UsersSearchQueryVariables>(UsersSearchDocument, options);
      }
export function useUsersSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersSearchQuery, UsersSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersSearchQuery, UsersSearchQueryVariables>(UsersSearchDocument, options);
        }
export type UsersSearchQueryHookResult = ReturnType<typeof useUsersSearchQuery>;
export type UsersSearchLazyQueryHookResult = ReturnType<typeof useUsersSearchLazyQuery>;
export type UsersSearchQueryResult = ApolloReactCommon.QueryResult<UsersSearchQuery, UsersSearchQueryVariables>;
export const UsersDocument = gql`
    query Users($companyId: BigInteger!) {
  users: restUsers(companyId: $companyId) @rest(type: "User", path: "/companies/{args.companyId}/users") {
    user_id
    first_name
    last_name
    email_address
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = ApolloReactCommon.QueryResult<UsersQuery, UsersQueryVariables>;
export const DcAdminFulfillmentOrdersDocument = gql`
    query DcAdminFulfillmentOrders($fulfillingInventoryIds: [ID!], $destinationInventoryIds: [ID!], $statuses: [FulfillmentOrderStatus], $orderNumbers: [BigInteger!], $demandRequestIds: [ID!], $transferOrderIds: [ID!], $dateCreatedAfter: ArrowDateTime, $dateCreatedBefore: ArrowDateTime, $paging: CursorPaging) {
  fulfillmentOrders(fulfillingInventoryIds: $fulfillingInventoryIds, destinationInventoryIds: $destinationInventoryIds, statuses: $statuses, orderNumbers: $orderNumbers, demandRequestIds: $demandRequestIds, transferOrderIds: $transferOrderIds, dateCreatedAfter: $dateCreatedAfter, dateCreatedBefore: $dateCreatedBefore, paging: $paging) {
    edges {
      node {
        id
        orderNumber
        status
        fulfillmentType
        dateCreated
        dateSubmittedForFulfillment
        dateCompleted
        mttId
        externalShopifyOrderId: externalOrderId(app: SHOPIFY)
        destinationInventory {
          id
          name
        }
        destinationKey
        destinationDescription
        pickOrders(isOpen: true) {
          id
          pickOrderNumber
        }
        lineItems {
          id
          quantity
          quantityFulfilled
          demandRequestLineItem {
            demandRequest {
              requestNumber
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useDcAdminFulfillmentOrdersQuery__
 *
 * To run a query within a React component, call `useDcAdminFulfillmentOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcAdminFulfillmentOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcAdminFulfillmentOrdersQuery({
 *   variables: {
 *      fulfillingInventoryIds: // value for 'fulfillingInventoryIds'
 *      destinationInventoryIds: // value for 'destinationInventoryIds'
 *      statuses: // value for 'statuses'
 *      orderNumbers: // value for 'orderNumbers'
 *      demandRequestIds: // value for 'demandRequestIds'
 *      transferOrderIds: // value for 'transferOrderIds'
 *      dateCreatedAfter: // value for 'dateCreatedAfter'
 *      dateCreatedBefore: // value for 'dateCreatedBefore'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useDcAdminFulfillmentOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DcAdminFulfillmentOrdersQuery, DcAdminFulfillmentOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DcAdminFulfillmentOrdersQuery, DcAdminFulfillmentOrdersQueryVariables>(DcAdminFulfillmentOrdersDocument, options);
      }
export function useDcAdminFulfillmentOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DcAdminFulfillmentOrdersQuery, DcAdminFulfillmentOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DcAdminFulfillmentOrdersQuery, DcAdminFulfillmentOrdersQueryVariables>(DcAdminFulfillmentOrdersDocument, options);
        }
export type DcAdminFulfillmentOrdersQueryHookResult = ReturnType<typeof useDcAdminFulfillmentOrdersQuery>;
export type DcAdminFulfillmentOrdersLazyQueryHookResult = ReturnType<typeof useDcAdminFulfillmentOrdersLazyQuery>;
export type DcAdminFulfillmentOrdersQueryResult = ApolloReactCommon.QueryResult<DcAdminFulfillmentOrdersQuery, DcAdminFulfillmentOrdersQueryVariables>;
export const AssignDemandRequestDocument = gql`
    mutation AssignDemandRequest($input: AssignDemandRequestInput!) {
  assignDemandRequest(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUserId
      assignedToUser {
        id
        firstName
        lastName
      }
      dateUpdated
    }
  }
}
    `;
export type AssignDemandRequestMutationFn = ApolloReactCommon.MutationFunction<AssignDemandRequestMutation, AssignDemandRequestMutationVariables>;

/**
 * __useAssignDemandRequestMutation__
 *
 * To run a mutation, you first call `useAssignDemandRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignDemandRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignDemandRequestMutation, { data, loading, error }] = useAssignDemandRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignDemandRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignDemandRequestMutation, AssignDemandRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignDemandRequestMutation, AssignDemandRequestMutationVariables>(AssignDemandRequestDocument, options);
      }
export type AssignDemandRequestMutationHookResult = ReturnType<typeof useAssignDemandRequestMutation>;
export type AssignDemandRequestMutationResult = ApolloReactCommon.MutationResult<AssignDemandRequestMutation>;
export type AssignDemandRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignDemandRequestMutation, AssignDemandRequestMutationVariables>;
export const BulkUpdateDemandRequestLineItemFulfillerNotesDocument = gql`
    mutation BulkUpdateDemandRequestLineItemFulfillerNotes($input: BulkUpdateDemandRequestLineItemFulfillerNotesInput!) {
  bulkUpdateDemandRequestLineItemFulfillerNotes(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        fulfillerNotes
      }
    }
  }
}
    `;
export type BulkUpdateDemandRequestLineItemFulfillerNotesMutationFn = ApolloReactCommon.MutationFunction<BulkUpdateDemandRequestLineItemFulfillerNotesMutation, BulkUpdateDemandRequestLineItemFulfillerNotesMutationVariables>;

/**
 * __useBulkUpdateDemandRequestLineItemFulfillerNotesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateDemandRequestLineItemFulfillerNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateDemandRequestLineItemFulfillerNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateDemandRequestLineItemFulfillerNotesMutation, { data, loading, error }] = useBulkUpdateDemandRequestLineItemFulfillerNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateDemandRequestLineItemFulfillerNotesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdateDemandRequestLineItemFulfillerNotesMutation, BulkUpdateDemandRequestLineItemFulfillerNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUpdateDemandRequestLineItemFulfillerNotesMutation, BulkUpdateDemandRequestLineItemFulfillerNotesMutationVariables>(BulkUpdateDemandRequestLineItemFulfillerNotesDocument, options);
      }
export type BulkUpdateDemandRequestLineItemFulfillerNotesMutationHookResult = ReturnType<typeof useBulkUpdateDemandRequestLineItemFulfillerNotesMutation>;
export type BulkUpdateDemandRequestLineItemFulfillerNotesMutationResult = ApolloReactCommon.MutationResult<BulkUpdateDemandRequestLineItemFulfillerNotesMutation>;
export type BulkUpdateDemandRequestLineItemFulfillerNotesMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdateDemandRequestLineItemFulfillerNotesMutation, BulkUpdateDemandRequestLineItemFulfillerNotesMutationVariables>;
export const CancelDemandRequestLineItemDocument = gql`
    mutation CancelDemandRequestLineItem($input: CancelDemandRequestLineItemInput!) {
  cancelDemandRequestLineItem(input: $input) {
    success
    message
    demandRequest {
      id
      dateCompleted
      dateCancelled
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type CancelDemandRequestLineItemMutationFn = ApolloReactCommon.MutationFunction<CancelDemandRequestLineItemMutation, CancelDemandRequestLineItemMutationVariables>;

/**
 * __useCancelDemandRequestLineItemMutation__
 *
 * To run a mutation, you first call `useCancelDemandRequestLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDemandRequestLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDemandRequestLineItemMutation, { data, loading, error }] = useCancelDemandRequestLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelDemandRequestLineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelDemandRequestLineItemMutation, CancelDemandRequestLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelDemandRequestLineItemMutation, CancelDemandRequestLineItemMutationVariables>(CancelDemandRequestLineItemDocument, options);
      }
export type CancelDemandRequestLineItemMutationHookResult = ReturnType<typeof useCancelDemandRequestLineItemMutation>;
export type CancelDemandRequestLineItemMutationResult = ApolloReactCommon.MutationResult<CancelDemandRequestLineItemMutation>;
export type CancelDemandRequestLineItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelDemandRequestLineItemMutation, CancelDemandRequestLineItemMutationVariables>;
export const CancelDemandRequestLineItemsDocument = gql`
    mutation CancelDemandRequestLineItems($input: CancelDemandRequestLineItemsInput!) {
  cancelDemandRequestLineItems(input: $input) {
    success
    message
    demandRequest {
      id
      dateCompleted
      dateCancelled
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type CancelDemandRequestLineItemsMutationFn = ApolloReactCommon.MutationFunction<CancelDemandRequestLineItemsMutation, CancelDemandRequestLineItemsMutationVariables>;

/**
 * __useCancelDemandRequestLineItemsMutation__
 *
 * To run a mutation, you first call `useCancelDemandRequestLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDemandRequestLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDemandRequestLineItemsMutation, { data, loading, error }] = useCancelDemandRequestLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelDemandRequestLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelDemandRequestLineItemsMutation, CancelDemandRequestLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelDemandRequestLineItemsMutation, CancelDemandRequestLineItemsMutationVariables>(CancelDemandRequestLineItemsDocument, options);
      }
export type CancelDemandRequestLineItemsMutationHookResult = ReturnType<typeof useCancelDemandRequestLineItemsMutation>;
export type CancelDemandRequestLineItemsMutationResult = ApolloReactCommon.MutationResult<CancelDemandRequestLineItemsMutation>;
export type CancelDemandRequestLineItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelDemandRequestLineItemsMutation, CancelDemandRequestLineItemsMutationVariables>;
export const CancelDemandRequestDocument = gql`
    mutation CancelDemandRequest($input: CancelDemandRequestInput!) {
  cancelDemandRequest(input: $input) {
    success
    message
    demandRequest {
      id
      dateCompleted
      dateCancelled
      dateUpdated
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type CancelDemandRequestMutationFn = ApolloReactCommon.MutationFunction<CancelDemandRequestMutation, CancelDemandRequestMutationVariables>;

/**
 * __useCancelDemandRequestMutation__
 *
 * To run a mutation, you first call `useCancelDemandRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDemandRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDemandRequestMutation, { data, loading, error }] = useCancelDemandRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelDemandRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelDemandRequestMutation, CancelDemandRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelDemandRequestMutation, CancelDemandRequestMutationVariables>(CancelDemandRequestDocument, options);
      }
export type CancelDemandRequestMutationHookResult = ReturnType<typeof useCancelDemandRequestMutation>;
export type CancelDemandRequestMutationResult = ApolloReactCommon.MutationResult<CancelDemandRequestMutation>;
export type CancelDemandRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelDemandRequestMutation, CancelDemandRequestMutationVariables>;
export const CompleteDemandRequestDocument = gql`
    mutation CompleteDemandRequest($input: CompleteDemandRequestInput!) {
  completeDemandRequest(input: $input) {
    success
    message
    demandRequest {
      id
      dateCompleted
      completedByUserId
      dateUpdated
      assignedToUser {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type CompleteDemandRequestMutationFn = ApolloReactCommon.MutationFunction<CompleteDemandRequestMutation, CompleteDemandRequestMutationVariables>;

/**
 * __useCompleteDemandRequestMutation__
 *
 * To run a mutation, you first call `useCompleteDemandRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDemandRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDemandRequestMutation, { data, loading, error }] = useCompleteDemandRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteDemandRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteDemandRequestMutation, CompleteDemandRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteDemandRequestMutation, CompleteDemandRequestMutationVariables>(CompleteDemandRequestDocument, options);
      }
export type CompleteDemandRequestMutationHookResult = ReturnType<typeof useCompleteDemandRequestMutation>;
export type CompleteDemandRequestMutationResult = ApolloReactCommon.MutationResult<CompleteDemandRequestMutation>;
export type CompleteDemandRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteDemandRequestMutation, CompleteDemandRequestMutationVariables>;
export const CompleteDemandRequestLineItemDocument = gql`
    mutation CompleteDemandRequestLineItem($input: CompleteDemandRequestLineItemInput!) {
  completeDemandRequestLineItem(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type CompleteDemandRequestLineItemMutationFn = ApolloReactCommon.MutationFunction<CompleteDemandRequestLineItemMutation, CompleteDemandRequestLineItemMutationVariables>;

/**
 * __useCompleteDemandRequestLineItemMutation__
 *
 * To run a mutation, you first call `useCompleteDemandRequestLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDemandRequestLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDemandRequestLineItemMutation, { data, loading, error }] = useCompleteDemandRequestLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteDemandRequestLineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteDemandRequestLineItemMutation, CompleteDemandRequestLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteDemandRequestLineItemMutation, CompleteDemandRequestLineItemMutationVariables>(CompleteDemandRequestLineItemDocument, options);
      }
export type CompleteDemandRequestLineItemMutationHookResult = ReturnType<typeof useCompleteDemandRequestLineItemMutation>;
export type CompleteDemandRequestLineItemMutationResult = ApolloReactCommon.MutationResult<CompleteDemandRequestLineItemMutation>;
export type CompleteDemandRequestLineItemMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteDemandRequestLineItemMutation, CompleteDemandRequestLineItemMutationVariables>;
export const CompleteDemandRequestLineItemsDocument = gql`
    mutation CompleteDemandRequestLineItems($input: CompleteDemandRequestLineItemsInput!) {
  completeDemandRequestLineItems(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type CompleteDemandRequestLineItemsMutationFn = ApolloReactCommon.MutationFunction<CompleteDemandRequestLineItemsMutation, CompleteDemandRequestLineItemsMutationVariables>;

/**
 * __useCompleteDemandRequestLineItemsMutation__
 *
 * To run a mutation, you first call `useCompleteDemandRequestLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDemandRequestLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDemandRequestLineItemsMutation, { data, loading, error }] = useCompleteDemandRequestLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteDemandRequestLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CompleteDemandRequestLineItemsMutation, CompleteDemandRequestLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CompleteDemandRequestLineItemsMutation, CompleteDemandRequestLineItemsMutationVariables>(CompleteDemandRequestLineItemsDocument, options);
      }
export type CompleteDemandRequestLineItemsMutationHookResult = ReturnType<typeof useCompleteDemandRequestLineItemsMutation>;
export type CompleteDemandRequestLineItemsMutationResult = ApolloReactCommon.MutationResult<CompleteDemandRequestLineItemsMutation>;
export type CompleteDemandRequestLineItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<CompleteDemandRequestLineItemsMutation, CompleteDemandRequestLineItemsMutationVariables>;
export const CreateDemandRequestDocument = gql`
    mutation CreateDemandRequest($input: CreateDemandRequestInput!) {
  createDemandRequest(input: $input) {
    success
    message
    demandRequest {
      companyId
      contactPhonePrimary
      fulfillingInventoryId
      requestingInventoryId
      notes
    }
  }
}
    `;
export type CreateDemandRequestMutationFn = ApolloReactCommon.MutationFunction<CreateDemandRequestMutation, CreateDemandRequestMutationVariables>;

/**
 * __useCreateDemandRequestMutation__
 *
 * To run a mutation, you first call `useCreateDemandRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDemandRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDemandRequestMutation, { data, loading, error }] = useCreateDemandRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDemandRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDemandRequestMutation, CreateDemandRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDemandRequestMutation, CreateDemandRequestMutationVariables>(CreateDemandRequestDocument, options);
      }
export type CreateDemandRequestMutationHookResult = ReturnType<typeof useCreateDemandRequestMutation>;
export type CreateDemandRequestMutationResult = ApolloReactCommon.MutationResult<CreateDemandRequestMutation>;
export type CreateDemandRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDemandRequestMutation, CreateDemandRequestMutationVariables>;
export const CreateProductListDocument = gql`
    mutation CreateProductList($input: CreateProductListInput!) {
  createProductList(input: $input) {
    success
    message
    productList {
      id
      context
      items {
        productId
        quantity
        targetId
        targetType
        notes
      }
    }
  }
}
    `;
export type CreateProductListMutationFn = ApolloReactCommon.MutationFunction<CreateProductListMutation, CreateProductListMutationVariables>;

/**
 * __useCreateProductListMutation__
 *
 * To run a mutation, you first call `useCreateProductListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductListMutation, { data, loading, error }] = useCreateProductListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductListMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProductListMutation, CreateProductListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProductListMutation, CreateProductListMutationVariables>(CreateProductListDocument, options);
      }
export type CreateProductListMutationHookResult = ReturnType<typeof useCreateProductListMutation>;
export type CreateProductListMutationResult = ApolloReactCommon.MutationResult<CreateProductListMutation>;
export type CreateProductListMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProductListMutation, CreateProductListMutationVariables>;
export const ReopenDemandRequestDocument = gql`
    mutation ReopenDemandRequest($input: ReopenDemandRequestInput!) {
  reopenDemandRequest(input: $input) {
    success
    message
    demandRequest {
      id
      dateCompleted
      completedByUserId
      dateUpdated
      assignedToUser {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type ReopenDemandRequestMutationFn = ApolloReactCommon.MutationFunction<ReopenDemandRequestMutation, ReopenDemandRequestMutationVariables>;

/**
 * __useReopenDemandRequestMutation__
 *
 * To run a mutation, you first call `useReopenDemandRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenDemandRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenDemandRequestMutation, { data, loading, error }] = useReopenDemandRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenDemandRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenDemandRequestMutation, ReopenDemandRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenDemandRequestMutation, ReopenDemandRequestMutationVariables>(ReopenDemandRequestDocument, options);
      }
export type ReopenDemandRequestMutationHookResult = ReturnType<typeof useReopenDemandRequestMutation>;
export type ReopenDemandRequestMutationResult = ApolloReactCommon.MutationResult<ReopenDemandRequestMutation>;
export type ReopenDemandRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenDemandRequestMutation, ReopenDemandRequestMutationVariables>;
export const ReopenDemandRequestLineItemDocument = gql`
    mutation ReopenDemandRequestLineItem($input: ReopenDemandRequestLineItemInput!) {
  reopenDemandRequestLineItem(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type ReopenDemandRequestLineItemMutationFn = ApolloReactCommon.MutationFunction<ReopenDemandRequestLineItemMutation, ReopenDemandRequestLineItemMutationVariables>;

/**
 * __useReopenDemandRequestLineItemMutation__
 *
 * To run a mutation, you first call `useReopenDemandRequestLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenDemandRequestLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenDemandRequestLineItemMutation, { data, loading, error }] = useReopenDemandRequestLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenDemandRequestLineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenDemandRequestLineItemMutation, ReopenDemandRequestLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenDemandRequestLineItemMutation, ReopenDemandRequestLineItemMutationVariables>(ReopenDemandRequestLineItemDocument, options);
      }
export type ReopenDemandRequestLineItemMutationHookResult = ReturnType<typeof useReopenDemandRequestLineItemMutation>;
export type ReopenDemandRequestLineItemMutationResult = ApolloReactCommon.MutationResult<ReopenDemandRequestLineItemMutation>;
export type ReopenDemandRequestLineItemMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenDemandRequestLineItemMutation, ReopenDemandRequestLineItemMutationVariables>;
export const ReopenDemandRequestLineItemsDocument = gql`
    mutation ReopenDemandRequestLineItems($input: ReopenDemandRequestLineItemsInput!) {
  reopenDemandRequestLineItems(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        status
      }
    }
  }
}
    `;
export type ReopenDemandRequestLineItemsMutationFn = ApolloReactCommon.MutationFunction<ReopenDemandRequestLineItemsMutation, ReopenDemandRequestLineItemsMutationVariables>;

/**
 * __useReopenDemandRequestLineItemsMutation__
 *
 * To run a mutation, you first call `useReopenDemandRequestLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenDemandRequestLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenDemandRequestLineItemsMutation, { data, loading, error }] = useReopenDemandRequestLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenDemandRequestLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReopenDemandRequestLineItemsMutation, ReopenDemandRequestLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReopenDemandRequestLineItemsMutation, ReopenDemandRequestLineItemsMutationVariables>(ReopenDemandRequestLineItemsDocument, options);
      }
export type ReopenDemandRequestLineItemsMutationHookResult = ReturnType<typeof useReopenDemandRequestLineItemsMutation>;
export type ReopenDemandRequestLineItemsMutationResult = ApolloReactCommon.MutationResult<ReopenDemandRequestLineItemsMutation>;
export type ReopenDemandRequestLineItemsMutationOptions = ApolloReactCommon.BaseMutationOptions<ReopenDemandRequestLineItemsMutation, ReopenDemandRequestLineItemsMutationVariables>;
export const UpdateDemandRequestLineItemFulfillerNotesDocument = gql`
    mutation UpdateDemandRequestLineItemFulfillerNotes($input: UpdateDemandRequestLineItemFulfillerNotesInput!) {
  updateDemandRequestLineItemFulfillerNotes(input: $input) {
    success
    message
    demandRequest {
      id
      assignedToUser {
        id
        firstName
        lastName
      }
      lineItems {
        lineItemId
        fulfillerNotes
      }
    }
  }
}
    `;
export type UpdateDemandRequestLineItemFulfillerNotesMutationFn = ApolloReactCommon.MutationFunction<UpdateDemandRequestLineItemFulfillerNotesMutation, UpdateDemandRequestLineItemFulfillerNotesMutationVariables>;

/**
 * __useUpdateDemandRequestLineItemFulfillerNotesMutation__
 *
 * To run a mutation, you first call `useUpdateDemandRequestLineItemFulfillerNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDemandRequestLineItemFulfillerNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDemandRequestLineItemFulfillerNotesMutation, { data, loading, error }] = useUpdateDemandRequestLineItemFulfillerNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDemandRequestLineItemFulfillerNotesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDemandRequestLineItemFulfillerNotesMutation, UpdateDemandRequestLineItemFulfillerNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDemandRequestLineItemFulfillerNotesMutation, UpdateDemandRequestLineItemFulfillerNotesMutationVariables>(UpdateDemandRequestLineItemFulfillerNotesDocument, options);
      }
export type UpdateDemandRequestLineItemFulfillerNotesMutationHookResult = ReturnType<typeof useUpdateDemandRequestLineItemFulfillerNotesMutation>;
export type UpdateDemandRequestLineItemFulfillerNotesMutationResult = ApolloReactCommon.MutationResult<UpdateDemandRequestLineItemFulfillerNotesMutation>;
export type UpdateDemandRequestLineItemFulfillerNotesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDemandRequestLineItemFulfillerNotesMutation, UpdateDemandRequestLineItemFulfillerNotesMutationVariables>;
export const DemandRequestDocument = gql`
    query DemandRequest($id: ID!) {
  demandRequest(id: $id) {
    id
    requestNumber
    requestType
    contactPhonePrimary
    notes
    dateCreated
    dateCompleted
    dateCancelled
    requestedByUser {
      id
      firstName
      lastName
      emailAddress
      companyId
    }
    assignedToUser {
      id
      firstName
      lastName
    }
    completedByUser {
      id
      firstName
      lastName
    }
    cancelledByUser {
      id
      firstName
      lastName
    }
    deliveryAddress {
      line1
      line2
      city
      state
      postalCode
    }
    requestingInventory {
      id
      name
      branchId
      branchV2 {
        isMtt
      }
    }
    fulfillingInventory {
      id
      name
      isWarehouse
    }
    owningInventory {
      id
      name
      isWarehouse
    }
    lineItems {
      lineItemId
      productId
      quantityRequested
      status
      targetType
      targetId
      lineNotes
      fulfillerNotes
      neededBy
      allowSubstitution
      willCall
      dateCancelled
      fulfillingInventoryStorePart {
        id
        availableQuantity
        location
      }
      cancelledByUser {
        id
        firstName
        lastName
      }
      product {
        id
        partNumber
        manufacturerNumber
        name
        hasActiveItemMaster
        partClass {
          id
          description
        }
        provider {
          id
          name
        }
        preferredVendor {
          name
        }
        preferredVendorPrice {
          amount
          currencyCode
        }
      }
      fulfilledQuantity
      outstandingQuantity
      inFlightFulfillmentOrderCount
      inFlightTransferOrderCount
      isCompleted
      fulfillmentOrderLineItems {
        id
        fulfillmentOrderId
        quantity
        isFullyFulfilled
        quantityFulfilled
        fulfillmentOrder {
          id
          orderNumber
          dateSubmittedForFulfillment
          dateCreated
          status
          dateCompleted
          fulfillingInventory {
            id
            name
          }
        }
        product {
          id
          partNumber
          name
        }
        fulfillmentLineItems {
          quantityFulfilled
          quantityUnfulfilled
          fulfillment {
            id
            dateShipped
            trackingNumber
            systemTransferOrder {
              id
              status
              transferOrderType
            }
          }
        }
      }
      transferOrderLineItems {
        lineItemId
        transferOrderId
        quantityRequested
        product {
          ... on GoodProduct {
            id
            name
            manufacturerNumber
          }
        }
        transferOrder {
          id
          status
          transferOrderType
          dateCreated
        }
      }
    }
    __typename
  }
}
    `;

/**
 * __useDemandRequestQuery__
 *
 * To run a query within a React component, call `useDemandRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useDemandRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDemandRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDemandRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DemandRequestQuery, DemandRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DemandRequestQuery, DemandRequestQueryVariables>(DemandRequestDocument, options);
      }
export function useDemandRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DemandRequestQuery, DemandRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DemandRequestQuery, DemandRequestQueryVariables>(DemandRequestDocument, options);
        }
export type DemandRequestQueryHookResult = ReturnType<typeof useDemandRequestQuery>;
export type DemandRequestLazyQueryHookResult = ReturnType<typeof useDemandRequestLazyQuery>;
export type DemandRequestQueryResult = ApolloReactCommon.QueryResult<DemandRequestQuery, DemandRequestQueryVariables>;
export const DemandRequestsDocument = gql`
    query DemandRequests($requestingInventoryIds: [ID!], $fulfillingInventoryIds: [ID!], $statuses: [DemandRequestStatus], $assignedToIds: [ID!], $requestedByUserIds: [ID!], $requestNumbers: [Int!], $fulfillmentOrderNumbers: [BigInteger!], $partIds: [ID!], $requestTypes: [DemandRequestType!], $paging: CursorPaging) {
  demandRequests(requestingInventoryIds: $requestingInventoryIds, fulfillingInventoryIds: $fulfillingInventoryIds, statuses: $statuses, assignedToIds: $assignedToIds, requestedByUserIds: $requestedByUserIds, requestNumbers: $requestNumbers, fulfillmentOrderNumbers: $fulfillmentOrderNumbers, partIds: $partIds, requestTypes: $requestTypes, paging: $paging) {
    edges {
      node {
        id
        companyId
        requestNumber
        requestType
        requestingInventoryId
        fulfillingInventoryId
        owningInventoryId
        contactPhonePrimary
        notes
        dateCreated
        requestedByUserId
        requestedByUser {
          id
          firstName
          lastName
        }
        assignedToUser {
          id
          firstName
          lastName
        }
        dateCompleted
        completedByUserId
        completedByUser {
          id
          firstName
          lastName
        }
        dateCancelled
        cancelledByUser {
          id
          firstName
          lastName
        }
        requestingInventory {
          id
          name
          branchId
        }
        fulfillingInventory {
          id
          name
          branchId
        }
        owningInventory {
          id
          name
          branchId
        }
        lineItems {
          fulfillmentOrderLineItems {
            fulfillmentOrder {
              id
              orderNumber
            }
          }
          productId
          quantityRequested
          targetType
          targetId
          lineNotes
          neededBy
          product {
            id
            partNumber
            partClass {
              id
              description
            }
            provider {
              id
              name
            }
          }
        }
        __typename
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    __typename
  }
}
    `;

/**
 * __useDemandRequestsQuery__
 *
 * To run a query within a React component, call `useDemandRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDemandRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDemandRequestsQuery({
 *   variables: {
 *      requestingInventoryIds: // value for 'requestingInventoryIds'
 *      fulfillingInventoryIds: // value for 'fulfillingInventoryIds'
 *      statuses: // value for 'statuses'
 *      assignedToIds: // value for 'assignedToIds'
 *      requestedByUserIds: // value for 'requestedByUserIds'
 *      requestNumbers: // value for 'requestNumbers'
 *      fulfillmentOrderNumbers: // value for 'fulfillmentOrderNumbers'
 *      partIds: // value for 'partIds'
 *      requestTypes: // value for 'requestTypes'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useDemandRequestsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DemandRequestsQuery, DemandRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DemandRequestsQuery, DemandRequestsQueryVariables>(DemandRequestsDocument, options);
      }
export function useDemandRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DemandRequestsQuery, DemandRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DemandRequestsQuery, DemandRequestsQueryVariables>(DemandRequestsDocument, options);
        }
export type DemandRequestsQueryHookResult = ReturnType<typeof useDemandRequestsQuery>;
export type DemandRequestsLazyQueryHookResult = ReturnType<typeof useDemandRequestsLazyQuery>;
export type DemandRequestsQueryResult = ApolloReactCommon.QueryResult<DemandRequestsQuery, DemandRequestsQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "DemandRequestSourcingArtifact": [
      "FulfillmentOrderLineItem",
      "TransferOrderLineItem"
    ],
    "ExternalEntityMeta": [
      "ExternalPartMeta",
      "ExternalStoreMeta"
    ],
    "IMutationError": [
      "MutationError"
    ],
    "IMutationResult": [
      "ActivateItemMasterVariantResult",
      "AddFulfillmentOrdersToPickOrderResult",
      "AddItemMasterVariant__Result",
      "AddPolicyToGroup__Result",
      "AddProductToVendorCatalogResult",
      "AddProductVendorPricingResult",
      "AdjustReservationQuantity__Result",
      "ApproveTransferOrderResult",
      "ArchiveInventoryLocation__Result",
      "ArchiveStore__Result",
      "ArchiveStorePart__Result",
      "AssignPermissionsToRole__Result",
      "AssignPickOrderResult",
      "AssignUsersToGroup__Result",
      "BatchOperations__Result",
      "BulkUpdateDemandRequestLineItemFulfillerNotesResult",
      "CancelDemandRequestLineItemsResult",
      "CancelMultiManufacturerProductUpload__Result",
      "CancelPickOrderResult",
      "CancelPreferredVendorPricingUpload__Result",
      "CancelReservation__Result",
      "CancelTransferOrderLineItemResult",
      "CancelTransferOrderResult",
      "CompleteDemandRequestLineItemsResult",
      "CompletePickOrderResult",
      "ConvertItems_Result",
      "ConvertParts__Result",
      "CreateBranch__Result",
      "CreateDistrict__Result",
      "CreateFulfillmentOrderResult",
      "CreateGroup__Result",
      "CreateInventoryLocation__Result",
      "CreateItemMasterResult",
      "CreateManualAdjustment__Result",
      "CreateManualTransferOrderResult",
      "CreateNamedStoreAsChildOf__Result",
      "CreateOrUpdateReservation__Result",
      "CreatePickOrderResult",
      "CreateProduct__Result",
      "CreateProductCategory__Result",
      "CreateProductClass__Result",
      "CreatePutAwayOrderResult",
      "CreateRegion__Result",
      "CreateRole__Result",
      "CreateStorePart__Result",
      "CreateWeightedAverageCostSnapshot__Result",
      "DeleteDistrict__Result",
      "DeleteGroup__Result",
      "DeleteProductVendorPricingResult",
      "DeleteRegion__Result",
      "DeleteRole__Result",
      "DeleteUserPreference__Result",
      "GenerateResultPresignedUrl__Result",
      "GenerateUploadPresignedUrl__Result",
      "InitializeCompany__Result",
      "MarkPartAsGloballyVerified__Result",
      "MarkProviderAsGloballyVerified__Result",
      "MergeParts__Result",
      "MergeProducts__Result",
      "MergeProviders__Result",
      "MoveInventoryLocationTo__Result",
      "MoveResource__Result",
      "ReceiveTransferOrderLineItemsResult",
      "RecordPickedQuantitiesResult",
      "RejectTransferOrderResult",
      "RemovePermissionsFromRole__Result",
      "RemoveProductFromVendorCatalogResult",
      "RemoveResourcePolicyFromGroup__Result",
      "RemoveUserFromGroup__Result",
      "RentalToRentalRetailSale__Result",
      "RentalToStore__Result",
      "RentalToStoreAndRetailSale__Result",
      "ReopenDemandRequestLineItemsResult",
      "RequestFulfillmentOrderCancellationResult",
      "ReserveInventoryItemsResult",
      "SetPreferredVendorResult",
      "StartMultiManufacturerProductUpload__Result",
      "StoreToRental__Result",
      "StoreToRentalRetailSale__Result",
      "UnloadMobileToolTrailerResult",
      "UpdateDemandRequestLineItemFulfillerNotesResult",
      "UpdateDistrict__Result",
      "UpdateGroup__Result",
      "UpdateInventoryLocation__Result",
      "UpdateItemMasterResult",
      "UpdateItemMasterVariantResult",
      "UpdateProduct__Result",
      "UpdateProductCategory__Result",
      "UpdateProductClass__Result",
      "UpdateProductVendorPricingResult",
      "UpdateRegion__Result",
      "UpdateRole__Result",
      "UpdateStore__Result",
      "UpdateStorePart__Result",
      "UpsertUserPreference__Result"
    ],
    "Item": [
      "NonSerializedItem"
    ],
    "ItemHistorySource": [
      "Asset",
      "CreditPurchaseReference",
      "InventoryLocation",
      "ManualAdjustment",
      "ManualTransferOrder",
      "OrderReference",
      "Provider",
      "PurchaseOrder",
      "RetailSaleReference",
      "StorePart",
      "SystemTransferOrder",
      "WorkOrderReference"
    ],
    "MobileToolTrailerInventoryItem": [
      "Asset",
      "StorePart"
    ],
    "NamedResourceEntity": [
      "Company",
      "District",
      "EsBranch",
      "ESResource",
      "Region",
      "Store"
    ],
    "Node": [
      "ManualAdjustment",
      "ManualAdjustmentReason"
    ],
    "Product": [
      "GoodProduct"
    ],
    "PutAwayOrderSource": [
      "ManualTransferOrder",
      "PurchaseOrder",
      "SystemTransferOrder"
    ],
    "StoreInterface": [
      "Branch",
      "NamedStore",
      "Store"
    ],
    "TransactionEntity": [
      "Branch",
      "NamedStore",
      "Provider"
    ],
    "TransferOrder": [
      "ManualTransferOrder",
      "SystemTransferOrder"
    ]
  }
};
      export default result;
    